import * as i0 from '@angular/core';
import { Component, EventEmitter, Output, Input, ViewChild, NgModule, CUSTOM_ELEMENTS_SCHEMA, Injectable, Inject, forwardRef, ViewEncapsulation, InjectionToken, HostBinding, HostListener, Pipe, ChangeDetectionStrategy } from '@angular/core';
import * as i2$1 from '@angular/common';
import { CommonModule } from '@angular/common';
import * as i1$3 from '@angular/common/http';
import { HttpClientModule } from '@angular/common/http';
import * as i1 from '@ngx-translate/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import * as i5 from '@angular/forms';
import { FormsModule, NG_VALUE_ACCESSOR, NG_ASYNC_VALIDATORS, ReactiveFormsModule, FormControl, FormGroup } from '@angular/forms';
import * as i2 from '@bento/bento-ng';
import { BentoComboboxModule, BentoCheckboxModule, BentoModule, BentoToolbarModule, BentoResetModule, BentoModalConfirmationModule, BentoBusyLoaderModule, BentoSideNavModule, BentoToggleModule, BentoSmartBadgeType, BentoSmartBadgeStyle, BentoPaginationComponent, BentoSmartBadgeModule, BentoPaginationModule, BentoSplitterGroupModule, BentoExpandCollapseButtonGroupModule, BentoDatepickerToggleModule, BentoAlertModule } from '@bento/bento-ng';
import { BehaviorSubject, from, of, combineLatest, Subscription, isObservable, ReplaySubject, Observable, NEVER } from 'rxjs';
import { PaginatedItemsRequestReason, ContactSet, View, Search, FileDrawer, ItemType, ContainerKey, ParentedItemKey, LinkType, isContainer, isLink, TreeNode, LoadingState, TreeRoot, ProjectGroupBy, keyToString, stringToKey, RootFolderType, isContainerKey as isContainerKey$1, isDocument, EsignPlaceholderType, Contact, Page, FilterOperator, Sort, LockType, isClientDrawer, ShareUserType, ShareRole, SortDirection, ItemHistory, CommunicationDisplayStatus, CommunicationRequestType, CommunicationSubRequest, LockLevel, User } from '@onviobr/toolbox-document-services/dist/esm5/models';
import { registerPopover, registerTabSet, registerTabItem, registerIcon, IconType as IconType$1, registerAlert } from '@onviobr/ui-elements';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';
import { __awaiter } from 'tslib';
import { getCompanyId, getContactId } from '@onviobr/services/session';
import * as i1$1 from '@onviobr/toolbox-document-services/dist/esm5';
import { RecipientsService, ContactService, ClientService } from '@onviobr/toolbox-document-services/dist/esm5';
import * as i2$2 from '@angular/platform-browser';
import { BrowserModule } from '@angular/platform-browser';
import * as i1$2 from '@ng-bootstrap/ng-bootstrap';
import { NgbAccordion, NgbModule, NgbTooltipModule, NgbPopoverModule, NgbAccordionModule, NgbDateAdapter, NgbDateNativeAdapter, NgbDatepickerModule, NgbAlertModule } from '@ng-bootstrap/ng-bootstrap';
import { has } from '@onviobr/services/access';
import { isNullOrEmpty } from '@onviobr/services/utils';
import { TreeStore, registerTree } from '@onviobr/ui-elements/bm-tree';
import { first, mergeMap, map, distinctUntilChanged, switchMap, catchError, startWith } from 'rxjs/operators';
import { IconType } from '@onviobr/ui-elements/bm-icons';
import { countryDefaultLang, countryDefaultLangMap } from '@onviobr/services/environment/language';
import { isContainerKey } from '@onviobr/toolbox-document-services/dist/esm5/models/container-key';
import { projectGroupKeyToContainer, isVirtualFolder, extractClient } from '@onviobr/toolbox-document-services/dist/esm5/services/project-grouping';
import * as BDS from '@onviobr/toolbox-document-services/dist/esm5/';
import { getCurrentLanguage } from '@onviobr/services/i18n';
import { renderInputGlobally } from '@onviobr/ui-elements/bm-input';
import { getItem, setItem } from '@onviobr/web-storage';
import { AnnotationDropDataTransferKey, AnnotationLocation, defaultOptions, PdfTronElement, viewControlAndMenuElements } from '@onviobr/toolbox-viewer/publish/dms-viewer-interface';
import { register } from '@onviobr/toolbox-viewer/publish';
import { has as has$1, hasSome } from '@onviobr/services/permission';
import { getAccounts, getCurrentUser } from '@onviobr/services/profile/user';
import { getEmployeeViews } from '@onviobr/services/core/employee-views';
import { FilterOperations } from '@onviobr/services/utils/sorting-filtering';
import { CollectionView, SortDescription } from '@grapecity/wijmo';
import { HeadersVisibility, SelectionMode } from '@grapecity/wijmo.grid';
import * as i5$1 from '@grapecity/wijmo.angular2.grid';
import { WjGridModule } from '@grapecity/wijmo.angular2.grid';
import { Subscription as Subscription$1 } from 'rxjs/internal/Subscription';
import { format, addMinutes } from 'date-fns';
import { isRoot } from '@onviobr/toolbox-document-services/dist/esm5/models/root-folder';
import { RecentItemVerb } from '@onviobr/toolbox-document-services/dist/esm5/models/recent-item';
import { CommunicationRequestRecipientType } from '@onviobr/toolbox-document-services/dist/esm5/models/communications/communication-request-recipient-type';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { WjInputModule } from '@grapecity/wijmo.angular2.input';
import { DocumentEventTypes } from '@onviobr/toolbox-document-services/dist/esm5/models/document-event-types';
import { loadCurrent } from '@onviobr/services/profile/help';
import customProtocolCheck from 'custom-protocol-check';

class DocumentComponentsComponent {
}
/** @nocollapse */ DocumentComponentsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentComponentsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentComponentsComponent, selector: "bdc-document-components", ngImport: i0, template: ` <p>document-components works!<br /></p> `, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bdc-document-components',
                    template: ` <p>document-components works!<br /></p> `,
                    styles: [],
                }]
        }] });

class TranslateFailoverService {
    constructor(translate) {
        this.translate = translate;
        this.unsubscribables = [];
    }
    get(key) {
        const translation$ = new BehaviorSubject(key);
        this.unsubscribables.push(this.translate.get(key).subscribe((result) => {
            if (result) {
                translation$.next(result);
            }
            if (!this.translationSucceeded(key, result)) {
                this.unsubscribables.push(this.translate.onDefaultLangChange.subscribe((event) => {
                    const translation = event.translations[key];
                    if (translation) {
                        translation$.next(translation);
                    }
                }));
            }
        }));
        this.unsubscribables.push(translation$);
        return translation$;
    }
    dispose() {
        this.unsubscribables.forEach(s => s.unsubscribe());
    }
    translationSucceeded(key, result) {
        return result !== undefined && result !== key;
    }
}

function translateFailoverServiceFactory(translate) {
    return new TranslateFailoverService(translate);
}
const NAME_HEADER_KEY$1 = marker('Blue.DocumentComponents.ContactSelector.NameHeader');
const EMAIL_HEADER_KEY = marker('Blue.DocumentComponents.ContactSelector.EmailHeader');
const RELATIONSHIP_HEADER_KEY = marker('Blue.DocumentComponents.ContactSelector.RelationshipHeader');
class ContactSelectorComponent {
    constructor(customTranslateService) {
        this.customTranslateService = customTranslateService;
        this.pageNumber = 1;
        this.skipReset = false;
        this.lastLoadedId = '';
        this.lastDataRequestReason = PaginatedItemsRequestReason.Paging;
        this.isContactValid = true;
        this.contactChange = new EventEmitter();
        this.dataRequested = new EventEmitter();
        this.readonly = false;
        this.showEmailAddressColumn = true;
        this.showRelationshipColumn = true;
        this.hideControlBorder = true;
        this.onBlur = new EventEmitter();
        this.comboboxOptions = {
            searchable: true,
            useServerSearch: true,
            itemHeight: 32,
            columns: [
                {
                    name: 'displayAs',
                    width: '250px',
                },
                {
                    name: 'emailAddress',
                    width: '250px',
                },
                {
                    name: 'relationship',
                    width: '200px',
                },
            ],
            headerTranslation: {
                displayAs: '',
                emailAddress: '',
                relationship: '',
            },
            debounceTime: 200,
            labelFormatter: this.formatContact,
        };
        this.itemsToShow$ = new BehaviorSubject([]);
    }
    set contact(value) {
        if (this.selectedContact !== value) {
            this.selectedContact = value;
            this.notifyContactChanged();
            // bento-combobox wants to reset itself on each item click
            this.skipReset = true;
        }
    }
    get contact() {
        return this.selectedContact;
    }
    set isValid(value) {
        if (value !== undefined) {
            this.isContactValid = value;
        }
    }
    set dataSource(dataSource$) {
        if (dataSource$) {
            const updateDataSource = (value) => {
                if (value.incremental) {
                    // bento-combobox internally treats .next() as a new page.
                    // Doing so facilitates pagination but lacks the power of Observables for other aims,
                    // like filtering, sorting.
                    // Just call itemsToShow$.next() for the incremental items list update:
                    this.itemsToShow$.next(value.contacts);
                }
                else {
                    // If we for some reason want to filter items in a dropdown
                    // (even items from previous pages, loaded earlier) we should use non-incremental update.
                    // For non-incremental update we need to re-set itemsToShow$.
                    // When using non-incremental update yet doing pagination,
                    // in order to do it smoothly on scroll, we still only can
                    // use itemsToShow$.next(). Otherwise, if we just re-set itemsToShow$,
                    // changes become visible either after re-opening dropdown or on next endOfScroll event.
                    // Hence the workaround:
                    // 	1. call itemsToShow$.next(<new_items>) just for immediate update
                    // 	2. re-set itemsToShow$
                    const oldSetEndsAt = value.contacts.findIndex((c) => c.id === this.lastLoadedId);
                    let isEmptyPage = false;
                    if (oldSetEndsAt > -1) {
                        const newPage = value.contacts.slice(oldSetEndsAt + 1);
                        this.itemsToShow$.next(newPage);
                        isEmptyPage = this.lastDataRequestReason === PaginatedItemsRequestReason.Paging && newPage.length === 0;
                    }
                    if (this.itemsToShow$) {
                        this.itemsToShow$.unsubscribe();
                    }
                    if (!isEmptyPage) {
                        this.itemsToShow$ = new BehaviorSubject(value.contacts);
                    }
                }
            };
            if (this.dataSourceSubscription) {
                this.dataSourceSubscription.unsubscribe();
            }
            this.dataSourceSubscription = dataSource$.subscribe({ next: updateDataSource });
        }
    }
    ngOnInit() {
        if (!this.readonly) {
            this.requestUpdate(undefined, PaginatedItemsRequestReason.Paging);
        }
        const setHeader = (header, translation) => {
            this.comboboxOptions.headerTranslation = this.comboboxOptions.headerTranslation || {};
            this.comboboxOptions.headerTranslation[header] = translation;
        };
        this.customTranslateService.get(NAME_HEADER_KEY$1).subscribe(res => setHeader('displayAs', res));
        if (this.showEmailAddressColumn) {
            this.customTranslateService.get(EMAIL_HEADER_KEY).subscribe(res => setHeader('emailAddress', res));
        }
        else if (this.comboboxOptions.columns) {
            this.comboboxOptions.columns = this.comboboxOptions.columns.filter(column => column.name !== 'emailAddress');
        }
        if (this.showRelationshipColumn) {
            this.customTranslateService.get(RELATIONSHIP_HEADER_KEY).subscribe(res => setHeader('relationship', res));
        }
        else if (this.comboboxOptions.columns) {
            this.comboboxOptions.columns = this.comboboxOptions.columns.filter(column => column.name !== 'relationship');
        }
        registerPopover();
    }
    ngAfterViewInit() {
        if (!this.readonly) {
            this.setupTextInput();
            this.fitScrollViewPort();
        }
        if (this.combobox) {
            this.combobox.onFocusOut = () => this.onBlur.emit();
        }
    }
    ngOnDestroy() {
        if (this.dataSourceSubscription) {
            this.dataSourceSubscription.unsubscribe();
        }
        if (this.itemsToShow$) {
            this.itemsToShow$.unsubscribe();
        }
        this.customTranslateService.dispose();
    }
    searchData($event) {
        this.pageNumber = 1;
        this.requestUpdate($event.search, PaginatedItemsRequestReason.Search);
    }
    endOfScroll($event) {
        this.pageNumber++;
        this.lastLoadedId = this.itemsToShow$.value[this.itemsToShow$.value.length - 1].id;
        this.requestUpdate($event.search, PaginatedItemsRequestReason.Paging);
    }
    reset() {
        if (!this.skipReset) {
            this.pageNumber = 1;
            this.requestUpdate(undefined, PaginatedItemsRequestReason.Paging);
        }
        else {
            this.skipReset = false;
        }
    }
    setupTextInput() {
        if (this.combobox) {
            // on focus, only display an email
            if (this.combobox && this.combobox._inputElRef) {
                const inputEl = this.combobox._inputElRef.nativeElement;
                if (inputEl) {
                    inputEl.onblur = (event) => {
                        if (this.contact && event.target) {
                            event.target.value = this.formatContact(this.contact);
                        }
                    };
                    inputEl.onfocus = (event) => {
                        if (this.contact && this.contact.emailAddress && event.target) {
                            event.target.value = this.contact.emailAddress;
                        }
                    };
                    if (this.hideControlBorder) {
                        inputEl.style.border = 'none';
                    }
                }
            }
        }
    }
    fitScrollViewPort() {
        if (this.combobox && this.combobox._listContainer && this.combobox._listContainer.nativeElement) {
            const scrollViewport = this.combobox._listContainer.nativeElement.querySelector('cdk-virtual-scroll-viewport');
            if (scrollViewport) {
                scrollViewport.setAttribute('style', 'overflow-x: hidden');
            }
        }
    }
    formatContact(contact) {
        if (contact.emailAddress) {
            return `${contact.displayAs} <${contact.emailAddress}>`;
        }
        return `${contact.displayAs}`;
    }
    notifyContactChanged() {
        this.contactChange.emit(this.contact);
    }
    requestUpdate(searchTerm, reason) {
        this.lastDataRequestReason = reason;
        this.dataRequested.emit({
            pageNumber: this.pageNumber,
            search: searchTerm,
            reason,
        });
    }
}
/** @nocollapse */ ContactSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactSelectorComponent, deps: [{ token: TranslateFailoverService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ContactSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ContactSelectorComponent, selector: "bdc-contact-selector", inputs: { contact: "contact", readonly: "readonly", showEmailAddressColumn: "showEmailAddressColumn", showRelationshipColumn: "showRelationshipColumn", hideControlBorder: "hideControlBorder", isValid: "isValid", dataSource: "dataSource", comboLabelText: "comboLabelText" }, outputs: { contactChange: "contactChange", dataRequested: "dataRequested", onBlur: "onBlur" }, providers: [
        {
            provide: TranslateFailoverService,
            useFactory: translateFailoverServiceFactory,
            deps: [TranslateService],
        },
    ], viewQueries: [{ propertyName: "combobox", first: true, predicate: ["combobox"], descendants: true }], ngImport: i0, template: "<div class=\"contact-selector ng-bento\" [ngClass]=\"{ 'invalid' : !isContactValid }\">\n\t<bm-popover placement=\"right\" trigger=\"mouse\"></bm-popover>\n\t<bento-combobox\n\t\t#combobox\n\t\tclass=\"contact-selector-combobox\"\n\t\t[(ngModel)]=\"contact\"\n\t\t[attr.aria-label]=\"'Blue.DocumentComponents.Communications.Recipient' | translate\"\n\t\t[itemsObservable]=\"itemsToShow$\"\n\t\t[options]=\"comboboxOptions\"\n\t\t[inputLabelText]=\"comboLabelText\"\n\t\t[readonly]=\"readonly\"\n\t\t(search)=\"searchData($event)\"\n\t\t(endOfScroll)=\"endOfScroll($event)\"\n\t\t(resetItems)=\"reset()\"\n\t>\n\t</bento-combobox>\n</div>\n", styles: [".invalid{border:1px solid red}.ng-bento .bento-select{right:0}\n"], components: [{ type: i2.BentoComboboxComponent, selector: "bento-combobox", inputs: ["appendTo", "options", "up", "readonly", "open", "itemsObservable", "required", "revertOnInvalidInput", "rowTemplate", "id", "inputLabelText", "inputLabelClass"], outputs: ["search", "resetItems", "endOfScroll", "openChange"] }], directives: [{ type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-contact-selector', providers: [
                        {
                            provide: TranslateFailoverService,
                            useFactory: translateFailoverServiceFactory,
                            deps: [TranslateService],
                        },
                    ], template: "<div class=\"contact-selector ng-bento\" [ngClass]=\"{ 'invalid' : !isContactValid }\">\n\t<bm-popover placement=\"right\" trigger=\"mouse\"></bm-popover>\n\t<bento-combobox\n\t\t#combobox\n\t\tclass=\"contact-selector-combobox\"\n\t\t[(ngModel)]=\"contact\"\n\t\t[attr.aria-label]=\"'Blue.DocumentComponents.Communications.Recipient' | translate\"\n\t\t[itemsObservable]=\"itemsToShow$\"\n\t\t[options]=\"comboboxOptions\"\n\t\t[inputLabelText]=\"comboLabelText\"\n\t\t[readonly]=\"readonly\"\n\t\t(search)=\"searchData($event)\"\n\t\t(endOfScroll)=\"endOfScroll($event)\"\n\t\t(resetItems)=\"reset()\"\n\t>\n\t</bento-combobox>\n</div>\n", styles: [".invalid{border:1px solid red}.ng-bento .bento-select{right:0}\n"] }]
        }], ctorParameters: function () { return [{ type: TranslateFailoverService }]; }, propDecorators: { contactChange: [{
                type: Output
            }], dataRequested: [{
                type: Output
            }], contact: [{
                type: Input
            }], readonly: [{
                type: Input
            }], showEmailAddressColumn: [{
                type: Input
            }], showRelationshipColumn: [{
                type: Input
            }], hideControlBorder: [{
                type: Input
            }], isValid: [{
                type: Input
            }], dataSource: [{
                type: Input
            }], comboLabelText: [{
                type: Input
            }], onBlur: [{
                type: Output
            }], combobox: [{
                type: ViewChild,
                args: ['combobox', { static: false }]
            }] } });

class ContactSelectorModule {
}
/** @nocollapse */ ContactSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ContactSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactSelectorModule, declarations: [ContactSelectorComponent], imports: [CommonModule, BentoComboboxModule, FormsModule, i1.TranslateModule], exports: [ContactSelectorComponent] });
/** @nocollapse */ ContactSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactSelectorModule, imports: [[CommonModule, BentoComboboxModule, FormsModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ContactSelectorComponent],
                    imports: [CommonModule, BentoComboboxModule, FormsModule, TranslateModule.forChild()],
                    exports: [ContactSelectorComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class ContactPersonalDetailsComponent {
    constructor(contactService, _sanitizer, appRef) {
        this.contactService = contactService;
        this._sanitizer = _sanitizer;
        this.appRef = appRef;
        this.contactInfoPopulated = false;
        this.nickname = '';
        this.entityType = '';
        this.allPagesLoaded = false;
        this._contactList$ = new BehaviorSubject(new ContactSet([], false));
        this.openContactClick = new EventEmitter();
        this.contactChanged = new EventEmitter();
        this.contactInfoPopulated = false;
    }
    get pageSize() {
        return 25;
    }
    getContactList() {
        return this._contactList$;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this._companyId = yield getCompanyId();
        });
    }
    populateContact(contactFields) {
        if (contactFields.nickname) {
            this.nickname = contactFields.nickname;
        }
        if (contactFields.entityType) {
            this.entityType = contactFields.entityType.name;
        }
        this.contactInfoPopulated = true;
        // tick is called to force the page to update
        this.appRef.tick();
    }
    getContactFields(companyId, newContact) {
        return __awaiter(this, void 0, void 0, function* () {
            let contactFields;
            // If we have the ID, we just call get. If we don't, let's use the email address from outlook to get the ID
            // And then call get because the findClientByEmail endpoint doesn't give us all the needed data
            if (newContact.id) {
                contactFields = yield this.contactService.get(companyId, newContact.id);
            }
            else {
                throw new Error('contact requested without ID');
            }
            yield this.setContactAvatar(companyId, contactFields.id);
            return contactFields;
        });
    }
    setContactAvatar(companyId, contactId) {
        return __awaiter(this, void 0, void 0, function* () {
            const contactImage = yield this.contactService.getContactImage(companyId, contactId);
            const contactImageString = contactImage.base64Image;
            if (contactImageString !== '' && contactImageString !== null) {
                // Had to call this bypassSecurity function in order to get the Base64 image to display
                this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + contactImageString);
            }
            else {
                this.imagePath = '';
            }
        });
    }
    changeContact(newContact) {
        return __awaiter(this, void 0, void 0, function* () {
            const companyId = yield getCompanyId();
            const contactFields = yield this.getContactFields(companyId, newContact);
            this.populateContact(contactFields);
            this.contactChanged.emit(newContact);
            return contactFields;
        });
    }
    openContactInOnvio() {
        // I'd rather directly open the link to the client setup page from here
        // But I open the window via a call to the Outlook JS library and
        // I definitely don't want to import that library here
        this.openContactClick.emit(this.contact.id);
    }
    // subscriber - change in page
    onDataRequested(dataRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            let incremental = true;
            if (dataRequest.reason === PaginatedItemsRequestReason.Search) {
                incremental = false;
            }
            if (!this.allPagesLoaded) {
                const view = new View();
                if (dataRequest.search) {
                    view.search = new Search(dataRequest.search, ['fullName']);
                }
                const page = {
                    pageNumber: dataRequest.pageNumber,
                    startIndex: this.pageSize * (dataRequest.pageNumber - 1) + 1,
                    itemCount: this.pageSize,
                    endIndex: this.pageSize * (dataRequest.pageNumber - 1) + this.pageSize,
                };
                this._companyId = this._companyId || (yield getCompanyId());
                const contacts = yield this.contactService.getContactViews(this._companyId || '', view, page);
                this.allPagesLoaded = contacts.length < this.pageSize;
                this._contactList$.next(new ContactSet(contacts, incremental));
            }
        });
    }
}
/** @nocollapse */ ContactPersonalDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactPersonalDetailsComponent, deps: [{ token: i1$1.ContactService }, { token: i2$2.DomSanitizer }, { token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ContactPersonalDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ContactPersonalDetailsComponent, selector: "bdc-contact-info", inputs: { contact: "contact", showRelationshipColumn: "showRelationshipColumn" }, outputs: { openContactClick: "openContactClick", contactChanged: "contactChanged" }, viewQueries: [{ propertyName: "contactSelector", first: true, predicate: ContactSelectorComponent, descendants: true }], ngImport: i0, template: "<div class=\"pd-header\">\n\t<div class=\"pd-header-text\">\n\t\tContact\n\t\t<a>\n\t\t\t<i *ngIf=\"contact\" id=\"open-in-onvio-btn\" class=\"bento-icon-newtab\" type=\"button\" (click)=\"openContactInOnvio()\"></i>\n\t\t</a>\n\t</div>\n</div>\n<div class=\"personal-details\">\n\t<bdc-contact-selector\n\t\t[dataSource]=\"getContactList()\"\n\t\t[contact]=\"contact\"\n\t\tcomboLabelText=\"Contact *\"\n\t\t[showRelationshipColumn]=\"this.showRelationshipColumn\"\n\t\t(contactChange)=\"changeContact($event)\"\n\t\t(dataRequested)=\"onDataRequested($event)\"\n\t>\n\t</bdc-contact-selector>\n\t<div class=\"pd-row avatar-row\" *ngIf=\"!!contactInfoPopulated\">\n\t\t<div class=\"pd-column\">\n\t\t\t<b>Entity Type: </b> {{entityType}}<br />\n\t\t\t<br />\n\t\t\t<b>Nickname:</b> {{nickname}}<br />\n\t\t</div>\n\t\t<div class=\"pd-column\">\n\t\t\t<img id=\"contact-avatar\" *ngIf=\"imagePath\" [src]=\"imagePath\" />\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#contact-avatar{height:51px;margin-left:70px;width:52px}#open-in-onvio-btn{margin-bottom:2px;margin-left:95px;margin-top:2px}.pd-row{border-bottom:1px solid rgb(213,212,217);padding-left:5px}.pd-header{background-color:#f4f5f7;border-color:#d5d4d9;border-style:solid;border-width:1px;margin-left:10px;width:270px}.pd-header-text{align-self:center;color:#606169;font-family:Knowledge Bold,Knowledge;font-size:12;font-weight:700;padding:3px 15px 7px;width:100%}.pd-column{float:left;width:50%}.row:after{clear:both;content:\"\";display:table}.avatar-row{min-height:51px;padding-bottom:53px;padding-top:3px}.personal-details{background-color:#fff;border-bottom-color:#d5d4d9;border-bottom-style:solid;border-bottom-width:1px;border-left-color:#d5d4d9;border-left-style:solid;border-left-width:1px;border-right-color:#d5d4d9;border-right-style:solid;border-right-width:1px;box-shadow:2px 2px 10px #00000038;color:#000;font-family:Arial Bold,Arial Regular,Arial;font-size:12px;margin-left:10px;width:270px}\n"], components: [{ type: ContactSelectorComponent, selector: "bdc-contact-selector", inputs: ["contact", "readonly", "showEmailAddressColumn", "showRelationshipColumn", "hideControlBorder", "isValid", "dataSource", "comboLabelText"], outputs: ["contactChange", "dataRequested", "onBlur"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactPersonalDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-contact-info', template: "<div class=\"pd-header\">\n\t<div class=\"pd-header-text\">\n\t\tContact\n\t\t<a>\n\t\t\t<i *ngIf=\"contact\" id=\"open-in-onvio-btn\" class=\"bento-icon-newtab\" type=\"button\" (click)=\"openContactInOnvio()\"></i>\n\t\t</a>\n\t</div>\n</div>\n<div class=\"personal-details\">\n\t<bdc-contact-selector\n\t\t[dataSource]=\"getContactList()\"\n\t\t[contact]=\"contact\"\n\t\tcomboLabelText=\"Contact *\"\n\t\t[showRelationshipColumn]=\"this.showRelationshipColumn\"\n\t\t(contactChange)=\"changeContact($event)\"\n\t\t(dataRequested)=\"onDataRequested($event)\"\n\t>\n\t</bdc-contact-selector>\n\t<div class=\"pd-row avatar-row\" *ngIf=\"!!contactInfoPopulated\">\n\t\t<div class=\"pd-column\">\n\t\t\t<b>Entity Type: </b> {{entityType}}<br />\n\t\t\t<br />\n\t\t\t<b>Nickname:</b> {{nickname}}<br />\n\t\t</div>\n\t\t<div class=\"pd-column\">\n\t\t\t<img id=\"contact-avatar\" *ngIf=\"imagePath\" [src]=\"imagePath\" />\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#contact-avatar{height:51px;margin-left:70px;width:52px}#open-in-onvio-btn{margin-bottom:2px;margin-left:95px;margin-top:2px}.pd-row{border-bottom:1px solid rgb(213,212,217);padding-left:5px}.pd-header{background-color:#f4f5f7;border-color:#d5d4d9;border-style:solid;border-width:1px;margin-left:10px;width:270px}.pd-header-text{align-self:center;color:#606169;font-family:Knowledge Bold,Knowledge;font-size:12;font-weight:700;padding:3px 15px 7px;width:100%}.pd-column{float:left;width:50%}.row:after{clear:both;content:\"\";display:table}.avatar-row{min-height:51px;padding-bottom:53px;padding-top:3px}.personal-details{background-color:#fff;border-bottom-color:#d5d4d9;border-bottom-style:solid;border-bottom-width:1px;border-left-color:#d5d4d9;border-left-style:solid;border-left-width:1px;border-right-color:#d5d4d9;border-right-style:solid;border-right-width:1px;box-shadow:2px 2px 10px #00000038;color:#000;font-family:Arial Bold,Arial Regular,Arial;font-size:12px;margin-left:10px;width:270px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ContactService }, { type: i2$2.DomSanitizer }, { type: i0.ApplicationRef }]; }, propDecorators: { contactSelector: [{
                type: ViewChild,
                args: [ContactSelectorComponent, { static: false }]
            }], contact: [{
                type: Input
            }], showRelationshipColumn: [{
                type: Input
            }], openContactClick: [{
                type: Output
            }], contactChanged: [{
                type: Output
            }] } });

class ContactPersonalDetailsModule {
}
/** @nocollapse */ ContactPersonalDetailsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactPersonalDetailsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ContactPersonalDetailsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactPersonalDetailsModule, declarations: [ContactPersonalDetailsComponent], imports: [CommonModule,
        BentoCheckboxModule,
        BentoComboboxModule,
        FormsModule,
        ContactSelectorModule, i1.TranslateModule], exports: [ContactPersonalDetailsComponent, ContactSelectorComponent] });
/** @nocollapse */ ContactPersonalDetailsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactPersonalDetailsModule, imports: [[
            CommonModule,
            BentoCheckboxModule,
            BentoComboboxModule,
            FormsModule,
            ContactSelectorModule,
            TranslateModule.forChild(),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ContactPersonalDetailsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ContactPersonalDetailsComponent],
                    imports: [
                        CommonModule,
                        BentoCheckboxModule,
                        BentoComboboxModule,
                        FormsModule,
                        ContactSelectorModule,
                        TranslateModule.forChild(),
                    ],
                    exports: [ContactPersonalDetailsComponent, ContactSelectorComponent],
                }]
        }] });

function sameKey(a, b) {
    if (!!a && !!b) {
        // Both defined, compare IDs
        return a.id === b.id;
    }
    if (!a && !b) {
        // Neither defined, same
        return true;
    }
    // One is defined, one isn't
    return false;
}
function navSelectionChanged(prev, next) {
    if (!prev && !next) {
        return false;
    }
    if (!prev || !next) {
        return true;
    }
    return (prev.drawer !== next.drawer ||
        // Only compare clientId if we're going TO a client state
        (next.drawer === FileDrawer.Client && prev.drawerId !== next.drawerId) ||
        !sameKey(prev.container, next.container) ||
        !sameKey(prev.document, next.document));
}
function getDrawerKey(selection) {
    if (selection.drawerId) {
        const type = selection.drawer === FileDrawer.Client ? ItemType.Client : ItemType.Folder;
        return new ContainerKey(selection.drawerId, type);
    }
}
function getContainer(selection) {
    return selection.container || getDrawerKey(selection);
}
function getSelectedItemKey(selection) {
    if (selection.container) {
        if (selection.document) {
            return new ParentedItemKey(selection.document.id, ItemType.Document, selection.container);
        }
        return selection.container;
    }
}

const prefix = 'DMS.components.';
class StorageService {
    // we're going to use the legacy key until all of the grids are moved to angular
    // so they remain in sync
    get itemsPerPageKey() {
        return 'onvio.dms.itemsPerPage';
    }
    setItem(key, value) {
        localStorage.setItem(prefix + key, JSON.stringify(value));
    }
    getItem(key, def = null) {
        const str = localStorage.getItem(prefix + key);
        if (str !== null) {
            return JSON.parse(str);
        }
        return def;
    }
    getBoolean(key, def = false) {
        const value = this.getItem(key);
        return typeof value === 'boolean' ? value : def;
    }
    setItemsPerPage(items) {
        localStorage.setItem(this.itemsPerPageKey, items.toString());
    }
    getItemsPerPage(defaultValue) {
        const items = localStorage.getItem(this.itemsPerPageKey);
        return isNullOrEmpty(items) ? 25 : parseInt(items, 10);
    }
}
/** @nocollapse */ StorageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: StorageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ StorageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: StorageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: StorageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class TreeNavToolbarComponent {
    constructor() {
        this.hasIAC = has;
        this.expandClick = new EventEmitter();
        this.collapseClick = new EventEmitter();
        this.includeFiles = true;
        this.includeFilesChange = new EventEmitter();
        this.showIncludeFiles = false;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.validateIAC();
        });
    }
    expand() {
        this.expandClick.emit();
    }
    collapse() {
        this.collapseClick.emit();
    }
    toggleIncludeFiles() {
        this.includeFiles = !this.includeFiles;
        this.emitIncludeFilesChange();
    }
    emitIncludeFilesChange() {
        this.includeFilesChange.emit(this.includeFiles);
    }
    validateIAC() {
        return __awaiter(this, void 0, void 0, function* () {
            const shouldSuppressLoading = yield this.hasIAC('DMS_SuppressDocumentLoadingInTree');
            this.showIncludeFiles = !shouldSuppressLoading;
            if (shouldSuppressLoading) {
                this.includeFiles = false;
                this.emitIncludeFilesChange();
            }
        });
    }
}
/** @nocollapse */ TreeNavToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TreeNavToolbarComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ TreeNavToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TreeNavToolbarComponent, selector: "bdc-tree-nav-toolbar", inputs: { includeFiles: "includeFiles" }, outputs: { expandClick: "expandClick", collapseClick: "collapseClick", includeFilesChange: "includeFilesChange" }, ngImport: i0, template: "<bento-toolbar class=\"bento-toolbar hide-overflow\" [moreText]=\"'Blue.DocumentComponents.Toolbar.More' | translate\">\n\t<!-- Left -->\n\t<div class=\"navbar-left\">\n\t\t<div class=\"nav navbar-nav\">\n\t\t\t<!-- Expand All button -->\n\t\t\t<div role=\"none\" (click)=\"expand()\">\n\t\t\t\t<button\n\t\t\t\t\tclass=\"bento-icon-expand expand-collapse-button\"\n\t\t\t\t\trole=\"menuitem\"\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tattr.aria-label=\"{{'Blue.DocumentComponents.Toolbar.ExpandAll' | translate}}\"\n\t\t\t\t></button>\n\t\t\t</div>\n\n\t\t\t<!-- Separator slash -->\n\t\t\t<div><span class=\"expand-collapse-separator\">/</span></div>\n\n\t\t\t<!-- Collapse All button-->\n\t\t\t<div role=\"none\" (click)=\"collapse()\">\n\t\t\t\t<button\n\t\t\t\t\tclass=\"bento-icon-collapse expand-collapse-button\"\n\t\t\t\t\trole=\"menuitem\"\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tattr.aria-label=\"{{'Blue.DocumentComponents.Toolbar.CollapseAll' | translate}}\"\n\t\t\t\t></button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Right -->\n\t<div class=\"navbar-right\">\n\t\t<ul class=\"nav navbar-nav\">\n\t\t\t<!-- Include Files checkbox -->\n\t\t\t<li *ngIf=\"showIncludeFiles\" class=\"include-files-button\">\n\t\t\t\t<bento-checkbox\n\t\t\t\t\tclass=\"include-files-checkbox\"\n\t\t\t\t\t[(ngModel)]=\"includeFiles\"\n\t\t\t\t\t(change)=\"emitIncludeFilesChange()\"\n\t\t\t\t\tid=\"include-files\"\n\t\t\t\t\trole=\"checkbox\"\n\t\t\t\t\taria-checked=\"{{includeFiles}}\"\n\t\t\t\t\t(click)=\"toggleIncludeFiles()\"\n\t\t\t\t></bento-checkbox>\n\t\t\t\t&nbsp;\n\t\t\t\t<label class=\"include-files-label\" for=\"include-files\">\n\t\t\t\t\t{{'Blue.DocumentComponents.Toolbar.IncludeFiles' | translate}}\n\t\t\t\t</label>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</bento-toolbar>\n", styles: [":host{display:block;width:100%}.navbar-left{padding-left:10px}.nav.navbar-nav .expand-collapse-button{background:none;border:none;outline:none;padding:0 5px;transform:scale(1.2);transform-origin:top center}.expand-collapse-separator{font-size:21px;position:relative;top:-1px}.bento-icon-expand:focus{box-shadow:none!important;outline:1px dotted #000!important}.bento-icon-collapse:focus{box-shadow:none!important;outline:1px dotted #000!important}.include-files-checkbox{align-self:center;top:-1px}bento-toolbar ul.nav.navbar-nav>li>button{align-items:baseline}bento-toolbar .nav.navbar-nav>div>button{align-items:baseline}.navbar-left ul.nav.navbar-nav{margin-bottom:2px}.include-files-button{position:relative;top:-1px}.bento-toolbar .navbar-right .nav.navbar-nav>li>button{font-size:13px}.bento-toolbar .navbar-right .nav.navbar-nav>li>button>label{margin-bottom:5px}.hide-overflow{max-height:44px;overflow:hidden}\n"], components: [{ type: i2.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["moreText", "items"] }, { type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TreeNavToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-tree-nav-toolbar', template: "<bento-toolbar class=\"bento-toolbar hide-overflow\" [moreText]=\"'Blue.DocumentComponents.Toolbar.More' | translate\">\n\t<!-- Left -->\n\t<div class=\"navbar-left\">\n\t\t<div class=\"nav navbar-nav\">\n\t\t\t<!-- Expand All button -->\n\t\t\t<div role=\"none\" (click)=\"expand()\">\n\t\t\t\t<button\n\t\t\t\t\tclass=\"bento-icon-expand expand-collapse-button\"\n\t\t\t\t\trole=\"menuitem\"\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tattr.aria-label=\"{{'Blue.DocumentComponents.Toolbar.ExpandAll' | translate}}\"\n\t\t\t\t></button>\n\t\t\t</div>\n\n\t\t\t<!-- Separator slash -->\n\t\t\t<div><span class=\"expand-collapse-separator\">/</span></div>\n\n\t\t\t<!-- Collapse All button-->\n\t\t\t<div role=\"none\" (click)=\"collapse()\">\n\t\t\t\t<button\n\t\t\t\t\tclass=\"bento-icon-collapse expand-collapse-button\"\n\t\t\t\t\trole=\"menuitem\"\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\tattr.aria-label=\"{{'Blue.DocumentComponents.Toolbar.CollapseAll' | translate}}\"\n\t\t\t\t></button>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<!-- Right -->\n\t<div class=\"navbar-right\">\n\t\t<ul class=\"nav navbar-nav\">\n\t\t\t<!-- Include Files checkbox -->\n\t\t\t<li *ngIf=\"showIncludeFiles\" class=\"include-files-button\">\n\t\t\t\t<bento-checkbox\n\t\t\t\t\tclass=\"include-files-checkbox\"\n\t\t\t\t\t[(ngModel)]=\"includeFiles\"\n\t\t\t\t\t(change)=\"emitIncludeFilesChange()\"\n\t\t\t\t\tid=\"include-files\"\n\t\t\t\t\trole=\"checkbox\"\n\t\t\t\t\taria-checked=\"{{includeFiles}}\"\n\t\t\t\t\t(click)=\"toggleIncludeFiles()\"\n\t\t\t\t></bento-checkbox>\n\t\t\t\t&nbsp;\n\t\t\t\t<label class=\"include-files-label\" for=\"include-files\">\n\t\t\t\t\t{{'Blue.DocumentComponents.Toolbar.IncludeFiles' | translate}}\n\t\t\t\t</label>\n\t\t\t</li>\n\t\t</ul>\n\t</div>\n</bento-toolbar>\n", styles: [":host{display:block;width:100%}.navbar-left{padding-left:10px}.nav.navbar-nav .expand-collapse-button{background:none;border:none;outline:none;padding:0 5px;transform:scale(1.2);transform-origin:top center}.expand-collapse-separator{font-size:21px;position:relative;top:-1px}.bento-icon-expand:focus{box-shadow:none!important;outline:1px dotted #000!important}.bento-icon-collapse:focus{box-shadow:none!important;outline:1px dotted #000!important}.include-files-checkbox{align-self:center;top:-1px}bento-toolbar ul.nav.navbar-nav>li>button{align-items:baseline}bento-toolbar .nav.navbar-nav>div>button{align-items:baseline}.navbar-left ul.nav.navbar-nav{margin-bottom:2px}.include-files-button{position:relative;top:-1px}.bento-toolbar .navbar-right .nav.navbar-nav>li>button{font-size:13px}.bento-toolbar .navbar-right .nav.navbar-nav>li>button>label{margin-bottom:5px}.hide-overflow{max-height:44px;overflow:hidden}\n"] }]
        }], propDecorators: { expandClick: [{
                type: Output
            }], collapseClick: [{
                type: Output
            }], includeFiles: [{
                type: Input
            }], includeFilesChange: [{
                type: Output
            }] } });

const defaultColor = '#212121';

/* spell-checker: disable */
const applicationTypeIdToIcon = {
    ARGROSSINCOMETAX: IconType.GrossIncomeTaxApp,
    ARINVESTMENTACCOUNTS: IconType.InvestmentAccountsApp,
    ARTAXAMNESTY: IconType.TaxAmnestyApp,
    AUACTIVITYSTATEMENTS: IconType.ActivityStatementsApp,
    AUTAX: IconType.TaxApp,
    CATAX: IconType.TaxApp,
    CHECKPOINTENGAGE: IconType.CheckpointEngageApp,
    GPTP: IconType.TaxApp,
    NONE: IconType.NoApp,
    ONVIOACCOUNTS: IconType.AccountingApp,
    TRIALBALANCE: IconType.TrialBalanceApp,
    UKCOMPANYFORMATIONS: IconType.CompanyFormationsApp,
    UKSECRETARIAL: IconType.SecretarialApp,
    UKTAX: IconType.TaxApp,
    UKVAT: IconType.TaxApp,
    ULTRATAX: IconType.UltraTaxApp,
    USADVISORYTOOLS: IconType.AdvisoryApp,
    USFIXEDASSETS: IconType.FixedAssetsApp,
    USTAX: IconType.TaxApp,
    WORKPAPERS: IconType.WorkpapersApp,
};
/* spell-checker: enable */
function getAppIcon(applicationTypeId) {
    const icon = applicationTypeId && applicationTypeIdToIcon[applicationTypeId];
    return icon || IconType.NoApp;
}

const itemTypeIcons = {
    file: { name: IconType.File, color: defaultColor },
    folder: { name: IconType.Folder, color: defaultColor },
    folderFilled: { name: IconType.FolderFilled, color: defaultColor },
    word: { name: IconType.FileWord, color: '#1472C2' },
    excel: { name: IconType.FileExcel, color: '#397C2B' },
    pdf: { name: IconType.FilePdf, color: '#ff0000' },
    image: { name: IconType.FileImage, color: '#621F95' },
    link: { name: IconType.ExternalLink, color: defaultColor },
    checkpoint: { name: IconType.CheckpointEngage, color: defaultColor },
    folderGlobeShare: { name: IconType.FolderGlobeShare, color: defaultColor },
    folderGlobe: { name: IconType.FolderGlobe, color: defaultColor },
    calendar: { name: IconType.Calendar, color: defaultColor },
    share: { name: IconType.Share, color: defaultColor },
    powerPoint: { name: IconType.filePowerPoint, color: '#B7472A' },
};
/* spell-checker: disable */
const mimeTypeToIcon = {
    'application/pdf': itemTypeIcons.pdf,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': itemTypeIcons.word,
    'application/vnd.ms-word.document.macroEnabled.12': itemTypeIcons.word,
    'application/msword': itemTypeIcons.word,
    'application/vnd.ms-word.template.macroEnabled.12': itemTypeIcons.word,
    'application/vnd.openxmlformats-officedocument.wordprocessingml.template': itemTypeIcons.word,
    'application/vnd.oasis.opendocument.text': itemTypeIcons.word,
    'application/rtf': itemTypeIcons.word,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': itemTypeIcons.excel,
    'application/vnd.oasis.opendocument.spreadsheet': itemTypeIcons.excel,
    'application/vnd.ms-excel.sheet.binary.macroEnabled.12': itemTypeIcons.excel,
    'application/vnd.ms-excel': itemTypeIcons.excel,
    'application/vnd.ms-excel.sheet.macroEnabled.12': itemTypeIcons.excel,
    'application/vnd.openxmlformats-officedocument.spreadsheetml.template': itemTypeIcons.excel,
    'text/csv': itemTypeIcons.excel,
    'image/bmp': itemTypeIcons.image,
    'image/png': itemTypeIcons.image,
    'image/gif': itemTypeIcons.image,
    'image/x-icon': itemTypeIcons.image,
    'image/pjpeg': itemTypeIcons.image,
    'image/jpeg': itemTypeIcons.image,
    'image/x-portable-bitmap': itemTypeIcons.image,
    'image/x-portable-graymap': itemTypeIcons.image,
    'image/x-portable-pixmap': itemTypeIcons.image,
    'image/x-cmu-raster': itemTypeIcons.image,
    'image/tiff': itemTypeIcons.image,
    'application/x-msmetafile': itemTypeIcons.image,
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': itemTypeIcons.powerPoint,
};
/* spell-checker: enable */
const fileExtensionToIcon = {
    jif: itemTypeIcons.image,
    pcd: itemTypeIcons.image,
    pcx: itemTypeIcons.image,
    tga: itemTypeIcons.image,
};
function getIconByMimeType(mimeType) {
    return mimeTypeToIcon[mimeType] || null;
}
function getIconByExtension(name) {
    const extension = name.substring(name.lastIndexOf('.') + 1);
    return fileExtensionToIcon[extension] || null;
}
function containerIcon(item, hasChildren) {
    // Default language is not testable
    /* istanbul ignore next */
    if (countryDefaultLang === countryDefaultLangMap.br && item.customFields && item.customFields.get('templateId')) {
        return itemTypeIcons.folderGlobe;
    }
    return hasChildren ? itemTypeIcons.folderFilled : itemTypeIcons.folder;
}
function linkIcon(item) {
    return item.linkType === LinkType.CheckpointEngage ? itemTypeIcons.checkpoint : itemTypeIcons.link;
}
function appIcon(item) {
    return {
        name: getAppIcon(item.application),
    };
}
function shareIcon() {
    return itemTypeIcons.share;
}
function getItemTypeIcon(item, hasChildren) {
    if (item.type === ItemType.AppGroup) {
        return appIcon(item);
    }
    if (isContainer(item)) {
        return containerIcon(item, hasChildren);
    }
    if (isLink(item)) {
        return linkIcon(item);
    }
    const doc = item;
    return getIconByMimeType(doc.mimeType) || getIconByExtension(doc.name) || itemTypeIcons.file;
}

/**
 * Combines sort functions, sorting in the given order.
 *
 * Sorters will be applied in order, meaning that the first has the least precedence
 * because it is overridden by later sorts. (This is consistent with programs like Excel.)
 *
 * Ex:
 * ```js
 * array.sort(collate([
 * 	alphabeticalByName,
 * 	rankAscending,
 * ])) === [
 * 	{name: 'aa', rank: 1},
 * 	{name: 'zz', rank: 1},
 * 	{name: 'aa', rank: 2},
 * 	{name: 'zz', rank: 2},
 * ];
 * ```
 *
 * @param sorters array of comparison functions, from lowest to highest priority
 */
function collate(sorters) {
    return (a, b) => {
        const finalResult = sorters.reduceRight((result, sorter) => {
            return result || sorter(a, b);
        }, 0);
        return finalResult || 0;
    };
}
/**
 * Creates a sort comparator using a boolean predicate.
 * Basically, if `test(item)` returns true, it will be sorted to the top.
 *
 * Example:
 * ```js
 * const betterSort = sortFirst(el => el.top);
 * const array = [{top: false}, {top: true}, {top: false}];
 *
 * array.sort(betterSort) === [{top: true}, {top: false}, {top: false}];
 * ```
 *
 * @param test predicate function
 */
function sortFirst(test) {
    return (a, b) => {
        const aFirst = test(a);
        const bFirst = test(b);
        // We only care if one should be first and the other shouldn't, thus `!==`
        if (aFirst !== bFirst) {
            // If a should precede b, return -1. If b should precede a, return +1
            return aFirst ? -1 : 1;
        }
        // These are the same as far as we're concerned.
        return 0;
    };
}

const statusIcons = {
    share: { name: IconType.Share, color: defaultColor },
    lock: { name: IconType.Lock, color: defaultColor },
    openInTab: { name: IconType.ExternalLink, color: defaultColor },
};
function getStatusIcons(item, parentItem) {
    const icons = [];
    if (isLink(item)) {
        icons.push(statusIcons.openInTab);
    }
    if (((item.type === ItemType.Folder || item.type === ItemType.Project) && item.isShared) ||
        (item.type === ItemType.Document && parentItem && parentItem.isShared)) {
        icons.push(statusIcons.share);
    }
    if (item.lock) {
        icons.push(statusIcons.lock);
    }
    return icons;
}

/* spell-checker: disable */
const applicationTypeIdToNameKey = {
    ARGROSSINCOMETAX: marker('Blue.DocumentComponents.AppName.ARGrossIncomeTax'),
    ARINVESTMENTACCOUNTS: marker('Blue.DocumentComponents.AppName.ARInvestmentAccounts'),
    ARTAXAMNESTY: marker('Blue.DocumentComponents.AppName.ARTaxAmnesty'),
    AUACTIVITYSTATEMENTS: marker('Blue.DocumentComponents.AppName.AUActivityStatements'),
    AUTAX: marker('Blue.DocumentComponents.AppName.AUTax'),
    CATAX: marker('Blue.DocumentComponents.AppName.CATax'),
    CHECKPOINTENGAGE: marker('Blue.DocumentComponents.AppName.CheckpointEngage'),
    GPTP: marker('Blue.DocumentComponents.AppName.GPTP'),
    NONE: marker('Blue.DocumentComponents.AppName.None'),
    ONVIOACCOUNTS: marker('Blue.DocumentComponents.AppName.OnvioAccounts'),
    TRIALBALANCE: marker('Blue.DocumentComponents.AppName.TrialBalance'),
    UKCOMPANYFORMATIONS: marker('Blue.DocumentComponents.AppName.UKCompanyFormations'),
    UKSECRETARIAL: marker('Blue.DocumentComponents.AppName.UKSecretarial'),
    UKTAX: marker('Blue.DocumentComponents.AppName.UKTax'),
    UKVAT: marker('Blue.DocumentComponents.AppName.UKVAT'),
    ULTRATAX: marker('Blue.DocumentComponents.AppName.UltraTax'),
    USADVISORYTOOLS: marker('Blue.DocumentComponents.AppName.USAdvisoryTools'),
    USFIXEDASSETS: marker('Blue.DocumentComponents.AppName.USFixedAssets'),
    USTAX: marker('Blue.DocumentComponents.AppName.USTax'),
    WORKPAPERS: marker('Blue.DocumentComponents.AppName.Workpapers'),
};
class OnvioAppNameService {
    constructor(translate) {
        this.translate = translate;
    }
    getName(appId) {
        const name = appId && applicationTypeIdToNameKey[appId];
        if (appId && !name) {
            console.warn('Unexpected application type ID: ' + appId);
        }
        return name || '';
    }
    getTranslatedName(appId) {
        return (appId && this.translate.instant(this.getName(appId))) || '';
    }
}
/** @nocollapse */ OnvioAppNameService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OnvioAppNameService, deps: [{ token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ OnvioAppNameService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OnvioAppNameService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OnvioAppNameService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }]; } });

class ItemDisplayNameService {
    constructor(onvioAppName, translateService) {
        this.onvioAppName = onvioAppName;
        this.translateService = translateService;
    }
    get(item) {
        if (item.type === ItemType.AppGroup) {
            return this.onvioAppName.getTranslatedName(item.application);
        }
        if (item.type === ItemType.YearGroup) {
            return String(item.year);
        }
        if ('year' in item && !!item.year) {
            return `${item.name} (${item.year})`;
        }
        if (item.name === '|firmdocuments|') {
            return this.translateService.instant('Blue.DocumentComponents.SpecialFolders.FirmDocuments');
        }
        if (item.name === '|mydocuments|') {
            return this.translateService.instant('Blue.DocumentComponents.SpecialFolders.MyDocuments');
        }
        return item.name;
    }
}
/** @nocollapse */ ItemDisplayNameService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDisplayNameService, deps: [{ token: OnvioAppNameService }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ ItemDisplayNameService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDisplayNameService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDisplayNameService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: OnvioAppNameService }, { type: i1.TranslateService }]; } });

function isRootFolder(item) {
    return 'rootType' in item;
}
function addRootItemToTree(tree, item) {
    const rootNode = new TreeNode(item, tree.children, LoadingState.loaded);
    return new TreeRoot([rootNode], LoadingState.loaded);
}
function nodeIsVirtualFolder(node) {
    return node.item.isVirtualFolder;
}
function nodeIsContainer(node) {
    return node.item.isContainer;
}
class DocumentTreeService {
    constructor(clientStore, itemStore, translate, treeStore, itemName) {
        this.clientStore = clientStore;
        this.itemStore = itemStore;
        this.translate = translate;
        this.treeStore = treeStore;
        this.itemName = itemName;
        // Used for 'natural' sort
        this.naturalSort = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        this.sortWithYearGrouping = (a, b) => {
            if ((a.item.type !== 'YEAR_GROUP' && b.item.type === 'YEAR_GROUP') ||
                (b.item.type !== 'YEAR_GROUP' && a.item.type === 'YEAR_GROUP')) {
                if (a.item.type === 'YEAR_GROUP') {
                    return 1;
                }
                if (b.item.type === 'YEAR_GROUP') {
                    return -1;
                }
            }
            if (a.item.type === 'YEAR_GROUP' && b.item.type === 'YEAR_GROUP') {
                return this.naturalSort.compare(a.item.name, b.item.name) * -1;
            }
            return this.naturalSort.compare(a.item.name, b.item.name);
        };
        this.sorter = (sortOrder, customSort) => {
            const order = sortOrder && sortOrder === 'desc' ? -1 : 1;
            const selectedSort = customSort ||
                ((a, b) => {
                    const yearA = a.item.year || 0;
                    const yearB = b.item.year || 0;
                    return this.naturalSort.compare(a.item.name, b.item.name) * order || yearB - yearA;
                });
            // Sort order is in order, so the last sort has highest priority
            // Virtual folders will be at the top, then other containers, then alphabetical
            return collate([selectedSort, sortFirst(nodeIsContainer), sortFirst(nodeIsVirtualFolder)]);
        };
    }
    observeTree(rootKey, showFiles, showRoot, groupBy, root$) {
        const tree$ = this.treeStore.observeTree(rootKey, {
            includeFiles: showFiles,
            grouping: groupBy && { groupBy },
        });
        // BDS observables are slightly incompatible for some reason. `from` smooths that out.
        return showRoot && root$ ? this.addRootToTree(tree$, root$) : from(tree$);
    }
    bdsTreeRootToUiTreeItems(root, showFiles, getHref, canBeSelected, groupBy) {
        const sortedTree = root.children.sort(this.sortByGroup(groupBy).bind(this));
        return sortedTree.map(node => this.bdsTreeNodeToUiTreeItem(node, showFiles, getHref, undefined, canBeSelected, groupBy));
    }
    sortByGroup(groupBy, sortingSubFolders) {
        if (groupBy === ProjectGroupBy.Year) {
            return this.sorter('desc', this.sortWithYearGrouping);
        }
        if (groupBy === ProjectGroupBy.AppThenYear) {
            if (sortingSubFolders)
                return this.sorter('desc', this.sortWithYearGrouping);
            return this.sorter();
        }
        if (groupBy === ProjectGroupBy.YearThenApp) {
            return this.sorter('desc', this.sortWithYearGrouping);
        }
        return this.sorter();
    }
    bdsTreeNodeToUiTreeItem(node, showFiles, getHref, parentNode, canBeSelected, groupBy) {
        const item = node.item;
        const subItems = this.getSubItems(node, showFiles, undefined, canBeSelected, groupBy);
        const parent = parentNode && parentNode.item;
        const href = getHref ? getHref(item) : undefined;
        const allowSelect = canBeSelected ? canBeSelected(item) : true;
        const id = keyToString(item);
        const hasChildren = isContainer(item) && item.hasChildren;
        return {
            id,
            name: this.itemName.get(item),
            subItems,
            leftIcon: [getItemTypeIcon(item, hasChildren)],
            rightIcon: getStatusIcons(item, parent),
            href,
            showCheckBox: false,
            allowSelect: allowSelect,
            allowItemDrag: false,
            allowDropInto: false,
        };
    }
    getDocItemsFromTreeItems(treeItems) {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = treeItems.map((item) => __awaiter(this, void 0, void 0, function* () { return this.treeItemToDocItem(item); }));
            return Promise.all(promises);
        });
    }
    treeItemToDocItem(item) {
        return __awaiter(this, void 0, void 0, function* () {
            const key = stringToKey(item.id);
            if (key.type === ItemType.AppGroup || key.type === ItemType.YearGroup) {
                return projectGroupKeyToContainer(key);
            }
            const item$ = this.itemStore.observeItem(key);
            return item$.pipe(first()).toPromise();
        });
    }
    observeAndUpdateRootItem(key) {
        if (key.type === ItemType.Client) {
            return from(getCompanyId()).pipe(mergeMap(companyId => {
                return this.clientStore.observeClient(companyId, key);
            }));
        }
        this.treeStore.updateAncestry(key);
        // `flatMap` turns Observable<Observable<Foo>> into Observable<Foo>
        return from(this.itemStore.observeItem(key)).pipe(mergeMap(item => {
            if (isRootFolder(item)) {
                return this.renameRootFolder(item);
            }
            return of(item);
        }));
    }
    treeIsEmpty(tree) {
        return !!tree && tree.state === LoadingState.loaded && tree.children.length < 1;
    }
    loadTree(key, includeFiles, depth) {
        return __awaiter(this, void 0, void 0, function* () {
            const container = isVirtualFolder(key) ? extractClient(key) : key;
            return this.treeStore.updateChildren(container, { includeFiles }, depth);
        });
    }
    loadAncestors(key, groupBy) {
        return __awaiter(this, void 0, void 0, function* () {
            const container = isContainerKey(key) ? key : key.parent;
            const ancestorsUpdatePromise = !isVirtualFolder(container)
                ? this.treeStore.updateAncestry(container)
                : Promise.resolve();
            return from(ancestorsUpdatePromise)
                .pipe(mergeMap(() => this.treeStore.observeAncestry(container, groupBy)), first())
                .toPromise();
        });
    }
    loadChildrenOf(containers, includeFiles) {
        return __awaiter(this, void 0, void 0, function* () {
            containers.forEach(container => {
                if (!isVirtualFolder(container)) {
                    this.treeStore.updateChildren(container, { includeFiles }, 1);
                }
            });
        });
    }
    addRootToTree(tree$, item$) {
        // combineLatest is kind of like Promise.all but it can resolve multiple times
        const combined$ = combineLatest([tree$, item$]);
        // Build a new tree with root item at the root
        return combined$.pipe(map(([tree, root]) => addRootItemToTree(tree, root)));
    }
    getSubItems(node, showFiles, getHref, canBeSelected, groupBy) {
        if (!isContainer(node.item)) {
            return [];
        }
        const sortingSubItems = true;
        const nodeChildren = node.children.sort(this.sortByGroup(groupBy, sortingSubItems).bind(this));
        const children = nodeChildren.map(child => this.bdsTreeNodeToUiTreeItem(child, showFiles, getHref, node, canBeSelected));
        const isLoading = node.state !== LoadingState.loaded;
        if (node.item.hasChildren && isLoading) {
            children.push(this.loadingItem(node.item.id));
        }
        return children;
    }
    renameRootFolder(item) {
        const nameKey = item.rootType === RootFolderType.FirmDocuments
            ? 'Blue.DocumentComponents.DrawerTabs.Firm'
            : 'Blue.DocumentComponents.DrawerTabs.My';
        return this.translate.get(nameKey).pipe(map(name => (Object.assign(Object.assign({}, item), { name }))));
    }
    loadingItem(id) {
        return {
            id: `${id}#loading`,
            name: this.translate.instant('Blue.DocumentComponents.Tree.FolderLoading'),
            allowSelect: false,
            allowDropInto: false,
            allowItemDrag: false,
        };
    }
}
/** @nocollapse */ DocumentTreeService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeService, deps: [{ token: i1$1.ClientStore }, { token: i1$1.ItemStore }, { token: i1.TranslateService }, { token: i1$1.TreeStore }, { token: ItemDisplayNameService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ DocumentTreeService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ClientStore }, { type: i1$1.ItemStore }, { type: i1.TranslateService }, { type: i1$1.TreeStore }, { type: ItemDisplayNameService }]; } });

class DocumentTreeComponent {
    constructor(element, documentTreeService) {
        this.element = element;
        this.documentTreeService = documentTreeService;
        this.initialLoadDepth = 2;
        this.expandNodeLoadDepth = 3;
        this.hasIAC = has;
        this.enableChildCalls = false;
        this.selected = [];
        this.selectedChange = new EventEmitter();
        this.loading = new EventEmitter();
        this.showFiles = false;
        this.showRoot = false;
        this.groupProjectsBy = ProjectGroupBy.None;
        this.store = new TreeStore(false);
        this.treeIsEmpty = false;
        // Initialized so we don't have to check if its defined
        this.treeSubscription = new Subscription();
        // These sets keep track of things that should open opened to or selected
        // but haven't appeared in the tree yet. These should be removed after ui-tree is updated
        // to track the state of unknown items.
        this.toOpenTo = new Set();
        this.toSelect = new Set();
        registerTree();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.enableChildCalls = yield has('DMS_EnableChildrenCalls').catch(() => false);
            if (!this.enableChildCalls) {
                this.initialLoadDepth = 1;
                this.expandNodeLoadDepth = 1;
            }
        });
    }
    ngOnChanges(changes) {
        if (this.root && (!this.rootObservable$ || this.rootChanged(changes.root))) {
            // There's little or no cost to creating the observable if it isn't used,
            // so we create it whether showRoot is true or not.
            this.rootObservable$ = this.documentTreeService.observeAndUpdateRootItem(this.root);
        }
        if (this.rootChanged(changes.root)) {
            // Clear existing tree
            this.store.setStore([]);
            this.buildTree();
        }
        else if (changes.showFiles || changes.showRoot || changes.groupProjectsBy) {
            this.buildTree();
        }
        if (changes.selected) {
            this.selectItems(changes.selected.currentValue);
        }
    }
    ngAfterViewInit() {
        this.element.nativeElement.querySelector('bm-tree').style.setProperty('--bm-tree-item-font-size', '13px');
    }
    openTo(key) {
        return __awaiter(this, void 0, void 0, function* () {
            const found = this.store.set(keyToString(key), { visible: true });
            if (!found) {
                const ancestors = yield this.documentTreeService.loadAncestors(key, this.groupProjectsBy);
                this.documentTreeService.loadChildrenOf(ancestors, this.showFiles);
                ancestors.forEach(ancestor => this.toOpenTo.add(keyToString(ancestor)));
                this.toOpenTo.add(keyToString(key));
                this.tryToOpenItems();
            }
        });
    }
    tryToOpenItems() {
        for (const keyString of this.toOpenTo) {
            const found = this.store.set(keyString, { visible: true });
            if (found) {
                const node = this.store.get(keyString);
                // Attempt to open any ancestors already in the tree
                node.ancestors.forEach(ancestor => this.store.set(ancestor, { visible: true }));
                this.toOpenTo.delete(keyString);
            }
        }
    }
    expandAll() {
        const unexpanded = this.store
            .getAll()
            // remove "Loading..." placeholder items
            .filter(treeItem => !treeItem.id.match(/#loading$/))
            .filter(treeItem => !treeItem.expanded)
            .map(item => stringToKey(item.id))
            .filter(isContainerKey$1);
        this.documentTreeService.loadChildrenOf(unexpanded, this.showFiles);
        this.store.setAll({ visible: true });
    }
    collapseAll() {
        this.store.setAll({ visible: false });
    }
    /**
     * Event handler hit when a user selects an item in the tree without hitting the + button
     * If the item selected is a folder or project, we will load two levels beneath it
     *
     * @param event emitted by tree when user expands a node
     */
    itemSelected(event) {
        return __awaiter(this, void 0, void 0, function* () {
            const items = yield this.documentTreeService.getDocItemsFromTreeItems(event.detail);
            yield this.loadTree(event.detail[0].id);
            this.selectedChange.emit(items);
            this.restoreFocus(event.detail[0].id);
        });
    }
    ngOnDestroy() {
        if (this.treeSubscription) {
            this.treeSubscription.unsubscribe();
        }
    }
    /**
     * Event handler for expanding the a node in the tree
     * This happens when a user clicks the + button in the tree
     * Triggers loading the rest of the children of that item
     *
     * @param event emitted by tree when user expands a node
     */
    onItemExpanded(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (event.detail.expanded) {
                yield this.loadTree(event.detail.treeItem.id);
                this.restoreFocus(event.detail.treeItem.id);
            }
        });
    }
    restoreFocus(id) {
        if (this.root) {
            const tree = this.documentTreeService.observeTree(this.root, this.showFiles, this.showRoot, this.groupProjectsBy, this.rootObservable$);
            tree.subscribe((node) => {
                var _a, _b;
                if (node.state === LoadingState.loaded) {
                    if (id) {
                        const treeItem = (_b = (_a = document.getElementsByTagName('bm-tree')[0]) === null || _a === void 0 ? void 0 : _a.shadowRoot) === null || _b === void 0 ? void 0 : _b.getElementById(id);
                        if (treeItem) {
                            treeItem.focus();
                        }
                    }
                }
            });
        }
    }
    loadTree(id) {
        return __awaiter(this, void 0, void 0, function* () {
            // If the item selected is a folder, let's load two levels deep from the given node
            const key = stringToKey(id);
            if (key.type === ItemType.Project || key.type === ItemType.Folder) {
                yield this.documentTreeService.loadTree(key, this.showFiles, this.expandNodeLoadDepth);
            }
        });
    }
    selectItems(keys) {
        this.deselectItems();
        if (keys && keys.length) {
            keys.forEach(key => this.selectItem(key));
            this.tryToSelectItems();
        }
    }
    selectItem(key) {
        this.openTo(key);
        this.toSelect.add(keyToString(key));
        if (isContainerKey$1(key)) {
            this.documentTreeService.loadTree(key, this.showFiles, this.expandNodeLoadDepth);
        }
    }
    deselectItems() {
        this.toSelect = new Set();
        this.store.setAll({ selected: false });
    }
    tryToSelectItems() {
        for (const keyString of this.toSelect) {
            const found = this.store.set(keyString, { selected: true });
            if (found) {
                this.toSelect.delete(keyString);
            }
            else if (keyString.includes(ItemType.Folder)) {
                const replacedString = keyString.replace(ItemType.Folder, ItemType.Project);
                const projectFound = this.store.set(replacedString, { selected: true });
                if (projectFound) {
                    this.toSelect.delete(keyString);
                }
            }
        }
    }
    rootChanged(root) {
        // no root change given
        if (!root) {
            return false;
            // There wasn't a root and now there is or vice-versa
        }
        if (!!root.currentValue !== !!root.previousValue) {
            return true;
            // There was and is a root but the ID changed
        }
        if (root.currentValue && root.previousValue) {
            return root.currentValue.id !== root.previousValue.id;
        }
        return false;
    }
    buildTree() {
        if (!this.root) {
            return;
        }
        this.loading.emit(true);
        this.treeSubscription.unsubscribe();
        const tree$ = this.documentTreeService.observeTree(this.root, this.showFiles, this.showRoot, this.groupProjectsBy, this.rootObservable$);
        this.treeSubscription = tree$.subscribe((tree) => __awaiter(this, void 0, void 0, function* () { return this.setTree(tree); }));
        // Start initial shallow update (only two levels deep)
        this.documentTreeService.loadTree(this.root, this.showFiles, this.initialLoadDepth);
    }
    setTree(tree) {
        return __awaiter(this, void 0, void 0, function* () {
            this.treeIsEmpty = this.documentTreeService.treeIsEmpty(tree);
            const uiTree = this.documentTreeService.bdsTreeRootToUiTreeItems(tree, this.showFiles, this.getHref, this.canBeSelected, this.groupProjectsBy);
            this.store.setStore(uiTree);
            if (this.showRoot) {
                // Expand the root
                this.store.set(keyToString(this.root), { expanded: true });
            }
            this.tryToOpenItems();
            this.tryToSelectItems();
            this.loading.emit(false);
        });
    }
}
/** @nocollapse */ DocumentTreeComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeComponent, deps: [{ token: i0.ElementRef }, { token: DocumentTreeService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentTreeComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentTreeComponent, selector: "bdc-document-tree", inputs: { selected: "selected", treeEmptyMessage: "treeEmptyMessage", root: "root", drawer: "drawer", showFiles: "showFiles", showRoot: "showRoot", groupProjectsBy: "groupProjectsBy", getHref: "getHref", canBeSelected: "canBeSelected" }, outputs: { selectedChange: "selectedChange", loading: "loading" }, usesOnChanges: true, ngImport: i0, template: "<bm-tree [store]=\"store\" (select)=\"itemSelected($event)\" (expand)=\"onItemExpanded($event)\"></bm-tree>\n<div *ngIf=\"treeIsEmpty\" class=\"treeIsEmpty\">\n\t{{treeEmptyMessage || ('Blue.DocumentComponents.DocumentTree.Empty' | translate)}}\n</div>\n", styles: ["bm-tree{display:inline-block}.treeIsEmpty{text-align:center}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-tree', template: "<bm-tree [store]=\"store\" (select)=\"itemSelected($event)\" (expand)=\"onItemExpanded($event)\"></bm-tree>\n<div *ngIf=\"treeIsEmpty\" class=\"treeIsEmpty\">\n\t{{treeEmptyMessage || ('Blue.DocumentComponents.DocumentTree.Empty' | translate)}}\n</div>\n", styles: ["bm-tree{display:inline-block}.treeIsEmpty{text-align:center}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: DocumentTreeService }]; }, propDecorators: { selected: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], loading: [{
                type: Output
            }], treeEmptyMessage: [{
                type: Input
            }], root: [{
                type: Input
            }], drawer: [{
                type: Input
            }], showFiles: [{
                type: Input
            }], showRoot: [{
                type: Input
            }], groupProjectsBy: [{
                type: Input
            }], getHref: [{
                type: Input
            }], canBeSelected: [{
                type: Input
            }] } });

const DEFAULT_PANEL_ID = 'doc-tree-pane';
class DocumentTreePaneComponent {
    constructor(clientStore, storage) {
        this.clientStore = clientStore;
        this.storage = storage;
        this.clientSubscription = new Subscription();
        this.groupProjectsBy = ProjectGroupBy.None;
        this.selectedChange = new EventEmitter();
        /** This attribute will be set in ngOnInit function based on an IAC */
        this._showFiles = true;
        this.showFilesDefault = true;
        /** Should show tree only when the IAC is loaded */
        this.showTree = false;
        this.drawerName = '';
        this.panelId = DEFAULT_PANEL_ID;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            has('DMS_SuppressDocumentLoadingInTree')
                .then(hideFiles => (this.showFilesDefault = !hideFiles))
                .finally(() => (this.showTree = true));
        });
    }
    ngOnChanges(changes) {
        if (changes.selected && changes.selected.currentValue) {
            const selected = changes.selected.currentValue;
            this.onSelectedChange(selected);
        }
    }
    ngOnDestroy() {
        this.clientSubscription.unsubscribe();
    }
    get showFiles() {
        return this._showFiles;
    }
    set showFiles(show) {
        this.storage.setItem(this.showFilesStorageKey(), show);
        this._showFiles = show;
    }
    emptyTreeText() {
        return this.isClientSelected() ? marker('Blue.DocumentComponents.DocumentTree.EmptyClient') : '';
    }
    // Maps the event sent from the tree and
    // propagates the new selection to the parent component
    treeNodeSelected(items) {
        if (!items || items.length <= 0) {
            return;
        }
        const item = items[0];
        if (!item) {
            return;
        }
        if (isLink(item)) {
            this.openLinkInNewTab(item);
        }
        else {
            const selected = this.itemToSelection(item);
            // notify parent that a selection was made
            this.selectedChange.emit(selected);
        }
    }
    /** @returns a function that can generate a URL for a given tree item. */
    createGetHref() {
        return (item) => {
            return this.getHref ? this.getHref(item) : undefined;
        };
    }
    clientAccordionToggled(event) {
        if (event.panelId) {
            this.selectedChange.emit({
                drawer: this.selected.drawer,
                drawerId: event.panelId !== DEFAULT_PANEL_ID ? this.panelIdToDrawerId(event.panelId) : undefined,
            });
        }
        // Prevent collapse
        // TODO: remove when there's more than one client
        if (!event.nextState) {
            event.preventDefault();
        }
    }
    showFilesStorageKey() {
        return 'Tree.ShowFiles.DrawerId:' + (this.selected ? this.selected.drawerId : 'unknown');
    }
    isClientSelected() {
        return !!this.selected && this.selected.drawer === FileDrawer.Client;
    }
    subscribeClient(key) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.client || this.client.id !== key.id) {
                this.clientSubscription.unsubscribe();
                const companyId = yield getCompanyId();
                this.clientSubscription = this.clientStore.observeClient(companyId, key).subscribe(client => {
                    this.client = client;
                    this.drawerName = client.name;
                });
            }
        });
    }
    itemToSelection(item) {
        if (!this.selected) {
            throw new Error('Item selected without known client?');
        }
        const isDocument = item.type === ItemType.Document;
        const container = isDocument ? item.parent : item;
        return {
            drawer: this.selected.drawer,
            drawerId: this.selected.drawerId,
            container: container,
            document: isDocument ? item : undefined,
        };
    }
    openLinkInNewTab(link) {
        window.open(link.url, '_blank');
    }
    onSelectedChange(selection) {
        if (!selection || !selection.drawerId) {
            this.panelId = DEFAULT_PANEL_ID;
            // No client or root folder selected
            if (this.accordion) {
                this.accordion.collapse(this.panelId);
            }
            return;
        }
        const isClient = selection.drawer === FileDrawer.Client;
        this.rootKey = new ContainerKey(selection.drawerId, isClient ? ItemType.Client : ItemType.Folder);
        this.panelId = this.drawerIdToPanelId(selection.drawerId);
        if (isClient) {
            this.subscribeClient(this.rootKey);
        }
        else {
            this.drawerName =
                selection.drawer === FileDrawer.Firm
                    ? marker('Blue.DocumentComponents.SpecialFolders.FirmDocuments')
                    : marker('Blue.DocumentComponents.SpecialFolders.MyDocuments');
        }
        // If the "client" is selected, we actually want to "select" nothing
        this.selectedItem = getSelectedItemKey(selection);
        this.showFiles = this.storage.getBoolean(this.showFilesStorageKey(), this.showFilesDefault);
        if (this.accordion) {
            this.accordion.expand(this.panelId);
        }
    }
    panelIdToDrawerId(panelId) {
        return `${panelId.slice(5)}`;
    }
    drawerIdToPanelId(drawerId) {
        return `pane-${drawerId}`;
    }
}
/** @nocollapse */ DocumentTreePaneComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreePaneComponent, deps: [{ token: i1$1.ClientStore }, { token: StorageService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentTreePaneComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentTreePaneComponent, selector: "bdc-document-tree-pane", inputs: { selected: "selected", getHref: "getHref", groupProjectsBy: "groupProjectsBy" }, outputs: { selectedChange: "selectedChange" }, viewQueries: [{ propertyName: "tree", first: true, predicate: ["tree"], descendants: true }, { propertyName: "accordion", first: true, predicate: NgbAccordion, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<!-- Toolbar -->\n<bdc-tree-nav-toolbar\n\t(expandClick)=\"tree!.expandAll()\"\n\t(collapseClick)=\"tree!.collapseAll()\"\n\t(includeFilesChange)=\"showFiles = $event\"\n\t[includeFiles]=\"showFiles\"\n></bdc-tree-nav-toolbar>\n\n<!-- \"Select a Client\" message -->\n<div\n\tclass=\"documentTreePaneSelectClientText\"\n\t*ngIf=\"selected && !selected.drawerId && selected.drawer && selected.drawer === 'Client'\"\n>\n\t{{'Blue.DocumentComponents.DocumentTreePane.SelectClient' | translate}}\n</div>\n\n<!-- Client Accordion -->\n<ngb-accordion\n\tclass=\"bento-accordion\"\n\t*ngIf=\"selected\"\n\t[closeOthers]=\"true\"\n\t[activeIds]=\"panelId\"\n\t[destroyOnHide]=\"false\"\n\t(panelChange)=\"clientAccordionToggled($event)\"\n>\n\t<!-- Non-breaking space keeps accordion from collapsing vertically -->\n\t<ngb-panel [id]=\"panelId\" animation=\"false\" [title]=\"(drawerName | translate) || '&nbsp;'\">\n\t\t<!-- Tree -->\n\t\t<ng-template ngbPanelContent>\n\t\t\t<div class=\"documentTreePaneTreeContainer\">\n\t\t\t\t<bdc-document-tree\n\t\t\t\t\t#tree\n\t\t\t\t\t*ngIf=\"showTree\"\n\t\t\t\t\t[root]=\"rootKey\"\n\t\t\t\t\t[drawer]=\"selected && selected.drawer\"\n\t\t\t\t\t[showFiles]=\"showFiles\"\n\t\t\t\t\t(selectedChange)=\"treeNodeSelected($event)\"\n\t\t\t\t\t[selected]=\"selectedItem && [selectedItem]\"\n\t\t\t\t\t[treeEmptyMessage]=\"emptyTreeText() | translate\"\n\t\t\t\t\t[getHref]=\"createGetHref()\"\n\t\t\t\t\t[groupProjectsBy]=\"groupProjectsBy\"\n\t\t\t\t></bdc-document-tree>\n\t\t\t</div>\n\t\t</ng-template>\n\t</ngb-panel>\n</ngb-accordion>\n\n<!-- TODO -->\n<!-- add a spinner to the pane and have it respond to the loading event form the tree-->\n<!-- (loading)=\"treeLoading = $event\"  -->\n", styles: [":host{display:block;height:100%;width:100%}.documentTreePaneSelectClientText{font-size:26px;text-align:center}.documentTreePaneTreeContainer{text-align:left}::ng-deep bdc-document-tree-pane .bento-accordion .card-header button{padding-left:8px}::ng-deep bdc-document-tree-pane .bento-accordion .card-header button[aria-expanded=true]:after{content:none}\n"], components: [{ type: TreeNavToolbarComponent, selector: "bdc-tree-nav-toolbar", inputs: ["includeFiles"], outputs: ["expandClick", "collapseClick", "includeFilesChange"] }, { type: i1$2.NgbAccordion, selector: "ngb-accordion", inputs: ["animation", "activeIds", "closeOthers", "destroyOnHide", "type"], outputs: ["panelChange", "shown", "hidden"], exportAs: ["ngbAccordion"] }, { type: DocumentTreeComponent, selector: "bdc-document-tree", inputs: ["selected", "treeEmptyMessage", "root", "drawer", "showFiles", "showRoot", "groupProjectsBy", "getHref", "canBeSelected"], outputs: ["selectedChange", "loading"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbPanel, selector: "ngb-panel", inputs: ["disabled", "id", "title", "type", "cardClass"], outputs: ["shown", "hidden"] }, { type: i1$2.NgbPanelContent, selector: "ng-template[ngbPanelContent]" }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreePaneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-tree-pane', template: "<!-- Toolbar -->\n<bdc-tree-nav-toolbar\n\t(expandClick)=\"tree!.expandAll()\"\n\t(collapseClick)=\"tree!.collapseAll()\"\n\t(includeFilesChange)=\"showFiles = $event\"\n\t[includeFiles]=\"showFiles\"\n></bdc-tree-nav-toolbar>\n\n<!-- \"Select a Client\" message -->\n<div\n\tclass=\"documentTreePaneSelectClientText\"\n\t*ngIf=\"selected && !selected.drawerId && selected.drawer && selected.drawer === 'Client'\"\n>\n\t{{'Blue.DocumentComponents.DocumentTreePane.SelectClient' | translate}}\n</div>\n\n<!-- Client Accordion -->\n<ngb-accordion\n\tclass=\"bento-accordion\"\n\t*ngIf=\"selected\"\n\t[closeOthers]=\"true\"\n\t[activeIds]=\"panelId\"\n\t[destroyOnHide]=\"false\"\n\t(panelChange)=\"clientAccordionToggled($event)\"\n>\n\t<!-- Non-breaking space keeps accordion from collapsing vertically -->\n\t<ngb-panel [id]=\"panelId\" animation=\"false\" [title]=\"(drawerName | translate) || '&nbsp;'\">\n\t\t<!-- Tree -->\n\t\t<ng-template ngbPanelContent>\n\t\t\t<div class=\"documentTreePaneTreeContainer\">\n\t\t\t\t<bdc-document-tree\n\t\t\t\t\t#tree\n\t\t\t\t\t*ngIf=\"showTree\"\n\t\t\t\t\t[root]=\"rootKey\"\n\t\t\t\t\t[drawer]=\"selected && selected.drawer\"\n\t\t\t\t\t[showFiles]=\"showFiles\"\n\t\t\t\t\t(selectedChange)=\"treeNodeSelected($event)\"\n\t\t\t\t\t[selected]=\"selectedItem && [selectedItem]\"\n\t\t\t\t\t[treeEmptyMessage]=\"emptyTreeText() | translate\"\n\t\t\t\t\t[getHref]=\"createGetHref()\"\n\t\t\t\t\t[groupProjectsBy]=\"groupProjectsBy\"\n\t\t\t\t></bdc-document-tree>\n\t\t\t</div>\n\t\t</ng-template>\n\t</ngb-panel>\n</ngb-accordion>\n\n<!-- TODO -->\n<!-- add a spinner to the pane and have it respond to the loading event form the tree-->\n<!-- (loading)=\"treeLoading = $event\"  -->\n", styles: [":host{display:block;height:100%;width:100%}.documentTreePaneSelectClientText{font-size:26px;text-align:center}.documentTreePaneTreeContainer{text-align:left}::ng-deep bdc-document-tree-pane .bento-accordion .card-header button{padding-left:8px}::ng-deep bdc-document-tree-pane .bento-accordion .card-header button[aria-expanded=true]:after{content:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ClientStore }, { type: StorageService }]; }, propDecorators: { selected: [{
                type: Input
            }], getHref: [{
                type: Input
            }], groupProjectsBy: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], tree: [{
                type: ViewChild,
                args: ['tree', { static: false }]
            }], accordion: [{
                type: ViewChild,
                args: [NgbAccordion]
            }] } });

const filenameTranslations = {
    firmdocuments: marker('Blue.DocumentComponents.SpecialFolders.FirmDocuments'),
    mydocuments: marker('Blue.DocumentComponents.SpecialFolders.MyDocuments'),
};
class FileDownloadService {
    constructor(
    // Due to limitations of Angular's AoT compilation, we can't
    // inject these with the proper type. So we inject as any and reassign.
    windowWrapper, documentWrapper, translateService) {
        this.translateService = translateService;
        this.window = windowWrapper;
        this.document = documentWrapper;
    }
    downloadBlob(response, defaultFilename) {
        const blob = response.body;
        if (!blob) {
            throw new Error('Cannot download file. Response body missing.');
        }
        const filename = this.getDownloadFilename(response, defaultFilename);
        if (navigator && navigator.msSaveOrOpenBlob) {
            // Internet Explorer only
            navigator.msSaveOrOpenBlob(blob, filename);
        }
        else {
            this.startDownload(blob, filename);
        }
    }
    getDownloadFilename(response, defaultFilename) {
        const contentDisposition = response.headers.get('content-disposition');
        if (contentDisposition && contentDisposition.length > 0) {
            const givenFilename = this.getFilenameFromContentDisposition(contentDisposition);
            if (givenFilename) {
                return this.translateFilename(givenFilename);
            }
        }
        return this.translateFilename(defaultFilename);
    }
    translateFilename(filename) {
        return Object.keys(filenameTranslations).reduce((name, key) => {
            if (name.match(key)) {
                // Can't convince TS that `key` must be a valid key of `filenameTranslations`
                const i18n = this.translateService.instant(filenameTranslations[key]);
                return name.replace(key, i18n);
            }
            return name;
        }, filename);
    }
    getFilenameFromContentDisposition(value) {
        // Match the string `filename=*utf-8''` then capture letters, dot, letters
        const preferred = value.match(/filename\*=utf-8''([^;]+)/);
        if (preferred && preferred.length > 0) {
            // TS is apparently unaware of decodeUriComponent
            return this.window.decodeURIComponent(preferred[1]);
        }
        // Match the string `filename=` then everything until the next semicolon
        const fallback = value.match(/filename=([^;]+)/);
        if (fallback && fallback.length > 0) {
            return this.window.decodeURIComponent(fallback[1]);
        }
        return null;
    }
    startDownload(blob, filename) {
        const url = this.window.URL.createObjectURL(blob);
        const linkElement = this.document.createElement('a');
        linkElement.style.display = 'none';
        linkElement.setAttribute('href', url);
        linkElement.setAttribute('download', filename);
        this.document.body.appendChild(linkElement);
        linkElement.click();
        linkElement.remove();
        this.window.URL.revokeObjectURL(url);
    }
}
/** @nocollapse */ FileDownloadService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FileDownloadService, deps: [{ token: 'windowWrapper' }, { token: 'documentWrapper' }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ FileDownloadService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FileDownloadService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: FileDownloadService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['windowWrapper']
                    }] }, { type: undefined, decorators: [{
                        type: Inject,
                        args: ['documentWrapper']
                    }] }, { type: i1.TranslateService }];
    } });

const DEFAULT_DOWNLOAD_FILENAME = 'onvio.zip';
class NgHttpWrapperService {
    constructor(http, fileDownloadService) {
        this.http = http;
        this.fileDownloadService = fileDownloadService;
        this.http = http;
    }
    dropEmptyArrays(params) {
        if (!params) {
            return params;
        }
        return Object.keys(params).reduce((accum, key) => {
            const value = params[key];
            if (!Array.isArray(value) || value.length > 0) {
                accum[key] = value;
            }
            return accum;
        }, {});
    }
    request(config) {
        return __awaiter(this, void 0, void 0, function* () {
            config.headers = config.headers || {};
            if (!(config.body instanceof FormData)) {
                config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json';
            }
            config.headers['accept-language'] = getCurrentLanguage();
            const options = {
                body: config.body,
                responseType: (config.responseType || 'json'),
                headers: config.headers,
                params: this.dropEmptyArrays(config.params),
                withCredentials: true,
                observe: 'response',
            };
            const result = this.http.request(config.method, config.url, options);
            const response = yield result.toPromise();
            if (config.responseType === 'blob') {
                this.fileDownloadService.downloadBlob(response, DEFAULT_DOWNLOAD_FILENAME);
            }
            return {
                ok: response.ok,
                status: response.status,
                statusText: response.statusText,
                body: response.body,
            };
        });
    }
}
/** @nocollapse */ NgHttpWrapperService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgHttpWrapperService, deps: [{ token: i1$3.HttpClient }, { token: FileDownloadService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ NgHttpWrapperService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgHttpWrapperService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NgHttpWrapperService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$3.HttpClient }, { type: FileDownloadService }]; } });

/* istanbul ignore file */
// AoT requires an exported function for factories
function bdsContainerInstanceProvider(http) {
    // Have to specify type because I forgot it in BDS.
    // Can remove in BDS > 8.1.1
    const instance = BDS.DiContainer.instance;
    instance.http = http.request.bind(http);
    return BDS.DiContainer.instance;
}
// AoT SUCKS
// Should this all be one nice function? Yes. But Angular don't like that. So we have this.
function approvalServiceFactory(container) {
    return container.approvalService;
}
function clientServiceFactory(container) {
    return container.clientService;
}
function commentsServiceFactory(container) {
    return container.commentsService;
}
function communicationServiceFactory(container) {
    return container.communicationService;
}
function communicationSubRequestServiceFactory(container) {
    return container.communicationSubRequestService;
}
function contactServiceFactory(container) {
    return container.contactService;
}
function companyServiceFactory(container) {
    return container.companyService;
}
function containerServiceFactory(container) {
    return container.containerService;
}
function documentServiceFactory(container) {
    return container.documentService;
}
function emailBodyServiceFactory(container) {
    return container.emailBodyService;
}
function itemServiceFactory(container) {
    return container.itemService;
}
function jobServiceFactory(container) {
    return container.jobService;
}
function templateServiceFactory(container) {
    return container.jobService;
}
function themeServiceFactory(container) {
    return container.themeService;
}
function shareServiceFactory(container) {
    return container.shareService;
}
function treeServiceFactory(container) {
    return container.treeService;
}
function documentConstraintsServiceFactory(container) {
    return container.documentConstraintsService;
}
function annotationsServiceFactory(container) {
    return container.annotationsService;
}
function approvalStoreFactory(container) {
    return container.approvalStore;
}
function clientStoreFactory(container) {
    return container.clientStore;
}
function commentsStoreFactory(container) {
    return container.commentsStore;
}
function containerStoreFactory(container) {
    return container.containerStore;
}
function itemStoreFactory(container) {
    return container.itemStore;
}
function shareStoreFactory(container) {
    return container.shareStore;
}
function templateStoreFactory(container) {
    return container.templateStore;
}
function treeStoreFactory(container) {
    return container.treeStore;
}
function recentItemServiceFactory(container) {
    return container.recentItemService;
}
// Below comment fixes issue with lambda support.
// @dynamic
class DocumentServicesModule {
}
/** @nocollapse */ DocumentServicesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentServicesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentServicesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentServicesModule, imports: [CommonModule] });
/** @nocollapse */ DocumentServicesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentServicesModule, providers: [
        // Container - do not export
        {
            provide: BDS.DiContainer,
            useFactory: bdsContainerInstanceProvider,
            deps: [NgHttpWrapperService],
        },
        // Services
        {
            provide: BDS.ApprovalService,
            useFactory: approvalServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ClientService,
            useFactory: clientServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.CommentsService,
            useFactory: commentsServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.CommunicationService,
            useFactory: communicationServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.CommunicationSubRequestService,
            useFactory: communicationSubRequestServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ContactService,
            useFactory: contactServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.CompanyService,
            useFactory: companyServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ContainerService,
            useFactory: containerServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.DocumentService,
            useFactory: documentServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.EmailBodyService,
            useFactory: emailBodyServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.RecentItemService,
            useFactory: recentItemServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.JobService,
            useFactory: jobServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ItemService,
            useFactory: itemServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.TemplateService,
            useFactory: templateServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ThemeService,
            useFactory: themeServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ShareService,
            useFactory: shareServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.TreeService,
            useFactory: treeServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.DocumentConstraintsService,
            useFactory: documentConstraintsServiceFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.AnnotationsService,
            useFactory: annotationsServiceFactory,
            deps: [BDS.DiContainer],
        },
        // Stores
        {
            provide: BDS.ApprovalStore,
            useFactory: approvalStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ClientStore,
            useFactory: clientStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.CommentsStore,
            useFactory: commentsStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ContainerStore,
            useFactory: containerStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ItemStore,
            useFactory: itemStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.ShareStore,
            useFactory: shareStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.TemplateStore,
            useFactory: templateStoreFactory,
            deps: [BDS.DiContainer],
        },
        {
            provide: BDS.TreeStore,
            useFactory: treeStoreFactory,
            deps: [BDS.DiContainer],
        },
    ], imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentServicesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [CommonModule],
                    providers: [
                        // Container - do not export
                        {
                            provide: BDS.DiContainer,
                            useFactory: bdsContainerInstanceProvider,
                            deps: [NgHttpWrapperService],
                        },
                        // Services
                        {
                            provide: BDS.ApprovalService,
                            useFactory: approvalServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ClientService,
                            useFactory: clientServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.CommentsService,
                            useFactory: commentsServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.CommunicationService,
                            useFactory: communicationServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.CommunicationSubRequestService,
                            useFactory: communicationSubRequestServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ContactService,
                            useFactory: contactServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.CompanyService,
                            useFactory: companyServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ContainerService,
                            useFactory: containerServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.DocumentService,
                            useFactory: documentServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.EmailBodyService,
                            useFactory: emailBodyServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.RecentItemService,
                            useFactory: recentItemServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.JobService,
                            useFactory: jobServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ItemService,
                            useFactory: itemServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.TemplateService,
                            useFactory: templateServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ThemeService,
                            useFactory: themeServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ShareService,
                            useFactory: shareServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.TreeService,
                            useFactory: treeServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.DocumentConstraintsService,
                            useFactory: documentConstraintsServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.AnnotationsService,
                            useFactory: annotationsServiceFactory,
                            deps: [BDS.DiContainer],
                        },
                        // Stores
                        {
                            provide: BDS.ApprovalStore,
                            useFactory: approvalStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ClientStore,
                            useFactory: clientStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.CommentsStore,
                            useFactory: commentsStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ContainerStore,
                            useFactory: containerStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ItemStore,
                            useFactory: itemStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.ShareStore,
                            useFactory: shareStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.TemplateStore,
                            useFactory: templateStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                        {
                            provide: BDS.TreeStore,
                            useFactory: treeStoreFactory,
                            deps: [BDS.DiContainer],
                        },
                    ],
                    exports: [],
                }]
        }] });

class ClientPersonalDetailsComponent {
    constructor(clientService, contactService, _sanitizer, appRef) {
        this.clientService = clientService;
        this.contactService = contactService;
        this._sanitizer = _sanitizer;
        this.appRef = appRef;
        this.clientInfoPopulated = false;
        this.fullName = '';
        this.emailAddress = '';
        this.nickname = '';
        this.entityType = '';
        this.openClientClick = new EventEmitter();
        this.clientInfoPopulated = false;
    }
    populateClient(clientFields) {
        if (clientFields.primaryContactExpanded.emailAddresses &&
            clientFields.primaryContactExpanded.emailAddresses.length > 0) {
            this.emailAddress = clientFields.primaryContactExpanded.emailAddresses[0].emailAddress;
        }
        else {
            this.emailAddress = '';
        }
        this.nickname = clientFields.primaryContactExpanded.nickname;
        this.entityType = clientFields.primaryContactExpanded.entityType.name;
        this.clientInfoPopulated = true;
        this.fullName = clientFields.name;
        // tick is called to force the page to update
        this.appRef.tick();
    }
    getClientFields(companyId, newClient) {
        return __awaiter(this, void 0, void 0, function* () {
            let clientFields;
            // If we have the ID, we just call get. If we don't, let's use the email address from outlook to get the ID
            // And then call get because the findClientByEmail endpoint doesn't give us all the needed data
            if (newClient.id) {
                clientFields = yield this.clientService.get(companyId, newClient.id);
            }
            else if (newClient.primaryContactExpanded) {
                const clientFromEmail = yield this.clientService.findClientByEmail(newClient.primaryContactExpanded.emailAddresses[0].emailAddress);
                clientFields = yield this.clientService.get(companyId, clientFromEmail.id);
            }
            else {
                throw new Error('client requested without ID or email');
            }
            this.clientId = clientFields.id;
            yield this.setClientAvatar(companyId, clientFields.primaryContactExpanded.id);
            return clientFields;
        });
    }
    setClientAvatar(companyId, clientContactId) {
        return __awaiter(this, void 0, void 0, function* () {
            const contactImage = yield this.contactService.getContactImage(companyId, clientContactId);
            const contactImageString = contactImage.base64Image;
            if (contactImageString !== '' && contactImageString != null) {
                // Had to call this bypassSecurity function in order to get the Base64 image to display
                this.imagePath = this._sanitizer.bypassSecurityTrustResourceUrl('data:image/jpeg;base64,' + contactImageString);
            }
            else {
                this.imagePath = '';
            }
        });
    }
    changeClient(newClient) {
        return __awaiter(this, void 0, void 0, function* () {
            const companyId = yield getCompanyId();
            const clientFields = yield this.getClientFields(companyId, newClient);
            this.populateClient(clientFields);
            return clientFields;
        });
    }
    openClientInOnvio() {
        // I'd rather directly open the link to the client setup page from here
        // But I open the window via a call to the Outlook JS library and
        // I definitely don't want to import that library here
        this.openClientClick.emit(this.clientId);
    }
}
/** @nocollapse */ ClientPersonalDetailsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientPersonalDetailsComponent, deps: [{ token: BDS.ClientService }, { token: BDS.ContactService }, { token: i2$2.DomSanitizer }, { token: i0.ApplicationRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ClientPersonalDetailsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientPersonalDetailsComponent, selector: "bdc-client-info", outputs: { openClientClick: "openClientClick" }, ngImport: i0, template: "<div class=\"pd-header\">\n\t<div class=\"pd-header-text\">\n\t\t{{fullName}}\n\t\t<a href=\"javascript:void(0)\">\n\t\t\t<i *ngIf=\"fullName\" id=\"open-in-onvio-btn\" class=\"bento-icon-newtab\" type=\"button\" (click)=\"openClientInOnvio()\"></i>\n\t\t</a>\n\t</div>\n</div>\n<div class=\"personal-details\" *ngIf=\"!!clientInfoPopulated\">\n\t<div class=\"pd-row avatar-row\">\n\t\t<div class=\"pd-column\">\n\t\t\t<b>Entity Type: </b> {{entityType}}<br />\n\t\t\t<br />\n\t\t\t<b>Nickname:</b> {{nickname}}<br />\n\t\t</div>\n\t\t<div class=\"pd-column\">\n\t\t\t<img id=\"contact-avatar\" *ngIf=\"imagePath\" [src]=\"imagePath\" />\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#contact-avatar{height:51px;margin-left:70px;width:52px}#open-in-onvio-btn{float:right;margin-top:2px}.pd-row{border-bottom:1px solid rgb(213,212,217);padding-left:5px}.pd-header{background-color:#f4f5f7;border-color:#d5d4d9;border-style:solid;border-width:1px;margin-left:10px;width:270px}.pd-header-text{align-self:center;color:#606169;font-family:Knowledge Bold,Knowledge;font-size:12;font-weight:700;padding:3px 15px 7px;width:100%}.pd-column{float:left;width:50%}.pd-row:after{clear:both;content:\"\";display:table}.avatar-row{padding-top:3px}.personal-details{background-color:#fff;border-bottom-color:#d5d4d9;border-bottom-style:solid;border-bottom-width:1px;border-left-color:#d5d4d9;border-left-style:solid;border-left-width:1px;border-right-color:#d5d4d9;border-right-style:solid;border-right-width:1px;box-shadow:2px 2px 10px #00000038;color:#000;font-family:Arial Bold,Arial Regular,Arial,\"sans-serif\";font-size:12px;height:auto;margin-left:10px;width:270px}\n"], directives: [{ type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientPersonalDetailsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-client-info', template: "<div class=\"pd-header\">\n\t<div class=\"pd-header-text\">\n\t\t{{fullName}}\n\t\t<a href=\"javascript:void(0)\">\n\t\t\t<i *ngIf=\"fullName\" id=\"open-in-onvio-btn\" class=\"bento-icon-newtab\" type=\"button\" (click)=\"openClientInOnvio()\"></i>\n\t\t</a>\n\t</div>\n</div>\n<div class=\"personal-details\" *ngIf=\"!!clientInfoPopulated\">\n\t<div class=\"pd-row avatar-row\">\n\t\t<div class=\"pd-column\">\n\t\t\t<b>Entity Type: </b> {{entityType}}<br />\n\t\t\t<br />\n\t\t\t<b>Nickname:</b> {{nickname}}<br />\n\t\t</div>\n\t\t<div class=\"pd-column\">\n\t\t\t<img id=\"contact-avatar\" *ngIf=\"imagePath\" [src]=\"imagePath\" />\n\t\t</div>\n\t</div>\n</div>\n", styles: ["#contact-avatar{height:51px;margin-left:70px;width:52px}#open-in-onvio-btn{float:right;margin-top:2px}.pd-row{border-bottom:1px solid rgb(213,212,217);padding-left:5px}.pd-header{background-color:#f4f5f7;border-color:#d5d4d9;border-style:solid;border-width:1px;margin-left:10px;width:270px}.pd-header-text{align-self:center;color:#606169;font-family:Knowledge Bold,Knowledge;font-size:12;font-weight:700;padding:3px 15px 7px;width:100%}.pd-column{float:left;width:50%}.pd-row:after{clear:both;content:\"\";display:table}.avatar-row{padding-top:3px}.personal-details{background-color:#fff;border-bottom-color:#d5d4d9;border-bottom-style:solid;border-bottom-width:1px;border-left-color:#d5d4d9;border-left-style:solid;border-left-width:1px;border-right-color:#d5d4d9;border-right-style:solid;border-right-width:1px;box-shadow:2px 2px 10px #00000038;color:#000;font-family:Arial Bold,Arial Regular,Arial,\"sans-serif\";font-size:12px;height:auto;margin-left:10px;width:270px}\n"] }]
        }], ctorParameters: function () { return [{ type: BDS.ClientService }, { type: BDS.ContactService }, { type: i2$2.DomSanitizer }, { type: i0.ApplicationRef }]; }, propDecorators: { openClientClick: [{
                type: Output
            }] } });

function createDebounce(delayMs = 0) {
    let timeoutId = -1;
    return (fn) => __awaiter(this, void 0, void 0, function* () {
        return new Promise(resolve => {
            window.clearTimeout(timeoutId);
            timeoutId = window.setTimeout(() => resolve(fn()), delayMs);
        });
    });
}

renderInputGlobally();
const validationDebounce$1 = createDebounce(200);
// ControlValueAccessor and Validator interfaces make this compatible with angular's reactive forms
class NameInputComponent {
    constructor(documentService, containerService, documentConstraintsService) {
        this.documentService = documentService;
        this.containerService = containerService;
        this.documentConstraintsService = documentConstraintsService;
        this.itemName = '';
        this.allowReplace = true;
        this.disabled = false;
        this.autofocus = false;
        this.requiredExtension = '';
        this.qeIdPrefix = '';
        this.nameChange = new EventEmitter();
        this.errors = null;
        this.touched = false;
        this._replaceOnSave = false;
        this.subs = [];
        // Required by ControlValueAccessor interface
        this.onChange = () => { };
        // Required by ControlValueAccessor interface
        this.onTouched = () => { };
    }
    /**
     * Used by consuming apps to retrieve the full file name with a required extension, if it exists.
     */
    get fullFileName() {
        if (this.requiredExtension) {
            return this.itemName + '.' + this.requiredExtension;
        }
        return this.itemName;
    }
    ngOnChanges(changes) {
        if (changes.itemName && changes.itemName.currentValue) {
            this.onChange(changes.itemName.currentValue);
        }
        if (changes.containerKey) {
            // Trigger revalidation
            this.onChange(this.itemName);
        }
    }
    ngOnDestroy() {
        this.subs.forEach(sub => {
            sub.unsubscribe();
        });
    }
    // Implements ControlValueAccessor interface
    writeValue(value) {
        if (typeof value === 'string') {
            this.itemName = value;
        }
    }
    // Implements ControlValueAccessor interface
    registerOnChange(fn) {
        this.onChange = fn;
        if (this.itemName) {
            this.onChange(this.itemName);
        }
    }
    // Implements ControlValueAccessor interface
    registerOnTouched(fn) {
        this.onTouched = () => {
            fn();
            this.touched = true;
        };
    }
    // Implements ControlValueAccessor interface
    setDisabledState(isDisabled) {
        this.disabled = isDisabled;
    }
    validate(control) {
        return __awaiter(this, void 0, void 0, function* () {
            const value = control.value;
            this.errors = null;
            const itemConstraints = yield this.getItemConstrains();
            const isDocument = this.isDocument();
            let valueLength = 0;
            if (value) {
                valueLength = value.length;
            }
            if (!value || !String(value).trim()) {
                this.errors = { required: true };
            }
            else if (isDocument && valueLength > itemConstraints.maxFileNameSize) {
                this.errors = {
                    maxFileName: true,
                    maxFileNameSize: itemConstraints.maxFileNameSize,
                };
            }
            else if (!isDocument && valueLength > itemConstraints.maxFolderNameSize) {
                this.errors = {
                    maxFolderName: true,
                    maxFolderNameSize: itemConstraints.maxFolderNameSize,
                };
            }
            else if (isDocument && valueLength < itemConstraints.minFileNameSize) {
                this.errors = {
                    minFileName: true,
                    minFileNameSize: itemConstraints.minFileNameSize,
                };
            }
            else if (itemConstraints.minFolderNameSize && !isDocument && valueLength < itemConstraints.minFolderNameSize) {
                this.errors = {
                    minFolderName: true,
                    minFolderNameSize: this.itemConstraints.minFolderNameSize,
                };
            }
            else if (value[0] === '.') {
                this.errors = { beginsWithPeriod: true };
            }
            else if (yield this.validateExists(value)) {
                this.errors = { exists: true };
            }
            return this.errors;
        });
    }
    onInput(value) {
        this.itemName = value;
        this.replaceOnSave(false);
        this.onChange(value);
        this.emitChange();
    }
    replaceOnSave(replace) {
        if (arguments.length && this._replaceOnSave !== replace) {
            this._replaceOnSave = !!replace;
        }
        return this._replaceOnSave;
    }
    isDocument() {
        return !!this.itemType && this.itemType === ItemType.Document;
    }
    getQeId() {
        var _a;
        return (_a = this.qeIdPrefix) !== null && _a !== void 0 ? _a : 'dms-fe-components';
    }
    emitChange() {
        this.nameChange.emit({
            name: this.itemName,
            replaceExisting: this._replaceOnSave,
            existingItemId: this.existingItemId,
        });
    }
    validateExists(value) {
        return __awaiter(this, void 0, void 0, function* () {
            if (!value || !(typeof value === 'string') || !value.trim() || !this.containerKey || !this.itemType) {
                return false;
            }
            // Add extension if not already present
            const regex = new RegExp(`\.${this.requiredExtension}$`);
            if (!value.match(regex)) {
                value += `.${this.requiredExtension}`;
            }
            const exists = yield validationDebounce$1(() => __awaiter(this, void 0, void 0, function* () {
                return this.itemExists(this.containerKey.id, this.containerKey.type, this.itemType, value);
            }));
            this.existingItemId = (!!exists && exists.id) || undefined;
            if (this.replaceOnSave() && !exists) {
                this.replaceOnSave(false);
            }
            this.emitChange();
            return !this.replaceOnSave() && !!exists;
        });
    }
    itemExists(containerId, containerType, itemType, name) {
        return __awaiter(this, void 0, void 0, function* () {
            if (itemType === ItemType.Document) {
                return this.documentService.exists(new ContainerKey(containerId, containerType), name);
            }
            return this.containerService.exists(new ContainerKey(containerId, containerType), name);
        });
    }
    getItemConstrains() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.itemConstraints) {
                this.itemConstraints = yield this.documentConstraintsService.get();
            }
            return this.itemConstraints;
        });
    }
}
/** @nocollapse */ NameInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NameInputComponent, deps: [{ token: BDS.DocumentService }, { token: BDS.ContainerService }, { token: BDS.DocumentConstraintsService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ NameInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: NameInputComponent, selector: "bdc-name-input", inputs: { containerKey: "containerKey", itemType: "itemType", itemName: "itemName", allowReplace: "allowReplace", disabled: "disabled", autofocus: "autofocus", requiredExtension: "requiredExtension", qeIdPrefix: "qeIdPrefix" }, outputs: { nameChange: "nameChange" }, providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef((() => NameInputComponent)),
            multi: true,
        },
        {
            provide: NG_ASYNC_VALIDATORS,
            useExisting: forwardRef((() => NameInputComponent)),
            multi: true,
        },
    ], usesOnChanges: true, ngImport: i0, template: "<ng-container>\n\t<div class=\"input-border\">\n\t\t<input\n\t\t\tclass=\"bm-input form-control\"\n\t\t\ttype=\"text\"\n\t\t\tname=\"nameInputElement\"\n\t\t\tautocomplete=\"off\"\n\t\t\t(input)=\"onInput($event.target.value)\"\n\t\t\t(blur)=\"onTouched()\"\n\t\t\t[value]=\"itemName\"\n\t\t\t[autofocus]=\"autofocus\"\n\t\t\t[disabled]=\"disabled\"\n\t\t\tspellcheck=\"false\"\n\t\t\t[attr.data-qe-id]=\"getQeId() + '-name-input'\"\n\t\t/>\n\t\t<div *ngIf=\"requiredExtension\" class=\"input-extension\">.{{requiredExtension}}</div>\n\t</div>\n\n\t<!-- Required error -->\n\t<div *ngIf=\"touched && errors && errors.required\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.Required' | translate}}\n\t</div>\n\n\t<!-- Max length error -->\n\t<div *ngIf=\"touched && errors && errors.maxFileName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameExceedsMaxLength' | translate : '{length: ' + errors.maxFileNameSize +\n\t\t'}' }}\n\t</div>\n\t<div *ngIf=\"touched && errors && errors.maxFolderName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameExceedsMaxLength' | translate : '{length: ' + errors.maxFolderNameSize\n\t\t+ '}' }}\n\t</div>\n\n\t<!-- Min length error -->\n\t<div *ngIf=\"touched && errors && errors.minFileName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameFailsToMeetMinLength' | translate : '{length: ' +\n\t\terrors.minFileNameSize + '}'}}\n\t</div>\n\t<div *ngIf=\"touched && errors && errors.minFolderName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameFailsToMeetMinLength' | translate : '{length: ' +\n\t\terrors.minFolderNameSize + '}'}}\n\t</div>\n\n\t<!-- Period start error -->\n\t<div *ngIf=\"touched && errors && errors.beginsWithPeriod\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameCannotBeginWithPeriod' | translate}}\n\t</div>\n\n\t<!-- Name exists error -->\n\t<div *ngIf=\"errors && errors.exists && !replaceOnSave()\" class=\"validation danger\">\n\t\t<span *ngIf=\"isDocument()\"> {{'Blue.DocumentComponents.NameInput.Error.FileExists' | translate}} </span>\n\t\t<span *ngIf=\"!isDocument()\"> {{'Blue.DocumentComponents.NameInput.Error.FolderExists' | translate}} </span>\n\t\t<!-- returns false to prevent page load -->\n\t\t<a *ngIf=\"allowReplace\" (click)=\"replaceOnSave(true) && false\" href>\n\t\t\t{{'Blue.DocumentComponents.NameInput.ReplaceOnSavePrompt' | translate}}\n\t\t</a>\n\t</div>\n\n\t<!-- Item will be replaced message -->\n\t<div *ngIf=\"replaceOnSave()\" class=\"validation info\">\n\t\t{{'Blue.DocumentComponents.NameInput.WillReplaceOnSave' | translate}}\n\t</div>\n</ng-container>\n", styles: [".input-border{border:3px;max-width:150}.bm-input{display:inline-block;width:250px}.input-extension{display:inline;margin-right:0}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NameInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-name-input', providers: [
                        {
                            provide: NG_VALUE_ACCESSOR,
                            useExisting: forwardRef((() => NameInputComponent)),
                            multi: true,
                        },
                        {
                            provide: NG_ASYNC_VALIDATORS,
                            useExisting: forwardRef((() => NameInputComponent)),
                            multi: true,
                        },
                    ], template: "<ng-container>\n\t<div class=\"input-border\">\n\t\t<input\n\t\t\tclass=\"bm-input form-control\"\n\t\t\ttype=\"text\"\n\t\t\tname=\"nameInputElement\"\n\t\t\tautocomplete=\"off\"\n\t\t\t(input)=\"onInput($event.target.value)\"\n\t\t\t(blur)=\"onTouched()\"\n\t\t\t[value]=\"itemName\"\n\t\t\t[autofocus]=\"autofocus\"\n\t\t\t[disabled]=\"disabled\"\n\t\t\tspellcheck=\"false\"\n\t\t\t[attr.data-qe-id]=\"getQeId() + '-name-input'\"\n\t\t/>\n\t\t<div *ngIf=\"requiredExtension\" class=\"input-extension\">.{{requiredExtension}}</div>\n\t</div>\n\n\t<!-- Required error -->\n\t<div *ngIf=\"touched && errors && errors.required\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.Required' | translate}}\n\t</div>\n\n\t<!-- Max length error -->\n\t<div *ngIf=\"touched && errors && errors.maxFileName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameExceedsMaxLength' | translate : '{length: ' + errors.maxFileNameSize +\n\t\t'}' }}\n\t</div>\n\t<div *ngIf=\"touched && errors && errors.maxFolderName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameExceedsMaxLength' | translate : '{length: ' + errors.maxFolderNameSize\n\t\t+ '}' }}\n\t</div>\n\n\t<!-- Min length error -->\n\t<div *ngIf=\"touched && errors && errors.minFileName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameFailsToMeetMinLength' | translate : '{length: ' +\n\t\terrors.minFileNameSize + '}'}}\n\t</div>\n\t<div *ngIf=\"touched && errors && errors.minFolderName\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameFailsToMeetMinLength' | translate : '{length: ' +\n\t\terrors.minFolderNameSize + '}'}}\n\t</div>\n\n\t<!-- Period start error -->\n\t<div *ngIf=\"touched && errors && errors.beginsWithPeriod\" class=\"validation danger\">\n\t\t{{'Blue.DocumentComponents.NameInput.Error.NameCannotBeginWithPeriod' | translate}}\n\t</div>\n\n\t<!-- Name exists error -->\n\t<div *ngIf=\"errors && errors.exists && !replaceOnSave()\" class=\"validation danger\">\n\t\t<span *ngIf=\"isDocument()\"> {{'Blue.DocumentComponents.NameInput.Error.FileExists' | translate}} </span>\n\t\t<span *ngIf=\"!isDocument()\"> {{'Blue.DocumentComponents.NameInput.Error.FolderExists' | translate}} </span>\n\t\t<!-- returns false to prevent page load -->\n\t\t<a *ngIf=\"allowReplace\" (click)=\"replaceOnSave(true) && false\" href>\n\t\t\t{{'Blue.DocumentComponents.NameInput.ReplaceOnSavePrompt' | translate}}\n\t\t</a>\n\t</div>\n\n\t<!-- Item will be replaced message -->\n\t<div *ngIf=\"replaceOnSave()\" class=\"validation info\">\n\t\t{{'Blue.DocumentComponents.NameInput.WillReplaceOnSave' | translate}}\n\t</div>\n</ng-container>\n", styles: [".input-border{border:3px;max-width:150}.bm-input{display:inline-block;width:250px}.input-extension{display:inline;margin-right:0}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], ctorParameters: function () { return [{ type: BDS.DocumentService }, { type: BDS.ContainerService }, { type: BDS.DocumentConstraintsService }]; }, propDecorators: { containerKey: [{
                type: Input
            }], itemType: [{
                type: Input
            }], itemName: [{
                type: Input
            }], allowReplace: [{
                type: Input
            }], disabled: [{
                type: Input
            }], autofocus: [{
                type: Input
            }], requiredExtension: [{
                type: Input
            }], qeIdPrefix: [{
                type: Input
            }], nameChange: [{
                type: Output
            }] } });

class NameInputModule {
}
/** @nocollapse */ NameInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NameInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ NameInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NameInputModule, declarations: [NameInputComponent], imports: [CommonModule, ReactiveFormsModule, i1.TranslateModule], exports: [NameInputComponent] });
/** @nocollapse */ NameInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NameInputModule, imports: [[CommonModule, ReactiveFormsModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NameInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NameInputComponent],
                    imports: [CommonModule, ReactiveFormsModule, TranslateModule.forChild()],
                    exports: [NameInputComponent],
                }]
        }] });

class ItemCollection {
    constructor(items) {
        this.items = items.slice(0);
        Object.freeze(this.items);
    }
    count() {
        return this.items.length;
    }
    hasItems() {
        return this.count() > 0;
    }
    hasOne() {
        return this.count() === 1;
    }
    hasAtLeastOne() {
        return this.count() >= 1;
    }
    hasDocument() {
        return this.items.some(item => isDocument(item));
    }
    hasContainer() {
        return this.items.some(item => isContainer(item));
    }
    isOnlyDocuments() {
        return this.hasItems() && this.items.every(item => isDocument(item));
    }
    isOnlyContainers() {
        return this.hasItems() && this.items.every(item => isContainer(item));
    }
}
ItemCollection.empty = new ItemCollection([]);

/**
 * Similar to `rxjs/combineLatest` but handles empty arrays properly.
 *
 * **Explanation:**
 *
 * Rxjs' `combineLatest([obs1$, obs2$])` returns a new Observable that emits every time `obs1$` or `obs2$` emits.
 * But `combineLatest([])` returns a new Observable that _never_ emits and _never_ completes.
 *
 * `alwaysCombineLatest` works the same as `combineLatest` unless the given argument is an empty array,
 * in which case it returns an Observable that emits an empty array and then completes.
 *
 * @param arr Array of observables to turn into a single observable of an array
 */
function alwaysCombineLatest(arr) {
    return arr.length === 0 ? of([]) : combineLatest(arr);
}

function isPromise(obj) {
    return !!obj && !!obj.then && typeof obj.then === 'function';
}
function meetsConditions(conditions, state) {
    // `combineLatest` with an empty array never completes which trips me up **every time**
    if (conditions.length < 1) {
        return of(true);
    }
    const allResults$ = conditions.map(condition => {
        const result = condition(state.selection, state.items);
        return isObservable(result)
            ? result
            : isPromise(result)
                ? from(result) // rxjs `from` turns a Promise into an Observable with the same value as the Promise
                : of(result); // rxjs `of` wraps the given value in a completed observable with the value as its payload
    });
    return combineLatest(allResults$).pipe(map(results => results.every(result => !!result)));
}

var PersistentStateKey;
(function (PersistentStateKey) {
    PersistentStateKey["Grid_Sort"] = "Grid_Sort";
    PersistentStateKey["Grid_HideColumns"] = "Grid_HideColumns";
    PersistentStateKey["Grid_PageSize"] = "Grid_PageSize";
})(PersistentStateKey || (PersistentStateKey = {}));
class PersistentStateService {
    constructor() {
        this.getStorageItem = getItem;
        this.setStorageItem = setItem;
    }
    storageKey(key) {
        return {
            appId: 'dms',
            dataId: key,
        };
    }
    get(key, defaultValue) {
        const storageKey = this.storageKey(key);
        const stringData = this.getStorageItem(storageKey, localStorage);
        if (stringData !== null) {
            try {
                return JSON.parse(stringData);
            }
            catch (_a) {
                return defaultValue;
            }
        }
        return defaultValue;
    }
    set(key, value) {
        const storageKey = this.storageKey(key);
        const stringData = JSON.stringify(value);
        this.setStorageItem(storageKey, stringData, localStorage);
    }
}
/** @nocollapse */ PersistentStateService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: PersistentStateService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ PersistentStateService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: PersistentStateService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: PersistentStateService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ColumnSelectorComponent {
    constructor(state) {
        this.state = state;
        this.columns = [
            {
                name: 'type',
                labelKey: marker('Blue.DocumentComponents.Grid.Header.Type'),
                visible: true,
            },
            {
                name: 'app',
                labelKey: marker('Blue.DocumentComponents.Grid.Header.App'),
                visible: true,
            },
            {
                name: 'name',
                labelKey: marker('Blue.DocumentComponents.Grid.Header.Name'),
                visible: true,
            },
            {
                name: 'shared',
                labelKey: marker('Blue.DocumentComponents.Grid.Header.Shared'),
                visible: true,
            },
            {
                name: 'year',
                labelKey: marker('Blue.DocumentComponents.Grid.Header.Year'),
                visible: true,
            },
            {
                name: 'date',
                labelKey: marker('Blue.DocumentComponents.Grid.Header.Date'),
                visible: true,
            },
        ];
        this.qeId = '';
        this.columnsChange = new EventEmitter();
    }
    ngOnInit() {
        this.loadVisibility();
        // This makes angular less grumpy with the change detection.
        // In general is a very bad idea to emit on on ngOnInit that does not own the model
        setTimeout(() => {
            this.columnsChange.emit(this.columns);
        });
    }
    checkboxChanged() {
        this.columnsChange.emit(this.columns);
        this.saveVisibility();
    }
    loadVisibility() {
        const saved = this.state.get(PersistentStateKey.Grid_HideColumns, []);
        this.columns = this.columns.map(column => {
            return Object.assign(Object.assign({}, column), { visible: !saved.includes(column.name) });
        });
    }
    saveVisibility() {
        const visible = this.columns.filter(col => !col.visible).map(col => col.name);
        this.state.set(PersistentStateKey.Grid_HideColumns, visible);
    }
}
/** @nocollapse */ ColumnSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnSelectorComponent, deps: [{ token: PersistentStateService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ColumnSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ColumnSelectorComponent, selector: "bdc-column-selector", inputs: { qeId: "qeId" }, outputs: { columnsChange: "columnsChange" }, ngImport: i0, template: "<li ngbDropdown [autoClose]=\"'outside'\" class=\"dropdown\">\n\t<button\n\t\tclass=\"btn btn-outline-primary btn-icon btn-toggle\"\n\t\tngbDropdownToggle\n\t\tplacement=\"bottom\"\n\t\tngbTooltip=\"{{ 'Blue.DocumentComponents.ColumnSelector.Tooltip' | translate }}\"\n\t\ttooltipClass=\"tooltip-ngb\"\n\t\tcontainer=\"body\"\n\t\t[openDelay]=\"400\"\n\t\taria-label=\"toggle columns\"\n\t\t[attr.qe-id]=\"qeId + 'column-selector-toggle'\"\n\t>\n\t\t<i aria-hidden=\"true\" class=\"bento-icon-cog\"></i>\n\t\t<i aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n\t</button>\n\t<span ngbDropdownMenu class=\"dropdown-menu grid-dropdown\">\n\t\t<fieldset>\n\t\t\t<ul class=\"group-list\" [attr.qe-id]=\"qeId + 'column-selector-options'\">\n\t\t\t\t<li *ngFor=\"let item of columns\" class=\"dropdown-item\">\n\t\t\t\t\t<label [attr.for]=\"qeId + 'column-selection-'+item.name\">\n\t\t\t\t\t\t<bento-checkbox\n\t\t\t\t\t\t\t[(ngModel)]=\"item.visible\"\n\t\t\t\t\t\t\t(change)=\"checkboxChanged()\"\n\t\t\t\t\t\t\t[attr.id]=\"qeId + 'column-selection-'+item.name\"\n\t\t\t\t\t\t></bento-checkbox>\n\t\t\t\t\t\t{{item.labelKey | translate}}\n\t\t\t\t\t</label>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</fieldset>\n\t</span>\n</li>\n", styles: ["li[ngbDropdown]{margin-right:3.5em}\n"], components: [{ type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i1$2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i2.BentoNgbTooltipSupportDirective, selector: "[ngbTooltip]" }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i2.BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i1$2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-column-selector', template: "<li ngbDropdown [autoClose]=\"'outside'\" class=\"dropdown\">\n\t<button\n\t\tclass=\"btn btn-outline-primary btn-icon btn-toggle\"\n\t\tngbDropdownToggle\n\t\tplacement=\"bottom\"\n\t\tngbTooltip=\"{{ 'Blue.DocumentComponents.ColumnSelector.Tooltip' | translate }}\"\n\t\ttooltipClass=\"tooltip-ngb\"\n\t\tcontainer=\"body\"\n\t\t[openDelay]=\"400\"\n\t\taria-label=\"toggle columns\"\n\t\t[attr.qe-id]=\"qeId + 'column-selector-toggle'\"\n\t>\n\t\t<i aria-hidden=\"true\" class=\"bento-icon-cog\"></i>\n\t\t<i aria-hidden=\"true\" class=\"bento-icon-caret-down-filled\"></i>\n\t</button>\n\t<span ngbDropdownMenu class=\"dropdown-menu grid-dropdown\">\n\t\t<fieldset>\n\t\t\t<ul class=\"group-list\" [attr.qe-id]=\"qeId + 'column-selector-options'\">\n\t\t\t\t<li *ngFor=\"let item of columns\" class=\"dropdown-item\">\n\t\t\t\t\t<label [attr.for]=\"qeId + 'column-selection-'+item.name\">\n\t\t\t\t\t\t<bento-checkbox\n\t\t\t\t\t\t\t[(ngModel)]=\"item.visible\"\n\t\t\t\t\t\t\t(change)=\"checkboxChanged()\"\n\t\t\t\t\t\t\t[attr.id]=\"qeId + 'column-selection-'+item.name\"\n\t\t\t\t\t\t></bento-checkbox>\n\t\t\t\t\t\t{{item.labelKey | translate}}\n\t\t\t\t\t</label>\n\t\t\t\t</li>\n\t\t\t</ul>\n\t\t</fieldset>\n\t</span>\n</li>\n", styles: ["li[ngbDropdown]{margin-right:3.5em}\n"] }]
        }], ctorParameters: function () { return [{ type: PersistentStateService }]; }, propDecorators: { qeId: [{
                type: Input
            }], columnsChange: [{
                type: Output
            }] } });

class ToolbarComponent {
    constructor(translate, element) {
        this.translate = translate;
        this.element = element;
        this.selection = { drawer: FileDrawer.Client };
        this.selectedItems = ItemCollection.empty;
        this.buttons = [];
        this.showSearch = true;
        this.buttonClicked = new EventEmitter();
        this.gridColumnsChange = new EventEmitter();
        this.search = new EventEmitter();
        this.bentoToolbarItems = [];
        this.searchTermInput = new FormControl('');
        this.state$ = new ReplaySubject(1);
        this.subscriptions = [];
    }
    ngOnInit() {
        var _a;
        (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.refresh();
        const bentoToolbarItems$ = this.state$.pipe(mergeMap(state => this.stateToBentoItems(state)));
        this.bentoItemsSubscription = bentoToolbarItems$.subscribe(items => {
            // If you replace the items array, the entire toolbar disappears for half a second.
            // Setting the length to zero effectively empties the array, then we push the items back in.
            this.bentoToolbarItems.length = 0;
            items.forEach(item => this.bentoToolbarItems.push(item));
            // Bit of a race condition, especially on first load.
            // If refresh happens before Bento processes the new buttons,
            // they get stuck behind "More"
            setTimeout(() => { var _a; return (_a = this.toolbar) === null || _a === void 0 ? void 0 : _a.refresh(); }, 100);
        });
        this.subscriptions.push(this.searchTermInput.valueChanges.subscribe(value => {
            // if the value is fully cleared, notify listeners
            if (value.length < 1) {
                this.search.emit('');
            }
            else {
                // make sure we have a data-qe-id on the reset button
                const resetButton = this.element.nativeElement.querySelector('.bento-reset-close-button');
                if (resetButton && !resetButton.getAttribute('data-qe-id')) {
                    resetButton.setAttribute('data-qe-id', this.buttonQeIdPrefix + '-search-input-reset-button');
                }
            }
        }));
    }
    ngOnChanges(changes) {
        if (changes.buttons || changes.selection || changes.selectedItems) {
            this.state$.next({
                buttons: this.buttons,
                selection: this.selection,
                items: this.selectedItems,
            });
        }
    }
    ngOnDestroy() {
        if (this.bentoItemsSubscription) {
            this.bentoItemsSubscription.unsubscribe();
        }
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
    submitSearch() {
        const searchTerm = this.searchTermInput.value.trim();
        if (searchTerm.length > 0) {
            this.search.emit(searchTerm);
        }
    }
    stateToBentoItems(state) {
        const visible$ = this.observeVisibleButtons(state.buttons, state);
        const bento$ = visible$.pipe(mergeMap(buttons => this.observeBentoToolbarItems(buttons, state)));
        return bento$;
    }
    observeBentoToolbarItems(buttons, state) {
        const bentoItems$ = buttons.map(button => {
            const enabled$ = meetsConditions(button.enableIf, state);
            const label$ = this.translate.get(button.labelKey);
            const childBentoItems$ = this.observeBentoToolbarItems(button.children, state);
            const asyncProperties$ = combineLatest([enabled$, label$, childBentoItems$]);
            const bentoItem$ = asyncProperties$.pipe(map(([enabled, label, childBentoItems]) => this.dmsButtonToBentoItem(button, enabled, label, childBentoItems, button.width)));
            return bentoItem$;
        });
        return alwaysCombineLatest(bentoItems$);
    }
    observeVisibleButtons(buttons, state) {
        const maybeButtons$ = buttons.map(button => this.getButtonIfVisible(button, state));
        const visibleButtons$ = alwaysCombineLatest(maybeButtons$).pipe(map(maybeButtons => maybeButtons.filter(maybeButton => !!maybeButton)));
        return visibleButtons$;
    }
    getButtonIfVisible(button, state) {
        const isVisible$ = meetsConditions(button.visibleIf, state);
        const visibleChildren$ = this.observeVisibleButtons(button.children, state);
        const maybeButton$ = combineLatest([isVisible$, visibleChildren$]).pipe(map(([isVisible, children]) => {
            const buttonWithChildren = Object.assign(Object.assign({}, button), { children });
            return isVisible ? buttonWithChildren : null;
        }));
        return maybeButton$;
    }
    dmsButtonToBentoItem(button, enabled, label, childItems, width) {
        return {
            id: button.id,
            label,
            icon: button.icon,
            action: this.emitEvent.bind(this, button.id),
            disabled: !enabled,
            // Bento shows dropdown if `dropdown` is defined, even if it is empty.
            dropdown: childItems && childItems.length > 0 ? childItems : undefined,
            width,
        };
    }
    emitEvent(buttonId) {
        this.buttonClicked.emit({
            buttonId,
            selection: this.selection,
            items: this.selectedItems,
        });
    }
}
/** @nocollapse */ ToolbarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarComponent, deps: [{ token: i1.TranslateService }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ToolbarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ToolbarComponent, selector: "bdc-toolbar", inputs: { selection: "selection", selectedItems: "selectedItems", buttons: "buttons", buttonQeIdPrefix: "buttonQeIdPrefix", showSearch: "showSearch" }, outputs: { buttonClicked: "buttonClicked", gridColumnsChange: "gridColumnsChange", search: "search" }, viewQueries: [{ propertyName: "toolbar", first: true, predicate: ["toolbar"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<bento-toolbar\n\t#toolbar\n\tclass=\"bento-toolbar\"\n\t[items]=\"bentoToolbarItems\"\n\t[moreText]=\"'Blue.DocumentComponents.Toolbar.More' | translate\"\n>\n\t<ul class=\"nav navbar-right\" role=\"group\">\n\t\t<!-- Column Selector dropdown -->\n\t\t<bdc-column-selector (columnsChange)=\"gridColumnsChange.emit($event)\"></bdc-column-selector>\n\t\t<form (ngSubmit)=\"submitSearch()\" name=\"searchForm\" role=\"search\">\n\t\t\t<span class=\"bento-search\" *ngIf=\"showSearch\">\n\t\t\t\t<input\n\t\t\t\t\tbentoReset\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tname=\"bdc-toolbar-search\"\n\t\t\t\t\t[formControl]=\"searchTermInput\"\n\t\t\t\t\t(keydown.enter)=\"submitSearch()\"\n\t\t\t\t\t[placeholder]=\"'Blue.DocumentComponents.Toolbar.Search' | translate\"\n\t\t\t\t\t[attr.data-qe-id]=\"buttonQeIdPrefix + '-search-input'\"\n\t\t\t\t/>\n\t\t\t</span>\n\t\t</form>\n\t</ul>\n</bento-toolbar>\n", styles: ["bdc-document-grid-pane>bdc-toolbar{position:sticky;top:0;z-index:1}bdc-toolbar{display:block;width:100%}bdc-toolbar>.bento-toolbar .bento-search:before{content:\"\\e6c4\"}bdc-toolbar>.bento-toolbar [ngbdropdown] .dropdown-menu button{color:#37383d;font-family:Arial,Helvetica Neue,sans-serif;font-weight:700}bdc-toolbar>.bento-toolbar [ngbdropdown] .dropdown-menu button i{font-weight:700;padding-bottom:4px}bdc-toolbar>.bento-toolbar .navbar-nav .dropdown .dropdown-menu{overflow:hidden}\n"], components: [{ type: i2.BentoToolbarComponent, selector: "bento-toolbar", inputs: ["moreText", "items"] }, { type: ColumnSelectorComponent, selector: "bdc-column-selector", inputs: ["qeId"], outputs: ["columnsChange"] }], directives: [{ type: i5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i5.NgForm, selector: "form:not([ngNoForm]):not([formGroup]),ng-form,[ngForm]", inputs: ["ngFormOptions"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2.BentoResetDirective, selector: "input:not([type=checkbox])[formControlName][bentoReset],input:not([type=checkbox])[formControl][bentoReset],input:not([type=checkbox])[ngModel][bentoReset]" }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.FormControlDirective, selector: "[formControl]", inputs: ["formControl", "disabled", "ngModel"], outputs: ["ngModelChange"], exportAs: ["ngForm"] }], pipes: { "translate": i1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-toolbar', encapsulation: ViewEncapsulation.None, template: "<bento-toolbar\n\t#toolbar\n\tclass=\"bento-toolbar\"\n\t[items]=\"bentoToolbarItems\"\n\t[moreText]=\"'Blue.DocumentComponents.Toolbar.More' | translate\"\n>\n\t<ul class=\"nav navbar-right\" role=\"group\">\n\t\t<!-- Column Selector dropdown -->\n\t\t<bdc-column-selector (columnsChange)=\"gridColumnsChange.emit($event)\"></bdc-column-selector>\n\t\t<form (ngSubmit)=\"submitSearch()\" name=\"searchForm\" role=\"search\">\n\t\t\t<span class=\"bento-search\" *ngIf=\"showSearch\">\n\t\t\t\t<input\n\t\t\t\t\tbentoReset\n\t\t\t\t\tclass=\"form-control\"\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tname=\"bdc-toolbar-search\"\n\t\t\t\t\t[formControl]=\"searchTermInput\"\n\t\t\t\t\t(keydown.enter)=\"submitSearch()\"\n\t\t\t\t\t[placeholder]=\"'Blue.DocumentComponents.Toolbar.Search' | translate\"\n\t\t\t\t\t[attr.data-qe-id]=\"buttonQeIdPrefix + '-search-input'\"\n\t\t\t\t/>\n\t\t\t</span>\n\t\t</form>\n\t</ul>\n</bento-toolbar>\n", styles: ["bdc-document-grid-pane>bdc-toolbar{position:sticky;top:0;z-index:1}bdc-toolbar{display:block;width:100%}bdc-toolbar>.bento-toolbar .bento-search:before{content:\"\\e6c4\"}bdc-toolbar>.bento-toolbar [ngbdropdown] .dropdown-menu button{color:#37383d;font-family:Arial,Helvetica Neue,sans-serif;font-weight:700}bdc-toolbar>.bento-toolbar [ngbdropdown] .dropdown-menu button i{font-weight:700;padding-bottom:4px}bdc-toolbar>.bento-toolbar .navbar-nav .dropdown .dropdown-menu{overflow:hidden}\n"] }]
        }], ctorParameters: function () { return [{ type: i1.TranslateService }, { type: i0.ElementRef }]; }, propDecorators: { selection: [{
                type: Input
            }], selectedItems: [{
                type: Input
            }], buttons: [{
                type: Input
            }], buttonQeIdPrefix: [{
                type: Input
            }], showSearch: [{
                type: Input
            }], buttonClicked: [{
                type: Output
            }], gridColumnsChange: [{
                type: Output
            }], search: [{
                type: Output
            }], toolbar: [{
                type: ViewChild,
                args: ['toolbar', { static: false }]
            }] } });

class ColumnSelectorModule {
}
/** @nocollapse */ ColumnSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ColumnSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnSelectorModule, declarations: [ColumnSelectorComponent], imports: [CommonModule, i1.TranslateModule, BentoModule, NgbModule, FormsModule], exports: [ColumnSelectorComponent] });
/** @nocollapse */ ColumnSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnSelectorModule, imports: [[CommonModule, TranslateModule.forChild(), BentoModule, NgbModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ColumnSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ColumnSelectorComponent],
                    imports: [CommonModule, TranslateModule.forChild(), BentoModule, NgbModule, FormsModule],
                    exports: [ColumnSelectorComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class ToolbarModule {
}
/** @nocollapse */ ToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarModule, declarations: [ToolbarComponent], imports: [CommonModule,
        BentoToolbarModule,
        BentoResetModule, i1.TranslateModule, ColumnSelectorModule,
        FormsModule,
        ReactiveFormsModule], exports: [ToolbarComponent] });
/** @nocollapse */ ToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarModule, imports: [[
            CommonModule,
            BentoToolbarModule,
            BentoResetModule,
            TranslateModule.forChild(),
            ColumnSelectorModule,
            FormsModule,
            ReactiveFormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ToolbarComponent],
                    imports: [
                        CommonModule,
                        BentoToolbarModule,
                        BentoResetModule,
                        TranslateModule.forChild(),
                        ColumnSelectorModule,
                        FormsModule,
                        ReactiveFormsModule,
                    ],
                    exports: [ToolbarComponent],
                }]
        }] });

class NewFolderModalComponent {
    constructor(containerStore, templateStore, activeModal) {
        this.containerStore = containerStore;
        this.templateStore = templateStore;
        this.activeModal = activeModal;
        this.itemName = '';
        this.newFolderForm = new FormGroup({
            nameInput: new FormControl(),
        });
        this.templates = [];
        this.loading = false;
    }
    // Angular can't do change detection on dynamic components I guess?
    // So ngOnChange won't work for this property. Thus the setter/getter.
    get containerKey() {
        return this._containerKey;
    }
    set containerKey(containerKey) {
        this._containerKey = containerKey;
        if (containerKey) {
            this.setItemType();
            this.loadTemplates();
        }
    }
    ngOnDestroy() {
        if (this.templateSubscription) {
            this.templateSubscription.unsubscribe();
        }
    }
    setTemplate(event) {
        if (!this.newFolderForm.controls.template) {
            this.addTemplateControl();
        }
        this.newFolderForm.controls.template.setValue(event.target.value);
    }
    touchAllForm() {
        for (const key in this.newFolderForm.controls) {
            if (Object.hasOwnProperty.call(this.newFolderForm.controls, key)) {
                this.newFolderForm.get(key).markAsTouched();
            }
        }
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            const errors = yield this.itemNameInput.validate({ value: this.itemName });
            if (!this.containerKey || errors) {
                this.loading = false;
                return;
            }
            try {
                const result = yield this.addContainer();
                this.loading = false;
                this.activeModal.close(result);
            }
            catch (error) {
                if (error.status === 409) {
                    this.newFolderForm.controls.name.setErrors({ exists: true });
                }
                else {
                    throw error;
                }
            }
            finally {
                this.loading = false;
            }
        });
    }
    onNameChange(event) {
        this.itemName = event.name;
    }
    showTemplates() {
        return this.isNewProject() && !!this.templates && this.templates.length > 0;
    }
    addContainer() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.itemType === ItemType.Project) {
                return this.addProject();
            }
            if (this.itemType === ItemType.Folder) {
                return this.addFolder();
            }
            throw new Error('invalid item type: ' + this.itemType);
        });
    }
    addProject() {
        return __awaiter(this, void 0, void 0, function* () {
            const sourceTemplateKey = this.getSourceTemplateKey();
            return this.containerStore.addProject(this.containerKey, this.itemName, sourceTemplateKey);
        });
    }
    getSourceTemplateKey() {
        const sourceTemplateId = this.newFolderForm.controls.template && this.newFolderForm.controls.template.value;
        return sourceTemplateId ? new ContainerKey(sourceTemplateId, ItemType.Template) : undefined;
    }
    addFolder() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.containerStore.addFolder(this.containerKey, this.itemName);
        });
    }
    isNewProject() {
        return !!this.containerKey && this.containerKey.type === ItemType.Client;
    }
    setItemType() {
        this.itemType = this.isNewProject() ? ItemType.Project : ItemType.Folder;
    }
    loadTemplates() {
        if (this.isNewProject() && !this.templateSubscription) {
            this.loading = true;
            this.templateSubscription = this.templateStore.observeTemplates().subscribe(templates => {
                this.addTemplateControl();
                this.templates = templates;
                this.loading = false;
            });
        }
    }
    addTemplateControl() {
        this.newFolderForm.addControl('template', new FormControl(''));
    }
}
/** @nocollapse */ NewFolderModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalComponent, deps: [{ token: BDS.ContainerStore }, { token: BDS.TemplateStore }, { token: i1$2.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ NewFolderModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: NewFolderModalComponent, selector: "bdc-new-folder-modal", inputs: { containerKey: "containerKey" }, viewQueries: [{ propertyName: "itemNameInput", first: true, predicate: ["itemName"], descendants: true }], ngImport: i0, template: "<button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.close('x button')\">\n\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"modal-header\">{{'Blue.DocumentComponents.NewFolder.Title' | translate}}</div>\n<form [formGroup]=\"newFolderForm\" (ngSubmit)=\"onSubmit()\">\n\t<div class=\"modal-body\">\n\t\t<label>\n\t\t\t{{ 'Blue.DocumentComponents.NewFolder.Name' | translate }}\n\t\t\t<bdc-name-input\n\t\t\t\t#itemName\n\t\t\t\tformControlName=\"nameInput\"\n\t\t\t\t[containerKey]=\"containerKey\"\n\t\t\t\t[itemType]=\"itemType\"\n\t\t\t\t(nameChange)=\"onNameChange($event)\"\n\t\t\t\t[allowReplace]=\"false\"\n\t\t\t\t[autofocus]=\"true\"\n\t\t\t>\n\t\t\t</bdc-name-input>\n\t\t</label>\n\t\t<label *ngIf=\"showTemplates()\">\n\t\t\t{{ 'Blue.DocumentComponents.NewFolder.Template' | translate }}\n\t\t\t<select bentoSelect class=\"form-control\" formControlName=\"template\" (change)=\"setTemplate($event)\">\n\t\t\t\t<option [value]=\"\">{{ 'Blue.DocumentComponents.NewFolder.Template.None' | translate }}</option>\n\t\t\t\t<option *ngFor=\"let template of templates\" [value]=\"template.id\">{{template.name}}</option>\n\t\t\t</select>\n\t\t</label>\n\t\t<div>{{ 'Blue.DocumentComponents.RequiredField' | translate }}</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary\" [bentoBusyLoader]=\"loading\" [disabled]=\"loading\">\n\t\t\t{{ 'Blue.DocumentComponents.Button.Ok' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t[disabled]=\"loading\"\n\t\t\t(click)=\"activeModal.close('cancel button')\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Button.Cancel' | translate }}\n\t\t</button>\n\t</div>\n</form>\n", styles: ["form label{display:block;margin:15px 0}form label:nth-child(0){margin-top:0}\n"], components: [{ type: NameInputComponent, selector: "bdc-name-input", inputs: ["containerKey", "itemType", "itemName", "allowReplace", "disabled", "autofocus", "requiredExtension", "qeIdPrefix"], outputs: ["nameChange"] }], directives: [{ type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.BentoSelectDirective, selector: "select[bentoSelect]" }, { type: i5.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }, { type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-new-folder-modal', template: "<button type=\"button\" class=\"close\" aria-label=\"Close\" (click)=\"activeModal.close('x button')\">\n\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"modal-header\">{{'Blue.DocumentComponents.NewFolder.Title' | translate}}</div>\n<form [formGroup]=\"newFolderForm\" (ngSubmit)=\"onSubmit()\">\n\t<div class=\"modal-body\">\n\t\t<label>\n\t\t\t{{ 'Blue.DocumentComponents.NewFolder.Name' | translate }}\n\t\t\t<bdc-name-input\n\t\t\t\t#itemName\n\t\t\t\tformControlName=\"nameInput\"\n\t\t\t\t[containerKey]=\"containerKey\"\n\t\t\t\t[itemType]=\"itemType\"\n\t\t\t\t(nameChange)=\"onNameChange($event)\"\n\t\t\t\t[allowReplace]=\"false\"\n\t\t\t\t[autofocus]=\"true\"\n\t\t\t>\n\t\t\t</bdc-name-input>\n\t\t</label>\n\t\t<label *ngIf=\"showTemplates()\">\n\t\t\t{{ 'Blue.DocumentComponents.NewFolder.Template' | translate }}\n\t\t\t<select bentoSelect class=\"form-control\" formControlName=\"template\" (change)=\"setTemplate($event)\">\n\t\t\t\t<option [value]=\"\">{{ 'Blue.DocumentComponents.NewFolder.Template.None' | translate }}</option>\n\t\t\t\t<option *ngFor=\"let template of templates\" [value]=\"template.id\">{{template.name}}</option>\n\t\t\t</select>\n\t\t</label>\n\t\t<div>{{ 'Blue.DocumentComponents.RequiredField' | translate }}</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button type=\"submit\" class=\"btn btn-primary\" [bentoBusyLoader]=\"loading\" [disabled]=\"loading\">\n\t\t\t{{ 'Blue.DocumentComponents.Button.Ok' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t[disabled]=\"loading\"\n\t\t\t(click)=\"activeModal.close('cancel button')\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Button.Cancel' | translate }}\n\t\t</button>\n\t</div>\n</form>\n", styles: ["form label{display:block;margin:15px 0}form label:nth-child(0){margin-top:0}\n"] }]
        }], ctorParameters: function () { return [{ type: BDS.ContainerStore }, { type: BDS.TemplateStore }, { type: i1$2.NgbActiveModal }]; }, propDecorators: { containerKey: [{
                type: Input
            }], itemNameInput: [{
                type: ViewChild,
                args: ['itemName', { static: false }]
            }] } });

class NewFolderModalModule {
}
/** @nocollapse */ NewFolderModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ NewFolderModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalModule, declarations: [NewFolderModalComponent], imports: [CommonModule, NameInputModule, FormsModule, ReactiveFormsModule, BentoModule, i1.TranslateModule], exports: [NewFolderModalComponent] });
/** @nocollapse */ NewFolderModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalModule, imports: [[CommonModule, NameInputModule, FormsModule, ReactiveFormsModule, BentoModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [NewFolderModalComponent],
                    imports: [CommonModule, NameInputModule, FormsModule, ReactiveFormsModule, BentoModule, TranslateModule.forChild()],
                    exports: [NewFolderModalComponent],
                }]
        }] });

function getFileInfo(fullName) {
    const index = fullName.lastIndexOf('.');
    let fileName = '';
    let extension = '';
    if (index !== -1) {
        fileName = fullName.substring(0, index);
        extension = fullName.substring(index + 1);
    }
    else {
        fileName = fullName;
    }
    return {
        fileName,
        extension,
    };
}

class RenameModalComponent {
    constructor(activeModal, itemStore) {
        this.activeModal = activeModal;
        this.itemStore = itemStore;
        this.loading = false;
        this.itemName = '';
        this.getFileInfo = getFileInfo;
        // We are only supporting renaming documents for now.
        this.itemType = ItemType.Document;
        this.renameForm = new FormGroup({
            nameInput: new FormControl(),
        });
    }
    get item() {
        return this.itemValue;
    }
    set item(item) {
        if (item) {
            this.itemValue = item;
            this.fileInfo = this.getFileInfo(item.name);
        }
    }
    get qeIdPrefix() {
        return 'dms-fe-components-rename-modal';
    }
    onSubmit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.loading = true;
            try {
                yield this.renameDocument();
            }
            finally {
                this.loading = false;
            }
        });
    }
    renameDocument() {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            const newName = this.itemName + '.' + ((_a = this.fileInfo) === null || _a === void 0 ? void 0 : _a.extension);
            const errors = yield this.itemNameInput.validate({ value: newName });
            if (!this.item || !this.item.id || !this.item.parent || errors) {
                return;
            }
            const renamedDocument = yield this.itemStore.renameDocument(this.item, this.item.parent, newName);
            this.activeModal.close(renamedDocument);
        });
    }
    onNameChange(event) {
        this.itemName = event.name;
    }
}
/** @nocollapse */ RenameModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: BDS.ItemStore }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ RenameModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: RenameModalComponent, selector: "bdc-rename-modal", inputs: { item: "item" }, viewQueries: [{ propertyName: "itemNameInput", first: true, predicate: ["itemName"], descendants: true }], ngImport: i0, template: "<button\n\ttype=\"button\"\n\tclass=\"close\"\n\taria-label=\"Close\"\n\t(click)=\"activeModal.dismiss('x button')\"\n\t[attr.data-qe-id]=\"qeIdPrefix + '-x-button'\"\n>\n\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"modal-header\">{{'Blue.DocumentComponents.Modal.Rename.Header' | translate}}</div>\n<form [formGroup]=\"renameForm\" (ngSubmit)=\"onSubmit()\">\n\t<div class=\"modal-body\">\n\t\t<label>\n\t\t\t{{ 'Blue.DocumentComponents.Modal.Rename.NameText' | translate }}\n\t\t\t<bdc-name-input\n\t\t\t\t#itemName\n\t\t\t\t[itemName]=\"fileInfo?.fileName\"\n\t\t\t\tformControlName=\"nameInput\"\n\t\t\t\t[itemType]=\"itemType\"\n\t\t\t\t(nameChange)=\"onNameChange($event)\"\n\t\t\t\t[allowReplace]=\"false\"\n\t\t\t\t[autofocus]=\"true\"\n\t\t\t\t[qeIdPrefix]=\"qeIdPrefix\"\n\t\t\t>\n\t\t\t</bdc-name-input>\n\t\t</label>\n\t\t<div>{{ 'Blue.DocumentComponents.RequiredField' | translate }}</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\ttype=\"submit\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t[bentoBusyLoader]=\"loading\"\n\t\t\t[disabled]=\"loading\"\n\t\t\t[attr.data-qe-id]=\"qeIdPrefix + '-rename-button'\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Modal.Rename.RenameButtonText' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t[disabled]=\"loading\"\n\t\t\t(click)=\"activeModal.dismiss('cancel button')\"\n\t\t\t[attr.data-qe-id]=\"qeIdPrefix + '-cancel-button'\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Button.Cancel' | translate }}\n\t\t</button>\n\t</div>\n</form>\n", components: [{ type: NameInputComponent, selector: "bdc-name-input", inputs: ["containerKey", "itemType", "itemName", "allowReplace", "disabled", "autofocus", "requiredExtension", "qeIdPrefix"], outputs: ["nameChange"] }], directives: [{ type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i5.ɵNgNoValidate, selector: "form:not([ngNoForm]):not([ngNativeValidate])" }, { type: i5.NgControlStatusGroup, selector: "[formGroupName],[formArrayName],[ngModelGroup],[formGroup],form:not([ngNoForm]),[ngForm]" }, { type: i5.FormGroupDirective, selector: "[formGroup]", inputs: ["formGroup"], outputs: ["ngSubmit"], exportAs: ["ngForm"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.FormControlName, selector: "[formControlName]", inputs: ["formControlName", "disabled", "ngModel"], outputs: ["ngModelChange"] }, { type: i2.BentoFooterTabHelper, selector: "[class=\"modal-footer\"]" }, { type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-rename-modal', template: "<button\n\ttype=\"button\"\n\tclass=\"close\"\n\taria-label=\"Close\"\n\t(click)=\"activeModal.dismiss('x button')\"\n\t[attr.data-qe-id]=\"qeIdPrefix + '-x-button'\"\n>\n\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n</button>\n<div class=\"modal-header\">{{'Blue.DocumentComponents.Modal.Rename.Header' | translate}}</div>\n<form [formGroup]=\"renameForm\" (ngSubmit)=\"onSubmit()\">\n\t<div class=\"modal-body\">\n\t\t<label>\n\t\t\t{{ 'Blue.DocumentComponents.Modal.Rename.NameText' | translate }}\n\t\t\t<bdc-name-input\n\t\t\t\t#itemName\n\t\t\t\t[itemName]=\"fileInfo?.fileName\"\n\t\t\t\tformControlName=\"nameInput\"\n\t\t\t\t[itemType]=\"itemType\"\n\t\t\t\t(nameChange)=\"onNameChange($event)\"\n\t\t\t\t[allowReplace]=\"false\"\n\t\t\t\t[autofocus]=\"true\"\n\t\t\t\t[qeIdPrefix]=\"qeIdPrefix\"\n\t\t\t>\n\t\t\t</bdc-name-input>\n\t\t</label>\n\t\t<div>{{ 'Blue.DocumentComponents.RequiredField' | translate }}</div>\n\t</div>\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\ttype=\"submit\"\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t[bentoBusyLoader]=\"loading\"\n\t\t\t[disabled]=\"loading\"\n\t\t\t[attr.data-qe-id]=\"qeIdPrefix + '-rename-button'\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Modal.Rename.RenameButtonText' | translate }}\n\t\t</button>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t[disabled]=\"loading\"\n\t\t\t(click)=\"activeModal.dismiss('cancel button')\"\n\t\t\t[attr.data-qe-id]=\"qeIdPrefix + '-cancel-button'\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Button.Cancel' | translate }}\n\t\t</button>\n\t</div>\n</form>\n" }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: BDS.ItemStore }]; }, propDecorators: { item: [{
                type: Input
            }], itemNameInput: [{
                type: ViewChild,
                args: ['itemName']
            }] } });

class RenameModalModule {
}
/** @nocollapse */ RenameModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ RenameModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalModule, declarations: [RenameModalComponent], imports: [CommonModule, NameInputModule, FormsModule, ReactiveFormsModule, BentoModule, i1.TranslateModule], exports: [RenameModalComponent] });
/** @nocollapse */ RenameModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalModule, imports: [[CommonModule, NameInputModule, FormsModule, ReactiveFormsModule, BentoModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RenameModalComponent],
                    imports: [CommonModule, NameInputModule, FormsModule, ReactiveFormsModule, BentoModule, TranslateModule.forChild()],
                    exports: [RenameModalComponent],
                }]
        }] });

class TreeNavToolbarModule {
}
/** @nocollapse */ TreeNavToolbarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TreeNavToolbarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ TreeNavToolbarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TreeNavToolbarModule, declarations: [TreeNavToolbarComponent], imports: [CommonModule,
        BentoToolbarModule,
        BentoCheckboxModule,
        NgbTooltipModule,
        FormsModule, i1.TranslateModule], exports: [TreeNavToolbarComponent] });
/** @nocollapse */ TreeNavToolbarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TreeNavToolbarModule, imports: [[
            CommonModule,
            BentoToolbarModule,
            BentoCheckboxModule,
            NgbTooltipModule,
            FormsModule,
            TranslateModule.forChild(),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TreeNavToolbarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TreeNavToolbarComponent],
                    imports: [
                        CommonModule,
                        BentoToolbarModule,
                        BentoCheckboxModule,
                        NgbTooltipModule,
                        FormsModule,
                        TranslateModule.forChild(),
                    ],
                    exports: [TreeNavToolbarComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

var EsignSignatoryColor;
(function (EsignSignatoryColor) {
    EsignSignatoryColor["Orange"] = "#FF8000";
    EsignSignatoryColor["Purple"] = "#5d1893";
    EsignSignatoryColor["Green"] = "#387C2B";
    EsignSignatoryColor["Blue"] = "#005885";
})(EsignSignatoryColor || (EsignSignatoryColor = {}));
function getEsignatoryColorName(color) {
    for (const colorName in EsignSignatoryColor) {
        if (color === EsignSignatoryColor[colorName]) {
            return colorName;
        }
    }
}

const ESIGN_PLACEHOLDER_SIZE = {
    width: 100,
    height: 30,
};
class ESignPlaceholder {
    constructor(persisted, id, documentId, recipientId, placeholderType, location, size, isDeleted) {
        this.persisted = persisted;
        this.id = id;
        this.documentId = documentId;
        this.recipientId = recipientId;
        this.placeholderType = placeholderType;
        this.location = location;
        this.size = size;
        this.isDeleted = isDeleted;
        this.size = this.size || ESIGN_PLACEHOLDER_SIZE;
    }
}

class ESignPlaceholderDropData {
    constructor(placeholderType, signatoryId, id) {
        this.placeholderType = placeholderType;
        this.signatoryId = signatoryId;
        this.id = id;
    }
}

class PlaceholderBoxesComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.zoom = 1;
        this.readonly = false;
    }
    set selectedSignatory(value) {
        this._selectedSignatory = value;
    }
    get selectedSignatory() {
        return this._selectedSignatory;
    }
    ngOnInit() {
        this.createDummyImages();
        if (!this.readonly) {
            this.setUpDraggability();
        }
    }
    ngOnDestroy() {
        this.removeDummyImages();
    }
    getPlaceholderImage(placeholderType, color) {
        const element = this.getDummyImg(placeholderType, color);
        return element.src;
    }
    setZoom(value) {
        this.zoom = value;
    }
    setUpDraggability() {
        const boxes = this.elRef.nativeElement.querySelectorAll('.esign-placeholder .esign-box');
        boxes.forEach(this.setDragStartHandler.bind(this));
    }
    setDragStartHandler(esignBox) {
        esignBox.ondragstart = this.onDragStart.bind(this);
    }
    onDragStart(e) {
        if (!this.selectedSignatory || !this.selectedSignatory.id) {
            e.preventDefault();
            return false;
        }
        const color = this.selectedSignatory.color;
        if (!color) {
            e.preventDefault();
            return false;
        }
        const esignBox = e.target;
        const placeholderType = esignBox.attributes.getNamedItem('placeholder-type').value;
        const dummyImg = this.getDummyImg.bind(this)(placeholderType, color);
        const draggedImageOffset = { x: 0, y: 0 };
        dummyImg.style.width = ESIGN_PLACEHOLDER_SIZE.width * this.zoom + 'px';
        dummyImg.style.height = ESIGN_PLACEHOLDER_SIZE.height * this.zoom + 'px';
        e.dataTransfer.setDragImage(dummyImg, draggedImageOffset.x, draggedImageOffset.y);
        const dropData = {
            img: dummyImg.src,
            size: ESIGN_PLACEHOLDER_SIZE,
            offset: draggedImageOffset,
            metadata: JSON.stringify(new ESignPlaceholderDropData(placeholderType, this.selectedSignatory.id)),
        };
        e.dataTransfer.setData(AnnotationDropDataTransferKey, JSON.stringify(dropData));
        return true;
    }
    createDummyImages() {
        const placeholderTypes = [EsignPlaceholderType.Signature, EsignPlaceholderType.Date, EsignPlaceholderType.Initials];
        const colors = [
            EsignSignatoryColor.Orange,
            EsignSignatoryColor.Purple,
            EsignSignatoryColor.Green,
            EsignSignatoryColor.Blue,
        ];
        let x = -500;
        placeholderTypes.forEach(pt => {
            let y = -500;
            colors.forEach(c => {
                this.createDummyImage(pt, getEsignatoryColorName(c), c, x, y);
                y -= 3000;
            });
            x -= 10000;
        });
    }
    removeDummyImages() {
        const placeholderTypes = [EsignPlaceholderType.Signature, EsignPlaceholderType.Date, EsignPlaceholderType.Initials];
        const colors = [
            EsignSignatoryColor.Orange,
            EsignSignatoryColor.Purple,
            EsignSignatoryColor.Green,
            EsignSignatoryColor.Blue,
        ];
        placeholderTypes.forEach(placeholderType => {
            colors.forEach(color => {
                this.removeDummyImage(placeholderType, color);
            });
        });
    }
    createDummyImage(placeholderType, colorName, color, x, y) {
        const dummyElId = this.getDummyImgElementId(placeholderType, colorName);
        const iconCharacter = placeholderType === EsignPlaceholderType.Date
            ? '\ue62e'
            : placeholderType === EsignPlaceholderType.Signature
                ? '\ue662'
                : '\ue6e3';
        const div = document.createElement('div');
        const newImg = document.createElement('img');
        newImg.id = dummyElId;
        div.appendChild(newImg);
        div.style.position = 'absolute';
        div.style.left = x + 'px';
        div.style.top = y + 'px';
        document.body.appendChild(div);
        const width = ESIGN_PLACEHOLDER_SIZE.width;
        const height = ESIGN_PLACEHOLDER_SIZE.height;
        const iconWidth = 22;
        newImg.style.width = width + 'px';
        newImg.style.height = height + 'px';
        const canvas = document.createElement('canvas');
        canvas.width = width;
        canvas.height = height;
        const context = canvas.getContext('2d');
        context.fillStyle = color;
        context.fillRect(0, 0, width, height);
        context.fillStyle = '#000000';
        context.beginPath();
        context.rect(0, 0, width, height);
        context.stroke();
        context.fillStyle = '#FFFFFF';
        context.font = '18px "bento-icons"';
        context.textBaseline = 'middle';
        context.fillText(iconCharacter, (width - iconWidth) / 2, height / 2);
        newImg.src = canvas.toDataURL();
    }
    removeDummyImage(placeholderType, color) {
        const element = this.getDummyImg(placeholderType, color);
        if (element) {
            element.remove();
        }
    }
    getDummyImg(placeholderType, color) {
        const dummyElId = this.getDummyImgElementId(placeholderType, getEsignatoryColorName(color));
        const el = document.getElementById(dummyElId);
        return el;
    }
    getDummyImgElementId(placeholderType, colorName) {
        return placeholderType + '-' + colorName + '-placeholder-image';
    }
}
/** @nocollapse */ PlaceholderBoxesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: PlaceholderBoxesComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ PlaceholderBoxesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: PlaceholderBoxesComponent, selector: "bdc-placeholder-boxes", inputs: { selectedSignatory: "selectedSignatory", readonly: "readonly" }, ngImport: i0, template: "<div class=\"placeholder-container\">\n\t<div class=\"signature-placeholder esign-placeholder\">\n\t\t<div id=\"edit-icon-box\" class=\"esign-box\" draggable=\"true\" placeholder-type=\"Signature\">\n\t\t\t<i class=\"bento-icon-edit-filled-doc icon\"></i>\n\t\t\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Signature' | translate }}</div>\n\t\t</div>\n\t</div>\n\t<div class=\"date-placeholder esign-placeholder\">\n\t\t<div id=\"calendar-icon-box\" class=\"esign-box\" draggable=\"true\" placeholder-type=\"Date\">\n\t\t\t<i class=\"bento-icon-calendar icon\"></i>\n\t\t\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Date' | translate }}</div>\n\t\t</div>\n\t</div>\n\t<div class=\"initials-placeholder esign-placeholder\">\n\t\t<div id=\"type-icon-box\" class=\"esign-box\" draggable=\"true\" placeholder-type=\"Initials\">\n\t\t\t<i class=\"bento-icon-type icon\"></i>\n\t\t\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Initials' | translate }}</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div *ngIf=\"!readonly\" class=\"hint\">\n\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Hint' | translate }}</div>\n</div>\n", styles: [".placeholder-container{align-items:center;display:flex;font-family:Arial;justify-content:center;overflow:hidden}.esign-placeholder{border:1px solid #d5d4d9;color:#212121;font-size:14px;height:85px;margin:16px 0;text-align:center;width:85px}.signature-placeholder{margin-left:20px;margin-right:16px}.initials-placeholder{margin-left:16px;margin-right:20px}.esign-box{padding:8px}.hint{color:#212121;font-size:14px;margin:0 20px}[class^=bento-icon-]{font-size:32px}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: PlaceholderBoxesComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-placeholder-boxes', template: "<div class=\"placeholder-container\">\n\t<div class=\"signature-placeholder esign-placeholder\">\n\t\t<div id=\"edit-icon-box\" class=\"esign-box\" draggable=\"true\" placeholder-type=\"Signature\">\n\t\t\t<i class=\"bento-icon-edit-filled-doc icon\"></i>\n\t\t\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Signature' | translate }}</div>\n\t\t</div>\n\t</div>\n\t<div class=\"date-placeholder esign-placeholder\">\n\t\t<div id=\"calendar-icon-box\" class=\"esign-box\" draggable=\"true\" placeholder-type=\"Date\">\n\t\t\t<i class=\"bento-icon-calendar icon\"></i>\n\t\t\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Date' | translate }}</div>\n\t\t</div>\n\t</div>\n\t<div class=\"initials-placeholder esign-placeholder\">\n\t\t<div id=\"type-icon-box\" class=\"esign-box\" draggable=\"true\" placeholder-type=\"Initials\">\n\t\t\t<i class=\"bento-icon-type icon\"></i>\n\t\t\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Initials' | translate }}</div>\n\t\t</div>\n\t</div>\n</div>\n\n<div *ngIf=\"!readonly\" class=\"hint\">\n\t<div>{{ 'Blue.DocumentComponents.PlaceholderBox.Hint' | translate }}</div>\n</div>\n", styles: [".placeholder-container{align-items:center;display:flex;font-family:Arial;justify-content:center;overflow:hidden}.esign-placeholder{border:1px solid #d5d4d9;color:#212121;font-size:14px;height:85px;margin:16px 0;text-align:center;width:85px}.signature-placeholder{margin-left:20px;margin-right:16px}.initials-placeholder{margin-left:16px;margin-right:20px}.esign-box{padding:8px}.hint{color:#212121;font-size:14px;margin:0 20px}[class^=bento-icon-]{font-size:32px}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { selectedSignatory: [{
                type: Input
            }], readonly: [{
                type: Input
            }] } });

class SignatoryListComponent {
    constructor() {
        this.colors = [
            {
                background: EsignSignatoryColor.Orange,
                text: '#FFFFFF',
            },
            {
                background: EsignSignatoryColor.Purple,
                text: '#FFFFFF',
            },
            {
                background: EsignSignatoryColor.Green,
                text: '#FFFFFF',
            },
            {
                background: EsignSignatoryColor.Blue,
                text: '#FFFFFF',
            },
        ];
        this._recipients = [];
        this._signatories = [];
        this.readonly = false;
        this.selectedSignatory = null;
        this.signatorySelected = new EventEmitter();
    }
    set recipients(recipients) {
        this._signatories = [];
        if (recipients && recipients.length > 0) {
            this._signatories = recipients.map((recipient, index) => {
                const signatoryColor = this.colors[index % this.colors.length];
                return this.requestRecipientToSignatory(recipient, signatoryColor);
            });
            if (this.signatories.length) {
                this.selectSignatory(this.signatories[0]);
            }
        }
        this._recipients = recipients;
    }
    get recipients() {
        return this._recipients;
    }
    get signatories() {
        return this._signatories;
    }
    styleObject(i) {
        return {
            'background-color': this.colors[i].background,
            color: this.colors[i].text,
        };
    }
    selectSignatory(signatory) {
        this.selectedSignatory = signatory;
        this.signatorySelected.emit(signatory);
    }
    getSignatoryIds() {
        return this.signatories.map(s => s.id);
    }
    setEsignCompleteStatus(signatoryId, isComplete) {
        const signatory = this.signatories.find(s => s.id === signatoryId);
        if (signatory) {
            signatory.isEsignComplete = isComplete;
        }
    }
    getSignatoryColor(signatoryId) {
        const signatory = this.signatories.find(s => s.id === signatoryId);
        if (signatory) {
            return signatory.color;
        }
    }
    requestRecipientToSignatory(recipient, signatoryColor) {
        let firstName = '';
        let lastName = '';
        let initials = '';
        if (recipient.name) {
            [lastName, firstName] = recipient.name.split(',').map(name => {
                return name.trim();
            });
            initials = (firstName ? firstName[0] : '') + (lastName ? lastName[0] : '');
        }
        return {
            id: recipient.id,
            firstName: firstName,
            lastName: lastName,
            emailAddress: recipient.emailAddress,
            initials: initials,
            color: signatoryColor.background,
            isEsignComplete: false,
        };
    }
}
/** @nocollapse */ SignatoryListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SignatoryListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SignatoryListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SignatoryListComponent, selector: "bdc-signatory-list", inputs: { readonly: "readonly", recipients: "recipients" }, outputs: { signatorySelected: "signatorySelected" }, ngImport: i0, template: "<h2 *ngIf=\"!readonly\">{{ 'Blue.DocumentComponents.EsignModal.SignatoryList.SelectSignatoryHint' | translate }}</h2>\n<ul [class.margin]=\"readonly\">\n\t<li\n\t\t#listItem\n\t\t*ngFor=\"let signatory of signatories; index as i\"\n\t\t[class.selected]=\"!readonly && signatory === selectedSignatory\"\n\t\t(click)=\"selectSignatory(signatory)\"\n\t\t[attr.data-id]=\"signatory.id\"\n\t\t[class.enabled]=\"!readonly\"\n\t\t[class.disabled]=\"readonly\"\n\t>\n\t\t<div class=\"initials\" [ngStyle]=\"styleObject(i)\">\n\t\t\t<span>{{ signatory.initials }}</span>\n\t\t</div>\n\t\t<div class=\"personal-info\">\n\t\t\t<div class=\"name\">{{ signatory.firstName }} {{ signatory.lastName }}</div>\n\t\t\t<div class=\"email\">{{ signatory.emailAddress }}</div>\n\t\t</div>\n\t\t<div *ngIf=\"signatory.isEsignComplete\" class=\"check-status-mark\">\n\t\t\t<i class=\"bento-icon-checkmark\"></i>\n\t\t</div>\n\t</li>\n</ul>\n", styles: ["h2{font-family:Arial;font-size:14px;margin:16px 0 5px 16px}ul{list-style-type:none;margin-bottom:8px;padding:0 20px 0 16px}.margin{margin-top:16px}ul>li{align-items:center;background-color:#f4f5f7;border:1px solid #d5d4d9;border-radius:5px;color:#212121;display:flex;height:50px;margin-bottom:8px;padding:3px 3px 3px 0}ul>li:last-child{margin-bottom:32px}ul>li.selected,ul>li.enabled:hover{background-color:#606169;color:#fff}ul>li.disabled{pointer-events:none}ul>li:hover{cursor:pointer}.initials{align-items:center;border-radius:50%;color:#fff;display:flex;font-family:Knowledge Medium;font-size:14px;justify-content:center;margin:8px;min-height:30px;min-width:30px;text-transform:uppercase}.personal-info{flex-grow:2;overflow:hidden}.check-status-mark{margin-right:10px}.check-status-mark i{font-weight:700}li.enabled.selected .check-status-mark,li.enabled:hover .check-status-mark{color:#f4f5f7}li.enabled .check-status-mark{color:#387c2b}.personal-info .name{font-family:Knowledge Medium;font-size:14px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.personal-info .email{font-family:Arial;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$1.NgStyle, selector: "[ngStyle]", inputs: ["ngStyle"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SignatoryListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-signatory-list', template: "<h2 *ngIf=\"!readonly\">{{ 'Blue.DocumentComponents.EsignModal.SignatoryList.SelectSignatoryHint' | translate }}</h2>\n<ul [class.margin]=\"readonly\">\n\t<li\n\t\t#listItem\n\t\t*ngFor=\"let signatory of signatories; index as i\"\n\t\t[class.selected]=\"!readonly && signatory === selectedSignatory\"\n\t\t(click)=\"selectSignatory(signatory)\"\n\t\t[attr.data-id]=\"signatory.id\"\n\t\t[class.enabled]=\"!readonly\"\n\t\t[class.disabled]=\"readonly\"\n\t>\n\t\t<div class=\"initials\" [ngStyle]=\"styleObject(i)\">\n\t\t\t<span>{{ signatory.initials }}</span>\n\t\t</div>\n\t\t<div class=\"personal-info\">\n\t\t\t<div class=\"name\">{{ signatory.firstName }} {{ signatory.lastName }}</div>\n\t\t\t<div class=\"email\">{{ signatory.emailAddress }}</div>\n\t\t</div>\n\t\t<div *ngIf=\"signatory.isEsignComplete\" class=\"check-status-mark\">\n\t\t\t<i class=\"bento-icon-checkmark\"></i>\n\t\t</div>\n\t</li>\n</ul>\n", styles: ["h2{font-family:Arial;font-size:14px;margin:16px 0 5px 16px}ul{list-style-type:none;margin-bottom:8px;padding:0 20px 0 16px}.margin{margin-top:16px}ul>li{align-items:center;background-color:#f4f5f7;border:1px solid #d5d4d9;border-radius:5px;color:#212121;display:flex;height:50px;margin-bottom:8px;padding:3px 3px 3px 0}ul>li:last-child{margin-bottom:32px}ul>li.selected,ul>li.enabled:hover{background-color:#606169;color:#fff}ul>li.disabled{pointer-events:none}ul>li:hover{cursor:pointer}.initials{align-items:center;border-radius:50%;color:#fff;display:flex;font-family:Knowledge Medium;font-size:14px;justify-content:center;margin:8px;min-height:30px;min-width:30px;text-transform:uppercase}.personal-info{flex-grow:2;overflow:hidden}.check-status-mark{margin-right:10px}.check-status-mark i{font-weight:700}li.enabled.selected .check-status-mark,li.enabled:hover .check-status-mark{color:#f4f5f7}li.enabled .check-status-mark{color:#387c2b}.personal-info .name{font-family:Knowledge Medium;font-size:14px;overflow:hidden;text-overflow:ellipsis;text-transform:uppercase;white-space:nowrap}.personal-info .email{font-family:Arial;font-size:12px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}\n"] }]
        }], propDecorators: { readonly: [{
                type: Input
            }], recipients: [{
                type: Input
            }], signatorySelected: [{
                type: Output
            }] } });

class PlaceholderLocation {
    constructor(pageNumber, x, y) {
        this.pageNumber = pageNumber;
        this.x = x;
        this.y = y;
    }
}

class EsignPlaceholderStateController {
    constructor(signatorySelector, placeholderToolbar, documentViewer, documentSelector) {
        this.signatorySelector = signatorySelector;
        this.placeholderToolbar = placeholderToolbar;
        this.documentViewer = documentViewer;
        this.documentSelector = documentSelector;
        this.subscriptions = [];
        this._placeholders = [];
        this._isEsignComplete = true;
        this.persistedPlaceholdersChanged = false;
        this.newPlaceholderAdded = false;
        this.subscriptions.push(this.signatorySelector.signatorySelected.subscribe(this.signatorySelected.bind(this)), this.documentViewer.loadedDocumentChange.subscribe(this.loadedDocumentChanged.bind(this)), this.documentViewer.annotationChange.subscribe(this.annotationChanged.bind(this)), this.documentViewer.zoomChange.subscribe(this.documentViewerZoomChaged.bind(this)));
    }
    signatorySelected(selectedSignatory) {
        this.signatoryId = selectedSignatory.id;
    }
    set placeholders(value) {
        this._placeholders = value;
        this.markPlaceholdersPersisted();
        this.giveIdsToPlaceholders();
        this.updateEsignCompleteStatus();
    }
    get placeholders() {
        return this._placeholders;
    }
    isEsignComplete() {
        return this._isEsignComplete;
    }
    get placeholdersChanged() {
        return this.persistedPlaceholdersChanged || this.newPlaceholderAdded;
    }
    dispose() {
        this.subscriptions.forEach(s => s.unsubscribe());
    }
    loadedDocumentChanged(event) {
        this.documentId = event.detail;
        if (this.documentId) {
            const documentPlaceholders = this.placeholders.filter(p => p.documentId === this.documentId && !p.isDeleted);
            this.documentViewer.placeholders = this.getPlaceholderDescriptions(documentPlaceholders);
        }
    }
    annotationChanged(event) {
        if (event.type === 'annotationChange') {
            const action = event.detail.action;
            event.detail.annotations.forEach((annotation) => {
                this.applyAnnotationChange(annotation, action);
            });
        }
    }
    documentViewerZoomChaged(event) {
        this.placeholderToolbar.setZoom(event.detail);
    }
    addNewPlaceholder(addedAnnotation, metadata) {
        const id = this.getNewId().toString();
        const placeholder = new ESignPlaceholder(false, id, this.documentId, this.signatoryId, metadata.placeholderType, new PlaceholderLocation(addedAnnotation.location.pageNumber, addedAnnotation.location.coordinates.x, addedAnnotation.location.coordinates.y), ESIGN_PLACEHOLDER_SIZE);
        this.placeholders.push(placeholder);
        metadata.id = id;
        this.newPlaceholderAdded = true;
        this.updateEsignCompleteStatus();
    }
    updatePlaceholder(id, updatedAnnotation) {
        const placeholderToUpdate = this.placeholders.find(p => p.id === id);
        if (placeholderToUpdate) {
            placeholderToUpdate.location.x = updatedAnnotation.location.coordinates.x;
            placeholderToUpdate.location.y = updatedAnnotation.location.coordinates.y;
            this.persistedPlaceholdersChanged = this.persistedPlaceholdersChanged || placeholderToUpdate.persisted;
        }
    }
    deletePlaceholder(id) {
        const placeholder = this.placeholders.find(p => p.id === id);
        if (placeholder) {
            placeholder.isDeleted = true;
            if (placeholder.persisted) {
                this.persistedPlaceholdersChanged = true;
            }
            else {
                this.newPlaceholderAdded = this.placeholders.some(p => !p.persisted && !p.isDeleted);
            }
        }
        this.updateEsignCompleteStatus();
    }
    getPlaceholderDescriptions(placeholders) {
        const result = placeholders
            .filter(placeholder => !!(placeholder.recipientId && placeholder.placeholderType))
            .map(this.createPlaceholderDescription.bind(this));
        return result;
    }
    applyAnnotationChange(annotation, action) {
        const metadata = this.getMetadata(annotation);
        if (metadata) {
            const id = metadata.id;
            if (id) {
                if (action === 'modify') {
                    this.updatePlaceholder(id, annotation);
                }
                else if (action === 'delete') {
                    this.deletePlaceholder(id);
                }
            }
            else if (action === 'add') {
                this.addNewPlaceholder(annotation, metadata);
            }
            // give file viewer updated metadata
            this.setMetadata(annotation, metadata);
        }
    }
    createPlaceholderDescription(placeholder) {
        const color = this.signatorySelector.getSignatoryColor(placeholder.recipientId);
        const placeholderImage = this.placeholderToolbar.getPlaceholderImage(placeholder.placeholderType, color);
        const metadata = new ESignPlaceholderDropData(placeholder.placeholderType, placeholder.recipientId, placeholder.id);
        return {
            img: placeholderImage,
            location: new AnnotationLocation({
                x: placeholder.location.x,
                y: placeholder.location.y,
            }, placeholder.location.pageNumber),
            size: placeholder.size,
            metadata: JSON.stringify(metadata),
        };
    }
    getMetadata(annotation) {
        const metadataString = annotation.metadata;
        const metadata = JSON.parse(metadataString);
        return metadata;
    }
    setMetadata(annotation, metadata) {
        annotation.metadata = JSON.stringify(metadata);
    }
    updateEsignCompleteStatus() {
        const documentIds = this.documentSelector.getDocumentIds();
        const signatoryIds = this.signatorySelector.getSignatoryIds();
        const incompleteDocuments = new Set();
        const incompleteSignatories = new Set();
        let allComplete = true;
        for (const documentId of documentIds) {
            for (const signatoryId of signatoryIds) {
                const placeholderDroped = this.placeholders.some(placeholder => !placeholder.isDeleted && placeholder.documentId === documentId && placeholder.recipientId === signatoryId);
                if (!placeholderDroped) {
                    incompleteDocuments.add(documentId);
                    incompleteSignatories.add(signatoryId);
                    allComplete = false;
                }
            }
            const documentIsComplete = !incompleteDocuments.has(documentId);
            this.documentSelector.setEsignCompleteStatus(documentId, documentIsComplete);
        }
        for (const signatoryId of signatoryIds) {
            const signatoryIsComplete = !incompleteSignatories.has(signatoryId);
            this.signatorySelector.setEsignCompleteStatus(signatoryId, signatoryIsComplete);
        }
        this._isEsignComplete = allComplete;
    }
    getNewId() {
        let maxUsedId = Math.max(...this.placeholders.map(p => Number(p.id)).filter(id => !!id));
        if (maxUsedId === -Infinity) {
            maxUsedId = 0;
        }
        return maxUsedId + 1;
    }
    markPlaceholdersPersisted() {
        this.placeholders.forEach(p => (p.persisted = true));
    }
    giveIdsToPlaceholders() {
        let id = this.getNewId();
        this.placeholders.forEach(p => {
            if (!p.id) {
                p.id = id.toString();
                id++;
            }
        });
    }
}

const WEB_VIEWER_LIBRARY_PATH = new InjectionToken('PDFTron library path');

class EsignFileViewerComponent {
    constructor(webViewerLibPath) {
        this.options = defaultOptions;
        this.placeholders = [];
        this.loadingChange = new EventEmitter();
        this.loadedDocumentChange = new EventEmitter();
        this.annotationChange = new EventEmitter();
        this.zoomChange = new EventEmitter();
        this.documentMetadataLoaded = new EventEmitter();
        this.options.webViewerLibPath = webViewerLibPath;
        this.options.enablePrintHotKey = false;
        this.options.editable = undefined;
        this.options.enablePdfFeatures = false;
        register();
    }
    set esignDocuments(esignDocuments) {
        this._esignDocuments = esignDocuments;
        this.setSelectedDocument();
    }
    set selectedDocumentId(value) {
        this._selectedDocumentId = value;
        this.setSelectedDocument();
    }
    set additionalPdfTronElements(additionalPdfTronElements) {
        this.options.additionalPdfTronElements = additionalPdfTronElements;
    }
    set disableDefaultPdfTronElements(disableDefaultPdfTronElements) {
        this.options.disableDefaultPdfTronElements = disableDefaultPdfTronElements;
    }
    set readonly(readonly) {
        this.options.readonly = readonly;
    }
    setSelectedDocument() {
        if (this._selectedDocumentId && this._esignDocuments) {
            const currentDocument = this._esignDocuments.find(edoc => edoc.id === this._selectedDocumentId);
            if (currentDocument && currentDocument !== this.document) {
                this.container = currentDocument.parent;
                this.document = currentDocument;
            }
        }
    }
}
/** @nocollapse */ EsignFileViewerComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignFileViewerComponent, deps: [{ token: WEB_VIEWER_LIBRARY_PATH }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EsignFileViewerComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: EsignFileViewerComponent, selector: "bdc-esign-file-viewer", inputs: { esignDocuments: "esignDocuments", selectedDocumentId: "selectedDocumentId", additionalPdfTronElements: "additionalPdfTronElements", disableDefaultPdfTronElements: "disableDefaultPdfTronElements", placeholders: "placeholders", readonly: "readonly" }, outputs: { loadingChange: "loadingChange", loadedDocumentChange: "loadedDocumentChange", annotationChange: "annotationChange", zoomChange: "zoomChange", documentMetadataLoaded: "documentMetadataLoaded" }, ngImport: i0, template: "<dms-viewer-with-annotations\n\t[document]=\"document\"\n\t[container]=\"container\"\n\t[options]=\"options\"\n\t[annotations]=\"placeholders\"\n\t(loadingChange)=\"loadingChange.emit($event)\"\n\t(loadedDocumentChange)=\"loadedDocumentChange.emit($event)\"\n\t(annotationChange)=\"annotationChange.emit($event)\"\n\t(zoomChange)=\"zoomChange.emit($event)\"\n\t(documentMetadataLoaded)=\"documentMetadataLoaded.emit($event)\"\n>\n</dms-viewer-with-annotations>\n" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignFileViewerComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-esign-file-viewer', template: "<dms-viewer-with-annotations\n\t[document]=\"document\"\n\t[container]=\"container\"\n\t[options]=\"options\"\n\t[annotations]=\"placeholders\"\n\t(loadingChange)=\"loadingChange.emit($event)\"\n\t(loadedDocumentChange)=\"loadedDocumentChange.emit($event)\"\n\t(annotationChange)=\"annotationChange.emit($event)\"\n\t(zoomChange)=\"zoomChange.emit($event)\"\n\t(documentMetadataLoaded)=\"documentMetadataLoaded.emit($event)\"\n>\n</dms-viewer-with-annotations>\n" }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: [WEB_VIEWER_LIBRARY_PATH]
                    }] }];
    }, propDecorators: { esignDocuments: [{
                type: Input
            }], selectedDocumentId: [{
                type: Input
            }], additionalPdfTronElements: [{
                type: Input
            }], disableDefaultPdfTronElements: [{
                type: Input
            }], placeholders: [{
                type: Input
            }], readonly: [{
                type: Input
            }], loadingChange: [{
                type: Output
            }], loadedDocumentChange: [{
                type: Output
            }], annotationChange: [{
                type: Output
            }], zoomChange: [{
                type: Output
            }], documentMetadataLoaded: [{
                type: Output
            }] } });

class EsignDocumentMetadata {
    constructor(documentId, totalPages) {
        this.documentId = documentId;
        this.totalPages = totalPages;
    }
}

class DocumentListComponent {
    constructor() {
        this.documents = [];
        this.documentSelected = new EventEmitter();
    }
    set esignDocuments(esignDocuments) {
        this._esignDocuments = esignDocuments;
        this.documents = esignDocuments.documents.map(eDoc => {
            return {
                label: eDoc.document.name,
                selected: esignDocuments.selectedDocumentId === eDoc.document.id,
                data: eDoc,
            };
        });
    }
    get esignDocuments() {
        return this._esignDocuments;
    }
    onSelect(item) {
        this.documentSelected.emit(item.data);
    }
    getFileInfo(templateItem) {
        const fileInfo = getFileInfo(templateItem.label);
        return {
            fileName: fileInfo.fileName,
            extension: fileInfo.extension ? '.' + fileInfo.extension : '',
        };
    }
    getDocumentIds() {
        return this.esignDocuments.documents.map(ed => ed.document.id);
    }
    setEsignCompleteStatus(documentId, isComplete) {
        const document = this.esignDocuments.documents.find(ed => ed.document.id === documentId);
        if (document) {
            document.isEsignComplete = isComplete;
        }
    }
}
/** @nocollapse */ DocumentListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentListComponent, selector: "bdc-document-list", inputs: { esignDocuments: "esignDocuments" }, outputs: { documentSelected: "documentSelected" }, ngImport: i0, template: "<ng-template #itemTemplate let-item=\"item\">\n\t<div class=\"item-with-checkmark\">\n\t\t<div class=\"item-template-container\">\n\t\t\t<div class=\"name\">{{getFileInfo(item).fileName}}</div>\n\t\t\t<div>{{getFileInfo(item).extension}}</div>\n\t\t</div>\n\t\t<div *ngIf=\"item.data.isEsignComplete\" class=\"check-status-mark\">\n\t\t\t<i class=\"bento-icon-checkmark\"></i>\n\t\t</div>\n\t</div>\n</ng-template>\n\n<div class=\"bdc-document-list\">\n\t<bento-side-nav class=\"document-list\" [itemTemplate]=\"itemTemplate\" [items]=\"documents\" (select)=\"onSelect($event)\">\n\t</bento-side-nav>\n</div>\n", styles: [".bdc-document-list{display:flex}.bdc-document-list .document-list{border:none;font-family:Arial;padding:0;width:100%}.bdc-document-list .document-list ul{margin:0}.bdc-document-list .document-list ul>li .label{border-color:#d5d4d9;border-top:none}.bdc-document-list .document-list ul>li:last-child .label{border-bottom:none}.bdc-document-list .document-list ul>li .label a{font-size:13px;line-height:2;text-decoration:none}.bdc-document-list .document-list ul>li .label a:hover{text-decoration:none}.bdc-document-list .document-list .bento-side-nav-leaf.current-page a{font-size:13px;font-weight:700}.bdc-document-list .document-list .bento-side-nav-leaf.current-page a:focus{text-decoration:none}.bdc-document-list .item-with-checkmark{display:flex}.bdc-document-list .item-with-checkmark .item-template-container{display:flex;flex-grow:2;margin-right:10px;min-width:calc(100% - 30px)}.bdc-document-list .item-with-checkmark .item-template-container .name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bdc-document-list .item-with-checkmark .check-status-mark{color:#387c2b;margin-right:5px}.bdc-document-list .item-with-checkmark .check-status-mark i{font-weight:700;vertical-align:bottom}\n"], components: [{ type: i2.BentoSideNavComponent, selector: "bento-side-nav", inputs: ["items", "collapsible", "categoryExpandOnly", "selectableCategories", "searchable", "itemTemplate", "filterCompareFunc"], outputs: ["select"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-list', encapsulation: ViewEncapsulation.None, template: "<ng-template #itemTemplate let-item=\"item\">\n\t<div class=\"item-with-checkmark\">\n\t\t<div class=\"item-template-container\">\n\t\t\t<div class=\"name\">{{getFileInfo(item).fileName}}</div>\n\t\t\t<div>{{getFileInfo(item).extension}}</div>\n\t\t</div>\n\t\t<div *ngIf=\"item.data.isEsignComplete\" class=\"check-status-mark\">\n\t\t\t<i class=\"bento-icon-checkmark\"></i>\n\t\t</div>\n\t</div>\n</ng-template>\n\n<div class=\"bdc-document-list\">\n\t<bento-side-nav class=\"document-list\" [itemTemplate]=\"itemTemplate\" [items]=\"documents\" (select)=\"onSelect($event)\">\n\t</bento-side-nav>\n</div>\n", styles: [".bdc-document-list{display:flex}.bdc-document-list .document-list{border:none;font-family:Arial;padding:0;width:100%}.bdc-document-list .document-list ul{margin:0}.bdc-document-list .document-list ul>li .label{border-color:#d5d4d9;border-top:none}.bdc-document-list .document-list ul>li:last-child .label{border-bottom:none}.bdc-document-list .document-list ul>li .label a{font-size:13px;line-height:2;text-decoration:none}.bdc-document-list .document-list ul>li .label a:hover{text-decoration:none}.bdc-document-list .document-list .bento-side-nav-leaf.current-page a{font-size:13px;font-weight:700}.bdc-document-list .document-list .bento-side-nav-leaf.current-page a:focus{text-decoration:none}.bdc-document-list .item-with-checkmark{display:flex}.bdc-document-list .item-with-checkmark .item-template-container{display:flex;flex-grow:2;margin-right:10px;min-width:calc(100% - 30px)}.bdc-document-list .item-with-checkmark .item-template-container .name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.bdc-document-list .item-with-checkmark .check-status-mark{color:#387c2b;margin-right:5px}.bdc-document-list .item-with-checkmark .check-status-mark i{font-weight:700;vertical-align:bottom}\n"] }]
        }], propDecorators: { esignDocuments: [{
                type: Input
            }], documentSelected: [{
                type: Output
            }] } });

class ModalCloseService {
    constructor(location) {
        this.location = location;
    }
    subscribeOnBack(callback) {
        const subscription = this.location.subscribe(() => {
            callback();
            subscription.unsubscribe();
        });
    }
    goBack() {
        this.location.back();
    }
}
/** @nocollapse */ ModalCloseService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ModalCloseService, deps: [{ token: i2$1.Location }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ ModalCloseService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ModalCloseService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ModalCloseService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i2$1.Location }]; } });

const confirmationButtonsTranslationKeys = [
    {
        button: 0 /* OK */,
        key: marker('Blue.DocumentComponents.Button.Ok'),
    },
    {
        button: 1 /* Cancel */,
        key: marker('Blue.DocumentComponents.Button.Cancel'),
    },
    {
        button: 2 /* Yes */,
        key: marker('Blue.DocumentComponents.Button.Yes'),
    },
    {
        button: 3 /* No */,
        key: marker('Blue.DocumentComponents.Button.No'),
    },
    {
        button: 4 /* Save */,
        key: marker('Blue.DocumentComponents.Button.Save'),
    },
    {
        button: 5 /* Close */,
        key: marker('Blue.DocumentComponents.Button.Close'),
    },
    {
        button: 6 /* LearnMore */,
        key: marker('Blue.DocumentComponents.Button.LearnMore'),
    },
];

class ConfirmationPopupComponent {
    constructor(activeModal) {
        this.activeModal = activeModal;
        this.title = {};
        this.message = {};
        this.buttonsInitialized = false;
        this.visibleButtons = [];
    }
    get hasCustomTitle() {
        return !!this.title.text || !!this.title.translationKey;
    }
    set Buttons(value) {
        this._buttons = value;
        this.buttonsInitialized = false;
    }
    get Buttons() {
        return this._buttons || this.getOKButton();
    }
    setConfig(config) {
        this.title = config.title || {};
        this.message = config.message || {};
        this._buttons = config.buttons;
        this.buttonsInitialized = false;
        this.iconName = config.iconName;
        this.iconColorType = config.iconColorType;
    }
    getVisibleButtons() {
        if (!this.buttonsInitialized) {
            this.visibleButtons = this.Buttons.map(buttonConfig => ({
                translationKey: this.getButtonTranslationKey(buttonConfig.button),
                result: buttonConfig.button,
                isPrimary: buttonConfig.isPrimary,
                dataQeId: 'bdc-confirmation-popup-button-' + buttonConfig.button,
            }));
            this.buttonsInitialized = true;
        }
        return this.visibleButtons;
    }
    getOKButton() {
        return [
            {
                button: 0 /* OK */,
                isPrimary: true,
            },
        ];
    }
    getButtonTranslationKey(button) {
        return confirmationButtonsTranslationKeys.find(k => k.button === button).key;
    }
}
/** @nocollapse */ ConfirmationPopupComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationPopupComponent, deps: [{ token: i1$2.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ConfirmationPopupComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ConfirmationPopupComponent, selector: "bdc-confirmation-popup", host: { properties: { "class.bui-modal-has-title": "this.hasCustomTitle" } }, ngImport: i0, template: "<h3 class=\"modal-header h2\">{{ title.text || (title.translationKey && (title.translationKey | translate)) }}</h3>\n\n<div class=\"modal-body modal-confirmation-text modal-body-text\">\n\t<i\n\t\t*ngIf=\"iconName\"\n\t\tclass=\"modal-confirmation-icon modal-warning-icon {{ iconName }} text-{{ iconColorType }}\"\n\t\taria-hidden=\"true\"\n\t></i>\n\t<div>{{ message.text || (message.translationKey && (message.translationKey | translate)) }}</div>\n</div>\n\n<div class=\"buttons-container modal-footer\">\n\t<button\n\t\t*ngFor=\"let buttonConfig of getVisibleButtons()\"\n\t\ttype=\"button\"\n\t\tclass=\"btn\"\n\t\tngbAutoFocus\n\t\t[ngClass]=\"buttonConfig.isPrimary ? 'btn-primary' : 'btn-outline-primary'\"\n\t\t(click)=\"activeModal.close(buttonConfig.result)\"\n\t\t[attr.data-qe-id]=\"buttonConfig.dataQeId\"\n\t>\n\t\t{{buttonConfig.translationKey | translate}}\n\t</button>\n</div>\n", styles: ["bdc-confirmation-popup .close{color:#37383d;filter:none;height:58px;opacity:1;position:absolute;right:0;text-shadow:none;top:0;transition:color .2s;width:58px}@media (prefers-reduced-motion: reduce){bdc-confirmation-popup .close{transition:none}}bdc-confirmation-popup .close:hover,bdc-confirmation-popup .close:focus{color:#93939c}bdc-confirmation-popup .close:focus{box-shadow:none!important;outline:1px dotted #000!important;outline-offset:0!important;z-index:1}bdc-confirmation-popup .close i{font-size:17px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}bdc-confirmation-popup :not(.bui-modal-has-title) .modal-header{display:none}bdc-confirmation-popup .modal-header{display:none}bdc-confirmation-popup :not(.bui-modal-has-title) .modal-body{font-family:BentoRegular,arial,helvetica,sans-serif;font-size:20px;line-height:1.2em}bdc-confirmation-popup .modal-body{display:flex;font-size:20px}bdc-confirmation-popup .modal-body .modal-confirmation-icon{align-self:initial;line-height:1;margin-top:-2px}bdc-confirmation-popup{display:flex;flex-direction:column;min-height:128px}bdc-confirmation-popup .modal-footer{justify-self:flex-end}bdc-confirmation-popup .buttons-container.modal-footer .btn{font-size:1rem;height:2.143rem;line-height:2.143rem;min-width:6.0714rem;padding:0 .85rem;text-transform:none}bdc-confirmation-popup .modal-body.modal-confirmation-text.modal-body-text .modal-confirmation-icon.modal-warning-icon{font-size:1.75rem;margin-right:.5rem}.modal-backdrop.confirmation-popup-backdrop{opacity:.1!important}bdc-confirmation-popup .buttons-container.modal-footer .btn.btn-outline-primary:hover{background-color:#fff;cursor:pointer}bdc-confirmation-popup .buttons-container.modal-footer .btn.btn-outline-primary:focus{border-color:#37383d;box-shadow:0 0 0 .1rem #b2b2b8}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }], pipes: { "translate": i1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationPopupComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-confirmation-popup', encapsulation: ViewEncapsulation.None, template: "<h3 class=\"modal-header h2\">{{ title.text || (title.translationKey && (title.translationKey | translate)) }}</h3>\n\n<div class=\"modal-body modal-confirmation-text modal-body-text\">\n\t<i\n\t\t*ngIf=\"iconName\"\n\t\tclass=\"modal-confirmation-icon modal-warning-icon {{ iconName }} text-{{ iconColorType }}\"\n\t\taria-hidden=\"true\"\n\t></i>\n\t<div>{{ message.text || (message.translationKey && (message.translationKey | translate)) }}</div>\n</div>\n\n<div class=\"buttons-container modal-footer\">\n\t<button\n\t\t*ngFor=\"let buttonConfig of getVisibleButtons()\"\n\t\ttype=\"button\"\n\t\tclass=\"btn\"\n\t\tngbAutoFocus\n\t\t[ngClass]=\"buttonConfig.isPrimary ? 'btn-primary' : 'btn-outline-primary'\"\n\t\t(click)=\"activeModal.close(buttonConfig.result)\"\n\t\t[attr.data-qe-id]=\"buttonConfig.dataQeId\"\n\t>\n\t\t{{buttonConfig.translationKey | translate}}\n\t</button>\n</div>\n", styles: ["bdc-confirmation-popup .close{color:#37383d;filter:none;height:58px;opacity:1;position:absolute;right:0;text-shadow:none;top:0;transition:color .2s;width:58px}@media (prefers-reduced-motion: reduce){bdc-confirmation-popup .close{transition:none}}bdc-confirmation-popup .close:hover,bdc-confirmation-popup .close:focus{color:#93939c}bdc-confirmation-popup .close:focus{box-shadow:none!important;outline:1px dotted #000!important;outline-offset:0!important;z-index:1}bdc-confirmation-popup .close i{font-size:17px;left:50%;position:absolute;top:50%;transform:translate(-50%,-50%)}bdc-confirmation-popup :not(.bui-modal-has-title) .modal-header{display:none}bdc-confirmation-popup .modal-header{display:none}bdc-confirmation-popup :not(.bui-modal-has-title) .modal-body{font-family:BentoRegular,arial,helvetica,sans-serif;font-size:20px;line-height:1.2em}bdc-confirmation-popup .modal-body{display:flex;font-size:20px}bdc-confirmation-popup .modal-body .modal-confirmation-icon{align-self:initial;line-height:1;margin-top:-2px}bdc-confirmation-popup{display:flex;flex-direction:column;min-height:128px}bdc-confirmation-popup .modal-footer{justify-self:flex-end}bdc-confirmation-popup .buttons-container.modal-footer .btn{font-size:1rem;height:2.143rem;line-height:2.143rem;min-width:6.0714rem;padding:0 .85rem;text-transform:none}bdc-confirmation-popup .modal-body.modal-confirmation-text.modal-body-text .modal-confirmation-icon.modal-warning-icon{font-size:1.75rem;margin-right:.5rem}.modal-backdrop.confirmation-popup-backdrop{opacity:.1!important}bdc-confirmation-popup .buttons-container.modal-footer .btn.btn-outline-primary:hover{background-color:#fff;cursor:pointer}bdc-confirmation-popup .buttons-container.modal-footer .btn.btn-outline-primary:focus{border-color:#37383d;box-shadow:0 0 0 .1rem #b2b2b8}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }]; }, propDecorators: { hasCustomTitle: [{
                type: HostBinding,
                args: ['class.bui-modal-has-title']
            }] } });

class ConfirmationModalService {
    constructor(ngbModalService) {
        this.ngbModalService = ngbModalService;
    }
    open(config, options) {
        var _a;
        options.windowClass = (_a = options.windowClass) !== null && _a !== void 0 ? _a : 'bui-modal-confirmation';
        const modal = this.ngbModalService.open(ConfirmationPopupComponent, options);
        modal.componentInstance.setConfig(config);
        return modal;
    }
}
/** @nocollapse */ ConfirmationModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ ConfirmationModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class SideBoxComponent {
    constructor() {
        this.header = '';
    }
}
/** @nocollapse */ SideBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SideBoxComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SideBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SideBoxComponent, selector: "bdc-side-box", inputs: { header: "header" }, ngImport: i0, template: "<div class=\"side-box-container\">\n\t<div class=\"header\">\n\t\t<h1>{{header}}</h1>\n\t</div>\n\t<ng-content></ng-content>\n</div>\n", styles: [".side-box-container{border-color:#d5d4d9;border-style:solid;border-width:0 1px 1px 1px}.header{align-items:center;background-color:#f4f5f7;border-bottom:1px solid #d5d4d9;display:flex;height:44px}.header h1{color:#212121;font-family:Knowledge Regular;font-size:22px;margin:0;padding-left:20px}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SideBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-side-box', template: "<div class=\"side-box-container\">\n\t<div class=\"header\">\n\t\t<h1>{{header}}</h1>\n\t</div>\n\t<ng-content></ng-content>\n</div>\n", styles: [".side-box-container{border-color:#d5d4d9;border-style:solid;border-width:0 1px 1px 1px}.header{align-items:center;background-color:#f4f5f7;border-bottom:1px solid #d5d4d9;display:flex;height:44px}.header h1{color:#212121;font-family:Knowledge Regular;font-size:22px;margin:0;padding-left:20px}\n"] }]
        }], propDecorators: { header: [{
                type: Input
            }] } });

class EsignModalComponent {
    constructor(activeModal, modalCloseService, confirmationModalService) {
        this.activeModal = activeModal;
        this.modalCloseService = modalCloseService;
        this.confirmationModalService = confirmationModalService;
        this.viewerIsLoading = false;
        this.loadedDocumentsMetadata = [];
        this.disableDefaultPdfTronElements = false;
        this.additionalPdfTronElements = [PdfTronElement.annotationPopup, PdfTronElement.annotationDeleteButton];
        this.placeholders = [];
        this.readonly = false;
        this.alertVisible = false;
    }
    get alertShowTimeSeconds() {
        return 5;
    }
    get esignStateController() {
        return this._esignStateController;
    }
    set esignDocuments(value) {
        this._esignDocuments = value;
        this.documents = value.documents.map(eDoc => eDoc.document);
    }
    get esignDocuments() {
        return this._esignDocuments;
    }
    get hasChanges() {
        return !!this.esignStateController && this.esignStateController.placeholdersChanged;
    }
    escPressHandler() {
        this.cancelClick();
    }
    ngOnInit() {
        this.modalCloseService.subscribeOnBack(() => this.activeModal.close('cancel'));
    }
    ngAfterViewInit() {
        this._esignStateController = new EsignPlaceholderStateController(this.signatoryList, this.placeholderToolbar, this.documentViewer, this.documentSelector);
        this._esignStateController.placeholders = this.placeholders;
        if (this.selectedSignatory) {
            this._esignStateController.signatorySelected(this.selectedSignatory);
        }
    }
    signatorySelected(selectedSignatory) {
        this.selectedSignatory = selectedSignatory;
    }
    documentSelected(item) {
        this.selectedDocumentId = item.document.id;
    }
    viewerLoadingStateChange(isLoading) {
        this.viewerIsLoading = isLoading;
    }
    cancelClick() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.hasChanges) {
                const confirmationModalConfig = {
                    message: {
                        translationKey: marker('Blue.DocumentComponents.Cancel.Confirmation'),
                    },
                    buttons: [
                        {
                            button: 2 /* Yes */,
                            isPrimary: true,
                        },
                        {
                            button: 3 /* No */,
                            isPrimary: false,
                        },
                    ],
                    iconName: 'bento-icon-warning-filled',
                    iconColorType: 'danger',
                };
                const confirmationModal = this.confirmationModalService.open(confirmationModalConfig, {
                    backdrop: 'static',
                    container: this.container,
                });
                const buttonPressed = yield confirmationModal.result;
                if (buttonPressed === 2 /* Yes */) {
                    this.activeModal.dismiss('Cancel');
                }
            }
            else {
                this.activeModal.dismiss('Cancel');
            }
        });
    }
    documentMetadataChange(documentChange) {
        const hasDocumentMetadata = this.loadedDocumentsMetadata.some(m => m.documentId === this.selectedDocumentId);
        if (!hasDocumentMetadata) {
            this.loadedDocumentsMetadata.push(new EsignDocumentMetadata(this.selectedDocumentId, documentChange.totalPages));
        }
    }
    saveClick() {
        const isEsignComplete = this.esignStateController.isEsignComplete();
        if (isEsignComplete) {
            this.activeModal.close('Save');
        }
        else {
            this.showAlert();
        }
    }
    alertCloseClick() {
        if (this.alertHideTimeout) {
            clearTimeout(this.alertHideTimeout);
        }
        this.hideAlert();
    }
    ngOnDestroy() {
        if (this.esignStateController) {
            this.esignStateController.dispose();
        }
    }
    showAlert() {
        this.alertVisible = true;
        if (this.alertHideTimeout) {
            clearTimeout(this.alertHideTimeout);
        }
        this.alertHideTimeout = setTimeout(this.hideAlert.bind(this), this.alertShowTimeSeconds * 1000);
    }
    hideAlert() {
        this.alertVisible = false;
    }
}
/** @nocollapse */ EsignModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalComponent, deps: [{ token: i1$2.NgbActiveModal }, { token: ModalCloseService }, { token: ConfirmationModalService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EsignModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: EsignModalComponent, selector: "bdc-esign-modal", inputs: { recipients: "recipients", esignDocuments: "esignDocuments", selectedDocumentId: "selectedDocumentId", placeholders: "placeholders", readonly: "readonly", container: "container" }, host: { listeners: { "document:keydown.escape": "escPressHandler()" } }, viewQueries: [{ propertyName: "signatoryList", first: true, predicate: SignatoryListComponent, descendants: true }, { propertyName: "placeholderToolbar", first: true, predicate: PlaceholderBoxesComponent, descendants: true }, { propertyName: "documentViewer", first: true, predicate: EsignFileViewerComponent, descendants: true }, { propertyName: "documentSelector", first: true, predicate: DocumentListComponent, descendants: true }], ngImport: i0, template: "<div class=\"esign-container\">\n\t<div class=\"modal-header\">\n\t\t<div>\n\t\t\t<h1 *ngIf=\"!readonly\" class=\"modal-title\">\n\t\t\t\t{{ 'Blue.DocumentComponents.EsignModal.EsignModalHeader' | translate }}\n\t\t\t</h1>\n\t\t\t<h1 *ngIf=\"readonly\" class=\"modal-title\">\n\t\t\t\t{{ 'Blue.DocumentComponents.DocumentApprovals.eSignaturePlaceholders' | translate }}\n\t\t\t</h1>\n\t\t</div>\n\t\t<div class=\"esign-header-right-content\">\n\t\t\t<button\n\t\t\t\t*ngIf=\"!readonly\"\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t\t[disabled]=\"!hasChanges\"\n\t\t\t\t(click)=\"saveClick()\"\n\t\t\t>\n\t\t\t\t{{ 'Blue.DocumentComponents.Button.Save' | translate }}\n\t\t\t</button>\n\t\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancelClick()\">\n\t\t\t\t{{ 'Blue.DocumentComponents.Button.Cancel' | translate }}\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<div class=\"esign-container-content\">\n\t\t<div class=\"column left\">\n\t\t\t<bdc-side-box header=\"{{'Blue.DocumentComponents.EsignModal.SignatoryList.Signatories' | translate}}\">\n\t\t\t\t<bdc-signatory-list [recipients]=\"recipients\" [readonly]=\"readonly\" (signatorySelected)=\"signatorySelected($event)\">\n\t\t\t\t</bdc-signatory-list>\n\t\t\t</bdc-side-box>\n\t\t\t<bdc-side-box header=\"{{'Blue.DocumentComponents.PlaceholderBox.Placeholders' | translate}}\">\n\t\t\t\t<bdc-placeholder-boxes [readonly]=\"readonly\" [selectedSignatory]=\"selectedSignatory\"></bdc-placeholder-boxes>\n\t\t\t</bdc-side-box>\n\t\t</div>\n\t\t<div class=\"column pdf-content\" [bentoBusyLoader]=\"viewerIsLoading\">\n\t\t\t<bdc-esign-file-viewer\n\t\t\t\t[readonly]=\"readonly\"\n\t\t\t\t[esignDocuments]=\"documents\"\n\t\t\t\t[selectedDocumentId]=\"selectedDocumentId\"\n\t\t\t\t[disableDefaultPdfTronElements]=\"disableDefaultPdfTronElements\"\n\t\t\t\t[additionalPdfTronElements]=\"additionalPdfTronElements\"\n\t\t\t\t(loadingChange)=\"viewerLoadingStateChange($event.detail)\"\n\t\t\t\t(documentMetadataLoaded)=\"documentMetadataChange($event.detail)\"\n\t\t\t>\n\t\t\t</bdc-esign-file-viewer>\n\t\t\t<div class=\"alerts-container\">\n\t\t\t\t<bm-alert *ngIf=\"alertVisible\" [type]=\"'danger'\" [closeable]=\"true\" (close)=\"alertCloseClick()\">\n\t\t\t\t\t<span>{{ 'Blue.DocumentComponents.EsignModal.DocumentSignatoryValidationAlert' | translate }}</span>\n\t\t\t\t</bm-alert>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"column right\">\n\t\t\t<bdc-side-box header=\"{{'Blue.DocumentComponents.Common.Documents' | translate}}\">\n\t\t\t\t<bdc-document-list [esignDocuments]=\"esignDocuments\" (documentSelected)=\"documentSelected($event)\">\n\t\t\t\t</bdc-document-list>\n\t\t\t</bdc-side-box>\n\t\t</div>\n\t</div>\n</div>\n", styles: ["::ng-deep .esign-modal-window .modal-content{overflow:auto;width:100%!important}h1.modal-title{margin:0 0 0 20px}.esign-container{height:90%}.esign-header .btn{margin-right:5px}.esign-header-right-content{display:flex;justify-content:flex-end}.esign-container-content{display:flex;height:100%}.esign-header-right-content .btn-outline-primary{margin-left:10px}.column.left{width:327px}.column.pdf-content{flex:.75;height:100%;padding:5px 5px 0}.column.right{flex:.25;width:20%}.alerts-container{margin:auto;top:100%;transform:translateY(-100%);width:50%}@media (max-width: 1000px){.alerts-container{width:calc(100% - 30px)}}.esign-container .modal-header:before,.esign-container .modal-header:after{content:none}.esign-container .modal-header{justify-content:space-between}.esign-container .modal-header .btn{font-size:1rem;height:2.143rem;line-height:2.143rem;min-width:6.0714rem;padding:0 .85rem}\n"], components: [{ type: SideBoxComponent, selector: "bdc-side-box", inputs: ["header"] }, { type: SignatoryListComponent, selector: "bdc-signatory-list", inputs: ["readonly", "recipients"], outputs: ["signatorySelected"] }, { type: PlaceholderBoxesComponent, selector: "bdc-placeholder-boxes", inputs: ["selectedSignatory", "readonly"] }, { type: EsignFileViewerComponent, selector: "bdc-esign-file-viewer", inputs: ["esignDocuments", "selectedDocumentId", "additionalPdfTronElements", "disableDefaultPdfTronElements", "placeholders", "readonly"], outputs: ["loadingChange", "loadedDocumentChange", "annotationChange", "zoomChange", "documentMetadataLoaded"] }, { type: DocumentListComponent, selector: "bdc-document-list", inputs: ["esignDocuments"], outputs: ["documentSelected"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-esign-modal', template: "<div class=\"esign-container\">\n\t<div class=\"modal-header\">\n\t\t<div>\n\t\t\t<h1 *ngIf=\"!readonly\" class=\"modal-title\">\n\t\t\t\t{{ 'Blue.DocumentComponents.EsignModal.EsignModalHeader' | translate }}\n\t\t\t</h1>\n\t\t\t<h1 *ngIf=\"readonly\" class=\"modal-title\">\n\t\t\t\t{{ 'Blue.DocumentComponents.DocumentApprovals.eSignaturePlaceholders' | translate }}\n\t\t\t</h1>\n\t\t</div>\n\t\t<div class=\"esign-header-right-content\">\n\t\t\t<button\n\t\t\t\t*ngIf=\"!readonly\"\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t\t[disabled]=\"!hasChanges\"\n\t\t\t\t(click)=\"saveClick()\"\n\t\t\t>\n\t\t\t\t{{ 'Blue.DocumentComponents.Button.Save' | translate }}\n\t\t\t</button>\n\t\t\t<button type=\"button\" class=\"btn btn-outline-primary\" (click)=\"cancelClick()\">\n\t\t\t\t{{ 'Blue.DocumentComponents.Button.Cancel' | translate }}\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<div class=\"esign-container-content\">\n\t\t<div class=\"column left\">\n\t\t\t<bdc-side-box header=\"{{'Blue.DocumentComponents.EsignModal.SignatoryList.Signatories' | translate}}\">\n\t\t\t\t<bdc-signatory-list [recipients]=\"recipients\" [readonly]=\"readonly\" (signatorySelected)=\"signatorySelected($event)\">\n\t\t\t\t</bdc-signatory-list>\n\t\t\t</bdc-side-box>\n\t\t\t<bdc-side-box header=\"{{'Blue.DocumentComponents.PlaceholderBox.Placeholders' | translate}}\">\n\t\t\t\t<bdc-placeholder-boxes [readonly]=\"readonly\" [selectedSignatory]=\"selectedSignatory\"></bdc-placeholder-boxes>\n\t\t\t</bdc-side-box>\n\t\t</div>\n\t\t<div class=\"column pdf-content\" [bentoBusyLoader]=\"viewerIsLoading\">\n\t\t\t<bdc-esign-file-viewer\n\t\t\t\t[readonly]=\"readonly\"\n\t\t\t\t[esignDocuments]=\"documents\"\n\t\t\t\t[selectedDocumentId]=\"selectedDocumentId\"\n\t\t\t\t[disableDefaultPdfTronElements]=\"disableDefaultPdfTronElements\"\n\t\t\t\t[additionalPdfTronElements]=\"additionalPdfTronElements\"\n\t\t\t\t(loadingChange)=\"viewerLoadingStateChange($event.detail)\"\n\t\t\t\t(documentMetadataLoaded)=\"documentMetadataChange($event.detail)\"\n\t\t\t>\n\t\t\t</bdc-esign-file-viewer>\n\t\t\t<div class=\"alerts-container\">\n\t\t\t\t<bm-alert *ngIf=\"alertVisible\" [type]=\"'danger'\" [closeable]=\"true\" (close)=\"alertCloseClick()\">\n\t\t\t\t\t<span>{{ 'Blue.DocumentComponents.EsignModal.DocumentSignatoryValidationAlert' | translate }}</span>\n\t\t\t\t</bm-alert>\n\t\t\t</div>\n\t\t</div>\n\t\t<div class=\"column right\">\n\t\t\t<bdc-side-box header=\"{{'Blue.DocumentComponents.Common.Documents' | translate}}\">\n\t\t\t\t<bdc-document-list [esignDocuments]=\"esignDocuments\" (documentSelected)=\"documentSelected($event)\">\n\t\t\t\t</bdc-document-list>\n\t\t\t</bdc-side-box>\n\t\t</div>\n\t</div>\n</div>\n", styles: ["::ng-deep .esign-modal-window .modal-content{overflow:auto;width:100%!important}h1.modal-title{margin:0 0 0 20px}.esign-container{height:90%}.esign-header .btn{margin-right:5px}.esign-header-right-content{display:flex;justify-content:flex-end}.esign-container-content{display:flex;height:100%}.esign-header-right-content .btn-outline-primary{margin-left:10px}.column.left{width:327px}.column.pdf-content{flex:.75;height:100%;padding:5px 5px 0}.column.right{flex:.25;width:20%}.alerts-container{margin:auto;top:100%;transform:translateY(-100%);width:50%}@media (max-width: 1000px){.alerts-container{width:calc(100% - 30px)}}.esign-container .modal-header:before,.esign-container .modal-header:after{content:none}.esign-container .modal-header{justify-content:space-between}.esign-container .modal-header .btn{font-size:1rem;height:2.143rem;line-height:2.143rem;min-width:6.0714rem;padding:0 .85rem}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbActiveModal }, { type: ModalCloseService }, { type: ConfirmationModalService }]; }, propDecorators: { signatoryList: [{
                type: ViewChild,
                args: [SignatoryListComponent, { static: false }]
            }], placeholderToolbar: [{
                type: ViewChild,
                args: [PlaceholderBoxesComponent, { static: false }]
            }], documentViewer: [{
                type: ViewChild,
                args: [EsignFileViewerComponent, { static: false }]
            }], documentSelector: [{
                type: ViewChild,
                args: [DocumentListComponent, { static: false }]
            }], recipients: [{
                type: Input
            }], esignDocuments: [{
                type: Input
            }], selectedDocumentId: [{
                type: Input
            }], placeholders: [{
                type: Input
            }], readonly: [{
                type: Input
            }], container: [{
                type: Input
            }], escPressHandler: [{
                type: HostListener,
                args: ['document:keydown.escape']
            }] } });

class EsignFileViewerModule {
}
/** @nocollapse */ EsignFileViewerModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignFileViewerModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EsignFileViewerModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignFileViewerModule, declarations: [EsignFileViewerComponent], imports: [CommonModule, i1.TranslateModule], exports: [EsignFileViewerComponent] });
/** @nocollapse */ EsignFileViewerModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignFileViewerModule, imports: [[CommonModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignFileViewerModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EsignFileViewerComponent],
                    imports: [CommonModule, TranslateModule.forChild()],
                    exports: [EsignFileViewerComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class ConfirmationModalModule {
}
/** @nocollapse */ ConfirmationModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ConfirmationModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalModule, declarations: [ConfirmationPopupComponent], imports: [CommonModule, i1.TranslateModule, BentoModalConfirmationModule], exports: [ConfirmationPopupComponent] });
/** @nocollapse */ ConfirmationModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalModule, imports: [[CommonModule, TranslateModule.forChild(), BentoModalConfirmationModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ConfirmationPopupComponent],
                    imports: [CommonModule, TranslateModule.forChild(), BentoModalConfirmationModule],
                    exports: [ConfirmationPopupComponent],
                }]
        }] });

class EsignModalModule {
}
/** @nocollapse */ EsignModalModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EsignModalModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalModule, declarations: [EsignModalComponent,
        SignatoryListComponent,
        DocumentListComponent,
        SideBoxComponent,
        PlaceholderBoxesComponent], imports: [CommonModule,
        BentoBusyLoaderModule,
        BentoSideNavModule, i1.TranslateModule, EsignFileViewerModule,
        BentoModalConfirmationModule,
        ConfirmationModalModule], exports: [EsignModalComponent] });
/** @nocollapse */ EsignModalModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalModule, imports: [[
            CommonModule,
            BentoBusyLoaderModule,
            BentoSideNavModule,
            TranslateModule.forChild(),
            EsignFileViewerModule,
            BentoModalConfirmationModule,
            ConfirmationModalModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        EsignModalComponent,
                        SignatoryListComponent,
                        DocumentListComponent,
                        SideBoxComponent,
                        PlaceholderBoxesComponent,
                    ],
                    imports: [
                        CommonModule,
                        BentoBusyLoaderModule,
                        BentoSideNavModule,
                        TranslateModule.forChild(),
                        EsignFileViewerModule,
                        BentoModalConfirmationModule,
                        ConfirmationModalModule,
                    ],
                    exports: [EsignModalComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class TakenIds {
    constructor() {
        this.ids = [];
        this.observers = [];
        this.takenIds$ = new Observable(observer => {
            observer.next(this.ids);
            this.observers.push(observer);
        });
    }
    notifyIdTaken(index, id) {
        if (this.ids[index] !== id) {
            this.ids[index] = id;
            this.refresh();
        }
    }
    getObservable() {
        return this.takenIds$;
    }
    removeAt(index) {
        this.ids.splice(index, 1);
        this.refresh();
    }
    reset() {
        this.observers.forEach(observer => observer.unsubscribe());
        this.observers = [];
        this.ids = [];
    }
    refresh() {
        this.observers.forEach(observer => observer.next(this.ids));
    }
}

class ContactsRequest {
    constructor(client, 
    /**
     * zero-based index
     */
    // FIXME: change param order (breaking change)
    // eslint-disable-next-line @typescript-eslint/default-param-last
    index = 0, page) {
        this.client = client;
        this.index = index;
        this.page = page;
    }
}

const PRIMARY_CONTACT_KEY = marker('Blue.DocumentComponents.ContactSelector.PrimaryContact');
/**
 * Provides a set of related datasources for contact selector components.
 * Each component receives an Observable<ContactSet>.
 * Once a contact is selected by some component it's not visible anymore for others.
 */
class ContactSelectorDatasourceFactory {
    constructor(contactService, clientService, translate) {
        this.clientService = clientService;
        this.takenIds = new TakenIds();
        this.dataRequests = [];
        this.nonFilteredContactsCache = [];
        this.nonFilteredContactsTotalPages = -1;
        this.searchPagingState = [];
        this.allContacts = [];
        this.clientId$ = new BehaviorSubject(undefined);
        this.companyId$ = new BehaviorSubject(undefined);
        this._datasources = [];
        this.primaryContactString = '';
        this.recipientsService = new RecipientsService(contactService);
        translate.get([PRIMARY_CONTACT_KEY]).subscribe(strings => {
            this.primaryContactString = strings[PRIMARY_CONTACT_KEY];
        });
        const factory = this;
        // tslint thinks I'm using a deprecated version of subscribe
        const idPair = combineLatest(this.companyId$, this.clientId$, (companyId, clientId) => [companyId, clientId]);
        idPair
            .pipe(distinctUntilChanged((previous, current) => previous[0] === current[0] && previous[1] === current[1]))
            .subscribe({ next: factory.resetSearchState.bind(factory) });
        this.client$ = idPair.pipe(switchMap((newIds) => {
            const newCompanyId = newIds[0];
            const newClientId = newIds[1];
            factory.companyId = newCompanyId;
            let fetchedClientObservable;
            if (!newClientId && !factory.clientId) {
                fetchedClientObservable = of(undefined);
            }
            else {
                factory.clientId = newClientId;
                if (!factory.companyId || !factory.clientId) {
                    fetchedClientObservable = of(undefined);
                }
                else {
                    fetchedClientObservable = from(factory.clientService.get(factory.companyId, factory.clientId)).pipe(catchError(() => of(undefined)));
                }
            }
            return fetchedClientObservable.pipe(map(newClient => (factory.client = newClient)));
        }));
    }
    datasources() {
        return this._datasources;
    }
    setClientId(clientId) {
        this.clientId$.next(clientId);
    }
    setCompanyId(companyId) {
        this.companyId$.next(companyId);
    }
    registerNewConsumer() {
        const factory = this;
        const currentIndex = this._datasources.length;
        const initialRequest = { pageNumber: 0, reason: PaginatedItemsRequestReason.Paging };
        const newItemRequest$ = new BehaviorSubject([initialRequest, currentIndex]);
        const requestClientPairObservable = combineLatest(newItemRequest$, this.client$, (requestIndexPair, client) => {
            return new ContactsRequest(client, requestIndexPair[1], requestIndexPair[0]);
        });
        const allItemsObservable = (requestClientPairObservable.pipe(switchMap((contactsRequest) => {
            const pageRequest = contactsRequest.page;
            if (pageRequest.pageNumber === 0) {
                return NEVER;
            }
            const index = contactsRequest.index;
            let contactsObservable;
            const isNonIncrement = pageRequest.reason === PaginatedItemsRequestReason.Search;
            const isSearch = pageRequest.search && pageRequest.search.trim().length;
            if (pageRequest.pageNumber === this.searchPagingState[index].pageNumber &&
                pageRequest.search === this.searchPagingState[index].searchTerm) {
                contactsObservable = of(this.allContacts[index]);
            }
            else if (isNonIncrement) {
                if (isSearch) {
                    contactsObservable = factory
                        .fromContactsServiceCall(contactsRequest)
                        .pipe(map(factory.setAllContacts(contactsRequest)));
                }
                else {
                    contactsObservable = factory
                        .fromContactsServiceCall(contactsRequest)
                        .pipe(map(factory.cachePage(contactsRequest)), map(factory.setAllContacts(contactsRequest)));
                }
            }
            else if (isSearch) {
                contactsObservable = factory
                    .fromContactsServiceCall(contactsRequest)
                    .pipe(map(factory.updateAllContacts(contactsRequest)));
            }
            else {
                const cachedPage = factory.getCachedPage(pageRequest.pageNumber);
                if (cachedPage) {
                    contactsObservable = of(factory.updateAllContacts(contactsRequest)(cachedPage));
                }
                else {
                    contactsObservable = factory
                        .fromContactsServiceCall(contactsRequest)
                        .pipe(map(factory.cachePage(contactsRequest)), map(factory.updateAllContacts(contactsRequest)));
                }
            }
            return contactsObservable.pipe(map(contacts => [index, contacts]));
        })));
        const resultItems = combineLatest(allItemsObservable.pipe(map(([index, contacts]) => [index, new ContactSet(contacts, false)])), this.takenIds.getObservable(), this.filterFunc());
        this.searchPagingState.push(this.getInitialSearchPagingState());
        this.dataRequests.push(newItemRequest$);
        this._datasources.push(resultItems);
    }
    notifyIdTaken(index, id) {
        this.takenIds.notifyIdTaken(index, id);
    }
    notifyDataRequested(dataRequest, index) {
        this.dataRequests[index].next([dataRequest, index]);
    }
    removeAt(index) {
        this._datasources.splice(index, 1);
        this.dataRequests[index].unsubscribe();
        this.dataRequests.splice(index, 1);
        this.allContacts.splice(index, 1);
        this.searchPagingState.splice(index, 1);
        this.takenIds.removeAt(index);
        for (let i = index; i < this.dataRequests.length; i++) {
            this.dataRequests[i].next([this.dataRequests[i].value[0], i]);
        }
    }
    setCount(value) {
        if (value === 0) {
            this.reset();
        }
        else if (value > 0 && value < this._datasources.length) {
            const toRemove = this._datasources.length - value;
            for (let index = 0; index < toRemove; index++) {
                this.removeAt(this._datasources.length - 1);
            }
        }
        else if (value > this._datasources.length) {
            const toAdd = value - this._datasources.length;
            for (let index = 0; index < toAdd; index++) {
                this.registerNewConsumer();
            }
        }
    }
    reset() {
        this.takenIds.reset();
        this._datasources = [];
        if (this.dataRequests) {
            this.dataRequests.forEach(observable => {
                observable.unsubscribe();
            });
        }
        this.dataRequests = [];
        this.allContacts = [];
        this.nonFilteredContactsTotalPages = -1;
        this.nonFilteredContactsCache = [];
        this.searchPagingState = [];
    }
    resetSearchState() {
        this.allContacts.fill([]);
        this.nonFilteredContactsTotalPages = -1;
        this.nonFilteredContactsCache = [];
        this.searchPagingState.fill(this.getInitialSearchPagingState());
    }
    getInitialSearchPagingState() {
        return { pageNumber: 0, searchTerm: undefined };
    }
    cachePage(contactsRequest) {
        return (contacts) => {
            const index = contactsRequest.page.pageNumber - 1;
            if (this.nonFilteredContactsCache.length < index + 1) {
                this.nonFilteredContactsCache.length = index + 1;
            }
            this.nonFilteredContactsCache[index] = contacts;
            if (contacts.length === 0) {
                this.nonFilteredContactsTotalPages = contactsRequest.page.pageNumber - 1;
            }
            return contacts;
        };
    }
    updateAllContacts(contactsRequest) {
        if (contactsRequest.page.pageNumber === 1) {
            return this.setAllContacts(contactsRequest);
        }
        return (contacts) => {
            const index = contactsRequest.index;
            this.allContacts[index] = (this.allContacts[index] || []).concat(contacts);
            this.searchPagingState[index].pageNumber++;
            return this.allContacts[index];
        };
    }
    setAllContacts(contactsRequest) {
        return (contacts) => {
            const index = contactsRequest.index;
            if (this.allContacts.length <= index) {
                this.allContacts.length = index + 1;
            }
            this.allContacts[index] = contacts;
            this.searchPagingState[index] = {
                pageNumber: contactsRequest.page.pageNumber,
                searchTerm: contactsRequest.page.search,
            };
            return contacts;
        };
    }
    filterFunc() {
        return (nonFilteredContacts, takenIds) => {
            const index = nonFilteredContacts[0];
            const filtered = new ContactSet(nonFilteredContacts[1].contacts, nonFilteredContacts[1].incremental);
            filtered.contacts = filtered.contacts.filter((contact) => takenIds.every((id, idIndex) => index === idIndex || id !== contact.id));
            filtered.index = index;
            return filtered;
        };
    }
    fromContactsServiceCall(contactsRequest) {
        const factory = this;
        const page = contactsRequest.page;
        return from(this.getCompanyIdIfNotAvailable.bind(factory)()).pipe(switchMap(companyId => {
            factory.companyId = companyId;
            const recipientFilter = factory.getRecipientFilter(page.pageNumber, page.search);
            return from(factory.recipientsService.getRecipients(recipientFilter));
        }));
    }
    getCachedPage(pageNumber) {
        if (this.nonFilteredContactsTotalPages !== -1 && pageNumber > this.nonFilteredContactsTotalPages) {
            return [];
        }
        const pageIndex = pageNumber - 1;
        return this.nonFilteredContactsCache[pageIndex];
    }
    getRecipientFilter(pageNumber, search) {
        const CONTACTS_PER_PAGE = 100;
        let contactClient;
        let contactId;
        if (this.client && this.client.primaryContactExpanded) {
            contactId = this.client.primaryContactExpanded.id;
            const contactExpanded = this.client.primaryContactExpanded;
            const displayAs = contactExpanded.displayAs || this.client.name;
            const isClientCenterEnabled = contactExpanded.isClientCenterEnabled || false;
            const isIndividual = this.client.isIndividual;
            const primaryEmailAddress = (this.client.primaryContactExpanded.emailAddresses.find(ea => ea.isPrimary) || { emailAddress: undefined }).emailAddress;
            const newContact = new Contact(contactId, displayAs, isClientCenterEnabled, isIndividual, contactExpanded.givenName, contactExpanded.familyName, primaryEmailAddress, this.primaryContactString);
            contactClient =
                primaryEmailAddress && contactExpanded.givenName && contactExpanded.familyName ? newContact : undefined;
        }
        const otherPage = Page.fromPageNumber(pageNumber, CONTACTS_PER_PAGE);
        const recipientFilter = {
            companyId: this.companyId,
            contactId,
            primaryContact: contactClient,
            otherPage: otherPage,
            searchTerm: search,
        };
        return recipientFilter;
    }
    getCompanyIdIfNotAvailable() {
        return __awaiter(this, void 0, void 0, function* () {
            const factory = this;
            if (factory.companyId) {
                return factory.companyId;
            }
            return getCompanyId();
        });
    }
}

function contactDatasourceFactoryFactory(contactService, clientService, translateService) {
    return new ContactSelectorDatasourceFactory(contactService, clientService, translateService);
}
class RecipientSelectorComponent {
    constructor(datasourceFactory) {
        this.datasourceFactory = datasourceFactory;
        this._recipients = [];
        this.recipientsChange = new EventEmitter();
        this.maxAllowedCount = 0;
        this.readonly = false;
        this.showClientCenterCheckbox = true;
        this.disableSendEmailCheckbox = false;
        this.onBlur = new EventEmitter();
    }
    set recipients(value) {
        this.datasourceFactory.reset();
        this._recipients = value;
        this.datasourceFactory.setCount(this._recipients.length || 0);
    }
    get recipients() {
        return this._recipients;
    }
    set validator(value) {
        this._validator = value;
        this.recipientsValidation();
    }
    set companyId(value) {
        if (value !== this.companyIdValue) {
            this.companyIdValue = value;
            this.datasourceFactory.setCompanyId(value);
        }
    }
    set clientId(value) {
        this.datasourceFactory.setClientId(value);
    }
    getSendEmailValue(i) {
        return this.recipients[i].email;
    }
    setSendEmailValue(i, value) {
        const recipient = this.recipients[i];
        if (recipient.email !== value) {
            recipient.email = value;
            this.notifyRecipientListChanged();
        }
    }
    getClientCenterValue(i) {
        return this.recipients[i].clientCenter;
    }
    setClientCenterValue(i, value) {
        const recipient = this.recipients[i];
        if (recipient.clientCenter !== value) {
            recipient.clientCenter = value;
            this.notifyRecipientListChanged();
        }
    }
    get datasources() {
        return this.datasourceFactory.datasources();
    }
    onRecipientSelected(i, contact) {
        return __awaiter(this, void 0, void 0, function* () {
            const newContactId = contact && contact.id;
            const oldContactId = this.recipients[i] && this.recipients[i].contact && this.recipients[i].contact.id;
            if (oldContactId !== newContactId) {
                this.recipients[i].contact = contact;
                this.recipients[i].email = true;
                this.recipients[i].clientCenter = false;
            }
            yield this.validate(this.recipients[i]);
            this.datasourceFactory.notifyIdTaken(i, newContactId);
            this.notifyRecipientListChanged();
        });
    }
    onDataRequested(i, dataRequest) {
        this.datasourceFactory.notifyDataRequested(dataRequest, i);
    }
    isClientCenterEnabled(i) {
        const contact = this.recipients[i].contact;
        const result = !!contact && contact.isIndividual && contact.relationship !== undefined;
        return result;
    }
    addRecipient() {
        this.datasourceFactory.registerNewConsumer();
        this.recipients.push(this.getBlankRecipient());
        this.notifyRecipientListChanged();
    }
    moreThanOne() {
        return !!(this.recipients && this.recipients.length > 1);
    }
    allowMore() {
        return (!this.readonly && this.maxAllowedCount > 0 && !!this.recipients && this.recipients.length < this.maxAllowedCount);
    }
    allowRemove() {
        return !this.readonly && this.moreThanOne();
    }
    removeAt(index) {
        this.recipients.splice(index, 1);
        this.datasourceFactory.removeAt(index);
        this.notifyRecipientListChanged();
    }
    recipientsValidation() {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = [];
            this.recipients.forEach(recipient => {
                if (recipient.contact) {
                    promises.push(this.validate(recipient));
                }
            });
            yield Promise.all(promises);
            this.notifyRecipientListChanged();
        });
    }
    validate(recipient) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this._validator) {
                const validationResult = yield this._validator(recipient.contact);
                if (validationResult === undefined) {
                    recipient.isValid = true;
                }
                else {
                    recipient.isValid = validationResult;
                }
            }
            else {
                recipient.isValid = true;
            }
        });
    }
    getBlankRecipient() {
        return {
            contact: undefined,
            clientCenter: false,
            email: true,
            isValid: true,
        };
    }
    notifyRecipientListChanged() {
        this.recipientsChange.emit(this.recipients);
    }
}
/** @nocollapse */ RecipientSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RecipientSelectorComponent, deps: [{ token: ContactSelectorDatasourceFactory }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ RecipientSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: RecipientSelectorComponent, selector: "bdc-recipient-selector", inputs: { recipients: "recipients", maxAllowedCount: "maxAllowedCount", validator: "validator", companyId: "companyId", clientId: "clientId", readonly: "readonly", showClientCenterCheckbox: "showClientCenterCheckbox", disableSendEmailCheckbox: "disableSendEmailCheckbox" }, outputs: { recipientsChange: "recipientsChange", onBlur: "onBlur" }, providers: [
        {
            provide: ContactSelectorDatasourceFactory,
            useFactory: contactDatasourceFactoryFactory,
            deps: [ContactService, ClientService, TranslateService],
        },
    ], ngImport: i0, template: "<div class=\"delivery-method-chooser\">\n\t<div *ngFor=\"let recipient of recipients; index as i\" class=\"input-items-container\">\n\t\t<div\n\t\t\tclass=\"input-items-container top-border grid-cell\"\n\t\t\t[ngClass]=\"{ 'bottom-border': i === recipients.length - 1,\n\t\t\t\t\t\t'col-xs-10 col-sm-10 col-md-10 col-lg-10': allowRemove(),\n\t\t\t\t\t\t'col-xs-12 col-sm-12 col-md-12 col-lg-12': !allowRemove() }\"\n\t\t>\n\t\t\t<bdc-contact-selector\n\t\t\t\tclass=\"recipient-selector col-xs-7 col-sm-7 col-md-7 col-lg-7\"\n\t\t\t\t[dataSource]=\"datasources[i]\"\n\t\t\t\t[contact]=\"recipients[i].contact\"\n\t\t\t\t[readonly]=\"readonly\"\n\t\t\t\tcomboLabelText=\"  \"\n\t\t\t\t[isValid]=\"recipients[i].isValid\"\n\t\t\t\t(contactChange)=\"onRecipientSelected(i, $event)\"\n\t\t\t\t(dataRequested)=\"onDataRequested(i, $event)\"\n\t\t\t\t(onBlur)=\"onBlur.emit()\"\n\t\t\t>\n\t\t\t</bdc-contact-selector>\n\n\t\t\t<!-- SEND EMAIL CHECKBOX -->\n\t\t\t<div\n\t\t\t\tclass=\"ng-bento checkbox-container\"\n\t\t\t\t[ngClass]=\"{' col-xs-2 col-sm-2 col-md-2 col-lg-2 ': showClientCenterCheckbox, ' col-xs-5 col-sm-5 col-md-5 col-lg-5 ': !showClientCenterCheckbox}\"\n\t\t\t>\n\t\t\t\t<bento-checkbox\n\t\t\t\t\tclass=\"checkbox\"\n\t\t\t\t\t[ngModel]=\"getSendEmailValue(i)\"\n\t\t\t\t\t[attr.aria-label]=\"'Blue.DocumentComponents.RecipientSelector.SendViaEmailLabel' | translate\"\n\t\t\t\t\t(ngModelChange)=\"setSendEmailValue(i, $event)\"\n\t\t\t\t\t[disabled]=\"readonly || disableSendEmailCheckbox\"\n\t\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t>\n\t\t\t\t</bento-checkbox>\n\t\t\t</div>\n\n\t\t\t<!-- CLIENT CENTER CHECKBOX -->\n\t\t\t<div *ngIf=\"showClientCenterCheckbox\" class=\"ng-bento checkbox-container col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n\t\t\t\t<bento-checkbox\n\t\t\t\t\tclass=\"checkbox\"\n\t\t\t\t\t[ngModel]=\"getClientCenterValue(i)\"\n\t\t\t\t\t[attr.aria-label]=\"'Blue.DocumentComponents.RecipientSelector.SendViaClientCenterLabel' | translate\"\n\t\t\t\t\t(ngModelChange)=\"setClientCenterValue(i, $event)\"\n\t\t\t\t\t[disabled]=\"!isClientCenterEnabled(i) || readonly\"\n\t\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t>\n\t\t\t\t</bento-checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- REMOVE RECIPIENT -->\n\t\t<div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n\t\t\t<button type=\"button\" *ngIf=\"allowRemove()\" (click)=\"removeAt(i)\" class=\"btn btn-link btn-icon ng-bento side-btn\">\n\t\t\t\t<i class=\"bento-icon-close-circle-filled icon\"></i>\n\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.RecipientSelector.Remove' | translate}}</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<!-- ADD RECIPIENT -->\n\t<div\n\t\tclass=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 input-items-container bottom-border grid-cell\"\n\t\t*ngIf=\"allowMore()\"\n\t\t[ngClass]=\"{ 'top-border': recipients.length === 0 }\"\n\t>\n\t\t<button type=\"button\" (click)=\"addRecipient()\" class=\"btn btn-link btn-icon ng-bento side-btn\">\n\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-add-filled icon\"></i>\n\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.RecipientSelector.AddRecipient' | translate}}</span>\n\t\t</button>\n\t</div>\n</div>\n", styles: [".delivery-method-chooser{margin:0;width:100%}.input-items-container{align-items:center;display:flex;height:36px;padding:0}.bottom-border{border-bottom:1px solid #d5d4d9}.top-border{border-top:1px solid #d5d4d9}.recipient-selector{padding-left:0}.checkbox-container{text-align:center}.checkbox{display:inline-block}.checkbox.disabled{background-color:#f4f5f7}.side-btn{font-family:Arial;font-size:13px;padding:0}.grid-cell{padding:0}.delivery-method-chooser i.icon[class^=bento-icon-]{font-size:1em;margin-left:0;vertical-align:bottom}\n"], components: [{ type: ContactSelectorComponent, selector: "bdc-contact-selector", inputs: ["contact", "readonly", "showEmailAddressColumn", "showRelationshipColumn", "hideControlBorder", "isValid", "dataSource", "comboLabelText"], outputs: ["contactChange", "dataRequested", "onBlur"] }, { type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RecipientSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-recipient-selector', providers: [
                        {
                            provide: ContactSelectorDatasourceFactory,
                            useFactory: contactDatasourceFactoryFactory,
                            deps: [ContactService, ClientService, TranslateService],
                        },
                    ], template: "<div class=\"delivery-method-chooser\">\n\t<div *ngFor=\"let recipient of recipients; index as i\" class=\"input-items-container\">\n\t\t<div\n\t\t\tclass=\"input-items-container top-border grid-cell\"\n\t\t\t[ngClass]=\"{ 'bottom-border': i === recipients.length - 1,\n\t\t\t\t\t\t'col-xs-10 col-sm-10 col-md-10 col-lg-10': allowRemove(),\n\t\t\t\t\t\t'col-xs-12 col-sm-12 col-md-12 col-lg-12': !allowRemove() }\"\n\t\t>\n\t\t\t<bdc-contact-selector\n\t\t\t\tclass=\"recipient-selector col-xs-7 col-sm-7 col-md-7 col-lg-7\"\n\t\t\t\t[dataSource]=\"datasources[i]\"\n\t\t\t\t[contact]=\"recipients[i].contact\"\n\t\t\t\t[readonly]=\"readonly\"\n\t\t\t\tcomboLabelText=\"  \"\n\t\t\t\t[isValid]=\"recipients[i].isValid\"\n\t\t\t\t(contactChange)=\"onRecipientSelected(i, $event)\"\n\t\t\t\t(dataRequested)=\"onDataRequested(i, $event)\"\n\t\t\t\t(onBlur)=\"onBlur.emit()\"\n\t\t\t>\n\t\t\t</bdc-contact-selector>\n\n\t\t\t<!-- SEND EMAIL CHECKBOX -->\n\t\t\t<div\n\t\t\t\tclass=\"ng-bento checkbox-container\"\n\t\t\t\t[ngClass]=\"{' col-xs-2 col-sm-2 col-md-2 col-lg-2 ': showClientCenterCheckbox, ' col-xs-5 col-sm-5 col-md-5 col-lg-5 ': !showClientCenterCheckbox}\"\n\t\t\t>\n\t\t\t\t<bento-checkbox\n\t\t\t\t\tclass=\"checkbox\"\n\t\t\t\t\t[ngModel]=\"getSendEmailValue(i)\"\n\t\t\t\t\t[attr.aria-label]=\"'Blue.DocumentComponents.RecipientSelector.SendViaEmailLabel' | translate\"\n\t\t\t\t\t(ngModelChange)=\"setSendEmailValue(i, $event)\"\n\t\t\t\t\t[disabled]=\"readonly || disableSendEmailCheckbox\"\n\t\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t>\n\t\t\t\t</bento-checkbox>\n\t\t\t</div>\n\n\t\t\t<!-- CLIENT CENTER CHECKBOX -->\n\t\t\t<div *ngIf=\"showClientCenterCheckbox\" class=\"ng-bento checkbox-container col-xs-3 col-sm-3 col-md-3 col-lg-3\">\n\t\t\t\t<bento-checkbox\n\t\t\t\t\tclass=\"checkbox\"\n\t\t\t\t\t[ngModel]=\"getClientCenterValue(i)\"\n\t\t\t\t\t[attr.aria-label]=\"'Blue.DocumentComponents.RecipientSelector.SendViaClientCenterLabel' | translate\"\n\t\t\t\t\t(ngModelChange)=\"setClientCenterValue(i, $event)\"\n\t\t\t\t\t[disabled]=\"!isClientCenterEnabled(i) || readonly\"\n\t\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t>\n\t\t\t\t</bento-checkbox>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- REMOVE RECIPIENT -->\n\t\t<div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n\t\t\t<button type=\"button\" *ngIf=\"allowRemove()\" (click)=\"removeAt(i)\" class=\"btn btn-link btn-icon ng-bento side-btn\">\n\t\t\t\t<i class=\"bento-icon-close-circle-filled icon\"></i>\n\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.RecipientSelector.Remove' | translate}}</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\n\t<!-- ADD RECIPIENT -->\n\t<div\n\t\tclass=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 input-items-container bottom-border grid-cell\"\n\t\t*ngIf=\"allowMore()\"\n\t\t[ngClass]=\"{ 'top-border': recipients.length === 0 }\"\n\t>\n\t\t<button type=\"button\" (click)=\"addRecipient()\" class=\"btn btn-link btn-icon ng-bento side-btn\">\n\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-add-filled icon\"></i>\n\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.RecipientSelector.AddRecipient' | translate}}</span>\n\t\t</button>\n\t</div>\n</div>\n", styles: [".delivery-method-chooser{margin:0;width:100%}.input-items-container{align-items:center;display:flex;height:36px;padding:0}.bottom-border{border-bottom:1px solid #d5d4d9}.top-border{border-top:1px solid #d5d4d9}.recipient-selector{padding-left:0}.checkbox-container{text-align:center}.checkbox{display:inline-block}.checkbox.disabled{background-color:#f4f5f7}.side-btn{font-family:Arial;font-size:13px;padding:0}.grid-cell{padding:0}.delivery-method-chooser i.icon[class^=bento-icon-]{font-size:1em;margin-left:0;vertical-align:bottom}\n"] }]
        }], ctorParameters: function () { return [{ type: ContactSelectorDatasourceFactory }]; }, propDecorators: { recipientsChange: [{
                type: Output
            }], recipients: [{
                type: Input
            }], maxAllowedCount: [{
                type: Input
            }], validator: [{
                type: Input
            }], companyId: [{
                type: Input
            }], clientId: [{
                type: Input
            }], readonly: [{
                type: Input
            }], showClientCenterCheckbox: [{
                type: Input
            }], disableSendEmailCheckbox: [{
                type: Input
            }], onBlur: [{
                type: Output
            }] } });

class RecipientSelectorModule {
}
/** @nocollapse */ RecipientSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RecipientSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ RecipientSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RecipientSelectorModule, declarations: [RecipientSelectorComponent], imports: [CommonModule,
        BentoCheckboxModule,
        BentoComboboxModule,
        FormsModule,
        ContactSelectorModule, i1.TranslateModule], exports: [RecipientSelectorComponent] });
/** @nocollapse */ RecipientSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RecipientSelectorModule, imports: [[
            CommonModule,
            BentoCheckboxModule,
            BentoComboboxModule,
            FormsModule,
            ContactSelectorModule,
            TranslateModule.forChild(),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RecipientSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RecipientSelectorComponent],
                    imports: [
                        CommonModule,
                        BentoCheckboxModule,
                        BentoComboboxModule,
                        FormsModule,
                        ContactSelectorModule,
                        TranslateModule.forChild(),
                    ],
                    exports: [RecipientSelectorComponent],
                }]
        }] });

class ServiceBootstrapComponent {
    constructor() {
        this.initialized = new EventEmitter();
    }
    ngAfterViewInit() {
        this.initialized.emit();
    }
}
/** @nocollapse */ ServiceBootstrapComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ServiceBootstrapComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ServiceBootstrapComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ServiceBootstrapComponent, selector: "bdc-service-bootstrap", outputs: { initialized: "initialized" }, ngImport: i0, template: '', isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ServiceBootstrapComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'bdc-service-bootstrap',
                    template: '',
                }]
        }], propDecorators: { initialized: [{
                type: Output
            }] } });

class ServiceBootstrapModule {
}
/** @nocollapse */ ServiceBootstrapModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ServiceBootstrapModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ServiceBootstrapModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ServiceBootstrapModule, declarations: [ServiceBootstrapComponent], exports: [ServiceBootstrapComponent] });
/** @nocollapse */ ServiceBootstrapModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ServiceBootstrapModule, imports: [[]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ServiceBootstrapModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ServiceBootstrapComponent],
                    imports: [],
                    exports: [ServiceBootstrapComponent],
                }]
        }] });

class NewFolderModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(containerKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = this.modalService.open(NewFolderModalComponent, {
                backdrop: 'static',
            });
            modal.componentInstance.containerKey = containerKey;
            const result = yield modal.result;
            return result;
        });
    }
}
/** @nocollapse */ NewFolderModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ NewFolderModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: NewFolderModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class DrawerTabsComponent {
    constructor() {
        this.active = FileDrawer.Client;
        this.hasClientPerm = false;
        this.hasFirmPerm = false;
        this.hasMyPerm = false;
        this.showFirmDocumentsDrawer = true;
        this.showMyDocumentsDrawer = true;
        this.change = new EventEmitter();
        registerTabSet();
        registerTabItem();
        registerPopover();
        registerIcon();
        this.FileDrawer = FileDrawer;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            const promises = [
                has$1('OnvioDrive.ClientDocuments'),
                has$1('OnvioDrive.FirmDocuments'),
                has$1('OnvioDrive.MyDocuments'),
            ];
            [this.hasClientPerm, this.hasFirmPerm, this.hasMyPerm] = yield Promise.all(promises);
        });
    }
    drawerChange(event) {
        this.change.emit(event.detail);
    }
}
/** @nocollapse */ DrawerTabsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DrawerTabsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DrawerTabsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DrawerTabsComponent, selector: "bdc-drawer-tabs", inputs: { active: "active", showFirmDocumentsDrawer: "showFirmDocumentsDrawer", showMyDocumentsDrawer: "showMyDocumentsDrawer" }, outputs: { change: "change" }, ngImport: i0, template: "<bm-tab-set *ngIf=\"hasClientPerm || hasFirmPerm || hasMyPerm\" placement=\"left\" (change)=\"drawerChange($event)\">\n\t<!-- Client -->\n\t<bm-tab-item *ngIf=\"hasClientPerm\" name=\"Client\" [active]=\"active === FileDrawer.Client\">\n\t\t<bm-popover placement=\"right\" trigger=\"mouse\" [content]=\"'Blue.DocumentComponents.DrawerTabs.Client' | translate\">\n\t\t\t<bm-icon type=\"Users\"></bm-icon>\n\t\t</bm-popover>\n\t</bm-tab-item>\n\t<!-- Firm -->\n\t<bm-tab-item *ngIf=\"hasFirmPerm && showFirmDocumentsDrawer\" name=\"Firm\" [active]=\"active === FileDrawer.Firm\">\n\t\t<bm-popover placement=\"right\" trigger=\"mouse\" [content]=\"'Blue.DocumentComponents.DrawerTabs.Firm' | translate\">\n\t\t\t<bm-icon type=\"Buildings\"></bm-icon>\n\t\t</bm-popover>\n\t</bm-tab-item>\n\t<!-- My -->\n\t<bm-tab-item *ngIf=\"hasMyPerm && showMyDocumentsDrawer\" name=\"My\" [active]=\"active === FileDrawer.My\">\n\t\t<bm-popover placement=\"right\" trigger=\"mouse\" [content]=\"'Blue.DocumentComponents.DrawerTabs.My' | translate\">\n\t\t\t<bm-icon type=\"User\"></bm-icon>\n\t\t</bm-popover>\n\t</bm-tab-item>\n</bm-tab-set>\n", styles: ["bm-tab-set{height:100%}bm-tab-item[active] bm-icon{fill:#fff}bm-tab-item{padding:7px 6px}bm-icon{height:16px}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DrawerTabsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-drawer-tabs', template: "<bm-tab-set *ngIf=\"hasClientPerm || hasFirmPerm || hasMyPerm\" placement=\"left\" (change)=\"drawerChange($event)\">\n\t<!-- Client -->\n\t<bm-tab-item *ngIf=\"hasClientPerm\" name=\"Client\" [active]=\"active === FileDrawer.Client\">\n\t\t<bm-popover placement=\"right\" trigger=\"mouse\" [content]=\"'Blue.DocumentComponents.DrawerTabs.Client' | translate\">\n\t\t\t<bm-icon type=\"Users\"></bm-icon>\n\t\t</bm-popover>\n\t</bm-tab-item>\n\t<!-- Firm -->\n\t<bm-tab-item *ngIf=\"hasFirmPerm && showFirmDocumentsDrawer\" name=\"Firm\" [active]=\"active === FileDrawer.Firm\">\n\t\t<bm-popover placement=\"right\" trigger=\"mouse\" [content]=\"'Blue.DocumentComponents.DrawerTabs.Firm' | translate\">\n\t\t\t<bm-icon type=\"Buildings\"></bm-icon>\n\t\t</bm-popover>\n\t</bm-tab-item>\n\t<!-- My -->\n\t<bm-tab-item *ngIf=\"hasMyPerm && showMyDocumentsDrawer\" name=\"My\" [active]=\"active === FileDrawer.My\">\n\t\t<bm-popover placement=\"right\" trigger=\"mouse\" [content]=\"'Blue.DocumentComponents.DrawerTabs.My' | translate\">\n\t\t\t<bm-icon type=\"User\"></bm-icon>\n\t\t</bm-popover>\n\t</bm-tab-item>\n</bm-tab-set>\n", styles: ["bm-tab-set{height:100%}bm-tab-item[active] bm-icon{fill:#fff}bm-tab-item{padding:7px 6px}bm-icon{height:16px}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { active: [{
                type: Input
            }], showFirmDocumentsDrawer: [{
                type: Input
            }], showMyDocumentsDrawer: [{
                type: Input
            }], change: [{
                type: Output
            }] } });

const CLIENTS_PER_PAGE = 25;
const ID_HEADER_KEY = marker('Blue.DocumentComponents.ClientSelector.IdHeader');
const NAME_HEADER_KEY = marker('Blue.DocumentComponents.ClientSelector.NameHeader');
const searchStateDefaults = {
    pageIndex: 1,
    allPagesLoaded: false,
    searchTerm: undefined,
};
function clientLabel(value) {
    return (value === null || value === void 0 ? void 0 : value.name) && (value === null || value === void 0 ? void 0 : value.code) ? `${value.name} (${value.code})` : '';
}
const PIXELS_PER_CHAR = 10;
class ClientSelectorComponent {
    constructor(clientService, translate, changeDetectorRef) {
        this.clientService = clientService;
        this.changeDetectorRef = changeDetectorRef;
        this.getCompanyId = getCompanyId;
        this.required = false;
        /**
         * If true, the selected client cannot be changed
         */
        this.disabled = false;
        this.selectedChange = new EventEmitter();
        this.touched = false;
        this.clients$ = new BehaviorSubject([]);
        this.bentoOptions = {
            searchable: true,
            useServerSearch: true,
            columns: [
                {
                    name: 'code',
                    width: '100px',
                },
                {
                    name: 'name',
                    width: '200px',
                },
            ],
            labelFormatter: clientLabel,
            debounceTime: 200,
            // Prevents the wrong headers from showing before translations are found
            headerTranslation: { code: '', name: '' },
        };
        this.currentSearchState = searchStateDefaults;
        /**
         * Tracks the current longest known values for each column
         */
        this.maxColLengths = {
            name: 10,
            code: 20,
        };
        translate.get([ID_HEADER_KEY, NAME_HEADER_KEY]).subscribe(strings => {
            this.bentoOptions.headerTranslation = {
                code: strings[ID_HEADER_KEY],
                name: strings[NAME_HEADER_KEY],
            };
        });
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.insertAndFilterOutBubbledClients();
            yield this.loadClients();
        });
    }
    ngOnChanges(changes) {
        return __awaiter(this, void 0, void 0, function* () {
            const client = changes.selected && changes.selected.currentValue;
            // If we have a client ID but no name, look it up
            if (client && client.id && !client.name) {
                const companyId = yield this.getCompanyId();
                this.selected = yield this.clientService.get(companyId, client.id);
            }
        });
    }
    ngAfterViewInit() {
        if (this.combobox) {
            this.combobox.registerOnTouched(() => (this.touched = true));
        }
    }
    /**
     * Called by BentoNg Combobox whenever:
     * - User has selected an option
     * - User has cleared input text
     */
    reset() {
        return __awaiter(this, void 0, void 0, function* () {
            this.clear();
            yield this.insertAndFilterOutBubbledClients();
            yield this.loadClients();
        });
    }
    /**
     * Called by BentoNg Combobox when user changes text
     * (unless text is deleted, then `reset` is called instead)
     *
     * @param searchTerm value to search for
     */
    search(searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            this.clear();
            this.updateSearchState({ searchTerm });
            yield this.insertAndFilterOutBubbledClients();
            yield this.loadClients();
        });
    }
    /**
     * Called by BentoNg Combobox when user scrolls to the bottom of the visible option list
     */
    scroll() {
        return __awaiter(this, void 0, void 0, function* () {
            // Increment page number
            this.updateSearchState({ pageIndex: this.currentSearchState.pageIndex + 1 });
            yield this.loadClients();
            this.changeDetectorRef.detectChanges();
        });
    }
    /**
     * Called when the selected client in BentoNg Combobox changes
     *
     * @param client the new selected client value
     */
    clientChanged(client) {
        this.selectedChange.emit(client);
    }
    validate() {
        var _a;
        this.touched = true;
        if (this.required && !((_a = this.selected) === null || _a === void 0 ? void 0 : _a.id)) {
            return { required: true };
        }
        return null;
    }
    insertAndFilterOutBubbledClients() {
        return __awaiter(this, void 0, void 0, function* () {
            // create bubble filters and populate bubble
            if (this.bubbleClientsUp && this.bubbleClientsUp.length) {
                // filters the bubbled clients out of results below
                this.searchFilter = {
                    items: [
                        {
                            by: 'id',
                            op: FilterOperator.NotIn,
                            values: this.bubbleClientsUp,
                        },
                    ],
                };
                const bubbleFilter = {
                    items: [
                        {
                            by: 'id',
                            op: FilterOperator.In,
                            values: this.bubbleClientsUp,
                        },
                    ],
                };
                const companyId = yield this.getCompanyId();
                const view = new View(new Sort('name'), new Search(this.currentSearchState.searchTerm, ['name', 'code']), bubbleFilter);
                const page = {
                    pageNumber: 1,
                    startIndex: 1,
                    itemCount: 25,
                    endIndex: 100,
                };
                const bubbledClients = yield this.clientService.getList(companyId, view, page);
                const fullClientList = bubbledClients.concat(this.clients$.value);
                this.clients$.next(fullClientList);
            }
        });
    }
    loadClients() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.currentSearchState.allPagesLoaded) {
                // Last page loaded
                return;
            }
            const searchTerm = this.currentSearchState.searchTerm;
            const clients = yield this.getClientPage(this.currentSearchState.pageIndex, searchTerm);
            // If search has changed during await, discard results
            if (this.currentSearchState.searchTerm === searchTerm) {
                this.clients$.next(clients);
                this.updateSearchState({ allPagesLoaded: clients.length < CLIENTS_PER_PAGE });
                this.updateColumnWidth('name', clients);
                this.updateColumnWidth('code', clients);
            }
        });
    }
    clear() {
        this.updateSearchState(searchStateDefaults);
        this.clients$.complete();
        this.clients$ = new BehaviorSubject([]);
    }
    updateSearchState(changes) {
        this.currentSearchState = Object.assign(Object.assign({}, this.currentSearchState), changes);
    }
    getClientPage(pageIndex, searchTerm) {
        return __awaiter(this, void 0, void 0, function* () {
            const companyId = yield this.getCompanyId();
            const view = new View(new Sort('name'), new Search(searchTerm, ['name', 'code']));
            if (this.searchFilter) {
                view.filters = this.searchFilter;
            }
            const page = Page.fromPageNumber(pageIndex, CLIENTS_PER_PAGE);
            return this.clientService.getList(companyId, view, page);
        });
    }
    updateColumnWidth(field, clients) {
        this.maxColLengths[field] = clients.reduce((max, client) => {
            return Math.max(max, client[field].length);
        }, this.maxColLengths[field]);
        this.bentoOptions.columns.forEach(col => {
            if (col.name === field) {
                const width = this.maxColLengths[field] * PIXELS_PER_CHAR;
                col.width = width + 'px';
            }
        });
    }
}
/** @nocollapse */ ClientSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientSelectorComponent, deps: [{ token: BDS.ClientService }, { token: i1.TranslateService }, { token: i0.ChangeDetectorRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ClientSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ClientSelectorComponent, selector: "bdc-client-selector", inputs: { required: "required", selected: "selected", bubbleClientsUp: "bubbleClientsUp", disabled: "disabled", comboLabelText: "comboLabelText" }, outputs: { selectedChange: "selectedChange" }, viewQueries: [{ propertyName: "combobox", first: true, predicate: ["combobox"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<bento-combobox\n\t#combobox\n\tclass=\"client-selector-combobox\"\n\t(ngModelChange)=\"clientChanged($event)\"\n\t[ngModel]=\"selected\"\n\t[itemsObservable]=\"clients$\"\n\t[inputLabelText]=\"comboLabelText\"\n\t[options]=\"bentoOptions\"\n\t[revertOnInvalidInput]=\"false\"\n\t[required]=\"required\"\n\t(search)=\"search($event.search)\"\n\t(endOfScroll)=\"scroll()\"\n\t(resetItems)=\"reset()\"\n\t[disabled]=\"disabled\"\n></bento-combobox>\n<div class=\"errors\" *ngIf=\"required && touched && !selected?.id\">\n\t<div class=\"validation danger\">{{'Blue.DocumentComponents.ClientSelector.Error.Required' | translate}}</div>\n</div>\n", styles: [".id-header{min-width:50px}.name-header{min-width:100px}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], components: [{ type: i2.BentoComboboxComponent, selector: "bento-combobox", inputs: ["appendTo", "options", "up", "readonly", "open", "itemsObservable", "required", "revertOnInvalidInput", "rowTemplate", "id", "inputLabelText", "inputLabelClass"], outputs: ["search", "resetItems", "endOfScroll", "openChange"] }], directives: [{ type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.RequiredValidator, selector: ":not([type=checkbox])[required][formControlName],:not([type=checkbox])[required][formControl],:not([type=checkbox])[required][ngModel]", inputs: ["required"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-client-selector', template: "<bento-combobox\n\t#combobox\n\tclass=\"client-selector-combobox\"\n\t(ngModelChange)=\"clientChanged($event)\"\n\t[ngModel]=\"selected\"\n\t[itemsObservable]=\"clients$\"\n\t[inputLabelText]=\"comboLabelText\"\n\t[options]=\"bentoOptions\"\n\t[revertOnInvalidInput]=\"false\"\n\t[required]=\"required\"\n\t(search)=\"search($event.search)\"\n\t(endOfScroll)=\"scroll()\"\n\t(resetItems)=\"reset()\"\n\t[disabled]=\"disabled\"\n></bento-combobox>\n<div class=\"errors\" *ngIf=\"required && touched && !selected?.id\">\n\t<div class=\"validation danger\">{{'Blue.DocumentComponents.ClientSelector.Error.Required' | translate}}</div>\n</div>\n", styles: [".id-header{min-width:50px}.name-header{min-width:100px}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], ctorParameters: function () { return [{ type: BDS.ClientService }, { type: i1.TranslateService }, { type: i0.ChangeDetectorRef }]; }, propDecorators: { required: [{
                type: Input
            }], selected: [{
                type: Input
            }], bubbleClientsUp: [{
                type: Input
            }], disabled: [{
                type: Input
            }], comboLabelText: [{
                type: Input
            }], selectedChange: [{
                type: Output
            }], combobox: [{
                type: ViewChild,
                args: ['combobox']
            }] } });

class ItemSelectorComponent {
    constructor(treeStore, newFolderModal, activeModal) {
        this.treeStore = treeStore;
        this.newFolderModal = newFolderModal;
        this.activeModal = activeModal;
        this.hasSome = hasSome;
        this.getAccounts = getAccounts;
        this._options = {};
        this.FileDrawer = FileDrawer;
        this.selection = { drawer: FileDrawer.Client };
        this.selectedItems = [];
        this.selectionChanged = new EventEmitter();
        this.treeLoading = false;
        this.isSelectButtonEnabled = false;
        this.drawersEnabled = false;
        this.addFolderPermissionsEnabled = true;
        this.touched = false;
        this.isAddFolderButtonDisabled = true;
    }
    handleInput(event) {
        event.stopPropagation();
        if (event.key == 'Escape') {
            this.activeModal.close();
        }
    }
    set options(value) {
        this._options = value;
    }
    get options() {
        return this._options;
    }
    ngOnChanges(changes) {
        if (changes.selection && changes.selection.currentValue) {
            this.updateSelection(changes.selection.currentValue);
        }
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!!this.options.containerId && !!this.options.containerType) {
                yield this.updateSelection({
                    drawerId: this.clientId,
                    container: { id: this.options.containerId, type: this.options.containerType },
                });
            }
            else {
                yield this.updateSelection({ drawerId: this.clientId, container: undefined });
            }
            if (this.selection) {
                this.treeRoot = yield this.getTreeRoot(this.selection);
            }
            this.customTitle = this.options.customTitle;
            this.customSelectButtonText = this.options.customSelectButtonText;
            this.drawersEnabled = yield this.hasSome([
                'OnvioDrive.ClientDocuments',
                'OnvioDrive.FirmDocuments',
                'OnvioDrive.MyDocuments',
            ]);
            this.addFolderPermissionsEnabled = yield this.hasSome('OnvioDrive.AddFolders');
            const accounts = yield this.getAccounts({ active: true, onlyOnvio: true });
            this.userAccount = {
                userName: (accounts[0] && accounts[0].accountName) || '',
                firmName: (accounts[0] && accounts[0].companyName) || '',
            };
        });
    }
    getQeId(controlId) {
        return 'dms-fe-component' + (this.qeId ? '-' + this.qeId : '') + '-item-selector-' + controlId;
    }
    drawerChanged(drawer) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selection.container) {
                // We're going to clear the container
                // but we don't want to trigger a validation error
                // just because they switched drawers
                this.touched = false;
            }
            yield this.updateSelection({ drawer, container: undefined });
        });
    }
    clientSelected(client) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.updateSelection({ drawerId: client.id, container: undefined });
        });
    }
    itemSelected(items) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            if (items === null || items === void 0 ? void 0 : items.length) {
                const item = items[0];
                this.isAddFolderButtonDisabled = !!item.lock && ((_a = item.lock) === null || _a === void 0 ? void 0 : _a.type) !== LockType.None;
                this.isSelectButtonEnabled = this.selectButtonEnabled(item);
                if (isContainer(item)) {
                    yield this.updateSelection({ container: item });
                }
                else {
                    yield this.updateSelection({ document: item });
                }
                this.touched = true;
            }
        });
    }
    selectButtonEnabled(item) {
        const isPreviouslyAddedItem = this.isItemSelected(item.id);
        const isLockedFile = !isContainer(item) && !this.options.allowLockedFileSelection && !!item.lock;
        if (isPreviouslyAddedItem || isLockedFile) {
            return false;
        }
        if ((!isContainer(item) && this.options.allowFileSelection) ||
            (isContainer(item) && this.options.allowFolderSelection)) {
            return true;
        }
        return false;
    }
    isItemSelected(itemId) {
        return this.selectedItems && this.selectedItems.some(item => item.id === itemId);
    }
    select() {
        this.activeModal.close(this.selection);
    }
    treeLoadingChanged(loading) {
        this.treeLoading = loading;
    }
    isClientDrawer() {
        return !!this.selection && isClientDrawer(this.selection.drawer);
    }
    addFolder() {
        if (this.selection.container) {
            this.newFolderModal.open(this.selection.container);
        }
        else if (this.treeRoot) {
            this.newFolderModal.open(this.treeRoot);
        }
    }
    setTouched(touched = true) {
        this.touched = touched;
    }
    updateSelection(change) {
        return __awaiter(this, void 0, void 0, function* () {
            const selection = Object.assign(Object.assign({}, this.selection), change);
            if (!this.selection || navSelectionChanged(this.selection, selection)) {
                this.selection = selection;
                this.treeRoot = yield this.getTreeRoot(this.selection);
                this.selectionChanged.emit(this.selection);
            }
        });
    }
    getTreeRoot(selection) {
        return __awaiter(this, void 0, void 0, function* () {
            if (selection.drawer === FileDrawer.Firm) {
                return this.getRootFolderKey(RootFolderType.FirmDocuments);
            }
            if (selection.drawer === FileDrawer.My) {
                return this.getRootFolderKey(RootFolderType.MyDocuments);
            }
            if (selection.drawer === FileDrawer.Client && selection.drawerId) {
                return new ContainerKey(selection.drawerId, ItemType.Client);
            }
        });
    }
    getRootFolderKey(type) {
        return __awaiter(this, void 0, void 0, function* () {
            const rootFolder = yield this.treeStore.getRootFolder(type);
            return new ContainerKey(rootFolder.id, ItemType.Folder);
        });
    }
}
/** @nocollapse */ ItemSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorComponent, deps: [{ token: i1$1.TreeStore }, { token: NewFolderModalService }, { token: i1$2.NgbActiveModal }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ItemSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ItemSelectorComponent, selector: "bdc-item-selector", inputs: { selection: "selection", clientId: "clientId", options: "options", selectedItems: "selectedItems", qeId: "qeId", canBeSelected: "canBeSelected" }, outputs: { selectionChanged: "selectionChanged" }, host: { listeners: { "document:keydown": "handleInput($event)" } }, viewQueries: [{ propertyName: "tree", first: true, predicate: ["tree"], descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"item-selector\" (keydown)=\"handleInput($event)\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\taria-label=\"Close\"\n\t\t(click)=\"activeModal.close('x button')\"\n\t\t[attr.data-qe-id]=\"getQeId('close-x-button')\"\n\t>\n\t\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n\t</button>\n\n\t<div class=\"modal-header header-label\">\n\t\t<!-- Validation Border -->\n\t\t<div *ngIf=\"touched && !selection.container\" class=\"tree-validation-border\"></div>\n\n\t\t<!-- Drawer Header -->\n\t\t<div class=\"drawer-header\" *ngIf=\"customTitle\">\n\t\t\t<span>{{ customTitle | translate }}</span>\n\t\t</div>\n\n\t\t<div class=\"drawer-header\" [ngSwitch]=\"selection.drawer\" *ngIf=\"!customTitle\">\n\t\t\t<span *ngSwitchCase=\"FileDrawer.Client\"> {{ 'Blue.DocumentComponents.DrawerTabs.Client' | translate }} </span>\n\t\t\t<span *ngSwitchCase=\"FileDrawer.Firm\">\n\t\t\t\t{{ 'Blue.DocumentComponents.SpecialFolders.FirmDocuments' | translate }}\n\t\t\t</span>\n\t\t\t<span *ngSwitchCase=\"FileDrawer.My\"> {{ 'Blue.DocumentComponents.SpecialFolders.MyDocuments' | translate }} </span>\n\t\t</div>\n\t</div>\n\n\t<h2 [ngSwitch]=\"selection.drawer\" *ngIf=\"customTitle\">\n\t\t<span *ngSwitchCase=\"FileDrawer.Client\"> {{ 'Blue.DocumentComponents.DrawerTabs.Client' | translate }} </span>\n\t\t<span *ngSwitchCase=\"FileDrawer.Firm\">\n\t\t\t{{ 'Blue.DocumentComponents.SpecialFolders.FirmDocuments' | translate }}\n\t\t</span>\n\t\t<span *ngSwitchCase=\"FileDrawer.My\"> {{ 'Blue.DocumentComponents.SpecialFolders.MyDocuments' | translate }} </span>\n\t</h2>\n\n\t<!-- Tab Container -->\n\t<div class=\"tab-container\">\n\t\t<!-- Drawer Tabs -->\n\t\t<div class=\"tabs\">\n\t\t\t<bdc-drawer-tabs\n\t\t\t\t(change)=\"drawerChanged($event)\"\n\t\t\t\t[active]=\"selection.drawer\"\n\t\t\t\t[showFirmDocumentsDrawer]=\"options.showFirmDocumentsDrawer\"\n\t\t\t\t[showMyDocumentsDrawer]=\"options.showMyDocumentsDrawer\"\n\t\t\t>\n\t\t\t</bdc-drawer-tabs>\n\t\t</div>\n\t\t<!-- Tree Container -->\n\t\t<div class=\"tree-container\">\n\t\t\t<!-- Tree Header -->\n\t\t\t<div class=\"tree-header\">\n\t\t\t\t<!-- Drawer Identifier -->\n\t\t\t\t<div class=\"drawer-identifier\">\n\t\t\t\t\t<!-- Drawer Icon -->\n\t\t\t\t\t<div class=\"client-selector\">\n\t\t\t\t\t\t<!-- Client Selector -->\n\t\t\t\t\t\t<bdc-client-selector\n\t\t\t\t\t\t\t*ngIf=\"options.showClientSelector && isClientDrawer()\"\n\t\t\t\t\t\t\tcomboLabelText=\"Client\"\n\t\t\t\t\t\t\t(selectedChange)=\"clientSelected($event)\"\n\t\t\t\t\t\t\t[selected]=\"{id: selection.drawerId}\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t</bdc-client-selector>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- / Firm Name / My Name -->\n\t\t\t\t\t<span class=\"drawer-owner\" *ngIf=\"!isClientDrawer()\">\n\t\t\t\t\t\t{{ selection.drawer === FileDrawer.Firm ? userAccount?.firmName : ''}} {{ selection.drawer === FileDrawer.My ?\n\t\t\t\t\t\tuserAccount?.userName : ''}}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Tree -->\n\t\t\t<div class=\"tree\" [hidden]=\"treeLoading\" *ngIf=\"selection.drawerId || !isClientDrawer()\">\n\t\t\t\t<bdc-document-tree\n\t\t\t\t\t#tree\n\t\t\t\t\t[root]=\"treeRoot\"\n\t\t\t\t\t(loading)=\"treeLoadingChanged($event)\"\n\t\t\t\t\t[showFiles]=\"options.treeShowFiles\"\n\t\t\t\t\t[showRoot]=\"true\"\n\t\t\t\t\t(selectedChange)=\"itemSelected($event)\"\n\t\t\t\t\t[selected]=\"selectedItems\"\n\t\t\t\t\t[canBeSelected]=\"canBeSelected\"\n\t\t\t\t>\n\t\t\t\t</bdc-document-tree>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t(click)=\"select()\"\n\t\t\t[disabled]=\"!isSelectButtonEnabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId('select-button')\"\n\t\t>\n\t\t\t<span *ngIf=\"!customSelectButtonText\">{{'Blue.DocumentComponents.Button.SelectButton' | translate}}</span>\n\t\t\t<span *ngIf=\"customSelectButtonText\">{{ customSelectButtonText | translate }}</span>\n\t\t</button>\n\t\t<button class=\"btn btn-default\" (click)=\"activeModal.close('x button')\" [attr.data-qe-id]=\"getQeId('cancel-button')\">\n\t\t\t{{'Blue.DocumentComponents.Button.Cancel' | translate}}\n\t\t</button>\n\t\t<!-- Add Folder Button -->\n\t\t<button\n\t\t\tclass=\"btn btn-default btn-new add-folder-button\"\n\t\t\t*ngIf=\"addFolderPermissionsEnabled && options.showAddFolderButton\"\n\t\t\t(click)=\"addFolder()\"\n\t\t\t[disabled]=\"isAddFolderButtonDisabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId('add-folder-button')\"\n\t\t>\n\t\t\t<bm-icon type=\"add\" name=\"addFolder\"></bm-icon>\n\t\t\t{{'Blue.DocumentComponents.Toolbar.Buttons.Folder' | translate}}\n\t\t</button>\n\t</div>\n</div>\n", styles: [".tab-container{display:flex;flex-direction:row;height:100%;justify-content:space-between;max-height:400px;min-height:400px;overflow-x:hidden;overflow-y:auto;padding-bottom:10px}.item-selector-modal-window .modal-dialog.modal-sm .modal-content{width:570px}.tree-container{display:flex;flex:1;flex-direction:column;max-width:100%}.tree-header{border-bottom:1px solid #d5d4d9;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:4px;margin-top:4px;padding-bottom:0;padding-left:13px}.item-selector .header-label{font-size:23px;font-weight:700;margin-bottom:15px;padding:0}.item-selector .modal-footer{display:block}.item-selector .modal-header.header-label{display:grid}.item-selector .modal-footer bm-icon{margin-right:5px;position:relative;width:14px}.modal-footer .btn-new{float:right}.btn.btn-default.btn-new.disabled{color:#606169;cursor:not-allowed}.btn.btn-default.btn-new.disabled bm-icon{fill:#606169}.btn.btn-default.btn-new.disabled label{cursor:not-allowed}.tree{border-left:3px solid #37383d;left:-3px;overflow-x:auto;position:relative}::ng-deep .modal-backdrop.item-selector-backdrop{background-color:transparent}\n"], components: [{ type: DrawerTabsComponent, selector: "bdc-drawer-tabs", inputs: ["active", "showFirmDocumentsDrawer", "showMyDocumentsDrawer"], outputs: ["change"] }, { type: ClientSelectorComponent, selector: "bdc-client-selector", inputs: ["required", "selected", "bubbleClientsUp", "disabled", "comboLabelText"], outputs: ["selectedChange"] }, { type: DocumentTreeComponent, selector: "bdc-document-tree", inputs: ["selected", "treeEmptyMessage", "root", "drawer", "showFiles", "showRoot", "groupProjectsBy", "getHref", "canBeSelected"], outputs: ["selectedChange", "loading"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgSwitch, selector: "[ngSwitch]", inputs: ["ngSwitch"] }, { type: i2$1.NgSwitchCase, selector: "[ngSwitchCase]", inputs: ["ngSwitchCase"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-item-selector', template: "<div class=\"item-selector\" (keydown)=\"handleInput($event)\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"close\"\n\t\taria-label=\"Close\"\n\t\t(click)=\"activeModal.close('x button')\"\n\t\t[attr.data-qe-id]=\"getQeId('close-x-button')\"\n\t>\n\t\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n\t</button>\n\n\t<div class=\"modal-header header-label\">\n\t\t<!-- Validation Border -->\n\t\t<div *ngIf=\"touched && !selection.container\" class=\"tree-validation-border\"></div>\n\n\t\t<!-- Drawer Header -->\n\t\t<div class=\"drawer-header\" *ngIf=\"customTitle\">\n\t\t\t<span>{{ customTitle | translate }}</span>\n\t\t</div>\n\n\t\t<div class=\"drawer-header\" [ngSwitch]=\"selection.drawer\" *ngIf=\"!customTitle\">\n\t\t\t<span *ngSwitchCase=\"FileDrawer.Client\"> {{ 'Blue.DocumentComponents.DrawerTabs.Client' | translate }} </span>\n\t\t\t<span *ngSwitchCase=\"FileDrawer.Firm\">\n\t\t\t\t{{ 'Blue.DocumentComponents.SpecialFolders.FirmDocuments' | translate }}\n\t\t\t</span>\n\t\t\t<span *ngSwitchCase=\"FileDrawer.My\"> {{ 'Blue.DocumentComponents.SpecialFolders.MyDocuments' | translate }} </span>\n\t\t</div>\n\t</div>\n\n\t<h2 [ngSwitch]=\"selection.drawer\" *ngIf=\"customTitle\">\n\t\t<span *ngSwitchCase=\"FileDrawer.Client\"> {{ 'Blue.DocumentComponents.DrawerTabs.Client' | translate }} </span>\n\t\t<span *ngSwitchCase=\"FileDrawer.Firm\">\n\t\t\t{{ 'Blue.DocumentComponents.SpecialFolders.FirmDocuments' | translate }}\n\t\t</span>\n\t\t<span *ngSwitchCase=\"FileDrawer.My\"> {{ 'Blue.DocumentComponents.SpecialFolders.MyDocuments' | translate }} </span>\n\t</h2>\n\n\t<!-- Tab Container -->\n\t<div class=\"tab-container\">\n\t\t<!-- Drawer Tabs -->\n\t\t<div class=\"tabs\">\n\t\t\t<bdc-drawer-tabs\n\t\t\t\t(change)=\"drawerChanged($event)\"\n\t\t\t\t[active]=\"selection.drawer\"\n\t\t\t\t[showFirmDocumentsDrawer]=\"options.showFirmDocumentsDrawer\"\n\t\t\t\t[showMyDocumentsDrawer]=\"options.showMyDocumentsDrawer\"\n\t\t\t>\n\t\t\t</bdc-drawer-tabs>\n\t\t</div>\n\t\t<!-- Tree Container -->\n\t\t<div class=\"tree-container\">\n\t\t\t<!-- Tree Header -->\n\t\t\t<div class=\"tree-header\">\n\t\t\t\t<!-- Drawer Identifier -->\n\t\t\t\t<div class=\"drawer-identifier\">\n\t\t\t\t\t<!-- Drawer Icon -->\n\t\t\t\t\t<div class=\"client-selector\">\n\t\t\t\t\t\t<!-- Client Selector -->\n\t\t\t\t\t\t<bdc-client-selector\n\t\t\t\t\t\t\t*ngIf=\"options.showClientSelector && isClientDrawer()\"\n\t\t\t\t\t\t\tcomboLabelText=\"Client\"\n\t\t\t\t\t\t\t(selectedChange)=\"clientSelected($event)\"\n\t\t\t\t\t\t\t[selected]=\"{id: selection.drawerId}\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t</bdc-client-selector>\n\t\t\t\t\t</div>\n\t\t\t\t\t<!-- / Firm Name / My Name -->\n\t\t\t\t\t<span class=\"drawer-owner\" *ngIf=\"!isClientDrawer()\">\n\t\t\t\t\t\t{{ selection.drawer === FileDrawer.Firm ? userAccount?.firmName : ''}} {{ selection.drawer === FileDrawer.My ?\n\t\t\t\t\t\tuserAccount?.userName : ''}}\n\t\t\t\t\t</span>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- Tree -->\n\t\t\t<div class=\"tree\" [hidden]=\"treeLoading\" *ngIf=\"selection.drawerId || !isClientDrawer()\">\n\t\t\t\t<bdc-document-tree\n\t\t\t\t\t#tree\n\t\t\t\t\t[root]=\"treeRoot\"\n\t\t\t\t\t(loading)=\"treeLoadingChanged($event)\"\n\t\t\t\t\t[showFiles]=\"options.treeShowFiles\"\n\t\t\t\t\t[showRoot]=\"true\"\n\t\t\t\t\t(selectedChange)=\"itemSelected($event)\"\n\t\t\t\t\t[selected]=\"selectedItems\"\n\t\t\t\t\t[canBeSelected]=\"canBeSelected\"\n\t\t\t\t>\n\t\t\t\t</bdc-document-tree>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n\n\t<div class=\"modal-footer\">\n\t\t<button\n\t\t\tclass=\"btn btn-primary\"\n\t\t\t(click)=\"select()\"\n\t\t\t[disabled]=\"!isSelectButtonEnabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId('select-button')\"\n\t\t>\n\t\t\t<span *ngIf=\"!customSelectButtonText\">{{'Blue.DocumentComponents.Button.SelectButton' | translate}}</span>\n\t\t\t<span *ngIf=\"customSelectButtonText\">{{ customSelectButtonText | translate }}</span>\n\t\t</button>\n\t\t<button class=\"btn btn-default\" (click)=\"activeModal.close('x button')\" [attr.data-qe-id]=\"getQeId('cancel-button')\">\n\t\t\t{{'Blue.DocumentComponents.Button.Cancel' | translate}}\n\t\t</button>\n\t\t<!-- Add Folder Button -->\n\t\t<button\n\t\t\tclass=\"btn btn-default btn-new add-folder-button\"\n\t\t\t*ngIf=\"addFolderPermissionsEnabled && options.showAddFolderButton\"\n\t\t\t(click)=\"addFolder()\"\n\t\t\t[disabled]=\"isAddFolderButtonDisabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId('add-folder-button')\"\n\t\t>\n\t\t\t<bm-icon type=\"add\" name=\"addFolder\"></bm-icon>\n\t\t\t{{'Blue.DocumentComponents.Toolbar.Buttons.Folder' | translate}}\n\t\t</button>\n\t</div>\n</div>\n", styles: [".tab-container{display:flex;flex-direction:row;height:100%;justify-content:space-between;max-height:400px;min-height:400px;overflow-x:hidden;overflow-y:auto;padding-bottom:10px}.item-selector-modal-window .modal-dialog.modal-sm .modal-content{width:570px}.tree-container{display:flex;flex:1;flex-direction:column;max-width:100%}.tree-header{border-bottom:1px solid #d5d4d9;display:flex;flex-direction:row;justify-content:space-between;margin-bottom:4px;margin-top:4px;padding-bottom:0;padding-left:13px}.item-selector .header-label{font-size:23px;font-weight:700;margin-bottom:15px;padding:0}.item-selector .modal-footer{display:block}.item-selector .modal-header.header-label{display:grid}.item-selector .modal-footer bm-icon{margin-right:5px;position:relative;width:14px}.modal-footer .btn-new{float:right}.btn.btn-default.btn-new.disabled{color:#606169;cursor:not-allowed}.btn.btn-default.btn-new.disabled bm-icon{fill:#606169}.btn.btn-default.btn-new.disabled label{cursor:not-allowed}.tree{border-left:3px solid #37383d;left:-3px;overflow-x:auto;position:relative}::ng-deep .modal-backdrop.item-selector-backdrop{background-color:transparent}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.TreeStore }, { type: NewFolderModalService }, { type: i1$2.NgbActiveModal }]; }, propDecorators: { tree: [{
                type: ViewChild,
                args: ['tree', { static: false }]
            }], handleInput: [{
                type: HostListener,
                args: ['document:keydown', ['$event']]
            }], selection: [{
                type: Input
            }], clientId: [{
                type: Input
            }], options: [{
                type: Input
            }], selectedItems: [{
                type: Input
            }], selectionChanged: [{
                type: Output
            }], qeId: [{
                type: Input
            }], canBeSelected: [{
                type: Input
            }] } });

class ItemSelectorService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(clientId, options, selected) {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = this.modalService.open(ItemSelectorComponent, {
                windowClass: 'item-selector-modal-window',
                backdrop: 'static',
                backdropClass: 'item-selector-backdrop',
                container: '#bentoNGModalContainer',
            });
            modal.componentInstance.clientId = clientId;
            modal.componentInstance.options = options;
            modal.componentInstance.selectedItems = selected;
            return modal.result;
        });
    }
}
/** @nocollapse */ ItemSelectorService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ ItemSelectorService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class SafeResourcePipe {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    transform(value, resourceType) {
        switch (resourceType) {
            case 'url':
                return this.sanitizer.bypassSecurityTrustUrl(value);
            case 'resourceUrl':
                return this.sanitizer.bypassSecurityTrustResourceUrl(value);
            default:
                throw new Error(`Invalid safe type specified: ${resourceType}`);
        }
    }
}
/** @nocollapse */ SafeResourcePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SafeResourcePipe, deps: [{ token: i2$2.DomSanitizer }], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ SafeResourcePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SafeResourcePipe, name: "safeResource" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SafeResourcePipe, decorators: [{
            type: Pipe,
            args: [{
                    name: 'safeResource',
                }]
        }], ctorParameters: function () { return [{ type: i2$2.DomSanitizer }]; } });

class TruncateFileNamePipe {
    constructor() {
        this.getTruncatedFileName = function (value, width, pixelsPerSymbol) {
            const numberOfSymbols = Math.floor(width / pixelsPerSymbol);
            const extension = value.substring(value.lastIndexOf('.') + 1, value.length);
            const extensionWithDotsLength = extension.length + 1;
            const filenameLength = numberOfSymbols - extensionWithDotsLength;
            let filename = value.replace('.' + extension, '');
            if (filename.length <= filenameLength) {
                return value;
            }
            filename = filename.substr(0, filenameLength) + (value.length > filenameLength ? '...' : '');
            return filename + extension;
        };
    }
    transform(value, width, pixelsPerSymbol) {
        const widthParam = !width || isNaN(width) || width < 10 ? 100 : width;
        const pixelsPerSymbolParam = !pixelsPerSymbol || isNaN(pixelsPerSymbol) || pixelsPerSymbol < 6 ? 10 : pixelsPerSymbol;
        return this.getTruncatedFileName(value, widthParam, pixelsPerSymbolParam);
    }
}
/** @nocollapse */ TruncateFileNamePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TruncateFileNamePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ TruncateFileNamePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TruncateFileNamePipe, name: "truncateFileName" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TruncateFileNamePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'truncateFileName' }]
        }] });

class DocumentApprovalsComponent {
    constructor(itemSelectorService) {
        this.itemSelectorService = itemSelectorService;
        this.hasEsignaturePerm = false;
        this.documentApprovals = [];
        this.showViewPlaceholdersButton = false;
        this.disableEsignature = false;
        this.maxDocumentCount = 1;
        this.readonly = false;
        this.addESignPlaceholdersClick = new EventEmitter();
        this.addDocumentClick = new EventEmitter();
        this.esignatureToggleClick = new EventEmitter();
        this.removeDocumentClick = new EventEmitter();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.hasEsignaturePerm = yield has$1('OnvioDrive.ESignature').catch(() => false);
        });
    }
    addESignPlaceholders(docApproval) {
        return __awaiter(this, void 0, void 0, function* () {
            this.addESignPlaceholdersClick.emit(docApproval.document);
        });
    }
    esignToggleClick() {
        this.esignatureToggleClick.emit(this.documentApprovals);
    }
    removeDocumentAt(index) {
        const itemToRemove = this.documentApprovals[index];
        this.documentApprovals.splice(index, 1);
        this.removeDocumentClick.emit(itemToRemove);
    }
    addDocument() {
        return __awaiter(this, void 0, void 0, function* () {
            try {
                const navSelection = yield this.openFolderSelectorModal();
                if (navSelection.drawer) {
                    // TODO: fix document mapping in NavSelection model
                    const document = (navSelection.document || navSelection.container);
                    const docApproval = {
                        document: document,
                        hasESignature: false,
                        hasEsignPlaceholders: false,
                    };
                    this.documentApprovals.push(docApproval);
                    this.addDocumentClick.emit(docApproval);
                }
            }
            catch (e) {
                console.log(e);
            }
        });
    }
    disablePlaceHoldersLink(index) {
        const currentDocument = this.documentApprovals[index];
        if (currentDocument.document.mimeType !== 'application/pdf') {
            return true;
        }
        return false;
    }
    allowMore() {
        return this.documentApprovals.length < this.maxDocumentCount && !this.readonly;
    }
    isToggleDisabled(docApproval) {
        if (this.readonly) {
            return true;
        }
        if (this.disableEsignature) {
            return !docApproval.hasESignature;
        }
        return false;
    }
    openFolderSelectorModal() {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                showClientSelector: false,
                treeShowFiles: true,
                allowFileSelection: true,
                allowFolderSelection: false,
                allowLockedFileSelection: false,
                showFirmDocumentsDrawer: false,
                showMyDocumentsDrawer: false,
                showAddFolderButton: false,
            };
            const documents = this.documentApprovals.map(documentApprovalItem => documentApprovalItem.document);
            return this.itemSelectorService.open(this.clientId, options, documents);
        });
    }
    getQeId(controlId) {
        return 'dms-fe-component-document-approvals' + (this.qeId ? '-' + this.qeId : '') + '-' + controlId;
    }
}
/** @nocollapse */ DocumentApprovalsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentApprovalsComponent, deps: [{ token: ItemSelectorService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentApprovalsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentApprovalsComponent, selector: "bdc-document-approvals", inputs: { documentApprovals: "documentApprovals", clientId: "clientId", showViewPlaceholdersButton: "showViewPlaceholdersButton", disableEsignature: "disableEsignature", maxDocumentCount: "maxDocumentCount", readonly: "readonly", qeId: "qeId" }, outputs: { addESignPlaceholdersClick: "addESignPlaceholdersClick", addDocumentClick: "addDocumentClick", esignatureToggleClick: "esignatureToggleClick", removeDocumentClick: "removeDocumentClick" }, ngImport: i0, template: "<div class=\"approval-documents\">\n\t<!-- ADD DOCUMENT -->\n\t<ng-container *ngIf=\"!documentApprovals?.length\">\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\t[class.disabled]=\"!clientId\"\n\t\t\t(click)=\"addDocument()\"\n\t\t\tclass=\"btn btn-link btn-icon ng-bento add-btn\"\n\t\t\t[attr.data-qe-id]=\"getQeId('add-document-button')\"\n\t\t>\n\t\t\t<i class=\"bento-icon-add-filled icon\"></i>\n\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.DocumentApprovals.AddDocument' | translate}}</span>\n\t\t</button>\n\t</ng-container>\n\n\t<!-- DOCUMENT GRID -->\n\t<ng-container *ngIf=\"documentApprovals?.length\">\n\t\t<!-- HEADERS -->\n\t\t<div class=\"headers flex-container\">\n\t\t\t<div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 flex-container top-border bottom-border\">\n\t\t\t\t<div\n\t\t\t\t\tclass=\"grid-cell\"\n\t\t\t\t\t[ngClass]=\"hasEsignaturePerm ?'col-xs-5 col-sm-5 col-md-5 col-lg-5':'col-xs-12 col-sm-12 col-md-12 col-lg-12'\"\n\t\t\t\t>\n\t\t\t\t\t<label>{{'Blue.DocumentComponents.DocumentApprovals.Document' | translate}} *</label>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"hasEsignaturePerm\" class=\"col-xs-2 col-sm-2 col-md-2 grid-cell align-center ng-bento\">\n\t\t\t\t\t<label id=\"esignToggleLabel\">{{'Blue.DocumentComponents.DocumentApprovals.eSignature' | translate}} </label>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"hasEsignaturePerm\" class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 grid-cell align-center\">\n\t\t\t\t\t<label>{{'Blue.DocumentComponents.DocumentApprovals.eSignaturePlaceholders' | translate}}</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- DOCUMENTS -->\n\t\t<div *ngFor=\"let docApproval of documentApprovals; index as i\" class=\"flex-container\">\n\t\t\t<div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 flex-container bottom-border\">\n\t\t\t\t<!-- DOCUMENT -->\n\t\t\t\t<ng-template #tipContent>\n\t\t\t\t\t<img *ngIf=\"docApproval.thumbnail\" [src]=\"docApproval.thumbnail | safeResource: 'resourceUrl'\" target=\"_blank\" />\n\t\t\t\t</ng-template>\n\n\t\t\t\t<div\n\t\t\t\t\t#docLink\n\t\t\t\t\t[ngClass]=\"hasEsignaturePerm ? 'col-xs-5 col-sm-5 col-md-5 col-lg-5':'col-xs-12 col-sm-12 col-md-12 col-lg-12'\"\n\t\t\t\t\tclass=\"grid-cell\"\n\t\t\t\t>\n\t\t\t\t\t<label\n\t\t\t\t\t\t[ngbTooltip]=\"(docApproval.thumbnail) ? tipContent: ''\"\n\t\t\t\t\t\ttooltipClass=\"document-tooltip\"\n\t\t\t\t\t\tclass=\"document-title\"\n\t\t\t\t\t\t(mousedown)=\"$event.stopPropagation()\"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{ docApproval.document.name | truncateFileName: docLink.offsetWidth }}\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- eSIGNATURE TOGGLE -->\n\t\t\t\t<div\n\t\t\t\t\t*ngIf=\"hasEsignaturePerm\"\n\t\t\t\t\tclass=\"ng-bento col-xs-2 col-sm-2 col-md-2 col-lg-2 align-center grid-cell\"\n\t\t\t\t\t[attr.data-qe-id]=\"getQeId('esignature-toggle')\"\n\t\t\t\t>\n\t\t\t\t\t<bento-toggle\n\t\t\t\t\t\taria-labelledby=\"esignToggleLabel\"\n\t\t\t\t\t\t[(ngModel)]=\"docApproval.hasESignature\"\n\t\t\t\t\t\t(ngModelChange)=\"esignToggleClick()\"\n\t\t\t\t\t\t[disabled]=\"isToggleDisabled(docApproval)\"\n\t\t\t\t\t>\n\t\t\t\t\t</bento-toggle>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- ADD ESIGNATURE PLACEHOLDERS LINK -->\n\t\t\t\t<div *ngIf=\"hasEsignaturePerm\" class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 align-center grid-cell\">\n\t\t\t\t\t<button\n\t\t\t\t\t\t*ngIf=\"docApproval.hasESignature && !readonly\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t(click)=\"addESignPlaceholders(docApproval)\"\n\t\t\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn esign-placeholders-link\"\n\t\t\t\t\t\t[disabled]=\"disableEsignature || disablePlaceHoldersLink(i)\"\n\t\t\t\t\t\t[attr.data-qe-id]=\"getQeId('add-placeholder-button')\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i\n\t\t\t\t\t\t\tclass=\"icon\"\n\t\t\t\t\t\t\t[ngClass]=\"{' bento-icon-add-filled ': !docApproval.hasEsignPlaceholders, ' bento-icon-edit ': docApproval.hasEsignPlaceholders}\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t\t<span class=\"btn-text\"\n\t\t\t\t\t\t\t>{{(docApproval.hasEsignPlaceholders ? 'Blue.DocumentComponents.DocumentApprovals.ChangeESignaturePlaceholders' :\n\t\t\t\t\t\t\t'Blue.DocumentComponents.DocumentApprovals.AddESignaturePlaceholders') | translate}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button\n\t\t\t\t\t\t*ngIf=\"docApproval.hasESignature && readonly\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t(click)=\"addESignPlaceholders(docApproval)\"\n\t\t\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn view-btn\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class=\"bento-icon-eye icon\"></i>\n\t\t\t\t\t\t<span class=\"btn-text\"\n\t\t\t\t\t\t\t>{{ (showViewPlaceholdersButton ? 'Blue.DocumentComponents.DocumentApprovals.ViewESignaturePlaceholders' :\n\t\t\t\t\t\t\t'Blue.DocumentComponents.DocumentApprovals.ViewDocument') | translate}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- REMOVE DOCUMENT -->\n\t\t\t<div *ngIf=\"!readonly\" class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t(click)=\"removeDocumentAt(i)\"\n\t\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn\"\n\t\t\t\t\t[attr.data-qe-id]=\"getQeId('remove-document-button')\"\n\t\t\t\t>\n\t\t\t\t\t<i class=\"bento-icon-close-circle-filled icon\"></i>\n\t\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.RecipientSelector.Remove' | translate}}</span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- ADD DOCUMENT -->\n\t\t<div *ngIf=\"allowMore()\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 flex-container grid-cell bottom-border\">\n\t\t\t<button\n\t\t\t\ttype=\"button\"\n\t\t\t\t(click)=\"addDocument()\"\n\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn\"\n\t\t\t\t[attr.data-qe-id]=\"getQeId('add-document-button')\"\n\t\t\t>\n\t\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-add-filled icon\"></i>\n\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.DocumentApprovals.AddDocument' | translate}}</span>\n\t\t\t</button>\n\t\t</div>\n\t</ng-container>\n</div>\n", styles: [".approval-documents{margin:0;width:100%}.approval-documents .flex-container{align-items:center;display:flex;height:36px;padding:0}.approval-documents .top-border{border-top:1px solid #d5d4d9}.approval-documents .bottom-border{border-bottom:1px solid #d5d4d9}.approval-documents .grid-cell{padding:0}.approval-documents .side-btn,.approval-documents .btn.btn-link.add-btn{font-family:Arial;font-size:13px;padding:0}.approval-documents button.btn-icon[type=button] i.icon[class^=bento-icon-]{font-size:1em;margin-left:0;vertical-align:bottom}.approval-documents .btn.btn-link.side-btn .icon{font-size:13px;vertical-align:bottom}.approval-documents .align-center{text-align:center}.approval-documents .disabled{color:#93939c;cursor:default;pointer-events:none}.approval-documents label{font-family:Arial,Helvetica,sans-serif;font-size:13px;font-weight:700;margin:0 5px 0 0}.approval-documents .document-title{color:#0072a8;cursor:pointer;font-family:KnowledgeRegular;font-size:14px;font-weight:400;padding-left:10px}\n"], components: [{ type: i2.BentoToggleComponent, selector: "bento-toggle", inputs: ["readOnly", "lockToState", "showLabels"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe, "safeResource": SafeResourcePipe, "truncateFileName": TruncateFileNamePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentApprovalsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-approvals', template: "<div class=\"approval-documents\">\n\t<!-- ADD DOCUMENT -->\n\t<ng-container *ngIf=\"!documentApprovals?.length\">\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\t[class.disabled]=\"!clientId\"\n\t\t\t(click)=\"addDocument()\"\n\t\t\tclass=\"btn btn-link btn-icon ng-bento add-btn\"\n\t\t\t[attr.data-qe-id]=\"getQeId('add-document-button')\"\n\t\t>\n\t\t\t<i class=\"bento-icon-add-filled icon\"></i>\n\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.DocumentApprovals.AddDocument' | translate}}</span>\n\t\t</button>\n\t</ng-container>\n\n\t<!-- DOCUMENT GRID -->\n\t<ng-container *ngIf=\"documentApprovals?.length\">\n\t\t<!-- HEADERS -->\n\t\t<div class=\"headers flex-container\">\n\t\t\t<div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 flex-container top-border bottom-border\">\n\t\t\t\t<div\n\t\t\t\t\tclass=\"grid-cell\"\n\t\t\t\t\t[ngClass]=\"hasEsignaturePerm ?'col-xs-5 col-sm-5 col-md-5 col-lg-5':'col-xs-12 col-sm-12 col-md-12 col-lg-12'\"\n\t\t\t\t>\n\t\t\t\t\t<label>{{'Blue.DocumentComponents.DocumentApprovals.Document' | translate}} *</label>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"hasEsignaturePerm\" class=\"col-xs-2 col-sm-2 col-md-2 grid-cell align-center ng-bento\">\n\t\t\t\t\t<label id=\"esignToggleLabel\">{{'Blue.DocumentComponents.DocumentApprovals.eSignature' | translate}} </label>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"hasEsignaturePerm\" class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 grid-cell align-center\">\n\t\t\t\t\t<label>{{'Blue.DocumentComponents.DocumentApprovals.eSignaturePlaceholders' | translate}}</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- DOCUMENTS -->\n\t\t<div *ngFor=\"let docApproval of documentApprovals; index as i\" class=\"flex-container\">\n\t\t\t<div class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 flex-container bottom-border\">\n\t\t\t\t<!-- DOCUMENT -->\n\t\t\t\t<ng-template #tipContent>\n\t\t\t\t\t<img *ngIf=\"docApproval.thumbnail\" [src]=\"docApproval.thumbnail | safeResource: 'resourceUrl'\" target=\"_blank\" />\n\t\t\t\t</ng-template>\n\n\t\t\t\t<div\n\t\t\t\t\t#docLink\n\t\t\t\t\t[ngClass]=\"hasEsignaturePerm ? 'col-xs-5 col-sm-5 col-md-5 col-lg-5':'col-xs-12 col-sm-12 col-md-12 col-lg-12'\"\n\t\t\t\t\tclass=\"grid-cell\"\n\t\t\t\t>\n\t\t\t\t\t<label\n\t\t\t\t\t\t[ngbTooltip]=\"(docApproval.thumbnail) ? tipContent: ''\"\n\t\t\t\t\t\ttooltipClass=\"document-tooltip\"\n\t\t\t\t\t\tclass=\"document-title\"\n\t\t\t\t\t\t(mousedown)=\"$event.stopPropagation()\"\n\t\t\t\t\t>\n\t\t\t\t\t\t{{ docApproval.document.name | truncateFileName: docLink.offsetWidth }}\n\t\t\t\t\t</label>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- eSIGNATURE TOGGLE -->\n\t\t\t\t<div\n\t\t\t\t\t*ngIf=\"hasEsignaturePerm\"\n\t\t\t\t\tclass=\"ng-bento col-xs-2 col-sm-2 col-md-2 col-lg-2 align-center grid-cell\"\n\t\t\t\t\t[attr.data-qe-id]=\"getQeId('esignature-toggle')\"\n\t\t\t\t>\n\t\t\t\t\t<bento-toggle\n\t\t\t\t\t\taria-labelledby=\"esignToggleLabel\"\n\t\t\t\t\t\t[(ngModel)]=\"docApproval.hasESignature\"\n\t\t\t\t\t\t(ngModelChange)=\"esignToggleClick()\"\n\t\t\t\t\t\t[disabled]=\"isToggleDisabled(docApproval)\"\n\t\t\t\t\t>\n\t\t\t\t\t</bento-toggle>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- ADD ESIGNATURE PLACEHOLDERS LINK -->\n\t\t\t\t<div *ngIf=\"hasEsignaturePerm\" class=\"col-xs-5 col-sm-5 col-md-5 col-lg-5 align-center grid-cell\">\n\t\t\t\t\t<button\n\t\t\t\t\t\t*ngIf=\"docApproval.hasESignature && !readonly\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t(click)=\"addESignPlaceholders(docApproval)\"\n\t\t\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn esign-placeholders-link\"\n\t\t\t\t\t\t[disabled]=\"disableEsignature || disablePlaceHoldersLink(i)\"\n\t\t\t\t\t\t[attr.data-qe-id]=\"getQeId('add-placeholder-button')\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i\n\t\t\t\t\t\t\tclass=\"icon\"\n\t\t\t\t\t\t\t[ngClass]=\"{' bento-icon-add-filled ': !docApproval.hasEsignPlaceholders, ' bento-icon-edit ': docApproval.hasEsignPlaceholders}\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t</i>\n\t\t\t\t\t\t<span class=\"btn-text\"\n\t\t\t\t\t\t\t>{{(docApproval.hasEsignPlaceholders ? 'Blue.DocumentComponents.DocumentApprovals.ChangeESignaturePlaceholders' :\n\t\t\t\t\t\t\t'Blue.DocumentComponents.DocumentApprovals.AddESignaturePlaceholders') | translate}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</button>\n\t\t\t\t\t<button\n\t\t\t\t\t\t*ngIf=\"docApproval.hasESignature && readonly\"\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t(click)=\"addESignPlaceholders(docApproval)\"\n\t\t\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn view-btn\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class=\"bento-icon-eye icon\"></i>\n\t\t\t\t\t\t<span class=\"btn-text\"\n\t\t\t\t\t\t\t>{{ (showViewPlaceholdersButton ? 'Blue.DocumentComponents.DocumentApprovals.ViewESignaturePlaceholders' :\n\t\t\t\t\t\t\t'Blue.DocumentComponents.DocumentApprovals.ViewDocument') | translate}}\n\t\t\t\t\t\t</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<!-- REMOVE DOCUMENT -->\n\t\t\t<div *ngIf=\"!readonly\" class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2\">\n\t\t\t\t<button\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t(click)=\"removeDocumentAt(i)\"\n\t\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn\"\n\t\t\t\t\t[attr.data-qe-id]=\"getQeId('remove-document-button')\"\n\t\t\t\t>\n\t\t\t\t\t<i class=\"bento-icon-close-circle-filled icon\"></i>\n\t\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.RecipientSelector.Remove' | translate}}</span>\n\t\t\t\t</button>\n\t\t\t</div>\n\t\t</div>\n\n\t\t<!-- ADD DOCUMENT -->\n\t\t<div *ngIf=\"allowMore()\" class=\"col-xs-10 col-sm-10 col-md-10 col-lg-10 flex-container grid-cell bottom-border\">\n\t\t\t<button\n\t\t\t\ttype=\"button\"\n\t\t\t\t(click)=\"addDocument()\"\n\t\t\t\tclass=\"btn btn-link btn-icon ng-bento side-btn\"\n\t\t\t\t[attr.data-qe-id]=\"getQeId('add-document-button')\"\n\t\t\t>\n\t\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-add-filled icon\"></i>\n\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.DocumentApprovals.AddDocument' | translate}}</span>\n\t\t\t</button>\n\t\t</div>\n\t</ng-container>\n</div>\n", styles: [".approval-documents{margin:0;width:100%}.approval-documents .flex-container{align-items:center;display:flex;height:36px;padding:0}.approval-documents .top-border{border-top:1px solid #d5d4d9}.approval-documents .bottom-border{border-bottom:1px solid #d5d4d9}.approval-documents .grid-cell{padding:0}.approval-documents .side-btn,.approval-documents .btn.btn-link.add-btn{font-family:Arial;font-size:13px;padding:0}.approval-documents button.btn-icon[type=button] i.icon[class^=bento-icon-]{font-size:1em;margin-left:0;vertical-align:bottom}.approval-documents .btn.btn-link.side-btn .icon{font-size:13px;vertical-align:bottom}.approval-documents .align-center{text-align:center}.approval-documents .disabled{color:#93939c;cursor:default;pointer-events:none}.approval-documents label{font-family:Arial,Helvetica,sans-serif;font-size:13px;font-weight:700;margin:0 5px 0 0}.approval-documents .document-title{color:#0072a8;cursor:pointer;font-family:KnowledgeRegular;font-size:14px;font-weight:400;padding-left:10px}\n"] }]
        }], ctorParameters: function () { return [{ type: ItemSelectorService }]; }, propDecorators: { documentApprovals: [{
                type: Input
            }], clientId: [{
                type: Input
            }], showViewPlaceholdersButton: [{
                type: Input
            }], disableEsignature: [{
                type: Input
            }], maxDocumentCount: [{
                type: Input
            }], readonly: [{
                type: Input
            }], qeId: [{
                type: Input
            }], addESignPlaceholdersClick: [{
                type: Output
            }], addDocumentClick: [{
                type: Output
            }], esignatureToggleClick: [{
                type: Output
            }], removeDocumentClick: [{
                type: Output
            }] } });

class ToggleComponent {
    constructor() {
        this._toggleModel = false;
        this.disabled = false;
        this.toggleModelChange = new EventEmitter();
    }
    get toggleModel() {
        return this._toggleModel;
    }
    set toggleModel(value) {
        if (this._toggleModel !== value) {
            this._toggleModel = value;
            this.toggleModelChange.emit(value);
        }
    }
    getQeId() {
        return this.dataQeIdPrefix ? this.dataQeIdPrefix + '-' + 'toggle' : 'dms-fe-components-toggle';
    }
}
/** @nocollapse */ ToggleComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ToggleComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ToggleComponent, selector: "bdc-toggle", inputs: { toggleModel: "toggleModel", disabled: "disabled", dataQeIdPrefix: "dataQeIdPrefix" }, outputs: { toggleModelChange: "toggleModelChange" }, ngImport: i0, template: "<div class=\"ng-bento\">\n\t<bento-toggle [attr.data-qe-id]=\"getQeId()\" [(ngModel)]=\"toggleModel\" [disabled]=\"disabled\"> </bento-toggle>\n</div>\n", components: [{ type: i2.BentoToggleComponent, selector: "bento-toggle", inputs: ["readOnly", "lockToState", "showLabels"] }], directives: [{ type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-toggle', template: "<div class=\"ng-bento\">\n\t<bento-toggle [attr.data-qe-id]=\"getQeId()\" [(ngModel)]=\"toggleModel\" [disabled]=\"disabled\"> </bento-toggle>\n</div>\n" }]
        }], propDecorators: { toggleModel: [{
                type: Input
            }], disabled: [{
                type: Input
            }], toggleModelChange: [{
                type: Output
            }], dataQeIdPrefix: [{
                type: Input
            }] } });

class ToggleModule {
}
/** @nocollapse */ ToggleModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ToggleModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleModule, declarations: [ToggleComponent], imports: [CommonModule, BentoToggleModule, FormsModule], exports: [ToggleComponent] });
/** @nocollapse */ ToggleModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleModule, imports: [[CommonModule, BentoToggleModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToggleModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ToggleComponent],
                    imports: [CommonModule, BentoToggleModule, FormsModule],
                    exports: [ToggleComponent],
                }]
        }] });

class DocumentComponentsCommonModule {
}
/** @nocollapse */ DocumentComponentsCommonModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsCommonModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentComponentsCommonModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsCommonModule, declarations: [SafeResourcePipe, TruncateFileNamePipe], imports: [CommonModule], exports: [SafeResourcePipe, TruncateFileNamePipe] });
/** @nocollapse */ DocumentComponentsCommonModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsCommonModule, imports: [[CommonModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsCommonModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SafeResourcePipe, TruncateFileNamePipe],
                    imports: [CommonModule],
                    exports: [SafeResourcePipe, TruncateFileNamePipe],
                }]
        }] });

class DocumentApprovalsModule {
}
/** @nocollapse */ DocumentApprovalsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentApprovalsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentApprovalsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentApprovalsModule, declarations: [DocumentApprovalsComponent], imports: [CommonModule,
        NgbModule,
        BentoToggleModule,
        FormsModule,
        ToggleModule, i1.TranslateModule, DocumentComponentsCommonModule], exports: [DocumentApprovalsComponent, ToggleComponent] });
/** @nocollapse */ DocumentApprovalsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentApprovalsModule, providers: [ItemSelectorService], imports: [[
            CommonModule,
            NgbModule,
            BentoToggleModule,
            FormsModule,
            ToggleModule,
            TranslateModule.forChild(),
            DocumentComponentsCommonModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentApprovalsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DocumentApprovalsComponent],
                    imports: [
                        CommonModule,
                        NgbModule,
                        BentoToggleModule,
                        FormsModule,
                        ToggleModule,
                        TranslateModule.forChild(),
                        DocumentComponentsCommonModule,
                    ],
                    exports: [DocumentApprovalsComponent, ToggleComponent],
                    providers: [ItemSelectorService],
                }]
        }] });

class DrawerTabsModule {
}
/** @nocollapse */ DrawerTabsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DrawerTabsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DrawerTabsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DrawerTabsModule, declarations: [DrawerTabsComponent], imports: [CommonModule, i1.TranslateModule], exports: [DrawerTabsComponent] });
/** @nocollapse */ DrawerTabsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DrawerTabsModule, imports: [[CommonModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DrawerTabsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DrawerTabsComponent],
                    imports: [CommonModule, TranslateModule.forChild()],
                    exports: [DrawerTabsComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class DocumentTreeModule {
}
/** @nocollapse */ DocumentTreeModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentTreeModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeModule, declarations: [DocumentTreeComponent], imports: [CommonModule, i1.TranslateModule], exports: [DocumentTreeComponent] });
/** @nocollapse */ DocumentTreeModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeModule, imports: [[CommonModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentTreeModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DocumentTreeComponent],
                    imports: [CommonModule, TranslateModule.forChild()],
                    exports: [DocumentTreeComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class ClientSelectorModule {
}
/** @nocollapse */ ClientSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ClientSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientSelectorModule, declarations: [ClientSelectorComponent], imports: [CommonModule, i1.TranslateModule, BentoComboboxModule, FormsModule], exports: [ClientSelectorComponent] });
/** @nocollapse */ ClientSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientSelectorModule, imports: [[CommonModule, TranslateModule.forChild(), BentoComboboxModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ClientSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ClientSelectorComponent],
                    imports: [CommonModule, TranslateModule.forChild(), BentoComboboxModule, FormsModule],
                    exports: [ClientSelectorComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class ItemSelectorModule {
}
/** @nocollapse */ ItemSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ ItemSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorModule, declarations: [ItemSelectorComponent], imports: [CommonModule, i1.TranslateModule, DrawerTabsModule, DocumentTreeModule, ClientSelectorModule], exports: [ItemSelectorComponent] });
/** @nocollapse */ ItemSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorModule, imports: [[CommonModule, TranslateModule.forChild(), DrawerTabsModule, DocumentTreeModule, ClientSelectorModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [ItemSelectorComponent],
                    imports: [CommonModule, TranslateModule.forChild(), DrawerTabsModule, DocumentTreeModule, ClientSelectorModule],
                    exports: [ItemSelectorComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class CompanyHeaderComponent {
    constructor(themeService) {
        this.themeService = themeService;
        this.companyIdSubject = new BehaviorSubject('');
    }
    set companyId(value) {
        this.companyIdSubject.next(value);
    }
    get companyId() {
        return this.companyIdSubject.getValue();
    }
    ngOnInit() {
        this.companyIdSubject.subscribe((id) => __awaiter(this, void 0, void 0, function* () {
            const theme = yield this.themeService.getTheme(id);
            this.themeUrl = theme.headerImage;
            this.companyName = theme.headerLine1;
        }));
    }
    ngOnDestroy() {
        this.companyIdSubject.unsubscribe();
    }
}
/** @nocollapse */ CompanyHeaderComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CompanyHeaderComponent, deps: [{ token: i1$1.ThemeService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ CompanyHeaderComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CompanyHeaderComponent, selector: "bdc-company-header", inputs: { companyId: "companyId" }, ngImport: i0, template: "<div class=\"company-header-container\">\n\t<div *ngIf=\"themeUrl\" class=\"company-logo\">\n\t\t<img [hidden]=\"!themeUrl\" [src]=\"themeUrl\" />\n\t</div>\n\t<div class=\"company-name\">{{companyName}}</div>\n</div>\n", styles: [".company-header-container{display:flex;height:80px;width:100%}.company-logo{height:100%}.company-logo img{max-height:100%;max-width:100%}.company-name{color:#212121;font-family:KnowledgeRegular;font-size:26px;margin:25px 0 0 10px}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CompanyHeaderComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-company-header', template: "<div class=\"company-header-container\">\n\t<div *ngIf=\"themeUrl\" class=\"company-logo\">\n\t\t<img [hidden]=\"!themeUrl\" [src]=\"themeUrl\" />\n\t</div>\n\t<div class=\"company-name\">{{companyName}}</div>\n</div>\n", styles: [".company-header-container{display:flex;height:80px;width:100%}.company-logo{height:100%}.company-logo img{max-height:100%;max-width:100%}.company-name{color:#212121;font-family:KnowledgeRegular;font-size:26px;margin:25px 0 0 10px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ThemeService }]; }, propDecorators: { companyId: [{
                type: Input
            }] } });

class CompanyHeaderModule {
}
/** @nocollapse */ CompanyHeaderModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CompanyHeaderModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ CompanyHeaderModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CompanyHeaderModule, declarations: [CompanyHeaderComponent], imports: [CommonModule, i1.TranslateModule], exports: [CompanyHeaderComponent] });
/** @nocollapse */ CompanyHeaderModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CompanyHeaderModule, imports: [[CommonModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CompanyHeaderModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CompanyHeaderComponent],
                    imports: [CommonModule, TranslateModule.forChild()],
                    exports: [CompanyHeaderComponent],
                }]
        }] });

class CommentBoxComponent {
    constructor(commentsService) {
        this.commentsService = commentsService;
        this.commentText = '';
        this.displayName = '';
    }
    ngOnChanges() {
        this.loadComments();
    }
    loadComments() {
        return __awaiter(this, void 0, void 0, function* () {
            const comment = this.entityId && (yield this.getComment(this.entityId));
            if (comment) {
                this.displayName = this.getName(comment);
                this.commentText = comment.text;
            }
            else if (this.comment) {
                this.displayName = this.getName(this.comment);
            }
        });
    }
    getComment(entityId) {
        return __awaiter(this, void 0, void 0, function* () {
            const comments = yield this.commentsService.getCommentsForEntity(entityId);
            if (comments && comments.length > 0) {
                const earliest = this.findEarliest(comments);
                return this.trimQuotesFromText(earliest);
            }
        });
    }
    findEarliest(comments) {
        return comments.reduce((earliest, current) => {
            return earliest.history.createdDate < current.history.createdDate ? earliest : current;
        });
    }
    getName(comment) {
        const firstName = comment.history.createdBy.firstName || '';
        const lastName = comment.history.createdBy.lastName || '';
        return firstName + ' ' + lastName;
    }
    trimQuotesFromText(comment) {
        return Object.assign(Object.assign({}, comment), { 
            // capture quote at beginning and end, replace with empty string
            text: comment.text.replace(/^\"+|\"+$/g, '') });
    }
}
/** @nocollapse */ CommentBoxComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommentBoxComponent, deps: [{ token: i1$1.CommentsService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ CommentBoxComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CommentBoxComponent, selector: "bdc-comment-box", inputs: { entityId: "entityId", comment: "comment" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"comment-box\">\n\t<div class=\"comment-title\">\n\t\t{{'Blue.DocumentComponents.CommentBox.Title' | translate : { displayName: displayName } }}\n\t</div>\n\t<p *ngIf=\"commentText\">{{ commentText }}</p>\n\t<p *ngIf=\"comment\">{{ comment.text }}</p>\n</div>\n", styles: [".comment-box{margin:0;width:100%}.comment-title{font-family:Arial;font-size:14px;padding:0}p{display:block;font-family:Arial;font-size:13px;font-weight:700;line-height:1.5em;margin-bottom:0;margin-top:10px;max-height:15em;overflow:auto;padding-left:16px;text-overflow:ellipsis;word-wrap:break-word}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommentBoxComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-comment-box', template: "<div class=\"comment-box\">\n\t<div class=\"comment-title\">\n\t\t{{'Blue.DocumentComponents.CommentBox.Title' | translate : { displayName: displayName } }}\n\t</div>\n\t<p *ngIf=\"commentText\">{{ commentText }}</p>\n\t<p *ngIf=\"comment\">{{ comment.text }}</p>\n</div>\n", styles: [".comment-box{margin:0;width:100%}.comment-title{font-family:Arial;font-size:14px;padding:0}p{display:block;font-family:Arial;font-size:13px;font-weight:700;line-height:1.5em;margin-bottom:0;margin-top:10px;max-height:15em;overflow:auto;padding-left:16px;text-overflow:ellipsis;word-wrap:break-word}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.CommentsService }]; }, propDecorators: { entityId: [{
                type: Input
            }], comment: [{
                type: Input
            }] } });

class CommentBoxModule {
}
/** @nocollapse */ CommentBoxModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommentBoxModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ CommentBoxModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommentBoxModule, declarations: [CommentBoxComponent], imports: [CommonModule, i1.TranslateModule, FormsModule], exports: [CommentBoxComponent] });
/** @nocollapse */ CommentBoxModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommentBoxModule, imports: [[CommonModule, TranslateModule.forChild(), FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommentBoxModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CommentBoxComponent],
                    imports: [CommonModule, TranslateModule.forChild(), FormsModule],
                    exports: [CommentBoxComponent],
                }]
        }] });

class FilterCheckBoxOptions {
    constructor(checkBoxName, contactId) {
        this.checkBoxName = checkBoxName;
        this.contactId = contactId;
        this.isIndeterminate = false;
        this.isChecked = false;
        this.isDisabled = false;
    }
}

const REPO_NAME = 'dms-fe-components';
function buildQeId(qeId, baseQeId = '') {
    return REPO_NAME + (baseQeId ? '-' + baseQeId : '') + '-' + qeId;
}

class MultiselectFilterSectionComponent {
    constructor(elRef) {
        this.elRef = elRef;
        this.selectedItemsCount = 0;
        this.checkboxQeId = '';
        this.linkButtonQeId = '';
        // Base format for a qe-id
        this.qeId = 'multiselect-filter-section';
        // Is the show more/show less link allowed/needed.
        this.allowCollapsing = false;
        // Number of check boxes to display before collapsing them into a show more/show less link.
        this.collapseCount = 0;
        // Is the show more/show less link expanded?
        this.isExpanded = false;
        // Is the accordion panel open. A value of true will open the panel.
        this.panelActive = false;
        // Heading for the panel.
        this.heading = '';
        // The checkboxes to be displayed in this panel.
        this.model = [];
        // Unique id for panel.
        this.panelId = '';
        this.clearAll = 0;
        this.panelStateChanged = new EventEmitter();
        this.itemCountChanged = new EventEmitter();
        this.getDataQeId = buildQeId;
    }
    ngOnInit() {
        this.checkboxQeId = this.getDataQeId('checkbox', this.qeId);
        this.linkButtonQeId = this.getDataQeId('link-button', this.qeId);
    }
    ngOnChanges(changes) {
        if (changes.panelActive && this.accordion) {
            if (changes.panelActive.currentValue) {
                this.accordion.expandAll();
            }
            else {
                this.accordion.collapseAll();
            }
        }
        if (changes.clearAll && this.selectedItemsCount !== 0) {
            this.selectedItemsCount = 0;
            this.itemCountChanged.emit();
        }
    }
    ngAfterViewInit() {
        const sectionHeader = this.elRef.nativeElement.querySelector('.card-header button');
        sectionHeader === null || sectionHeader === void 0 ? void 0 : sectionHeader.setAttribute('data-qe-id', buildQeId('header', this.qeId));
    }
    itemShouldBeShown(index) {
        return !this.allowCollapsing || this.isExpanded || index < this.collapseCount;
    }
    updateSelectedItemsCount(index, checked) {
        this.model[index].isChecked = checked;
        this.updateCount();
    }
    updateCount() {
        this.selectedItemsCount = this.model.filter(d => d.isChecked).length;
        this.itemCountChanged.emit();
    }
    expandCollapseLinksShouldBeShown() {
        return this.allowCollapsing && this.model.length > this.collapseCount;
    }
    toggleExpandState() {
        this.isExpanded = !this.isExpanded;
    }
    getExpandCollapseLinkCaptionKey() {
        return this.isExpanded
            ? marker('Blue.DocumentComponents.MultiselectFilterSection.Less')
            : marker('Blue.DocumentComponents.MultiselectFilterSection.More');
    }
    panelChanged($event) {
        this.panelActive = $event.nextState;
        this.panelStateChanged.emit({
            panelId: this.panelId,
            panelActive: this.panelActive,
        });
    }
    clearClicked($event) {
        $event.preventDefault();
        $event.stopPropagation();
        if (this.panelId === 'event-filter') {
            this.model.forEach(ele => {
                ele.isChecked = false;
            });
            this.updateCount();
        }
        else if (this.panelId === 'event-by-filter') {
            this.model.forEach(ele => {
                ele.isChecked = false;
            });
            this.updateCount();
        }
    }
}
/** @nocollapse */ MultiselectFilterSectionComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiselectFilterSectionComponent, deps: [{ token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ MultiselectFilterSectionComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: MultiselectFilterSectionComponent, selector: "bdc-multiselect-filter-section", inputs: { qeId: "qeId", allowCollapsing: "allowCollapsing", collapseCount: "collapseCount", isExpanded: "isExpanded", panelActive: "panelActive", heading: "heading", model: "model", panelId: "panelId", clearAll: "clearAll" }, outputs: { panelStateChanged: "panelStateChanged", itemCountChanged: "itemCountChanged" }, viewQueries: [{ propertyName: "accordion", first: true, predicate: NgbAccordion, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<ngb-accordion\n\tclass=\"bento-accordion bento-accordion-alternate\"\n\tanimation=\"false\"\n\tactiveIds=\"{{'multi-select-panel-' + panelId}}\"\n\t(panelChange)=\"panelChanged($event)\"\n>\n\t<ngb-panel id=\"{{'multi-select-panel-' + panelId}}\">\n\t\t<ng-template ngbPanelTitle>\n\t\t\t<b>{{heading | translate}}</b>\n\t\t\t<span class=\"selected-count-badge\" *ngIf=\"selectedItemsCount > 0\">{{selectedItemsCount}}</span>\n\t\t\t<a\n\t\t\t\thref\n\t\t\t\ttype=\"button\"\n\t\t\t\trole=\"button\"\n\t\t\t\tclass=\"btn btn-xs btn-default float-right clear\"\n\t\t\t\t*ngIf=\"selectedItemsCount > 0\"\n\t\t\t\t(click)=\"clearClicked($event)\"\n\t\t\t\t(keydown.Space)=\"clearClicked($event)\"\n\t\t\t>\n\t\t\t\t{{'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n\t\t\t</a>\n\t\t</ng-template>\n\n\t\t<ng-template ngbPanelContent>\n\t\t\t<div class=\"ng-bento checkbox-container\" *ngFor=\"let item of model; index as i;\">\n\t\t\t\t<div *ngIf=\"itemShouldBeShown(i)\">\n\t\t\t\t\t<bento-checkbox\n\t\t\t\t\t\tclass=\"checkbox\"\n\t\t\t\t\t\t[ngModel]=\"item.isChecked\"\n\t\t\t\t\t\t(ngModelChange)=\"updateSelectedItemsCount(i, $event)\"\n\t\t\t\t\t\t[disabled]=\"false\"\n\t\t\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t\t\t[attr.data-qe-id]=\"(checkboxQeId + '-' + (i + 1))\"\n\t\t\t\t\t\tid=\"{{checkboxQeId + '_' + (i+1)}}\"\n\t\t\t\t\t></bento-checkbox>\n\t\t\t\t\t<label for=\"{{checkboxQeId + '_' + (i+1)}}\">{{item.checkBoxName | translate}}</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-link btn-sm\"\n\t\t\t\t*ngIf=\"expandCollapseLinksShouldBeShown()\"\n\t\t\t\t(click)=\"toggleExpandState()\"\n\t\t\t\t[attr.data-qe-id]=\"linkButtonQeId\"\n\t\t\t>\n\t\t\t\t<span>{{getExpandCollapseLinkCaptionKey() | translate}}</span>\n\t\t\t</button>\n\t\t</ng-template>\n\t</ngb-panel>\n</ngb-accordion>\n", styles: ["bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate .selected-count-badge{background-color:#000;border-radius:2px;color:#b6b6b6;line-height:1.2em;margin-left:7px;padding:0 6px}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container label{margin:5px 0 4px 2px;pointer-events:none;vertical-align:text-top;white-space:nowrap}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container{cursor:default;margin-bottom:0;padding-left:22px}bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate b{font-size:16px;font-weight:500}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container .checkbox{display:inline-block;margin-bottom:5px;margin-top:7px;vertical-align:middle}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container .checkbox input{height:1em;width:1em}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion-alternate>.card .card-header{border-bottom-color:#fff}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion-alternate>.card .card-header .btn{line-height:1.6em;padding-top:12px!important}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion-alternate .card .card-body{display:flex;flex-direction:column;padding-top:8px;word-wrap:normal}bdc-multiselect-filter-section>.bento-accordion>.card .card-body .checkbox-container div{display:flex;margin-bottom:2px}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion button.btn.btn-link.btn-sm span{font-size:14px}bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate button.btn.btn-link.btn-sm:focus{outline:0!important}bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate button.btn.btn-link.btn-sm{justify-content:flex-start;padding:5px}.clear{align-items:flex-end!important;background-color:#efefef;border:#666;color:#37383d;font-family:Knowledge Medium;font-size:9px;height:18px;margin-right:10px;text-transform:uppercase}.clear:hover{background-color:#fff}\n"], components: [{ type: i1$2.NgbAccordion, selector: "ngb-accordion", inputs: ["animation", "activeIds", "closeOthers", "destroyOnHide", "type"], outputs: ["panelChange", "shown", "hidden"], exportAs: ["ngbAccordion"] }, { type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i1$2.NgbPanel, selector: "ngb-panel", inputs: ["disabled", "id", "title", "type", "cardClass"], outputs: ["shown", "hidden"] }, { type: i1$2.NgbPanelTitle, selector: "ng-template[ngbPanelTitle]" }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbPanelContent, selector: "ng-template[ngbPanelContent]" }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe }, changeDetection: i0.ChangeDetectionStrategy.OnPush, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiselectFilterSectionComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-multiselect-filter-section', encapsulation: ViewEncapsulation.None, changeDetection: ChangeDetectionStrategy.OnPush, template: "<ngb-accordion\n\tclass=\"bento-accordion bento-accordion-alternate\"\n\tanimation=\"false\"\n\tactiveIds=\"{{'multi-select-panel-' + panelId}}\"\n\t(panelChange)=\"panelChanged($event)\"\n>\n\t<ngb-panel id=\"{{'multi-select-panel-' + panelId}}\">\n\t\t<ng-template ngbPanelTitle>\n\t\t\t<b>{{heading | translate}}</b>\n\t\t\t<span class=\"selected-count-badge\" *ngIf=\"selectedItemsCount > 0\">{{selectedItemsCount}}</span>\n\t\t\t<a\n\t\t\t\thref\n\t\t\t\ttype=\"button\"\n\t\t\t\trole=\"button\"\n\t\t\t\tclass=\"btn btn-xs btn-default float-right clear\"\n\t\t\t\t*ngIf=\"selectedItemsCount > 0\"\n\t\t\t\t(click)=\"clearClicked($event)\"\n\t\t\t\t(keydown.Space)=\"clearClicked($event)\"\n\t\t\t>\n\t\t\t\t{{'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n\t\t\t</a>\n\t\t</ng-template>\n\n\t\t<ng-template ngbPanelContent>\n\t\t\t<div class=\"ng-bento checkbox-container\" *ngFor=\"let item of model; index as i;\">\n\t\t\t\t<div *ngIf=\"itemShouldBeShown(i)\">\n\t\t\t\t\t<bento-checkbox\n\t\t\t\t\t\tclass=\"checkbox\"\n\t\t\t\t\t\t[ngModel]=\"item.isChecked\"\n\t\t\t\t\t\t(ngModelChange)=\"updateSelectedItemsCount(i, $event)\"\n\t\t\t\t\t\t[disabled]=\"false\"\n\t\t\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t\t\t[attr.data-qe-id]=\"(checkboxQeId + '-' + (i + 1))\"\n\t\t\t\t\t\tid=\"{{checkboxQeId + '_' + (i+1)}}\"\n\t\t\t\t\t></bento-checkbox>\n\t\t\t\t\t<label for=\"{{checkboxQeId + '_' + (i+1)}}\">{{item.checkBoxName | translate}}</label>\n\t\t\t\t</div>\n\t\t\t</div>\n\n\t\t\t<button\n\t\t\t\tclass=\"btn btn-link btn-sm\"\n\t\t\t\t*ngIf=\"expandCollapseLinksShouldBeShown()\"\n\t\t\t\t(click)=\"toggleExpandState()\"\n\t\t\t\t[attr.data-qe-id]=\"linkButtonQeId\"\n\t\t\t>\n\t\t\t\t<span>{{getExpandCollapseLinkCaptionKey() | translate}}</span>\n\t\t\t</button>\n\t\t</ng-template>\n\t</ngb-panel>\n</ngb-accordion>\n", styles: ["bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate .selected-count-badge{background-color:#000;border-radius:2px;color:#b6b6b6;line-height:1.2em;margin-left:7px;padding:0 6px}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container label{margin:5px 0 4px 2px;pointer-events:none;vertical-align:text-top;white-space:nowrap}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container{cursor:default;margin-bottom:0;padding-left:22px}bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate b{font-size:16px;font-weight:500}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container .checkbox{display:inline-block;margin-bottom:5px;margin-top:7px;vertical-align:middle}bdc-multiselect-filter-section>.bento-accordion .ng-bento.checkbox-container .checkbox input{height:1em;width:1em}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion-alternate>.card .card-header{border-bottom-color:#fff}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion-alternate>.card .card-header .btn{line-height:1.6em;padding-top:12px!important}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion-alternate .card .card-body{display:flex;flex-direction:column;padding-top:8px;word-wrap:normal}bdc-multiselect-filter-section>.bento-accordion>.card .card-body .checkbox-container div{display:flex;margin-bottom:2px}bdc-multiselect-filter-section>.accordion.bento-accordion.bento-accordion button.btn.btn-link.btn-sm span{font-size:14px}bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate button.btn.btn-link.btn-sm:focus{outline:0!important}bdc-multiselect-filter-section>.bento-accordion.bento-accordion-alternate button.btn.btn-link.btn-sm{justify-content:flex-start;padding:5px}.clear{align-items:flex-end!important;background-color:#efefef;border:#666;color:#37383d;font-family:Knowledge Medium;font-size:9px;height:18px;margin-right:10px;text-transform:uppercase}.clear:hover{background-color:#fff}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }]; }, propDecorators: { qeId: [{
                type: Input
            }], allowCollapsing: [{
                type: Input
            }], collapseCount: [{
                type: Input
            }], isExpanded: [{
                type: Input
            }], panelActive: [{
                type: Input
            }], heading: [{
                type: Input
            }], model: [{
                type: Input
            }], panelId: [{
                type: Input
            }], clearAll: [{
                type: Input
            }], panelStateChanged: [{
                type: Output
            }], itemCountChanged: [{
                type: Output
            }], accordion: [{
                type: ViewChild,
                args: [NgbAccordion]
            }] } });

class AllDocumentsPaneComponent {
    constructor() {
        this._curTotalPages = 0;
        this._employeeList$ = new BehaviorSubject(new ContactSet([], false));
        // Keep track if the last data load was for a search. If it was a subsequent paging operation
        // will need to cause a data load.
        this._lastDataLoadForSearch = false;
        this._employeePageLoadingAttempted = false;
        // Make mocking simpler
        this.getCompanyId = getCompanyId;
        this.getContactId = getContactId;
        this.isLeftOpened = true;
        this.leftWidth = 300;
        this.eventsFilterExpanded = false;
        // Active accordion sections
        this.myActiveSectionIds = [];
        this.employeeChanged = new EventEmitter();
        this.eventFilters = [
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Accessed')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Copied')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Created')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Linked')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Moved')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Restored')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Deleted')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Updated')),
        ];
    }
    // Options for a standard data loading operation (paged or search) that will load
    // for all employees other than the employee corresponding to the currently
    // logged in user.
    static getStandardDataLoadOptions(dataRequest, companyId, pageSize, currentContactId) {
        const getOptions = {
            companyId: companyId,
            expand: 'name,contactView.id',
            startIndex: pageSize * (dataRequest.pageNumber - 1) + 1,
            pageIndex: dataRequest.pageNumber,
            itemsPerPage: pageSize,
            search: dataRequest.search,
            searchBy: 'name',
            filter: {
                items: [
                    {
                        by: 'contactView.id',
                        op: FilterOperations.NOTEQ,
                        value: currentContactId,
                    },
                ],
            },
        };
        return getOptions;
    }
    // Options for a standard data loading operation (paged or search) that will load
    // for only the employee corresponding to the currently logged in user.
    static getCurrentContactDataLoadOptions(dataRequest, companyId, currentContactId) {
        const getOptionsForCurrentContact = {
            companyId: companyId,
            expand: 'name,contactView.id',
            search: dataRequest.search,
            searchBy: 'name',
            filter: {
                items: [
                    {
                        by: 'contactView.id',
                        op: FilterOperations.EQ,
                        value: currentContactId,
                    },
                ],
            },
        };
        return getOptionsForCurrentContact;
    }
    expandAll() {
        this.accordion.expandAll();
        this.eventsFilterExpanded = true;
    }
    collapseAll() {
        this.accordion.collapseAll();
        this.eventsFilterExpanded = false;
    }
    getEmployeeList() {
        return this._employeeList$;
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this._companyId = yield this.getCompanyId();
            this._currentContactId = yield this.getContactId();
        });
    }
    getDataQeId(element) {
        let id = 'dms-all-documents-pane-' + element;
        if (this.dataQeIdPrefix) {
            id = this.dataQeIdPrefix + '-' + id;
        }
        return id;
    }
    changeEmployee(newEmployee) {
        return __awaiter(this, void 0, void 0, function* () {
            this.employeeChanged.emit(newEmployee.id);
            return newEmployee;
        });
    }
    onDataRequested(dataRequest) {
        return __awaiter(this, void 0, void 0, function* () {
            let incremental = true;
            if (dataRequest.reason === PaginatedItemsRequestReason.Search) {
                incremental = false;
                this._lastDataLoadForSearch = true;
                this._employeePageLoadingAttempted = false;
            }
            if (this._curTotalPages === 0 ||
                dataRequest.pageNumber <= this._curTotalPages ||
                (dataRequest.reason === PaginatedItemsRequestReason.Paging && this._lastDataLoadForSearch)) {
                if (dataRequest.reason === PaginatedItemsRequestReason.Paging && this._lastDataLoadForSearch) {
                    // When switching from search to paging we need to clear the seach results and start over.
                    // Set incremental to false in the call to next to allow the observable to clear.
                    this._employeeList$.next(new ContactSet([], false));
                    this._employeePageLoadingAttempted = false;
                    this._lastDataLoadForSearch = false; // Need to reset for the search to paging transition.
                }
                this._companyId = this._companyId || (yield this.getCompanyId());
                this._currentContactId = this._currentContactId || (yield this.getContactId());
                let currentContacts = [];
                // The currently logged in staff must be first in the selector so load
                // for them first.
                // Load for the currently logged in staff if we are loading the
                // first page of results or this is a search.
                if (!this._employeePageLoadingAttempted || !incremental) {
                    const getOptionsForCurrentContact = AllDocumentsPaneComponent.getCurrentContactDataLoadOptions(dataRequest, this._companyId, this._currentContactId);
                    const currentEmployeeResponse = yield getEmployeeViews(getOptionsForCurrentContact);
                    const currentEmployee = currentEmployeeResponse.items.length === 1 ? currentEmployeeResponse.items[0] : null;
                    if (currentEmployee) {
                        currentContacts.push(new Contact(currentEmployee.contactView ? currentEmployee.contactView.id || '' : '', currentEmployee.name, false, true));
                    }
                }
                const getOptions = AllDocumentsPaneComponent.getStandardDataLoadOptions(dataRequest, this._companyId, AllDocumentsPaneComponent.pageSize, this._currentContactId);
                const employeeResponse = yield getEmployeeViews(getOptions);
                this._curTotalPages = employeeResponse.totalPages;
                const employees = employeeResponse.items;
                // Convert employees into contacts for the ContactSet which is used
                // in the selector control.
                currentContacts = currentContacts.concat(employees.map(e => new Contact(e.contactView ? e.contactView.id || '' : '', e.name, false, true)));
                this._employeeList$.next(new ContactSet(currentContacts, incremental));
                // Now that we have loaded data we can set _employeePageLoadingAttempted to
                // true to signify a data load has occurred.
                this._employeePageLoadingAttempted = true;
            }
        });
    }
}
AllDocumentsPaneComponent.pageSize = 25;
/** @nocollapse */ AllDocumentsPaneComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsPaneComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AllDocumentsPaneComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AllDocumentsPaneComponent, selector: "bdc-all-documents-pane", inputs: { dataQeIdPrefix: "dataQeIdPrefix" }, outputs: { employeeChanged: "employeeChanged" }, viewQueries: [{ propertyName: "accordion", first: true, predicate: NgbAccordion, descendants: true }], ngImport: i0, template: "<div class=\"card mb-3\">\n\t<div class=\"card-body all-documents-overall\">\n\t\t<bento-splitter-group [(leftOpened)]=\"isLeftOpened\" [(leftWidth)]=\"leftWidth\">\n\t\t\t<bento-splitter-group-left>\n\t\t\t\t<div>\n\t\t\t\t\t<bento-expand-collapse-button-group\n\t\t\t\t\t\t(expand)=\"expandAll()\"\n\t\t\t\t\t\t(collapse)=\"collapseAll()\"\n\t\t\t\t\t></bento-expand-collapse-button-group>\n\t\t\t\t\t<bdc-multiselect-filter-section\n\t\t\t\t\t\t[qeId]=\"'dms-all-documents-pane'\"\n\t\t\t\t\t\t[heading]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.Event' | translate\"\n\t\t\t\t\t\t[model]=\"eventFilters\"\n\t\t\t\t\t\t[allowCollapsing]=\"true\"\n\t\t\t\t\t\t[collapseCount]=\"4\"\n\t\t\t\t\t\t[isExpanded]=\"false\"\n\t\t\t\t\t\t[panelActive]=\"eventsFilterExpanded\"\n\t\t\t\t\t></bdc-multiselect-filter-section>\n\t\t\t\t\t<ngb-accordion\n\t\t\t\t\t\tclass=\"bento-accordion bento-accordion-alternate\"\n\t\t\t\t\t\tanimation=\"false\"\n\t\t\t\t\t\tactiveIds=\"originated-by-filter\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<ngb-panel\n\t\t\t\t\t\t\tid=\"originated-by-filter\"\n\t\t\t\t\t\t\t[title]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.OriginatedBy' | translate\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<ng-template ngbPanelContent>\n\t\t\t\t\t\t\t\t<bdc-contact-selector\n\t\t\t\t\t\t\t\t\t[dataSource]=\"getEmployeeList()\"\n\t\t\t\t\t\t\t\t\t[contact]=\"employee\"\n\t\t\t\t\t\t\t\t\tcomboLabelText=\"Employee *\"\n\t\t\t\t\t\t\t\t\t[showEmailAddressColumn]=\"false\"\n\t\t\t\t\t\t\t\t\t[showRelationshipColumn]=\"false\"\n\t\t\t\t\t\t\t\t\t[hideControlBorder]=\"false\"\n\t\t\t\t\t\t\t\t\t[attr.data-qe-id]=\"getDataQeId('originated-by-filter-selector')\"\n\t\t\t\t\t\t\t\t\t(contactChange)=\"changeEmployee($event)\"\n\t\t\t\t\t\t\t\t\t(dataRequested)=\"onDataRequested($event)\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t</bdc-contact-selector>\n\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t</ngb-panel>\n\t\t\t\t\t</ngb-accordion>\n\t\t\t\t\t<hr class=\"after-accordion\" />\n\t\t\t\t</div>\n\t\t\t</bento-splitter-group-left>\n\t\t\t<bento-splitter-group-main>\n\t\t\t\t<h1>Main Content Here</h1>\n\t\t\t\t<p>\n\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore\n\t\t\t\t\tmagna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n\t\t\t\t\tconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.\n\t\t\t\t\tExcepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\t\t\t\t</p>\n\t\t\t</bento-splitter-group-main>\n\t\t</bento-splitter-group>\n\t</div>\n</div>\n", styles: [".after-accordion{border:0;border-bottom-style:solid;border-bottom-width:1px;border-color:#93939c;margin-bottom:0;margin-top:0}.all-documents-overall{height:500px;position:relative;width:100%}\n"], components: [{ type: i2.BentoSplitterGroupComponent, selector: "bento-splitter-group", inputs: ["autoResize", "resizeStepSize", "noCollapse", "leftWidth", "leftMaxWidth", "leftOpened", "rightWidth", "rightMaxWidth", "rightOpened", "topHeight", "topMaxHeight", "topOpened", "bottomHeight", "bottomMaxHeight", "bottomOpened"], outputs: ["leftWidthChange", "leftOpenedChange", "rightWidthChange", "rightOpenedChange", "topHeightChange", "topOpenedChange", "bottomHeightChange", "bottomOpenedChange"] }, { type: i2.BentoSplitterGroupLeftComponent, selector: "bento-splitter-group-left" }, { type: i2.BentoExpandCollapseButtonGroupComponent, selector: "bento-expand-collapse-button-group", inputs: ["expandAllTitle", "collapseAllTitle"], outputs: ["expand", "collapse"] }, { type: MultiselectFilterSectionComponent, selector: "bdc-multiselect-filter-section", inputs: ["qeId", "allowCollapsing", "collapseCount", "isExpanded", "panelActive", "heading", "model", "panelId", "clearAll"], outputs: ["panelStateChanged", "itemCountChanged"] }, { type: i1$2.NgbAccordion, selector: "ngb-accordion", inputs: ["animation", "activeIds", "closeOthers", "destroyOnHide", "type"], outputs: ["panelChange", "shown", "hidden"], exportAs: ["ngbAccordion"] }, { type: ContactSelectorComponent, selector: "bdc-contact-selector", inputs: ["contact", "readonly", "showEmailAddressColumn", "showRelationshipColumn", "hideControlBorder", "isValid", "dataSource", "comboLabelText"], outputs: ["contactChange", "dataRequested", "onBlur"] }, { type: i2.BentoSplitterGroupMainComponent, selector: "bento-splitter-group-main" }], directives: [{ type: i1$2.NgbPanel, selector: "ngb-panel", inputs: ["disabled", "id", "title", "type", "cardClass"], outputs: ["shown", "hidden"] }, { type: i1$2.NgbPanelContent, selector: "ng-template[ngbPanelContent]" }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsPaneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-all-documents-pane', template: "<div class=\"card mb-3\">\n\t<div class=\"card-body all-documents-overall\">\n\t\t<bento-splitter-group [(leftOpened)]=\"isLeftOpened\" [(leftWidth)]=\"leftWidth\">\n\t\t\t<bento-splitter-group-left>\n\t\t\t\t<div>\n\t\t\t\t\t<bento-expand-collapse-button-group\n\t\t\t\t\t\t(expand)=\"expandAll()\"\n\t\t\t\t\t\t(collapse)=\"collapseAll()\"\n\t\t\t\t\t></bento-expand-collapse-button-group>\n\t\t\t\t\t<bdc-multiselect-filter-section\n\t\t\t\t\t\t[qeId]=\"'dms-all-documents-pane'\"\n\t\t\t\t\t\t[heading]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.Event' | translate\"\n\t\t\t\t\t\t[model]=\"eventFilters\"\n\t\t\t\t\t\t[allowCollapsing]=\"true\"\n\t\t\t\t\t\t[collapseCount]=\"4\"\n\t\t\t\t\t\t[isExpanded]=\"false\"\n\t\t\t\t\t\t[panelActive]=\"eventsFilterExpanded\"\n\t\t\t\t\t></bdc-multiselect-filter-section>\n\t\t\t\t\t<ngb-accordion\n\t\t\t\t\t\tclass=\"bento-accordion bento-accordion-alternate\"\n\t\t\t\t\t\tanimation=\"false\"\n\t\t\t\t\t\tactiveIds=\"originated-by-filter\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<ngb-panel\n\t\t\t\t\t\t\tid=\"originated-by-filter\"\n\t\t\t\t\t\t\t[title]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.OriginatedBy' | translate\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<ng-template ngbPanelContent>\n\t\t\t\t\t\t\t\t<bdc-contact-selector\n\t\t\t\t\t\t\t\t\t[dataSource]=\"getEmployeeList()\"\n\t\t\t\t\t\t\t\t\t[contact]=\"employee\"\n\t\t\t\t\t\t\t\t\tcomboLabelText=\"Employee *\"\n\t\t\t\t\t\t\t\t\t[showEmailAddressColumn]=\"false\"\n\t\t\t\t\t\t\t\t\t[showRelationshipColumn]=\"false\"\n\t\t\t\t\t\t\t\t\t[hideControlBorder]=\"false\"\n\t\t\t\t\t\t\t\t\t[attr.data-qe-id]=\"getDataQeId('originated-by-filter-selector')\"\n\t\t\t\t\t\t\t\t\t(contactChange)=\"changeEmployee($event)\"\n\t\t\t\t\t\t\t\t\t(dataRequested)=\"onDataRequested($event)\"\n\t\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t</bdc-contact-selector>\n\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t</ngb-panel>\n\t\t\t\t\t</ngb-accordion>\n\t\t\t\t\t<hr class=\"after-accordion\" />\n\t\t\t\t</div>\n\t\t\t</bento-splitter-group-left>\n\t\t\t<bento-splitter-group-main>\n\t\t\t\t<h1>Main Content Here</h1>\n\t\t\t\t<p>\n\t\t\t\t\tLorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod tempor incididunt ut labore et dolore\n\t\t\t\t\tmagna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo\n\t\t\t\t\tconsequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur.\n\t\t\t\t\tExcepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.\n\t\t\t\t</p>\n\t\t\t</bento-splitter-group-main>\n\t\t</bento-splitter-group>\n\t</div>\n</div>\n", styles: [".after-accordion{border:0;border-bottom-style:solid;border-bottom-width:1px;border-color:#93939c;margin-bottom:0;margin-top:0}.all-documents-overall{height:500px;position:relative;width:100%}\n"] }]
        }], propDecorators: { dataQeIdPrefix: [{
                type: Input
            }], employeeChanged: [{
                type: Output
            }], accordion: [{
                type: ViewChild,
                args: [NgbAccordion]
            }] } });

var GridColumn;
(function (GridColumn) {
    GridColumn["App"] = "app";
    GridColumn["Type"] = "type";
    GridColumn["Name"] = "name";
    GridColumn["Shared"] = "shared";
    GridColumn["Year"] = "year";
    GridColumn["DueDate"] = "dueDate";
})(GridColumn || (GridColumn = {}));

class UserLanguageService {
    constructor() {
        this.getCurrentUser = getCurrentUser;
    }
    getUserLanguage() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.language === undefined) {
                const user = yield this.getCurrentUser();
                this.language = user.language || '';
            }
            return this.language;
        });
    }
}
/** @nocollapse */ UserLanguageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UserLanguageService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ UserLanguageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UserLanguageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: UserLanguageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }] });

class ItemTypeColumnComponent {
    constructor() {
        registerIcon();
    }
    set item(item) {
        this.setIconType(item);
    }
    setIconType(item) {
        const hasChildren = isContainer(item) && item.hasChildren;
        const icon = item.type === ItemType.AppGroup ? containerIcon(item, hasChildren) : getItemTypeIcon(item, hasChildren);
        this.iconType = icon.name;
        this.iconColor = icon.color;
    }
}
/** @nocollapse */ ItemTypeColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemTypeColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ItemTypeColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ItemTypeColumnComponent, selector: "bdc-item-type-column", inputs: { item: "item" }, ngImport: i0, template: "<div class=\"center-cell\">\n\t<bm-icon [type]=\"iconType\" [style.fill]=\"iconColor\"></bm-icon>\n</div>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemTypeColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-item-type-column', template: "<div class=\"center-cell\">\n\t<bm-icon [type]=\"iconType\" [style.fill]=\"iconColor\"></bm-icon>\n</div>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { item: [{
                type: Input
            }] } });

class ProjectAppColumnComponent {
    constructor() {
        registerIcon();
    }
    set item(item) {
        if (ProjectAppColumnComponent.isProject(item)) {
            const app = item.application;
            this.iconType = getAppIcon(app);
        }
    }
    static isProject(item) {
        return item.type === ItemType.Project || item.type === ItemType.AppGroup || item.type === ItemType.YearGroup;
    }
}
/** @nocollapse */ ProjectAppColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProjectAppColumnComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ProjectAppColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ProjectAppColumnComponent, selector: "bdc-project-app-column", inputs: { item: "item" }, ngImport: i0, template: "<div class=\"center-cell\">\n\t<bm-icon [type]=\"iconType\"></bm-icon>\n</div>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ProjectAppColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-project-app-column', template: "<div class=\"center-cell\">\n\t<bm-icon [type]=\"iconType\"></bm-icon>\n</div>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { item: [{
                type: Input
            }] } });

class ItemNameLinkColumnComponent {
    constructor(itemName) {
        this.itemName = itemName;
        this.href = '#';
        this.nameClicked = new EventEmitter();
    }
    set item(item) {
        this._item = item;
        this.name = this.itemName.get(item);
    }
    onClick(event) {
        event.preventDefault();
        this.nameClicked.emit(this._item);
    }
    getDataQeId() {
        return 'dms-fe-component-item-name-link' + (this.qeId ? '-' + this.qeId : '');
    }
}
/** @nocollapse */ ItemNameLinkColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemNameLinkColumnComponent, deps: [{ token: ItemDisplayNameService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ItemNameLinkColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ItemNameLinkColumnComponent, selector: "bdc-item-name-link-column", inputs: { item: "item", href: "href", qeId: "qeId" }, outputs: { nameClicked: "nameClicked" }, ngImport: i0, template: "<a (click)=\"onClick($event)\" [attr.data-qe-id]=\"getDataQeId()\" [href]=\"href\"> {{name}} </a>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemNameLinkColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-item-name-link-column', template: "<a (click)=\"onClick($event)\" [attr.data-qe-id]=\"getDataQeId()\" [href]=\"href\"> {{name}} </a>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: ItemDisplayNameService }]; }, propDecorators: { item: [{
                type: Input
            }], href: [{
                type: Input
            }], qeId: [{
                type: Input
            }], nameClicked: [{
                type: Output
            }] } });

class LockMessageService {
    constructor(userLanguageService, translateService) {
        this.userLanguageService = userLanguageService;
        this.translateService = translateService;
        /**
         * Options for formatting the date string in the lock message
         */
        this.lockMessageOptions = { year: 'numeric', month: 'long', day: 'numeric' };
    }
    /**
     * Gets the Lock Message for a given lock to display in tooltips or modals
     * @param lock ItemLock for the item which we are retrieving the lock message
     * @returns Lock message with date format based on region.
     *  (ex. "Locked by Staff Member on May 4, 2021", or "Locked" if lock level is not master)
     */
    getLockMessage(lock) {
        return __awaiter(this, void 0, void 0, function* () {
            if (lock.isMaster) {
                const userLanguage = yield this.userLanguageService.getUserLanguage();
                const lockMessage = {
                    lockerName: lock.createdBy.displayAs,
                    lockedDate: lock.createdDate.toLocaleDateString(userLanguage, this.lockMessageOptions),
                };
                return this.translateService.get('Blue.DocumentComponents.Common.LockedMaster', lockMessage).toPromise();
            }
            return this.translateService.get('Blue.DocumentComponents.Common.LockedSubordinate').toPromise();
        });
    }
}
/** @nocollapse */ LockMessageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LockMessageService, deps: [{ token: UserLanguageService }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ LockMessageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LockMessageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LockMessageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: UserLanguageService }, { type: i1.TranslateService }]; } });

class ItemStatusIconComponent {
    constructor(lockMessageService) {
        this.lockMessageService = lockMessageService;
        this.statusIcons = [];
        this.getStatusIcons = getStatusIcons;
        this.hideIcons = [];
    }
    ngOnChanges() {
        if (this.item) {
            const allIcons = this.getStatusIcons(this.item);
            this.statusIcons = this.removeExcluded(allIcons);
            if (this.statusIcons.includes(statusIcons[IconType$1.Lock])) {
                this.lockTooltip = this.getLockTooltip(this.item);
            }
        }
    }
    // Getter for IconType enum to use in html file.
    get iconType() {
        return IconType$1;
    }
    getLockTooltip(item) {
        return __awaiter(this, void 0, void 0, function* () {
            if (item.lock) {
                return this.lockMessageService.getLockMessage(item.lock);
            }
            return '';
        });
    }
    removeExcluded(icons) {
        return icons.filter(icon => {
            return !this.hideIcons.some(toHide => toHide === icon.name);
        });
    }
}
/** @nocollapse */ ItemStatusIconComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemStatusIconComponent, deps: [{ token: LockMessageService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ ItemStatusIconComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: ItemStatusIconComponent, selector: "bdc-item-status-icon", inputs: { hideIcons: "hideIcons", item: "item" }, usesOnChanges: true, ngImport: i0, template: "<span *ngFor=\"let icon of statusIcons\">\n\t<bm-icon\n\t\tplacement=\"top\"\n\t\t[ngbTooltip]=\"icon.name === iconType.Lock ? (lockTooltip | async) : ''\"\n\t\ttooltipClass=\"lock-icon-tooltip\"\n\t\tcontainer=\"body\"\n\t\t[closeDelay]=\"1\"\n\t\t[type]=\"icon.name\"\n\t></bm-icon>\n</span>\n", styles: ["ngb-tooltip-window.lock-icon-tooltip.show{opacity:1}bdc-item-status-icon>span>bm-icon{display:inline-block}\n"], directives: [{ type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$2.NgbTooltip, selector: "[ngbTooltip]", inputs: ["animation", "autoClose", "placement", "triggers", "container", "disableTooltip", "tooltipClass", "openDelay", "closeDelay", "ngbTooltip"], outputs: ["shown", "hidden"], exportAs: ["ngbTooltip"] }], pipes: { "async": i2$1.AsyncPipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemStatusIconComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-item-status-icon', encapsulation: ViewEncapsulation.None, template: "<span *ngFor=\"let icon of statusIcons\">\n\t<bm-icon\n\t\tplacement=\"top\"\n\t\t[ngbTooltip]=\"icon.name === iconType.Lock ? (lockTooltip | async) : ''\"\n\t\ttooltipClass=\"lock-icon-tooltip\"\n\t\tcontainer=\"body\"\n\t\t[closeDelay]=\"1\"\n\t\t[type]=\"icon.name\"\n\t></bm-icon>\n</span>\n", styles: ["ngb-tooltip-window.lock-icon-tooltip.show{opacity:1}bdc-item-status-icon>span>bm-icon{display:inline-block}\n"] }]
        }], ctorParameters: function () { return [{ type: LockMessageService }]; }, propDecorators: { hideIcons: [{
                type: Input
            }], item: [{
                type: Input
            }] } });

class SharePopoverComponent {
    constructor() {
        this.editLinkClicked = new EventEmitter();
        this.hasSomePermission = hasSome;
        this.canShareFolders = false;
        this.shareModalLinkText = '';
        this.sharedInfoIsReady = false;
        this.shareGroups = [];
    }
    get shareFolderFrp() {
        return '';
    }
    get sharedWithFile() {
        return false;
    }
    ngOnChanges(changes) {
        return __awaiter(this, void 0, void 0, function* () {
            if (changes.shares.currentValue !== changes.shares.previousValue) {
                this.updateShareGroups();
            }
        });
    }
    ngOnInit() {
        this.checkCanShare();
        this.updateShareGroups();
    }
    editShare(event) {
        event.preventDefault();
        this.editLinkClicked.emit();
    }
    checkCanShare() {
        return __awaiter(this, void 0, void 0, function* () {
            const canShare = yield this.hasSomePermission(['OnvioDrive.ShareFolders', this.shareFolderFrp]);
            this.canShareFolders = canShare;
            this.shareModalLinkText =
                !this.canShareFolders || this.sharedWithFile
                    ? marker('Blue.DocumentComponents.Modal.Share.ViewSharedDetails')
                    : marker('Blue.DocumentComponents.Modal.Share.EditSharedDetails');
        });
    }
    updateShareGroups() {
        if (!this.shares) {
            return;
        }
        this.shareGroups = [];
        const sharesByRole = new Map();
        this.shares.forEach(share => {
            var _a;
            let numShownShares = 0;
            this.sharedInfoIsReady = true;
            // Only user shares are shown
            if (share.userType === ShareUserType.User) {
                // Only show 20 in the popover
                if (numShownShares < 20) {
                    const currentByRole = (_a = sharesByRole.get(share.role)) !== null && _a !== void 0 ? _a : [];
                    sharesByRole.set(share.role, currentByRole.concat(share));
                    numShownShares++;
                }
            }
        });
        if (sharesByRole.has(ShareRole.Owner)) {
            this.shareGroups.push({
                label: marker('Blue.DocumentComponents.Modal.Share.OwnerRole'),
                shares: sharesByRole.get(ShareRole.Owner),
            });
        }
        if (sharesByRole.has(ShareRole.Contributor)) {
            this.shareGroups.push({
                label: marker('Blue.DocumentComponents.Modal.Share.ContributorRole'),
                shares: sharesByRole.get(ShareRole.Contributor),
            });
        }
        if (sharesByRole.has(ShareRole.Reviewer)) {
            this.shareGroups.push({
                label: marker('Blue.DocumentComponents.Modal.Share.ReviewerRole'),
                shares: sharesByRole.get(ShareRole.Reviewer),
            });
        }
    }
}
/** @nocollapse */ SharePopoverComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharePopoverComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SharePopoverComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SharePopoverComponent, selector: "bdc-share-popover", inputs: { iconType: "iconType", iconColor: "iconColor", numSharedWith: "numSharedWith", shares: "shares" }, outputs: { editLinkClicked: "editLinkClicked" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"ng-bento sharedPopoverbutton\" *ngIf=\"sharedInfoIsReady\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-icon btn-sm\"\n\t\tplacement=\"right\"\n\t\t[ngbPopover]=\"popoverBody\"\n\t\t[popoverTitle]=\"popoverTitle\"\n\t\tpopoverClass=\"sharedPopoverWindow\"\n\t\tcontainer=\"body\"\n\t>\n\t\t<bm-icon [type]=\"iconType\" [style.fill]=\"iconColor\"></bm-icon>\n\t</button>\n</div>\n\n<div class=\"sharedPopoverbutton\" *ngIf=\"!sharedInfoIsReady\">\n\t<bm-icon [type]=\"iconType\" [style.fill]=\"iconColor\"></bm-icon>\n</div>\n\n<ng-template #popoverTitle>{{'Blue.DocumentComponents.Modal.Share.SharedListLabel' | translate}}</ng-template>\n\n<ng-template #popoverBody>\n\t<div class=\"shareGroup\" *ngFor=\"let group of shareGroups\">\n\t\t<h3>{{group.label | translate}}:</h3>\n\t\t<div *ngFor=\"let share of group.shares\">\n\t\t\t<p>{{share.user.displayAs}}</p>\n\t\t</div>\n\t</div>\n\t<div class=\"shareDetailsLink\">\n\t\t<a href (click)=\"editShare($event)\">{{shareModalLinkText | translate}}</a\n\t\t><span class=\"badge demo-badge-margin\">{{numSharedWith}}</span>\n\t</div>\n</ng-template>\n", styles: [".sharedPopoverbutton button bm-icon{width:14px}.sharedPopoverbutton bm-icon{width:14px}.sharedPopoverbutton button.btn{margin-bottom:5px;max-width:20px}\n", "code{text-transform:none}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbPopover, selector: "[ngbPopover]", inputs: ["animation", "autoClose", "ngbPopover", "popoverTitle", "placement", "triggers", "container", "disablePopover", "popoverClass", "openDelay", "closeDelay"], outputs: ["shown", "hidden"], exportAs: ["ngbPopover"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharePopoverComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-share-popover', encapsulation: ViewEncapsulation.None, styles: [".sharedPopoverbutton button bm-icon{width:14px}.sharedPopoverbutton bm-icon{width:14px}.sharedPopoverbutton button.btn{margin-bottom:5px;max-width:20px}\n", "code{text-transform:none}\n"], template: "<div class=\"ng-bento sharedPopoverbutton\" *ngIf=\"sharedInfoIsReady\">\n\t<button\n\t\ttype=\"button\"\n\t\tclass=\"btn btn-icon btn-sm\"\n\t\tplacement=\"right\"\n\t\t[ngbPopover]=\"popoverBody\"\n\t\t[popoverTitle]=\"popoverTitle\"\n\t\tpopoverClass=\"sharedPopoverWindow\"\n\t\tcontainer=\"body\"\n\t>\n\t\t<bm-icon [type]=\"iconType\" [style.fill]=\"iconColor\"></bm-icon>\n\t</button>\n</div>\n\n<div class=\"sharedPopoverbutton\" *ngIf=\"!sharedInfoIsReady\">\n\t<bm-icon [type]=\"iconType\" [style.fill]=\"iconColor\"></bm-icon>\n</div>\n\n<ng-template #popoverTitle>{{'Blue.DocumentComponents.Modal.Share.SharedListLabel' | translate}}</ng-template>\n\n<ng-template #popoverBody>\n\t<div class=\"shareGroup\" *ngFor=\"let group of shareGroups\">\n\t\t<h3>{{group.label | translate}}:</h3>\n\t\t<div *ngFor=\"let share of group.shares\">\n\t\t\t<p>{{share.user.displayAs}}</p>\n\t\t</div>\n\t</div>\n\t<div class=\"shareDetailsLink\">\n\t\t<a href (click)=\"editShare($event)\">{{shareModalLinkText | translate}}</a\n\t\t><span class=\"badge demo-badge-margin\">{{numSharedWith}}</span>\n\t</div>\n</ng-template>\n" }]
        }], propDecorators: { iconType: [{
                type: Input
            }], iconColor: [{
                type: Input
            }], numSharedWith: [{
                type: Input
            }], shares: [{
                type: Input
            }], editLinkClicked: [{
                type: Output
            }] } });

class SharedColumnComponent {
    constructor(shareStore) {
        this.shareStore = shareStore;
        this.editLinkClicked = new EventEmitter();
        this.shareSubscription = new Subscription$1();
        this.naturalSort = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        this.sorter = (a, b) => this.naturalSort.compare(a.user.displayAs || '', b.user.displayAs || '');
        this.shared = false;
    }
    set item(item) {
        this.shared = item.isShared;
        if (this.shared) {
            registerIcon();
            const icon = shareIcon();
            this.iconType = icon.name;
            this.iconColor = icon.color;
            this.numSharedWith = item.numSharedWith;
            this.smartBadgeDetails = {
                type: BentoSmartBadgeType.digit,
                content: { value: this.numSharedWith },
                ariaLabel: this.numSharedWith ? this.numSharedWith.toString() : '',
                color: BentoSmartBadgeStyle.info,
            };
        }
        if (item && isContainer(item)) {
            this.subscribeShares(item);
        }
        this._item = item;
    }
    subscribeShares(container) {
        this.shareSubscription.unsubscribe();
        const observer = this.shareStore.observeContainerShares(container);
        if (observer) {
            this.shareSubscription = observer.subscribe(share => (this.shares = share.sort(this.sorter)));
        }
    }
    ngOnDestroy() {
        this.shareSubscription.unsubscribe();
    }
    onEditLinkClicked() {
        this.editLinkClicked.emit(this._item);
    }
}
/** @nocollapse */ SharedColumnComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharedColumnComponent, deps: [{ token: i1$1.ShareStore }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SharedColumnComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SharedColumnComponent, selector: "bdc-shared-column", inputs: { item: "item" }, outputs: { editLinkClicked: "editLinkClicked" }, ngImport: i0, template: "<div *ngIf=\"shared\" class=\"center-cell\">\n\t<bento-smart-badge class=\"shared-smart-badge\" [details]=\"smartBadgeDetails\">\n\t\t<bdc-share-popover\n\t\t\t[iconType]=\"iconType\"\n\t\t\t[iconColor]=\"iconColor\"\n\t\t\t[numSharedWith]=\"numSharedWith\"\n\t\t\t[shares]=\"shares\"\n\t\t\t(editLinkClicked)=\"onEditLinkClicked()\"\n\t\t></bdc-share-popover>\n\t</bento-smart-badge>\n</div>\n", styles: ["bdc-shared-column .shared-smart-badge{margin-top:5px}bdc-shared-column .shared-smart-badge span.bento-smart-badge.bento-smart-badge-info{background:#0099c4;border:#fff solid 1px;border-radius:3px;color:#fff}bdc-shared-column .shared-smart-badge .btn.btn-icon{padding:0 .85rem!important}\n", "bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"], components: [{ type: i2.BentoSmartBadgeComponent, selector: "bento-smart-badge, [bentoSmartBadge]", inputs: ["details"] }, { type: SharePopoverComponent, selector: "bdc-share-popover", inputs: ["iconType", "iconColor", "numSharedWith", "shares"], outputs: ["editLinkClicked"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SharedColumnComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-shared-column', encapsulation: ViewEncapsulation.None, template: "<div *ngIf=\"shared\" class=\"center-cell\">\n\t<bento-smart-badge class=\"shared-smart-badge\" [details]=\"smartBadgeDetails\">\n\t\t<bdc-share-popover\n\t\t\t[iconType]=\"iconType\"\n\t\t\t[iconColor]=\"iconColor\"\n\t\t\t[numSharedWith]=\"numSharedWith\"\n\t\t\t[shares]=\"shares\"\n\t\t\t(editLinkClicked)=\"onEditLinkClicked()\"\n\t\t></bdc-share-popover>\n\t</bento-smart-badge>\n</div>\n", styles: ["bdc-shared-column .shared-smart-badge{margin-top:5px}bdc-shared-column .shared-smart-badge span.bento-smart-badge.bento-smart-badge-info{background:#0099c4;border:#fff solid 1px;border-radius:3px;color:#fff}bdc-shared-column .shared-smart-badge .btn.btn-icon{padding:0 .85rem!important}\n", "bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ShareStore }]; }, propDecorators: { editLinkClicked: [{
                type: Output
            }], item: [{
                type: Input
            }] } });

class ItemDatePipe {
    transform(value, language) {
        if (!language) {
            // we can't render the date until we know the language and we don't want to use a default
            // that might be different than the user's language which would cause a flicker
            return '';
        }
        return value ? value.toLocaleDateString(language) : '';
    }
}
/** @nocollapse */ ItemDatePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDatePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ ItemDatePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDatePipe, name: "bdcDate" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDatePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bdcDate' }]
        }] });

const defaultSort = new Sort(GridColumn.Name, SortDirection.Asc);
class DocumentGridComponent {
    constructor(changeDetector, itemName, state, appName, userLanguageService) {
        this.changeDetector = changeDetector;
        this.itemName = itemName;
        this.state = state;
        this.appName = appName;
        this.userLanguageService = userLanguageService;
        /** Array of items to display on the grid. Currently only Projects are officially supported */
        this.items = [];
        /** Array of the names of columns that should be hidden from view */
        this.hideColumns = [];
        /** Indicates whether or not the contents of the container have been retrieved from the server */
        this.loaded = false;
        /** Emits the item that was clicked when the name of an item is clicked. */
        this.itemClicked = new EventEmitter();
        /** Emits the collection of items that are selected any time the selection changes */
        this.selectionChanged = new EventEmitter();
        this.shareEditClicked = new EventEmitter();
        this.selected = ItemCollection.empty;
        // Internal use - maps Item ID to boolean - true if selected, false (or undefined) if not.
        this._isSelected = {};
        /** Wijmo setting - show all column headers */
        this.headersVisibility = HeadersVisibility.All;
        /** Wijmo setting - disable built-in row selection */
        this.selectionMode = SelectionMode.None;
        /** True if the user has clicked the select all checkbox in the upper left */
        this.hasAllSelected = false;
        this.pageSizeOptions = [10, 25, 50, 100];
        /**
         * Wijmo representation of a collection of items,
         * also keeps track of things like sorting and pagination
         */
        this.wijmoCollection = new CollectionView();
        /**
         * Current page number.
         * We set go input field model to it, when updateSelection() method is called
         */
        this.pageNumber = 1;
        /** A "natural sort" algorithm that makes sure 10 comes after 2 */
        this.naturalSort = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });
        this.collectionViewOptions = {
            // By default, the sort converter strips the item to whatever property
            // the current sort column is bound to.
            // We want to the whole item so we can do more complex sorting.
            sortConverter: (_, item) => item,
            sortComparer: this.itemSorter(),
            pageSize: this.pageSize,
        };
    }
    /** The current state */
    get pageSize() {
        return this.state.get(PersistentStateKey.Grid_PageSize, this.pageSizeOptions[1]);
    }
    set pageSize(size) {
        this.state.set(PersistentStateKey.Grid_PageSize, size);
        this.wijmoCollection.pageSize = size;
        this.wijmoCollection.moveToFirstPage();
        this.updateSelection();
    }
    /** The current state of sorting of this grid */
    get currentSort() {
        return this.state.get(PersistentStateKey.Grid_Sort, defaultSort);
    }
    set currentSort(sort) {
        this.state.set(PersistentStateKey.Grid_Sort, sort);
    }
    ngOnInit() {
        void this.setUserLanguage();
    }
    setUserLanguage() {
        return __awaiter(this, void 0, void 0, function* () {
            this.userLanguage = yield this.userLanguageService.getUserLanguage();
        });
    }
    ngOnChanges(changes) {
        if (changes.items) {
            this.onItemsChanged();
        }
    }
    onNameClick(item) {
        this.itemClicked.emit(item);
    }
    showColumn(name) {
        return !this.hideColumns.includes(name);
    }
    gridInitialized(grid) {
        grid.alternatingRowStep = 0;
        this.grid = grid;
        grid.columnHeaders.rows.defaultSize = 36;
    }
    _getHref(item) {
        return this.getHref ? this.getHref(item) : '#';
    }
    rowSelectionChanged(newValue, cell) {
        this._isSelected[cell.item.id] = newValue;
        this.onSelectionChange();
    }
    selectAllChanged(newValue) {
        this.hasAllSelected = newValue;
        if (newValue) {
            this.selectAllVisible();
        }
        else {
            this.deselectAll();
        }
        this.onSelectionChange();
    }
    onColumnSort(event) {
        const column = this.grid.columns[event.col];
        // This event is fired _after_ the user clicks a column but _before_ the sort is changed.
        // So "current sort" is what the sort direction **was**, so we flip it to get what it's going to be.
        const ascending = column.currentSort !== '+' ? SortDirection.Asc : SortDirection.Desc;
        this.currentSort = new Sort(column.binding, ascending);
    }
    /**
     * Updates the current visible page and selected items
     * @param pageNumber the new page number
     */
    onPageChange(pageNumber) {
        // TODO: This is a temporary solution, which should be removed after Bento issues (#1768, #1769) are fixed.
        if (this.pagination) {
            this.pagination.page =
                typeof this.pagination.page === 'string' ? Number(this.pagination.page) : this.pagination.page;
        }
        // Bento's pagination widget is 1-based, Wijmo is zero-based
        this.wijmoCollection.moveToPage(pageNumber - 1);
        this.hasAllSelected = false;
        this.deselectAll();
        this.updateSelection();
    }
    /**
     * @returns array of all Items which are currently visible depending on sort and pagination.
     */
    get visibleItems() {
        return this.wijmoCollection.items;
    }
    /**
     * Should run after the source items change for any reason.
     *
     * Sets the current sort and updates the current selection.
     */
    onItemsChanged() {
        this.wijmoCollection = new CollectionView(this.items, this.collectionViewOptions);
        // Wijmo forgets your sort settings when items reload, so we remember and "remind" it.
        const sort = new SortDescription(this.currentSort.column, this.currentSort.direction === SortDirection.Asc);
        this.wijmoCollection.sortDescriptions.push(sort);
        // Because of re-creating CollectionView need to specify page size once again
        this.wijmoCollection.pageSize = this.pageSize;
        // Bento's pagination widget is 1-based, Wijmo is zero-based
        this.wijmoCollection.moveToPage(this.pageNumber - 1);
        this.updateSelection();
    }
    /**
     * This should run anytime the visible items change.
     *
     * If 'select all' is checked, will select all visible items.
     * Otherwise, will remove no longer visible items from the selection.
     */
    updateSelection() {
        if (this.pagination) {
            this.pagination.paginationInputModel = this.pageNumber;
        }
        if (this.hasAllSelected) {
            // Instead of trying to figure out what's new just select everything
            this.selectAllVisible();
        }
        else {
            // Remove any items that are no longer in the grid
            // by rebuilding the selection map from the known items
            this._isSelected = this.visibleItems.reduce((selected, item) => {
                selected[item.id] = this._isSelected[item.id];
                return selected;
            }, {});
        }
        this.onSelectionChange();
    }
    itemSorter() {
        // collate works in sequential order, so the later sorts override the earlier ones (without changing internal order)
        return collate([
            (a, b) => this.sortByColumn(this.currentSort.column)(a, b),
            this.sortToTop(item => item.hasChildren),
            this.sortToTop(item => item.isContainer),
            this.sortToTop(item => isVirtualFolder(item)),
        ]);
    }
    /**
     * Special sort comparator that always pushes items that meet `test` to the beginning of the list
     * regardless of current grid sort order
     */
    sortToTop(test) {
        return sortFirst(item => {
            const ascending = this.currentSort.direction === SortDirection.Asc;
            const isTypeColumn = this.currentSort.column === GridColumn.Type;
            const result = test(item);
            // Flip the result if ascending or column name equals 'type'
            return ascending || isTypeColumn ? result : !result;
        });
    }
    sortByColumn(column) {
        if (column === GridColumn.Name) {
            return this.sortByNameThenYear();
        }
        if (column === GridColumn.Type) {
            return (a, b) => {
                var _a, _b;
                const nameA = (_a = a.fileExtension) !== null && _a !== void 0 ? _a : '';
                const nameB = (_b = b.fileExtension) !== null && _b !== void 0 ? _b : '';
                return this.naturalSort.compare(nameA, nameB);
            };
        }
        if (column === GridColumn.Year) {
            return this.sortByNumber(item => item.year);
        }
        if (column === GridColumn.DueDate) {
            return this.sortByNumber(item => { var _a; return item.dueDate && ((_a = item.dueDate) === null || _a === void 0 ? void 0 : _a.getTime()); });
        }
        if (column === GridColumn.Shared) {
            return this.sortByNumber(item => item.numSharedWith);
        }
        if (column === GridColumn.App) {
            return this.sortByString(item => this.appName.getTranslatedName(item.application));
        }
        // sort by name falls through to here
        // because itemSorter() already sorts by name as a last resort
        // to reduce nondeterministic sort results
        return () => 0;
    }
    sortByString(getString) {
        return (a, b) => {
            const stringA = getString(a) || '';
            const stringB = getString(b) || '';
            return this.naturalSort.compare(stringA, stringB);
        };
    }
    sortByNameThenYear() {
        return (a, b) => {
            const ascending = this.currentSort.direction === SortDirection.Asc;
            const stringA = a.name || '';
            const stringB = b.name || '';
            const yearA = a.year || 0;
            const yearB = b.year || 0;
            return ascending
                ? this.naturalSort.compare(stringA, stringB) || yearB - yearA
                : this.naturalSort.compare(stringA, stringB) || yearA - yearB;
        };
    }
    sortByNumber(getNumber) {
        return (a, b) => {
            const numA = getNumber(a) || 0;
            const numB = getNumber(b) || 0;
            return numA - numB;
        };
    }
    /**
     * Selects all the visible items (depending on sort and pagination)
     */
    selectAllVisible() {
        this._isSelected = this.visibleItems.reduce((selected, item) => {
            selected[item.id] = true;
            return selected;
        }, {});
    }
    /**
     * Deselects all items
     */
    deselectAll() {
        this._isSelected = {};
    }
    /**
     * - Updates the 'select all' checkbox based on what's currently selected
     * - Updates the `selected` property
     * - Emits the current selection
     */
    onSelectionChange() {
        this.hasAllSelected = this.visibleItems.length > 0 && this.visibleItems.every(item => this._isSelected[item.id]);
        const selected = this.visibleItems.filter(item => this._isSelected[item.id]);
        this.selected = new ItemCollection(selected);
        if (this.grid) {
            this.grid.invalidate();
        }
        this.selectionChanged.emit(this.selected);
        this.changeDetector.detectChanges();
    }
}
/** @nocollapse */ DocumentGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridComponent, deps: [{ token: i0.ChangeDetectorRef }, { token: ItemDisplayNameService }, { token: PersistentStateService }, { token: OnvioAppNameService }, { token: UserLanguageService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentGridComponent, selector: "bdc-document-grid", inputs: { items: "items", getHref: "getHref", hideColumns: "hideColumns", loaded: "loaded" }, outputs: { itemClicked: "itemClicked", selectionChanged: "selectionChanged", shareEditClicked: "shareEditClicked" }, viewQueries: [{ propertyName: "grid", first: true, predicate: ["grid"], descendants: true }, { propertyName: "pagination", first: true, predicate: BentoPaginationComponent, descendants: true }], usesOnChanges: true, ngImport: i0, template: "<div class=\"bdc-empty-folder-grid bdc-center-text\" *ngIf=\"loaded && items.length === 0\">\n\t{{ 'Blue.DocumentComponents.Grid.Empty' | translate }}\n</div>\n<wj-flex-grid\n\t#grid\n\t*ngIf=\"items.length > 0\"\n\tclass=\"bdc-wijmo-grid\"\n\t[itemsSource]=\"wijmoCollection\"\n\t(initialized)=\"gridInitialized(grid)\"\n\t[headersVisibility]=\"headersVisibility\"\n\t[selectionMode]=\"selectionMode\"\n\t(sortingColumn)=\"onColumnSort($event)\"\n>\n\t<!-- SELECT -->\n\n\t<!-- SELECT ALL -->\n\t<ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\">\n\t\t<bento-checkbox\n\t\t\tclass=\"bdc-documents-grid-select-checkbox\"\n\t\t\t[ngModel]=\"hasAllSelected\"\n\t\t\t(ngModelChange)=\"selectAllChanged($event)\"\n\t\t\t[indeterminate]=\"false\"\n\t\t\t[disabled]=\"false\"\n\t\t\tid=\"dms-fe-components-document-grid-select-all-checkbox\"\n\t\t></bento-checkbox>\n\t</ng-template>\n\n\t<!-- SELECT ROW -->\n\t<ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-cell=\"cell\" let-item=\"item\" let-row=\"row\">\n\t\t<bento-checkbox\n\t\t\tclass=\"bdc-documents-grid-select-checkbox\"\n\t\t\t[ngModel]=\"_isSelected[cell.item.id]\"\n\t\t\t(ngModelChange)=\"rowSelectionChanged($event, cell)\"\n\t\t\t[indeterminate]=\"false\"\n\t\t\t[disabled]=\"false\"\n\t\t\tid=\"dms-fe-components-document-grid-select-checkbox\"\n\t\t></bento-checkbox>\n\t</ng-template>\n\n\t<!-- Type -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Type' | translate\"\n\t\t[binding]=\"'type'\"\n\t\t[width]=\"75\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[visible]=\"showColumn('type')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-item-type-column [item]=\"cell.item\"></bdc-item-type-column>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- App -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.App' | translate\"\n\t\t[binding]=\"'app'\"\n\t\t[width]=\"75\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[visible]=\"showColumn('app')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-project-app-column [item]=\"cell.item\"></bdc-project-app-column>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- Name -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Name' | translate\"\n\t\t[binding]=\"'name'\"\n\t\t[width]=\"'*'\"\n\t\t[isReadOnly]=\"true\"\n\t\t[visible]=\"showColumn('name')\"\n\t\t[allowSorting]=\"true\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-item-name-link-column\n\t\t\t\t[item]=\"cell.item\"\n\t\t\t\t(nameClicked)=\"onNameClick($event)\"\n\t\t\t\t[href]=\"_getHref(cell.item)\"\n\t\t\t></bdc-item-name-link-column>\n\t\t\t<bdc-item-status-icon [item]=\"cell.item\" [hideIcons]=\"['share']\"></bdc-item-status-icon>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- Shared -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Shared' | translate\"\n\t\t[binding]=\"'shared'\"\n\t\t[width]=\"115\"\n\t\t[dataType]=\"'String'\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[visible]=\"showColumn('shared')\"\n\t\t[cssClass]=\"'shared-column'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-shared-column [item]=\"cell.item\" (editLinkClicked)=\"shareEditClicked.emit($event)\"></bdc-shared-column>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- Year -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Year' | translate\"\n\t\t[binding]=\"'year'\"\n\t\t[width]=\"65\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[dataType]=\"'String'\"\n\t\t[format]=\"'d4'\"\n\t\t[visible]=\"showColumn('year')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t</wj-flex-grid-column>\n\n\t<!-- Date -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Date' | translate\"\n\t\t[binding]=\"'dueDate'\"\n\t\t[width]=\"'*'\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[dataType]=\"'Date'\"\n\t\t[visible]=\"showColumn('date')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t{{cell.item['dueDate'] | bdcDate:userLanguage}}\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n</wj-flex-grid>\n\n<bento-pagination\n\t[(page)]=\"pageNumber\"\n\t(pageChange)=\"onPageChange($event)\"\n\t[directionLinks]=\"true\"\n\t[boundaryLinks]=\"true\"\n\t[goToLink]=\"true\"\n\t[infoText]=\"'_START_ to _END_ of _MAX_'\"\n\t[totalItems]=\"items.length\"\n\t[itemsArray]=\"pageSizeOptions\"\n\t[(itemsPerPage)]=\"pageSize\"\n>\n</bento-pagination>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"], components: [{ type: i5$1.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: i5$1.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor"], outputs: ["initialized", "isSelectedChange"] }, { type: ItemTypeColumnComponent, selector: "bdc-item-type-column", inputs: ["item"] }, { type: ProjectAppColumnComponent, selector: "bdc-project-app-column", inputs: ["item"] }, { type: ItemNameLinkColumnComponent, selector: "bdc-item-name-link-column", inputs: ["item", "href", "qeId"], outputs: ["nameClicked"] }, { type: ItemStatusIconComponent, selector: "bdc-item-status-icon", inputs: ["hideIcons", "item"] }, { type: SharedColumnComponent, selector: "bdc-shared-column", inputs: ["item"], outputs: ["editLinkClicked"] }, { type: i2.BentoPaginationComponent, selector: "bento-pagination", inputs: ["page", "totalItems", "itemsPerPage", "goToLink", "hideItemsPerPage", "boundaryLinks", "infoText", "infoPageText", "goToText", "directionLinks", "itemsArray", "pageOverride", "useStrings"], outputs: ["pageChange", "itemsPerPageChange", "eventTracking"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5$1.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellType", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe, "bdcDate": ItemDatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-grid', encapsulation: ViewEncapsulation.None, template: "<div class=\"bdc-empty-folder-grid bdc-center-text\" *ngIf=\"loaded && items.length === 0\">\n\t{{ 'Blue.DocumentComponents.Grid.Empty' | translate }}\n</div>\n<wj-flex-grid\n\t#grid\n\t*ngIf=\"items.length > 0\"\n\tclass=\"bdc-wijmo-grid\"\n\t[itemsSource]=\"wijmoCollection\"\n\t(initialized)=\"gridInitialized(grid)\"\n\t[headersVisibility]=\"headersVisibility\"\n\t[selectionMode]=\"selectionMode\"\n\t(sortingColumn)=\"onColumnSort($event)\"\n>\n\t<!-- SELECT -->\n\n\t<!-- SELECT ALL -->\n\t<ng-template wjFlexGridCellTemplate [cellType]=\"'TopLeft'\">\n\t\t<bento-checkbox\n\t\t\tclass=\"bdc-documents-grid-select-checkbox\"\n\t\t\t[ngModel]=\"hasAllSelected\"\n\t\t\t(ngModelChange)=\"selectAllChanged($event)\"\n\t\t\t[indeterminate]=\"false\"\n\t\t\t[disabled]=\"false\"\n\t\t\tid=\"dms-fe-components-document-grid-select-all-checkbox\"\n\t\t></bento-checkbox>\n\t</ng-template>\n\n\t<!-- SELECT ROW -->\n\t<ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-cell=\"cell\" let-item=\"item\" let-row=\"row\">\n\t\t<bento-checkbox\n\t\t\tclass=\"bdc-documents-grid-select-checkbox\"\n\t\t\t[ngModel]=\"_isSelected[cell.item.id]\"\n\t\t\t(ngModelChange)=\"rowSelectionChanged($event, cell)\"\n\t\t\t[indeterminate]=\"false\"\n\t\t\t[disabled]=\"false\"\n\t\t\tid=\"dms-fe-components-document-grid-select-checkbox\"\n\t\t></bento-checkbox>\n\t</ng-template>\n\n\t<!-- Type -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Type' | translate\"\n\t\t[binding]=\"'type'\"\n\t\t[width]=\"75\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[visible]=\"showColumn('type')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-item-type-column [item]=\"cell.item\"></bdc-item-type-column>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- App -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.App' | translate\"\n\t\t[binding]=\"'app'\"\n\t\t[width]=\"75\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[visible]=\"showColumn('app')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-project-app-column [item]=\"cell.item\"></bdc-project-app-column>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- Name -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Name' | translate\"\n\t\t[binding]=\"'name'\"\n\t\t[width]=\"'*'\"\n\t\t[isReadOnly]=\"true\"\n\t\t[visible]=\"showColumn('name')\"\n\t\t[allowSorting]=\"true\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-item-name-link-column\n\t\t\t\t[item]=\"cell.item\"\n\t\t\t\t(nameClicked)=\"onNameClick($event)\"\n\t\t\t\t[href]=\"_getHref(cell.item)\"\n\t\t\t></bdc-item-name-link-column>\n\t\t\t<bdc-item-status-icon [item]=\"cell.item\" [hideIcons]=\"['share']\"></bdc-item-status-icon>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- Shared -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Shared' | translate\"\n\t\t[binding]=\"'shared'\"\n\t\t[width]=\"115\"\n\t\t[dataType]=\"'String'\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[visible]=\"showColumn('shared')\"\n\t\t[cssClass]=\"'shared-column'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t<bdc-shared-column [item]=\"cell.item\" (editLinkClicked)=\"shareEditClicked.emit($event)\"></bdc-shared-column>\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n\n\t<!-- Year -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Year' | translate\"\n\t\t[binding]=\"'year'\"\n\t\t[width]=\"65\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[dataType]=\"'String'\"\n\t\t[format]=\"'d4'\"\n\t\t[visible]=\"showColumn('year')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t</wj-flex-grid-column>\n\n\t<!-- Date -->\n\t<wj-flex-grid-column\n\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Date' | translate\"\n\t\t[binding]=\"'dueDate'\"\n\t\t[width]=\"'*'\"\n\t\t[isReadOnly]=\"true\"\n\t\t[allowSorting]=\"true\"\n\t\t[dataType]=\"'Date'\"\n\t\t[visible]=\"showColumn('date')\"\n\t\t[cssClass]=\"'wijmo-row-height'\"\n\t>\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t{{cell.item['dueDate'] | bdcDate:userLanguage}}\n\t\t</ng-template>\n\t</wj-flex-grid-column>\n</wj-flex-grid>\n\n<bento-pagination\n\t[(page)]=\"pageNumber\"\n\t(pageChange)=\"onPageChange($event)\"\n\t[directionLinks]=\"true\"\n\t[boundaryLinks]=\"true\"\n\t[goToLink]=\"true\"\n\t[infoText]=\"'_START_ to _END_ of _MAX_'\"\n\t[totalItems]=\"items.length\"\n\t[itemsArray]=\"pageSizeOptions\"\n\t[(itemsPerPage)]=\"pageSize\"\n>\n</bento-pagination>\n", styles: ["bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .center-cell{display:flex;justify-content:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wj-header,bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.wijmo-row-height div{overflow:hidden;text-overflow:ellipsis}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid bm-icon{height:18px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid input.grid-checkbox{height:14px;width:14px}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-center-text{font-weight:700;text-align:center}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox{margin-right:0}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid .bdc-documents-grid-select-checkbox>input{margin-right:0}bdc-document-grid>bento-pagination nav.bento-pagination.d-flex{margin:20px 0 0;padding:0 10px}bdc-document-grid>bento-pagination .bento-pagination-browse-section{align-items:flex-start;bottom:8px;display:flex;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination-browse-section div.paginate-info{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-top:10px}bdc-document-grid>bento-pagination nav.bento-pagination .paginate-button i{font-family:bento-icomoon}bdc-document-grid>bento-pagination .paginate-bento-select.bento-pagination-items-per-page label{display:none}bdc-document-grid>bento-pagination .paginate-bento-select{bottom:3px;flex-direction:column-reverse;position:relative}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select div.bento-pagination-items-showing{margin-right:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select .bento-pagination-items-showing.paginate-info-select{align-self:end;font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:14px;margin-bottom:0}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select select.form-control{font-family:Arial,Helvetica Neue,sans-serif;font-size:12px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-info,bdc-document-grid>bento-pagination .bento-pagination-buttons{position:relative;top:8px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-wrap label{display:none}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group{left:17px}bdc-document-grid>bento-pagination .bento-pagination-nav-controls .paginate-input-group .go.btn{font-family:KnowledgeRegular,arial,helvetica,sans-serif;font-size:13px;width:40px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-input-wrap .input-group.paginate-input-group input.form-control{font-size:12px;width:70px;z-index:inherit}bdc-document-grid>bento-pagination .bento-pagination .paginate-button:not(.disabled) i:before{color:#37383d}bdc-document-grid>bento-pagination .bento-pagination .paginate-button .btn.btn-icon i:before{font-weight:400}bdc-document-grid>bento-pagination .bento-pagination .paginate-button.disabled i:before{color:#93939c}bdc-document-grid>wj-flex-grid.bdc-wijmo-grid.wj-content .wj-row .wj-cell.shared-column{overflow:hidden}bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .bento-select-border,bdc-document-grid>bento-pagination .bento-pagination .paginate-bento-select.bento-pagination-items-per-page .bento-select .btn.btn-icon{z-index:inherit}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ChangeDetectorRef }, { type: ItemDisplayNameService }, { type: PersistentStateService }, { type: OnvioAppNameService }, { type: UserLanguageService }]; }, propDecorators: { items: [{
                type: Input
            }], getHref: [{
                type: Input
            }], hideColumns: [{
                type: Input
            }], loaded: [{
                type: Input
            }], itemClicked: [{
                type: Output
            }], selectionChanged: [{
                type: Output
            }], shareEditClicked: [{
                type: Output
            }], grid: [{
                type: ViewChild,
                args: ['grid', { static: false }]
            }], pagination: [{
                type: ViewChild,
                args: [BentoPaginationComponent]
            }] } });

/**
 * Pipe to retrieve the time from a Date object and converted to string formatted as: {hour}:{minute}
 */
class ItemTimePipe {
    transform(value, language) {
        if (!language || !value) {
            return '';
        }
        return value.toLocaleTimeString(language, { hour: 'numeric', minute: 'numeric' });
    }
}
/** @nocollapse */ ItemTimePipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemTimePipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ ItemTimePipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemTimePipe, name: "bdcTime" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemTimePipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bdcTime' }]
        }] });

const userLangToDateFnDateTimeFormat = {
    'en-US': 'MM/dd/yyyy hh:mm a',
    'en-CA': 'yyyy-MM-dd hh:mm a',
    'en-GB': 'dd/MM/yyyy HH:mm',
    'fr-CA': 'yyyy-MM-dd HH:mm',
    'pt-BR': 'dd/MM/yyyy HH:mm',
    'es-AR': 'dd/MM/yyyy HH:mm',
    'nl-NL': 'MM/dd/yyyy hh:mm a',
    'en-IN': 'MM/dd/yyyy hh:mm a',
    'en-AU': 'dd/MM/yyyy hh:mm a',
    'es-PE': 'MM/dd/yyyy hh:mm a',
    'es-CL': 'MM/dd/yyyy hh:mm a',
    'xx-XX': 'MM/dd/yyyy hh:mm a',
};
class ItemDateFnPipe {
    transform(value, language, getFormat = false) {
        if (!language) {
            // we can't render the date until we know the language and we don't want to use a default
            // that might be different than the user's language which would cause a flicker
            return '';
        }
        if (getFormat) {
            // Instead of converting date to specified format the below condition just returns the format
            return userLangToDateFnDateTimeFormat[language];
        }
        return value
            ? format(addMinutes(value.valueOf(), -value.getTimezoneOffset()), userLangToDateFnDateTimeFormat[language])
            : '';
    }
}
/** @nocollapse */ ItemDateFnPipe.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDateFnPipe, deps: [], target: i0.ɵɵFactoryTarget.Pipe });
/** @nocollapse */ ItemDateFnPipe.ɵpipe = i0.ɵɵngDeclarePipe({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDateFnPipe, name: "bdcDateFn" });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ItemDateFnPipe, decorators: [{
            type: Pipe,
            args: [{ name: 'bdcDateFn' }]
        }] });

class DocumentGridModule {
}
/** @nocollapse */ DocumentGridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentGridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridModule, declarations: [DocumentGridComponent,
        ItemTypeColumnComponent,
        ItemNameLinkColumnComponent,
        ProjectAppColumnComponent,
        SharedColumnComponent,
        SharePopoverComponent,
        ItemDatePipe,
        ItemDateFnPipe,
        ItemTimePipe,
        ItemStatusIconComponent], imports: [CommonModule, i1.TranslateModule, WjGridModule,
        BentoSmartBadgeModule,
        BentoCheckboxModule,
        NgbPopoverModule,
        FormsModule,
        BentoPaginationModule,
        NgbTooltipModule], exports: [DocumentGridComponent,
        ItemTypeColumnComponent,
        ItemNameLinkColumnComponent,
        ProjectAppColumnComponent,
        ItemDatePipe,
        ItemDateFnPipe,
        ItemTimePipe,
        ItemStatusIconComponent] });
/** @nocollapse */ DocumentGridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridModule, imports: [[
            CommonModule,
            TranslateModule.forChild(),
            WjGridModule,
            BentoSmartBadgeModule,
            BentoCheckboxModule,
            NgbPopoverModule,
            FormsModule,
            BentoPaginationModule,
            NgbTooltipModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        DocumentGridComponent,
                        ItemTypeColumnComponent,
                        ItemNameLinkColumnComponent,
                        ProjectAppColumnComponent,
                        SharedColumnComponent,
                        SharePopoverComponent,
                        ItemDatePipe,
                        ItemDateFnPipe,
                        ItemTimePipe,
                        ItemStatusIconComponent,
                    ],
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        WjGridModule,
                        BentoSmartBadgeModule,
                        BentoCheckboxModule,
                        NgbPopoverModule,
                        FormsModule,
                        BentoPaginationModule,
                        NgbTooltipModule,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    exports: [
                        DocumentGridComponent,
                        ItemTypeColumnComponent,
                        ItemNameLinkColumnComponent,
                        ProjectAppColumnComponent,
                        ItemDatePipe,
                        ItemDateFnPipe,
                        ItemTimePipe,
                        ItemStatusIconComponent,
                    ],
                }]
        }] });

class MultiselectFilterSectionModule {
}
/** @nocollapse */ MultiselectFilterSectionModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiselectFilterSectionModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ MultiselectFilterSectionModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiselectFilterSectionModule, declarations: [MultiselectFilterSectionComponent], imports: [CommonModule, FormsModule, BentoCheckboxModule, NgbAccordionModule, i1.TranslateModule], exports: [MultiselectFilterSectionComponent] });
/** @nocollapse */ MultiselectFilterSectionModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiselectFilterSectionModule, imports: [[CommonModule, FormsModule, BentoCheckboxModule, NgbAccordionModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MultiselectFilterSectionModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MultiselectFilterSectionComponent],
                    imports: [CommonModule, FormsModule, BentoCheckboxModule, NgbAccordionModule, TranslateModule.forChild()],
                    exports: [MultiselectFilterSectionComponent],
                }]
        }] });

class AllDocumentsPaneModule {
}
/** @nocollapse */ AllDocumentsPaneModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsPaneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AllDocumentsPaneModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsPaneModule, declarations: [AllDocumentsPaneComponent], imports: [CommonModule,
        BentoSplitterGroupModule,
        BentoExpandCollapseButtonGroupModule,
        NgbAccordionModule,
        FormsModule,
        DocumentGridModule,
        ContactSelectorModule,
        MultiselectFilterSectionModule, i1.TranslateModule], exports: [AllDocumentsPaneComponent] });
/** @nocollapse */ AllDocumentsPaneModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsPaneModule, imports: [[
            CommonModule,
            BentoSplitterGroupModule,
            BentoExpandCollapseButtonGroupModule,
            NgbAccordionModule,
            FormsModule,
            DocumentGridModule,
            ContactSelectorModule,
            MultiselectFilterSectionModule,
            TranslateModule.forChild(),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsPaneModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AllDocumentsPaneComponent],
                    imports: [
                        CommonModule,
                        BentoSplitterGroupModule,
                        BentoExpandCollapseButtonGroupModule,
                        NgbAccordionModule,
                        FormsModule,
                        DocumentGridModule,
                        ContactSelectorModule,
                        MultiselectFilterSectionModule,
                        TranslateModule.forChild(),
                    ],
                    exports: [AllDocumentsPaneComponent],
                }]
        }] });

const defaults = {
    icon: '',
    children: [],
    enableIf: [],
    visibleIf: [],
};

const oneContainerSelected = (_, items) => {
    return items.hasOne() && items.isOnlyContainers();
};
const noVirtualFoldersSelected = (_, items) => {
    return !items.items.some(item => isVirtualFolder(item));
};
const isNotClientLevel = (_, items) => {
    return _.container !== null && _.container !== undefined;
};
const isClientLevel = (navSelection, _) => {
    return navSelection.container == null && navSelection.container == undefined;
};
const isNotPseudoFolderLevel = (_, items) => {
    return (_.container === null ||
        _.container === undefined ||
        (_.container.type !== ItemType.AppGroup && _.container.type !== ItemType.YearGroup));
};
const noLockedItemsSelected = (_, items) => {
    return !items.items.some(item => !!item.lock && item.lock.type !== LockType.None);
};
const isLockedForEdit = (_, items) => {
    return items.items.some(item => item.lock &&
        (item.lock.type === LockType.Edit || item.lock.context === 'Approvals' || item.lock.context === 'Esign Approvals'));
};
const noProjectFolderSelected = (_, items) => {
    return !items.items.some(item => item.type === ItemType.Project);
};
const noClientContactFolderSelected = (_, items) => {
    return !items.items.some(item => (isContainer(item) ? item.isClientUploadFolder : false));
};
const isNotLockedForUpdate = (_, items) => {
    return !items.items.some(item => (item.lock ? !item.lock.permissions.canUpdate : false));
};
const canUpdate = (_, items) => {
    return !items.items.some(item => !item.permissions.canUpdate);
};
const isClientState = (selection, items) => {
    return (selection === null || selection === void 0 ? void 0 : selection.drawer) === FileDrawer.Client;
};

const addFolderButton = Object.assign(Object.assign({}, defaults), { id: 'dms-fe-legacy-components-client-documents-new-folder-button', labelKey: marker('Blue.DocumentComponents.Toolbar.Buttons.Folder'), icon: 'bento-icon-add-filled', enableIf: [isNotPseudoFolderLevel] });

const deleteButton = Object.assign(Object.assign({}, defaults), { id: 'delete', labelKey: marker('Blue.DocumentComponents.Toolbar.DeleteButton.Label'), icon: 'bento-icon-remove', enableIf: [
        (_, items) => items.hasAtLeastOne(),
        noVirtualFoldersSelected,
        noLockedItemsSelected,
        (_, items) => items.items.every(item => { var _a, _b; return !item.lock || ((_b = (_a = item.lock) === null || _a === void 0 ? void 0 : _a.permissions) === null || _b === void 0 ? void 0 : _b.canDelete); }),
    ] });

const propertiesButton = Object.assign(Object.assign({}, defaults), { id: 'properties', labelKey: marker('Blue.DocumentComponents.Toolbar.PropertiesButton.Label'), icon: 'bento-icon-cog', enableIf: [oneContainerSelected, noVirtualFoldersSelected] });

const shareFolderButton = Object.assign(Object.assign({}, defaults), { id: 'shareFolder', labelKey: marker('Blue.DocumentComponents.Toolbar.ShareFolderButton.Label'), icon: 'bento-icon-share', enableIf: [oneContainerSelected, noVirtualFoldersSelected] });

const projectGridManageButton = Object.assign(Object.assign({}, defaults), { id: 'project-grid-manage', labelKey: marker('Blue.DocumentComponents.Toolbar.ProjectGridManage.Label'), children: [propertiesButton, deleteButton, shareFolderButton], width: 88 });

const upOneLevelButton = Object.assign(Object.assign({}, defaults), { id: 'upOneLevel', labelKey: marker('Blue.DocumentComponents.Toolbar.UpOneLevelButton.Label'), icon: 'dms-fe-component-icon-up-one-level', visibleIf: [isNotClientLevel] });

class DocumentGridPaneComponent {
    constructor(itemStore, treeStore) {
        this.itemStore = itemStore;
        this.treeStore = treeStore;
        this.itemSubscription = new Subscription();
        this.containerSubscription = new Subscription();
        this.itemClicked = new EventEmitter();
        this.selectionChanged = new EventEmitter();
        this.selectedItems = ItemCollection.empty;
        this.loaded = false;
        this.toolbarButtonClicked = new EventEmitter();
        this.groupProjectsBy = ProjectGroupBy.None;
        this.buttons = [addFolderButton, projectGridManageButton, upOneLevelButton];
        /**
         * Array of names of columns that should be hidden
         */
        this.hideGridColumns = [];
        this.items = [];
    }
    set selection(selection) {
        this._selection = selection;
        this.setContainer(selection);
    }
    get selection() {
        return this._selection;
    }
    ngOnDestroy() {
        this.itemSubscription.unsubscribe();
    }
    ngOnChanges(changes) {
        if (changes.groupProjectsBy) {
            if (this._selection) {
                const key = getContainer(this._selection);
                this.subscribeItems(key);
            }
        }
    }
    onSelectionChange(items) {
        this.selectionChanged.emit(items);
        this.selectedItems = items;
    }
    onToolbarButtonClicked(event) {
        this.toolbarButtonClicked.emit(event);
    }
    onGridColumnsChange(columns) {
        this.hideGridColumns = columns.reduce((hidden, column) => {
            return hidden.concat(column.visible ? [] : column.name);
        }, []);
    }
    onShareEditClicked(item) {
        this.toolbarButtonClicked.emit({
            buttonId: 'shareEditLink',
            selection: this._selection,
            items: new ItemCollection([item]),
        });
    }
    setContainer(selection) {
        const key = selection && getContainer(selection);
        if (key) {
            if (!this._container || this._container.id !== key.id) {
                const container$ = this.treeStore.observeLoadingState(key);
                this.containerSubscription = container$.subscribe(loaded => {
                    this.loaded = loaded === LoadingState.loaded;
                });
                this.updateChildren(key);
            }
            this._container = key;
            this.subscribeItems(key);
        }
        else {
            // No client selected case
            this.loaded = true;
        }
    }
    subscribeItems(key) {
        this.items = [];
        const items$ = this.itemStore.observeChildItems(key, {
            grouping: { groupBy: this.groupProjectsBy },
        });
        this.itemSubscription.unsubscribe();
        this.itemSubscription = items$.subscribe(items => (this.items = items));
    }
    updateChildren(container) {
        this.treeStore.updateChildren(container);
    }
}
/** @nocollapse */ DocumentGridPaneComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridPaneComponent, deps: [{ token: i1$1.ItemStore }, { token: i1$1.TreeStore }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentGridPaneComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentGridPaneComponent, selector: "bdc-document-grid-pane", inputs: { selection: "selection", getHref: "getHref", groupProjectsBy: "groupProjectsBy" }, outputs: { itemClicked: "itemClicked", selectionChanged: "selectionChanged", toolbarButtonClicked: "toolbarButtonClicked" }, usesOnChanges: true, ngImport: i0, template: "<bdc-toolbar\n\t[buttons]=\"buttons\"\n\t[selection]=\"selection\"\n\t[selectedItems]=\"selectedItems\"\n\t(buttonClicked)=\"onToolbarButtonClicked($event)\"\n\t(gridColumnsChange)=\"onGridColumnsChange($event)\"\n\t[showSearch]=\"false\"\n></bdc-toolbar>\n<bdc-document-grid\n\t[items]=\"items\"\n\t[getHref]=\"getHref\"\n\t(itemClicked)=\"itemClicked.emit($event)\"\n\t[loaded]=\"loaded\"\n\t(selectionChanged)=\"onSelectionChange($event)\"\n\t[hideColumns]=\"hideGridColumns\"\n\t(shareEditClicked)=\"onShareEditClicked($event)\"\n></bdc-document-grid>\n", components: [{ type: ToolbarComponent, selector: "bdc-toolbar", inputs: ["selection", "selectedItems", "buttons", "buttonQeIdPrefix", "showSearch"], outputs: ["buttonClicked", "gridColumnsChange", "search"] }, { type: DocumentGridComponent, selector: "bdc-document-grid", inputs: ["items", "getHref", "hideColumns", "loaded"], outputs: ["itemClicked", "selectionChanged", "shareEditClicked"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridPaneComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-grid-pane', template: "<bdc-toolbar\n\t[buttons]=\"buttons\"\n\t[selection]=\"selection\"\n\t[selectedItems]=\"selectedItems\"\n\t(buttonClicked)=\"onToolbarButtonClicked($event)\"\n\t(gridColumnsChange)=\"onGridColumnsChange($event)\"\n\t[showSearch]=\"false\"\n></bdc-toolbar>\n<bdc-document-grid\n\t[items]=\"items\"\n\t[getHref]=\"getHref\"\n\t(itemClicked)=\"itemClicked.emit($event)\"\n\t[loaded]=\"loaded\"\n\t(selectionChanged)=\"onSelectionChange($event)\"\n\t[hideColumns]=\"hideGridColumns\"\n\t(shareEditClicked)=\"onShareEditClicked($event)\"\n></bdc-document-grid>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.ItemStore }, { type: i1$1.TreeStore }]; }, propDecorators: { selection: [{
                type: Input
            }], getHref: [{
                type: Input
            }], itemClicked: [{
                type: Output
            }], selectionChanged: [{
                type: Output
            }], toolbarButtonClicked: [{
                type: Output
            }], groupProjectsBy: [{
                type: Input
            }] } });

class DocumentGridPaneModule {
}
/** @nocollapse */ DocumentGridPaneModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridPaneModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentGridPaneModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridPaneModule, declarations: [DocumentGridPaneComponent], imports: [CommonModule, DocumentGridModule, ToolbarModule], exports: [DocumentGridPaneComponent] });
/** @nocollapse */ DocumentGridPaneModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridPaneModule, imports: [[CommonModule, DocumentGridModule, ToolbarModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentGridPaneModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DocumentGridPaneComponent],
                    imports: [CommonModule, DocumentGridModule, ToolbarModule],
                    exports: [DocumentGridPaneComponent],
                }]
        }] });

/** A single item in a breadcrumb, used by the bdc-breadcrumb component */
class BreadcrumbItemComponent {
    constructor() {
        /** Indicator that the breadcrumb is read only even if an href is found */
        this.readOnly = false;
        this.href = '';
        this.iconClass = '';
        this.dataQeId = '';
        this.toolTip = '';
        this.displayName = '';
    }
    ngOnChanges(changes) {
        if (changes.item && changes.item.previousValue !== changes.item.currentValue) {
            this.refreshBreadcrumbDisplay();
        }
        if (changes.item || changes.dataQeIdPrefix) {
            this.dataQeId = this.getDataQeId();
        }
        if (changes.item || changes.folderNameLength) {
            if (this.item) {
                this.setDisplayName(this.item);
            }
        }
    }
    setDisplayName(item) {
        if (this.folderNameLength && item.name.length > this.folderNameLength) {
            this.displayName = item.name.slice(0, this.folderNameLength) + '...';
        }
        else {
            this.displayName = item.name;
        }
    }
    getDataQeId() {
        let id = '';
        if (this.dataQeIdPrefix && this.item) {
            id = this.dataQeIdPrefix + '-' + this.item.id;
        }
        return id;
    }
    refreshBreadcrumbDisplay() {
        if (this.item) {
            if (this.hrefBuilder) {
                this.href = this.hrefBuilder(this.item);
            }
            if (this.href.length < 1) {
                this.readOnly = true;
            }
            if (this.item.lock) {
                this.iconClass = 'bento-icon-lock';
            }
        }
    }
}
/** @nocollapse */ BreadcrumbItemComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbItemComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ BreadcrumbItemComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BreadcrumbItemComponent, selector: "bdc-breadcrumb-item", inputs: { item: "item", hrefBuilder: "hrefBuilder", readOnly: "readOnly", dataQeIdPrefix: "dataQeIdPrefix", folderNameLength: "folderNameLength" }, usesOnChanges: true, ngImport: i0, template: "<button\n\ttype=\"button\"\n\tclass=\"btn btn-link\"\n\t[ngClass]=\"{'btn-icon': iconClass.length > 0}\"\n\t[disabled]=\"readOnly\"\n\t[attr.data-qe-id]=\"dataQeId\"\n>\n\t<span class=\"btn-text\">{{ displayName }}</span>\n\t<i aria-hidden=\"true\" [ngClass]=\"iconClass\"></i>\n</button>\n", styles: ["bdc-breadcrumb-item{height:auto}.btn.btn-link{padding:0 5px}\n"], directives: [{ type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i2$1.NgClass, selector: "[ngClass]", inputs: ["class", "ngClass"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbItemComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-breadcrumb-item', template: "<button\n\ttype=\"button\"\n\tclass=\"btn btn-link\"\n\t[ngClass]=\"{'btn-icon': iconClass.length > 0}\"\n\t[disabled]=\"readOnly\"\n\t[attr.data-qe-id]=\"dataQeId\"\n>\n\t<span class=\"btn-text\">{{ displayName }}</span>\n\t<i aria-hidden=\"true\" [ngClass]=\"iconClass\"></i>\n</button>\n", styles: ["bdc-breadcrumb-item{height:auto}.btn.btn-link{padding:0 5px}\n"] }]
        }], propDecorators: { item: [{
                type: Input
            }], hrefBuilder: [{
                type: Input
            }], readOnly: [{
                type: Input
            }], dataQeIdPrefix: [{
                type: Input
            }], folderNameLength: [{
                type: Input
            }] } });

/** Displays the breadcrumbs leading to a given container */
class BreadcrumbComponent {
    constructor(clientStore, itemStore, treeStore, translateService, itemDisplayNameService) {
        this.clientStore = clientStore;
        this.itemStore = itemStore;
        this.treeStore = treeStore;
        this.translateService = translateService;
        this.itemDisplayNameService = itemDisplayNameService;
        /** Used to determine whether the links will be disabled or not */
        this.disableLinks = false;
        this.getCompanyId = getCompanyId;
        this.loading = false;
        this.path = [];
        this.collapsed = [];
        this.isRoot = isRoot;
        this.subscriptions = [];
        this.companyId = '';
        this.dataQeId = '';
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () {
            this.companyId = yield this.getCompanyId();
        });
    }
    ngOnChanges(changes) {
        if (changes.containerKey && this.containerKey) {
            this.path = [];
            this.collapsed = [];
            if (this.containerKey) {
                this.updatePath();
                this.dataQeId = this.getDataQeId(this.containerKey);
            }
        }
    }
    getDataQeId(itemKey) {
        let id = 'dms-breadcrumb-link-' + itemKey.id;
        if (this.dataQeIdPrefix) {
            id = this.dataQeIdPrefix + '-' + id;
        }
        return id;
    }
    getHref(item) {
        if (this.hrefBuilder) {
            return this.hrefBuilder(item);
        }
        return '';
    }
    updatePath() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.containerKey) {
                // clear previous subscriptions
                this.subscriptions.forEach(subscription => {
                    subscription.unsubscribe();
                });
                this.loading = true;
                if (this.containerKey.type === ItemType.Trash) {
                    this.path[0] = this.getCustomItem(this.translateService.instant('Blue.DocumentComponents.SpecialFolders.RecycleBin'), ItemType.Trash);
                    this.loading = false;
                }
                else {
                    this.subscriptions.push(this.treeStore.observeAncestry(this.containerKey).subscribe((ancestry) => {
                        this.path = [];
                        this.loadPath(ancestry);
                    }));
                    yield this.treeStore.updateAncestry(this.containerKey);
                }
            }
        });
    }
    getCustomItem(name, type) {
        return {
            name: name,
            isContainer: true,
            history: new ItemHistory({ id: 'user1', isCurrentUser: true }, new Date(Date.now()), { id: 'user1', isCurrentUser: true }, new Date(Date.now())),
            permissions: {
                canCreate: true,
                canRead: true,
                canUpdate: true,
                canMove: true,
                canDelete: true,
            },
            isShared: false,
            customFields: new Map(),
            parent: this.containerKey,
            id: type,
            type: type,
        };
    }
    loadPath(ancestry) {
        // set the path up with the correct number of items
        // do this before loading the items, as that's a asynchronous
        ancestry.forEach((containerKey, index) => __awaiter(this, void 0, void 0, function* () {
            let offset = ancestry.length - (this.collapseLength || 0);
            if (offset < 0 || !this.collapseLength) {
                offset = 0;
            }
            if (!this.collapseLength || index >= offset) {
                this.path.push(undefined);
                this.addToPath(containerKey, index - offset, this.path);
            }
            else {
                this.collapsed.push(undefined);
                this.addToPath(containerKey, index, this.collapsed);
            }
        }));
        this.loading = false;
    }
    addToPath(containerKey, index, currentPath) {
        if (containerKey.type === ItemType.Client && containerKey.id !== 'Templates') {
            this.subscriptions.push(this.clientStore.observeClient(this.companyId, containerKey).subscribe((item) => {
                currentPath[index] = item;
            }));
        }
        else if (containerKey.type === ItemType.Client && containerKey.id === 'Templates') {
            currentPath[index] = this.getCustomItem(this.translateService.instant('Blue.DocumentComponents.NewFolder.Template'), ItemType.Template);
        }
        else {
            this.subscriptions.push(this.itemStore.observeItem(containerKey).subscribe((item) => {
                currentPath[index] = Object.assign(Object.assign({}, item), { name: this.itemDisplayNameService.get(item) });
            }));
        }
    }
    getDropDownIndentation(index) {
        // start with a base value of 10 px
        const paddingValue = index * 10;
        if (paddingValue > 0) {
            return 'padding-left: ' + paddingValue + 'px;';
        }
        return '';
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
}
/** @nocollapse */ BreadcrumbComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbComponent, deps: [{ token: i1$1.ClientStore }, { token: i1$1.ItemStore }, { token: i1$1.TreeStore }, { token: i1.TranslateService }, { token: ItemDisplayNameService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ BreadcrumbComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: BreadcrumbComponent, selector: "bdc-breadcrumb", inputs: { containerKey: "containerKey", disableLinks: "disableLinks", hrefBuilder: "hrefBuilder", dataQeIdPrefix: "dataQeIdPrefix", collapseLength: "collapseLength", folderNameLength: "folderNameLength" }, usesOnChanges: true, ngImport: i0, template: "<div [bentoBusyLoader]=\"loading\" [size]=\"'sm'\" [attr.data-qe-id]=\"dataQeId\" class=\"dms\">\n\t<nav aria-label=\"breadcrumb\">\n\t\t<ol class=\"breadcrumb\">\n\t\t\t<li class=\"breadcrumb-item breadcrumb-dropdown-container\" *ngIf=\"collapsed.length > 0\">\n\t\t\t\t<div ngbDropdown class=\"dropdown\" [autoClose]=\"'outside'\" #collapsedDropDown=\"ngbDropdown\">\n\t\t\t\t\t<button\n\t\t\t\t\t\tngbDropdownToggle\n\t\t\t\t\t\taria-haspopup=\"true\"\n\t\t\t\t\t\taria-controls=\"collapsed-breadcrumbs\"\n\t\t\t\t\t\tclass=\"btn btn-icon btn-link\"\n\t\t\t\t\t\t(mouseenter)=\"$event.stopPropagation(); collapsedDropDown.open();\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-folder\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<div ngbDropdownMenu>\n\t\t\t\t\t\t<bdc-breadcrumb-item\n\t\t\t\t\t\t\t[item]=\"item\"\n\t\t\t\t\t\t\t[hrefBuilder]=\"getHref.bind(this)\"\n\t\t\t\t\t\t\t[readOnly]=\"disableLinks || !hrefBuilder\"\n\t\t\t\t\t\t\t[dataQeIdPrefix]=\"dataQeId\"\n\t\t\t\t\t\t\t[folderNameLength]=\"folderNameLength\"\n\t\t\t\t\t\t\t*ngFor=\"let item of collapsed; let itemIndex=index;\"\n\t\t\t\t\t\t\tngbDropdownItem\n\t\t\t\t\t\t\t[style]=\"getDropDownIndentation(itemIndex)\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t</bdc-breadcrumb-item>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t\t<li *ngFor=\"let item of path\" class=\"breadcrumb-item\">\n\t\t\t\t<bdc-breadcrumb-item\n\t\t\t\t\t[item]=\"item\"\n\t\t\t\t\t[hrefBuilder]=\"getHref.bind(this)\"\n\t\t\t\t\t[readOnly]=\"disableLinks || !hrefBuilder\"\n\t\t\t\t\t[dataQeIdPrefix]=\"dataQeId\"\n\t\t\t\t\t[folderNameLength]=\"folderNameLength\"\n\t\t\t\t>\n\t\t\t\t</bdc-breadcrumb-item>\n\t\t\t</li>\n\t\t</ol>\n\t</nav>\n</div>\n", styles: [".breadcrumb-item:after{padding:0;vertical-align:middle}bdc-breadcrumb-item{padding:0}.breadcrumb-dropdown-container .dropdown{display:inline-block}div.dropdown .dropdown-item{padding:0}ol.breadcrumb{background-color:inherit;display:inline;margin:0;padding:0;white-space:nowrap}::ng-deep bdc-breadcrumb-item:first-child .btn.btn-link{padding-left:0}::ng-deep .breadcrumb-dropdown-container.breadcrumb-item:after{content:\"\\e65c\";padding-right:2px}\n"], components: [{ type: BreadcrumbItemComponent, selector: "bdc-breadcrumb-item", inputs: ["item", "hrefBuilder", "readOnly", "dataQeIdPrefix", "folderNameLength"] }], directives: [{ type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbDropdown, selector: "[ngbDropdown]", inputs: ["autoClose", "dropdownClass", "open", "placement", "container", "display"], outputs: ["openChange"], exportAs: ["ngbDropdown"] }, { type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i1$2.NgbDropdownToggle, selector: "[ngbDropdownToggle]" }, { type: i2.BentoNgbDropdownAnimationDirective, selector: "[ngbDropdownMenu], bento-megamenu" }, { type: i1$2.NgbDropdownMenu, selector: "[ngbDropdownMenu]" }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i1$2.NgbDropdownItem, selector: "[ngbDropdownItem]", inputs: ["disabled"] }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-breadcrumb', template: "<div [bentoBusyLoader]=\"loading\" [size]=\"'sm'\" [attr.data-qe-id]=\"dataQeId\" class=\"dms\">\n\t<nav aria-label=\"breadcrumb\">\n\t\t<ol class=\"breadcrumb\">\n\t\t\t<li class=\"breadcrumb-item breadcrumb-dropdown-container\" *ngIf=\"collapsed.length > 0\">\n\t\t\t\t<div ngbDropdown class=\"dropdown\" [autoClose]=\"'outside'\" #collapsedDropDown=\"ngbDropdown\">\n\t\t\t\t\t<button\n\t\t\t\t\t\tngbDropdownToggle\n\t\t\t\t\t\taria-haspopup=\"true\"\n\t\t\t\t\t\taria-controls=\"collapsed-breadcrumbs\"\n\t\t\t\t\t\tclass=\"btn btn-icon btn-link\"\n\t\t\t\t\t\t(mouseenter)=\"$event.stopPropagation(); collapsedDropDown.open();\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-folder\"></i>\n\t\t\t\t\t</button>\n\t\t\t\t\t<div ngbDropdownMenu>\n\t\t\t\t\t\t<bdc-breadcrumb-item\n\t\t\t\t\t\t\t[item]=\"item\"\n\t\t\t\t\t\t\t[hrefBuilder]=\"getHref.bind(this)\"\n\t\t\t\t\t\t\t[readOnly]=\"disableLinks || !hrefBuilder\"\n\t\t\t\t\t\t\t[dataQeIdPrefix]=\"dataQeId\"\n\t\t\t\t\t\t\t[folderNameLength]=\"folderNameLength\"\n\t\t\t\t\t\t\t*ngFor=\"let item of collapsed; let itemIndex=index;\"\n\t\t\t\t\t\t\tngbDropdownItem\n\t\t\t\t\t\t\t[style]=\"getDropDownIndentation(itemIndex)\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t</bdc-breadcrumb-item>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</li>\n\t\t\t<li *ngFor=\"let item of path\" class=\"breadcrumb-item\">\n\t\t\t\t<bdc-breadcrumb-item\n\t\t\t\t\t[item]=\"item\"\n\t\t\t\t\t[hrefBuilder]=\"getHref.bind(this)\"\n\t\t\t\t\t[readOnly]=\"disableLinks || !hrefBuilder\"\n\t\t\t\t\t[dataQeIdPrefix]=\"dataQeId\"\n\t\t\t\t\t[folderNameLength]=\"folderNameLength\"\n\t\t\t\t>\n\t\t\t\t</bdc-breadcrumb-item>\n\t\t\t</li>\n\t\t</ol>\n\t</nav>\n</div>\n", styles: [".breadcrumb-item:after{padding:0;vertical-align:middle}bdc-breadcrumb-item{padding:0}.breadcrumb-dropdown-container .dropdown{display:inline-block}div.dropdown .dropdown-item{padding:0}ol.breadcrumb{background-color:inherit;display:inline;margin:0;padding:0;white-space:nowrap}::ng-deep bdc-breadcrumb-item:first-child .btn.btn-link{padding-left:0}::ng-deep .breadcrumb-dropdown-container.breadcrumb-item:after{content:\"\\e65c\";padding-right:2px}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.ClientStore }, { type: i1$1.ItemStore }, { type: i1$1.TreeStore }, { type: i1.TranslateService }, { type: ItemDisplayNameService }]; }, propDecorators: { containerKey: [{
                type: Input
            }], disableLinks: [{
                type: Input
            }], hrefBuilder: [{
                type: Input
            }], dataQeIdPrefix: [{
                type: Input
            }], collapseLength: [{
                type: Input
            }], folderNameLength: [{
                type: Input
            }] } });

class BreadcrumbModule {
}
/** @nocollapse */ BreadcrumbModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ BreadcrumbModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbModule, declarations: [BreadcrumbComponent, BreadcrumbItemComponent], imports: [BrowserModule, BentoModule, NgbModule], exports: [BreadcrumbComponent, BreadcrumbItemComponent] });
/** @nocollapse */ BreadcrumbModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbModule, imports: [[BrowserModule, BentoModule, NgbModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: BreadcrumbModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [BreadcrumbComponent, BreadcrumbItemComponent],
                    imports: [BrowserModule, BentoModule, NgbModule],
                    exports: [BreadcrumbComponent, BreadcrumbItemComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class AllDocumentsGridComponent {
    constructor(recentItemService, translateService, treeStore, userLanguageService, storageService, webViewerLibPath) {
        this.recentItemService = recentItemService;
        this.translateService = translateService;
        this.treeStore = treeStore;
        this.userLanguageService = userLanguageService;
        this.storageService = storageService;
        this.recentItems = [];
        /** Emits the item that was clicked when the name of an item is clicked. */
        this.itemClicked = new EventEmitter();
        this.getCompanyId = getCompanyId;
        this.headersVisibility = HeadersVisibility.All;
        this.selectionMode = SelectionMode.None;
        this.options = defaultOptions;
        this.clientNames = new Map();
        this.viewerIsLoading = false;
        this.gridDataIsLoading = false;
        this.toolbarButtons = [];
        this.previewedDocument = null;
        this.previewedDocumentParent = null;
        this.selected = ItemCollection.empty;
        /** Emits the collection of items that are selected any time the selection changes */
        this.selectionChanged = new EventEmitter();
        // Internal use - maps Item ID to boolean - true if selected, false (or undefined) if not.
        this._isSelected = {};
        this.selectItems = [10, 25, 50, 100];
        this.pagingState = {
            page: 1,
            totalItems: 0,
            numItems: 25,
        };
        this.subscriptions = [];
        this.closeButton = { id: 'close', label: 'Close' };
        this.allDocsPdfTronElements = [
            PdfTronElement.leftPanel,
            PdfTronElement.leftPanelButton,
            PdfTronElement.outlinesPanel,
        ];
        this._companyId = '';
        this.recentItemVerbTranslations = {
            [RecentItemVerb.Accessed]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Accessed'),
            [RecentItemVerb.Created]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Created'),
            [RecentItemVerb.Updated]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Updated'),
            [RecentItemVerb.Moved]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Moved'),
            [RecentItemVerb.Copied]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Copied'),
            [RecentItemVerb.Linked]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Linked'),
            [RecentItemVerb.Trashed]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Deleted'),
            [RecentItemVerb.Restored]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Restored'),
        };
        this.documentPreviewTranslations = [
            marker('Blue.DocumentComponents.Button.Close'),
            marker('Blue.DocumentComponents.Viewer.PreviewNotAvailable'),
            marker('Blue.DocumentComponents.Toolbar.DownloadButton.Label'),
        ];
        this.getHref = (item) => {
            return this.hrefBuilder ? this.hrefBuilder(item) : '#';
        };
        this.options.webViewerLibPath = webViewerLibPath;
        register();
    }
    ngOnInit() {
        this.setUserLanguage();
        this.setCompanyId();
        this.toolbarButtons.push(this.closeButton);
        this.subscribeObservables();
        this.pagingState.numItems = this.storageService.getItemsPerPage(25);
        this.loadRecentItems();
    }
    setCompanyId() {
        return __awaiter(this, void 0, void 0, function* () {
            this._companyId = yield this.getCompanyId();
        });
    }
    setUserLanguage() {
        return __awaiter(this, void 0, void 0, function* () {
            this.userLanguage = yield this.userLanguageService.getUserLanguage();
        });
    }
    loadRecentItems() {
        return __awaiter(this, void 0, void 0, function* () {
            this.gridDataIsLoading = true;
            const loadedRecentItems = yield this.recentItemService.get({
                verb: [
                    RecentItemVerb.Accessed,
                    RecentItemVerb.Created,
                    RecentItemVerb.Updated,
                    RecentItemVerb.Moved,
                    RecentItemVerb.Copied,
                    RecentItemVerb.Restored,
                    RecentItemVerb.Linked,
                    RecentItemVerb.Trashed,
                ],
                pageSize: this.pagingState.numItems,
                page: this.pagingState.page,
                getAncestors: true,
            });
            this.pagingState.totalItems = loadedRecentItems.totalItems;
            const nonTrashed = loadedRecentItems.items.filter(item => item.parent.id !== 'trash');
            nonTrashed.forEach((item) => __awaiter(this, void 0, void 0, function* () {
                this.subscriptions.push(this.treeStore.observeItemRoot(item.parent).subscribe(container => {
                    if (container.type === 'CLIENT' && !this.clientNames.has(item.parent.id)) {
                        this.clientNames.set(item.parent.id, container.name);
                    }
                }));
                this.treeStore.updateAncestry(item.parent, true, this._companyId);
            }));
            this.recentItems = loadedRecentItems.items;
            this.gridDataIsLoading = false;
        });
    }
    itemsPerPageChange() {
        this.storageService.setItemsPerPage(this.pagingState.numItems);
        this.loadRecentItems();
    }
    getContact(item) {
        var _a, _b;
        return (_b = (_a = item === null || item === void 0 ? void 0 : item.actor) === null || _a === void 0 ? void 0 : _a.displayAs) !== null && _b !== void 0 ? _b : '';
    }
    getEvent(item) {
        if (item.verb) {
            return this.translateService.get(this.recentItemVerbTranslations[item.verb]);
        }
        return of('');
    }
    onNameClick(item) {
        this.configureWebViewerAppearance(item);
        this.previewedDocument = item;
        this.previewedDocumentParent = item.parent;
    }
    documentViewerCallback($event) {
        if ($event.detail === 'close' && this.closeCallback) {
            this.closeCallback();
        }
    }
    rowSelectionChanged(newValue, cell) {
        this._isSelected[cell.item.id] = newValue;
        this.onSelectionChange();
    }
    onSelectionChange() {
        const selected = this.recentItems.filter(item => this._isSelected[item.id]);
        this.selected = new ItemCollection(selected);
        this.selectionChanged.emit(this.selected);
    }
    closeCallback() {
        this.previewedDocument = null;
    }
    configureWebViewerAppearance(item) {
        const options = Object.assign({}, this.options);
        options.showNavigationArrows = false;
        options.enableViewControlAndMenu = true;
        options.showPageNavOverlayButtons = true;
        if (item.mimeType === 'application/pdf') {
            options.additionalPdfTronElements = options.additionalPdfTronElements.concat(this.allDocsPdfTronElements);
        }
        else {
            options.additionalPdfTronElements = options.additionalPdfTronElements.filter(pdfTronElement => !this.allDocsPdfTronElements.includes(pdfTronElement));
        }
        if (item.canPreview) {
            options.disableDefaultPdfTronElements = false;
            options.enableViewControlAndMenu = true;
            options.showPageNavOverlayButtons = true;
        }
        else {
            options.disableDefaultPdfTronElements = true;
            options.enableViewControlAndMenu = false;
            options.showPageNavOverlayButtons = false;
            const elementsToErase = viewControlAndMenuElements.concat(PdfTronElement.pageNavOverlay);
            options.additionalPdfTronElements = options.additionalPdfTronElements.filter(pdfTronElement => !elementsToErase.includes(pdfTronElement));
        }
        this.options = options;
    }
    gridInitialized(grid) {
        this.grid = grid;
    }
    viewerLoadingStateChange(state) {
        this.viewerIsLoading = state;
    }
    subscribeObservables() {
        this.subscriptions.push(this.translateService.get(this.documentPreviewTranslations).subscribe(translations => {
            this.closeButton.label = translations['Blue.DocumentComponents.Button.Close'];
            this.options.strings.previewNotAvailable = translations['Blue.DocumentComponents.Viewer.PreviewNotAvailable'];
            this.options.strings.downloadButton = translations['Blue.DocumentComponents.Toolbar.DownloadButton.Label'];
        }));
    }
    ngOnDestroy() {
        this.subscriptions.forEach(subscription => {
            subscription.unsubscribe();
        });
    }
}
/** @nocollapse */ AllDocumentsGridComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsGridComponent, deps: [{ token: i1$1.RecentItemService }, { token: i1.TranslateService }, { token: i1$1.TreeStore }, { token: UserLanguageService }, { token: StorageService }, { token: WEB_VIEWER_LIBRARY_PATH }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ AllDocumentsGridComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: AllDocumentsGridComponent, selector: "bdc-all-documents-grid", inputs: { hrefBuilder: "hrefBuilder" }, outputs: { itemClicked: "itemClicked", selectionChanged: "selectionChanged" }, viewQueries: [{ propertyName: "grid", first: true, predicate: ["grid"], descendants: true }], ngImport: i0, template: "<div class=\"recents-grid-container-all-docs\" [bentoBusyLoader]=\"gridDataIsLoading\">\n\t<div *ngIf=\"previewedDocument\" [bentoBusyLoader]=\"viewerIsLoading\">\n\t\t<dms-viewer\n\t\t\tclass=\"detail-pane-preview\"\n\t\t\t[document]=\"previewedDocument\"\n\t\t\t[container]=\"previewedDocumentParent\"\n\t\t\t[options]=\"options\"\n\t\t\t[toolbarButtons]=\"toolbarButtons\"\n\t\t\t[editAnnotations]=\"true\"\n\t\t\t(customButtonAction)=\"documentViewerCallback($event)\"\n\t\t\t(loadingChange)=\"viewerLoadingStateChange($event.detail)\"\n\t\t>\n\t\t</dms-viewer>\n\t</div>\n\t<wj-flex-grid\n\t\t#grid\n\t\tclass=\"bdc-wijmo-grid\"\n\t\t[itemsSource]=\"recentItems\"\n\t\t(initialized)=\"gridInitialized(grid)\"\n\t\t[headersVisibility]=\"headersVisibility\"\n\t\t[selectionMode]=\"selectionMode\"\n\t\t[allowSorting]=\"'None'\"\n\t>\n\t\t<!-- SELECT-->\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-cell=\"cell\" let-item=\"item\">\n\t\t\t<bento-checkbox\n\t\t\t\tclass=\"bento-flex-grid-checkbox\"\n\t\t\t\t[ngModel]=\"_isSelected[cell.item.id]\"\n\t\t\t\t(ngModelChange)=\"rowSelectionChanged($event, cell)\"\n\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t[disabled]=\"cell.item.parent.id === 'trash'\"\n\t\t\t\t[attr.aria-label]=\"cell.item.name + ' Checkbox'\"\n\t\t\t\t[attr.data-qe-id]=\"'dms-fe-components-all-documents-grid-select-checkbox-' + (cell.item.id)\"\n\t\t\t></bento-checkbox>\n\t\t</ng-template>\n\n\t\t<!-- Type -->\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Type' | translate\"\n\t\t\t[binding]=\"'itemType'\"\n\t\t\t[width]=\"75\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t<bdc-item-type-column [item]=\"cell.item\"></bdc-item-type-column>\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<!-- Name -->\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Name' | translate\"\n\t\t\t[binding]=\"'name'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t<div *ngIf=\"cell.item.parent.id !== 'trash'\">\n\t\t\t\t\t<bdc-item-name-link-column\n\t\t\t\t\t\t[item]=\"cell.item\"\n\t\t\t\t\t\t(nameClicked)=\"onNameClick($event)\"\n\t\t\t\t\t\t[qeId]=\"'dms-all-documents-grid-name-' + cell.row.index\"\n\t\t\t\t\t\t[href]=\"getHref(cell.item)\"\n\t\t\t\t\t></bdc-item-name-link-column>\n\t\t\t\t\t<bdc-item-status-icon [item]=\"cell.item\"></bdc-item-status-icon>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"cell.item.parent.id === 'trash'\">{{cell.item.name}}</div>\n\t\t\t\t<bdc-breadcrumb\n\t\t\t\t\t[containerKey]=\"cell.item.parent\"\n\t\t\t\t\t[disableLinks]=\"false\"\n\t\t\t\t\t[hrefBuilder]=\"getHref\"\n\t\t\t\t\t[dataQeIdPrefix]=\"'all-documents'\"\n\t\t\t\t\t[useToolTip]=\"true\"\n\t\t\t\t\t[folderNameLength]=\"15\"\n\t\t\t\t\t[collapseLength]=\"3\"\n\t\t\t\t>\n\t\t\t\t</bdc-breadcrumb>\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Client' | translate\"\n\t\t\t[binding]=\"'primaryAssociationName'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t{{clientNames.get(cell.item.parent.id)}}\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.RecentEvent' | translate\"\n\t\t\t[binding]=\"'verb'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t{{getEvent(cell.item) | async}}\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Contact' | translate\"\n\t\t\t[binding]=\"'contact'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\"> {{getContact(cell.item)}} </ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.EventDate' | translate\"\n\t\t\t[binding]=\"'activityDate'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t{{cell.item.activityDate | bdcDate:userLanguage}} {{cell.item.activityDate | bdcTime:userLanguage}}\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\t</wj-flex-grid>\n\t<bento-pagination\n\t\t[(page)]=\"pagingState.page\"\n\t\t(pageChange)=\"loadRecentItems()\"\n\t\t[directionLinks]=\"true\"\n\t\t[boundaryLinks]=\"true\"\n\t\t[totalItems]=\"pagingState.totalItems\"\n\t\t[itemsArray]=\"selectItems\"\n\t\t[(itemsPerPage)]=\"pagingState.numItems\"\n\t\t(itemsPerPageChange)=\"itemsPerPageChange()\"\n\t>\n\t</bento-pagination>\n</div>\n", styles: [".recents-grid-container-all-docs dms-viewer.detail-pane-preview{height:calc(100% - 160px);left:20px;position:fixed;width:calc(100% - 40px);z-index:10}.recents-grid-container-all-docs wj-flex-grid bento-checkbox.disabled{background:#e8eaec;cursor:not-allowed;pointer-events:visibleFill}.recents-grid-container-all-docs .bento-flex-grid-checkbox{height:auto}\n"], components: [{ type: i5$1.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }, { type: i5$1.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor"], outputs: ["initialized", "isSelectedChange"] }, { type: ItemTypeColumnComponent, selector: "bdc-item-type-column", inputs: ["item"] }, { type: ItemNameLinkColumnComponent, selector: "bdc-item-name-link-column", inputs: ["item", "href", "qeId"], outputs: ["nameClicked"] }, { type: ItemStatusIconComponent, selector: "bdc-item-status-icon", inputs: ["hideIcons", "item"] }, { type: BreadcrumbComponent, selector: "bdc-breadcrumb", inputs: ["containerKey", "disableLinks", "hrefBuilder", "dataQeIdPrefix", "collapseLength", "folderNameLength"] }, { type: i2.BentoPaginationComponent, selector: "bento-pagination", inputs: ["page", "totalItems", "itemsPerPage", "goToLink", "hideItemsPerPage", "boundaryLinks", "infoText", "infoPageText", "goToText", "directionLinks", "itemsArray", "pageOverride", "useStrings"], outputs: ["pageChange", "itemsPerPageChange", "eventTracking"] }], directives: [{ type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5$1.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellType", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }], pipes: { "translate": i1.TranslatePipe, "async": i2$1.AsyncPipe, "bdcDate": ItemDatePipe, "bdcTime": ItemTimePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsGridComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-all-documents-grid', template: "<div class=\"recents-grid-container-all-docs\" [bentoBusyLoader]=\"gridDataIsLoading\">\n\t<div *ngIf=\"previewedDocument\" [bentoBusyLoader]=\"viewerIsLoading\">\n\t\t<dms-viewer\n\t\t\tclass=\"detail-pane-preview\"\n\t\t\t[document]=\"previewedDocument\"\n\t\t\t[container]=\"previewedDocumentParent\"\n\t\t\t[options]=\"options\"\n\t\t\t[toolbarButtons]=\"toolbarButtons\"\n\t\t\t[editAnnotations]=\"true\"\n\t\t\t(customButtonAction)=\"documentViewerCallback($event)\"\n\t\t\t(loadingChange)=\"viewerLoadingStateChange($event.detail)\"\n\t\t>\n\t\t</dms-viewer>\n\t</div>\n\t<wj-flex-grid\n\t\t#grid\n\t\tclass=\"bdc-wijmo-grid\"\n\t\t[itemsSource]=\"recentItems\"\n\t\t(initialized)=\"gridInitialized(grid)\"\n\t\t[headersVisibility]=\"headersVisibility\"\n\t\t[selectionMode]=\"selectionMode\"\n\t\t[allowSorting]=\"'None'\"\n\t>\n\t\t<!-- SELECT-->\n\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'RowHeader'\" let-cell=\"cell\" let-item=\"item\">\n\t\t\t<bento-checkbox\n\t\t\t\tclass=\"bento-flex-grid-checkbox\"\n\t\t\t\t[ngModel]=\"_isSelected[cell.item.id]\"\n\t\t\t\t(ngModelChange)=\"rowSelectionChanged($event, cell)\"\n\t\t\t\t[indeterminate]=\"false\"\n\t\t\t\t[disabled]=\"cell.item.parent.id === 'trash'\"\n\t\t\t\t[attr.aria-label]=\"cell.item.name + ' Checkbox'\"\n\t\t\t\t[attr.data-qe-id]=\"'dms-fe-components-all-documents-grid-select-checkbox-' + (cell.item.id)\"\n\t\t\t></bento-checkbox>\n\t\t</ng-template>\n\n\t\t<!-- Type -->\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Type' | translate\"\n\t\t\t[binding]=\"'itemType'\"\n\t\t\t[width]=\"75\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t<bdc-item-type-column [item]=\"cell.item\"></bdc-item-type-column>\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<!-- Name -->\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Name' | translate\"\n\t\t\t[binding]=\"'name'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t<div *ngIf=\"cell.item.parent.id !== 'trash'\">\n\t\t\t\t\t<bdc-item-name-link-column\n\t\t\t\t\t\t[item]=\"cell.item\"\n\t\t\t\t\t\t(nameClicked)=\"onNameClick($event)\"\n\t\t\t\t\t\t[qeId]=\"'dms-all-documents-grid-name-' + cell.row.index\"\n\t\t\t\t\t\t[href]=\"getHref(cell.item)\"\n\t\t\t\t\t></bdc-item-name-link-column>\n\t\t\t\t\t<bdc-item-status-icon [item]=\"cell.item\"></bdc-item-status-icon>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"cell.item.parent.id === 'trash'\">{{cell.item.name}}</div>\n\t\t\t\t<bdc-breadcrumb\n\t\t\t\t\t[containerKey]=\"cell.item.parent\"\n\t\t\t\t\t[disableLinks]=\"false\"\n\t\t\t\t\t[hrefBuilder]=\"getHref\"\n\t\t\t\t\t[dataQeIdPrefix]=\"'all-documents'\"\n\t\t\t\t\t[useToolTip]=\"true\"\n\t\t\t\t\t[folderNameLength]=\"15\"\n\t\t\t\t\t[collapseLength]=\"3\"\n\t\t\t\t>\n\t\t\t\t</bdc-breadcrumb>\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Client' | translate\"\n\t\t\t[binding]=\"'primaryAssociationName'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t{{clientNames.get(cell.item.parent.id)}}\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.RecentEvent' | translate\"\n\t\t\t[binding]=\"'verb'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t{{getEvent(cell.item) | async}}\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Contact' | translate\"\n\t\t\t[binding]=\"'contact'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\"> {{getContact(cell.item)}} </ng-template>\n\t\t</wj-flex-grid-column>\n\n\t\t<wj-flex-grid-column\n\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.EventDate' | translate\"\n\t\t\t[binding]=\"'activityDate'\"\n\t\t\t[width]=\"'*'\"\n\t\t\t[isReadOnly]=\"true\"\n\t\t>\n\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t{{cell.item.activityDate | bdcDate:userLanguage}} {{cell.item.activityDate | bdcTime:userLanguage}}\n\t\t\t</ng-template>\n\t\t</wj-flex-grid-column>\n\t</wj-flex-grid>\n\t<bento-pagination\n\t\t[(page)]=\"pagingState.page\"\n\t\t(pageChange)=\"loadRecentItems()\"\n\t\t[directionLinks]=\"true\"\n\t\t[boundaryLinks]=\"true\"\n\t\t[totalItems]=\"pagingState.totalItems\"\n\t\t[itemsArray]=\"selectItems\"\n\t\t[(itemsPerPage)]=\"pagingState.numItems\"\n\t\t(itemsPerPageChange)=\"itemsPerPageChange()\"\n\t>\n\t</bento-pagination>\n</div>\n", styles: [".recents-grid-container-all-docs dms-viewer.detail-pane-preview{height:calc(100% - 160px);left:20px;position:fixed;width:calc(100% - 40px);z-index:10}.recents-grid-container-all-docs wj-flex-grid bento-checkbox.disabled{background:#e8eaec;cursor:not-allowed;pointer-events:visibleFill}.recents-grid-container-all-docs .bento-flex-grid-checkbox{height:auto}\n"] }]
        }], ctorParameters: function () {
        return [{ type: i1$1.RecentItemService }, { type: i1.TranslateService }, { type: i1$1.TreeStore }, { type: UserLanguageService }, { type: StorageService }, { type: undefined, decorators: [{
                        type: Inject,
                        args: [WEB_VIEWER_LIBRARY_PATH]
                    }] }];
    }, propDecorators: { hrefBuilder: [{
                type: Input
            }], itemClicked: [{
                type: Output
            }], grid: [{
                type: ViewChild,
                args: ['grid', { static: false }]
            }], selectionChanged: [{
                type: Output
            }] } });

class AllDocumentsGridModule {
}
/** @nocollapse */ AllDocumentsGridModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsGridModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ AllDocumentsGridModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsGridModule, declarations: [AllDocumentsGridComponent], imports: [CommonModule, i1.TranslateModule, WjGridModule,
        DocumentGridModule,
        BreadcrumbModule,
        BentoModule,
        BentoCheckboxModule,
        FormsModule], exports: [AllDocumentsGridComponent] });
/** @nocollapse */ AllDocumentsGridModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsGridModule, imports: [[
            CommonModule,
            TranslateModule.forChild(),
            WjGridModule,
            DocumentGridModule,
            BreadcrumbModule,
            BentoModule,
            BentoCheckboxModule,
            FormsModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AllDocumentsGridModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [AllDocumentsGridComponent],
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        WjGridModule,
                        DocumentGridModule,
                        BreadcrumbModule,
                        BentoModule,
                        BentoCheckboxModule,
                        FormsModule,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    exports: [AllDocumentsGridComponent],
                }]
        }] });

class SecurityOptionsComponent {
    constructor() {
        this.isRequiredChange = new EventEmitter();
        this.passwordChange = new EventEmitter();
        /**
         * Indicator that the setting is new and editable.
         */
        this.isNew = false;
        /**
         * Event indicating that the validity of the fields has been updated.
         */
        this.isValid = new EventEmitter();
        this.touched = false;
        this.isRequired = false;
        this.password = '';
    }
    ngOnChanges(changes) {
        // make sure the new data is valid
        this.dataChanged();
    }
    /**
     * Returns the data-qe-id to use for a given field
     *
     * @param input - The unique data-qe-id for the field
     * @returns The data-qe-id adjusted based on the component prefix input
     */
    getDataQeId(input) {
        if (this.dataQeIdPrefix)
            return this.dataQeIdPrefix + '-' + input;
        return input;
    }
    /**
     * Validates form fields, raising an event indicating whether the current fields are valid
     */
    dataChanged() {
        if (this.isRequired && this.password.length < 1) {
            this.isValid.emit(false);
            return;
        }
        this.isValid.emit(true);
    }
    isPasswordDisabled() {
        return !this.isRequired || !this.isNew;
    }
    validate() {
        this.touch();
        return this.isRequired && !this.password ? { required: true } : null;
    }
    touch() {
        this.touched = true;
    }
}
/** @nocollapse */ SecurityOptionsComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SecurityOptionsComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SecurityOptionsComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SecurityOptionsComponent, selector: "bdc-security-options", inputs: { isRequired: "isRequired", password: "password", isNew: "isNew", dataQeIdPrefix: "dataQeIdPrefix" }, outputs: { isRequiredChange: "isRequiredChange", passwordChange: "passwordChange", isValid: "isValid" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"security-options\">\n\t<div class=\"security-options-password-required\">\n\t\t<bento-checkbox\n\t\t\tid=\"isRequired\"\n\t\t\tclass=\"bento-checkbox\"\n\t\t\t[(ngModel)]=\"isRequired\"\n\t\t\t(change)=\"dataChanged()\"\n\t\t\t[disabled]=\"!isNew\"\n\t\t\t[attr.aria-label]=\"'Password Required Checkbox'\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('password-is-required')\"\n\t\t></bento-checkbox>\n\t\t<label for=\"isRequired\">{{'Blue.DocumentComponents.SecurityOptions.RequirePassword' | translate}}</label>\n\t</div>\n\t<div class=\"security-options-password\">\n\t\t<input\n\t\t\tclass=\"bm-input form-control\"\n\t\t\ttype=\"text\"\n\t\t\tname=\"passwordInput\"\n\t\t\t(input)=\"dataChanged()\"\n\t\t\t[(ngModel)]=\"password\"\n\t\t\t[disabled]=\"isPasswordDisabled()\"\n\t\t\tspellcheck=\"false\"\n\t\t\t[attr.aria-label]=\"'Password Input'\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('password')\"\n\t\t\t[placeholder]=\"'Blue.DocumentComponents.SecurityOptions.RequirePassword' | translate\"\n\t\t\t(blur)=\"touch()\"\n\t\t/>\n\t</div>\n\t<div class=\"errors\" *ngIf=\"isRequired && touched && !password\">\n\t\t<div class=\"validation danger\">{{'Blue.DocumentComponents.SecurityOptions.Error.Required' | translate}}</div>\n\t</div>\n</div>\n", styles: [".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], components: [{ type: i2.BentoCheckboxComponent, selector: "bento-checkbox", inputs: ["indeterminate"], outputs: ["indeterminateChange"] }], directives: [{ type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SecurityOptionsComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-security-options', template: "<div class=\"security-options\">\n\t<div class=\"security-options-password-required\">\n\t\t<bento-checkbox\n\t\t\tid=\"isRequired\"\n\t\t\tclass=\"bento-checkbox\"\n\t\t\t[(ngModel)]=\"isRequired\"\n\t\t\t(change)=\"dataChanged()\"\n\t\t\t[disabled]=\"!isNew\"\n\t\t\t[attr.aria-label]=\"'Password Required Checkbox'\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('password-is-required')\"\n\t\t></bento-checkbox>\n\t\t<label for=\"isRequired\">{{'Blue.DocumentComponents.SecurityOptions.RequirePassword' | translate}}</label>\n\t</div>\n\t<div class=\"security-options-password\">\n\t\t<input\n\t\t\tclass=\"bm-input form-control\"\n\t\t\ttype=\"text\"\n\t\t\tname=\"passwordInput\"\n\t\t\t(input)=\"dataChanged()\"\n\t\t\t[(ngModel)]=\"password\"\n\t\t\t[disabled]=\"isPasswordDisabled()\"\n\t\t\tspellcheck=\"false\"\n\t\t\t[attr.aria-label]=\"'Password Input'\"\n\t\t\t[attr.data-qe-id]=\"getDataQeId('password')\"\n\t\t\t[placeholder]=\"'Blue.DocumentComponents.SecurityOptions.RequirePassword' | translate\"\n\t\t\t(blur)=\"touch()\"\n\t\t/>\n\t</div>\n\t<div class=\"errors\" *ngIf=\"isRequired && touched && !password\">\n\t\t<div class=\"validation danger\">{{'Blue.DocumentComponents.SecurityOptions.Error.Required' | translate}}</div>\n\t</div>\n</div>\n", styles: [".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], ctorParameters: function () { return []; }, propDecorators: { isRequired: [{
                type: Input
            }], isRequiredChange: [{
                type: Output
            }], password: [{
                type: Input
            }], passwordChange: [{
                type: Output
            }], isNew: [{
                type: Input
            }], dataQeIdPrefix: [{
                type: Input
            }], isValid: [{
                type: Output
            }] } });

class SecurityOptionsModule {
}
/** @nocollapse */ SecurityOptionsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SecurityOptionsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SecurityOptionsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SecurityOptionsModule, declarations: [SecurityOptionsComponent], imports: [CommonModule, i1.TranslateModule, BentoModule, BentoCheckboxModule, FormsModule], exports: [SecurityOptionsComponent] });
/** @nocollapse */ SecurityOptionsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SecurityOptionsModule, imports: [[CommonModule, TranslateModule.forChild(), BentoModule, BentoCheckboxModule, FormsModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SecurityOptionsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SecurityOptionsComponent],
                    imports: [CommonModule, TranslateModule.forChild(), BentoModule, BentoCheckboxModule, FormsModule],
                    exports: [SecurityOptionsComponent],
                }]
        }] });

class CommunicationStatusDropdownComponent {
    constructor() {
        this.requestStatuses = [
            {
                code: CommunicationDisplayStatus.WaitingOnClient,
                label: marker('Blue.DocumentComponents.Communications.Status.WaitingOnClient'),
            },
            {
                code: CommunicationDisplayStatus.Received,
                label: marker('Blue.DocumentComponents.Communications.Status.Received'),
            },
            {
                code: CommunicationDisplayStatus.Completed,
                label: marker('Blue.DocumentComponents.Communications.Status.Completed'),
            },
            {
                code: CommunicationDisplayStatus.Canceled,
                label: marker('Blue.DocumentComponents.Communications.Status.Canceled'),
            },
        ];
        this.disableDropdown = false;
        this.selectedStatus = CommunicationDisplayStatus.WaitingOnClient;
        /** Indicator that the label is to be displayed */
        this.showLabel = true;
    }
    getQeId() {
        return 'dms-fe-component-document-approvals' + (this.qeId ? '-' + this.qeId : '') + '-communication-status-dropdown';
    }
}
/** @nocollapse */ CommunicationStatusDropdownComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommunicationStatusDropdownComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ CommunicationStatusDropdownComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: CommunicationStatusDropdownComponent, selector: "bdc-communication-status-dropdown", inputs: { disableDropdown: "disableDropdown", selectedStatus: "selectedStatus", qeId: "qeId", showLabel: "showLabel" }, providers: [], ngImport: i0, template: "<div class=\"status-dropdown\">\n\t<label *ngIf=\"showLabel\">{{'Blue.DocumentComponents.Communications.Status' | translate}}</label>\n\t<select\n\t\tname=\"statusDropdown\"\n\t\tclass=\"form-control\"\n\t\t[(ngModel)]=\"selectedStatus\"\n\t\t[disabled]=\"disableDropdown\"\n\t\t[attr.data-qe-id]=\"getQeId()\"\n\t>\n\t\t<option *ngFor=\"let status of requestStatuses\" [ngValue]=\"status.code\">{{status.label | translate}}</option>\n\t</select>\n</div>\n", styles: [".status-dropdown{margin-bottom:5px;margin-top:5px}.status-dropdown label{margin-bottom:4px}.status-dropdown select:disabled{cursor:not-allowed}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5.SelectControlValueAccessor, selector: "select:not([multiple])[formControlName],select:not([multiple])[formControl],select:not([multiple])[ngModel]", inputs: ["compareWith"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }, { type: i5.NgSelectOption, selector: "option", inputs: ["ngValue", "value"] }, { type: i5.ɵNgSelectMultipleOption, selector: "option", inputs: ["ngValue", "value"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommunicationStatusDropdownComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-communication-status-dropdown', providers: [], template: "<div class=\"status-dropdown\">\n\t<label *ngIf=\"showLabel\">{{'Blue.DocumentComponents.Communications.Status' | translate}}</label>\n\t<select\n\t\tname=\"statusDropdown\"\n\t\tclass=\"form-control\"\n\t\t[(ngModel)]=\"selectedStatus\"\n\t\t[disabled]=\"disableDropdown\"\n\t\t[attr.data-qe-id]=\"getQeId()\"\n\t>\n\t\t<option *ngFor=\"let status of requestStatuses\" [ngValue]=\"status.code\">{{status.label | translate}}</option>\n\t</select>\n</div>\n", styles: [".status-dropdown{margin-bottom:5px;margin-top:5px}.status-dropdown label{margin-bottom:4px}.status-dropdown select:disabled{cursor:not-allowed}\n"] }]
        }], propDecorators: { disableDropdown: [{
                type: Input
            }], selectedStatus: [{
                type: Input
            }], qeId: [{
                type: Input
            }], showLabel: [{
                type: Input
            }] } });

const translateModule$2 = TranslateModule.forChild();
class CommunicationStatusDropdownModule {
}
/** @nocollapse */ CommunicationStatusDropdownModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommunicationStatusDropdownModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ CommunicationStatusDropdownModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommunicationStatusDropdownModule, declarations: [CommunicationStatusDropdownComponent], imports: [CommonModule, FormsModule, i1.TranslateModule], exports: [CommunicationStatusDropdownComponent] });
/** @nocollapse */ CommunicationStatusDropdownModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommunicationStatusDropdownModule, imports: [[CommonModule, FormsModule, translateModule$2]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CommunicationStatusDropdownModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [CommunicationStatusDropdownComponent],
                    imports: [CommonModule, FormsModule, translateModule$2],
                    exports: [CommunicationStatusDropdownComponent],
                }]
        }] });

class MessageSubjectFieldComponent {
    constructor() {
        this.disabled = false;
        this.subject = '';
        this.subjectChange = new EventEmitter();
        this.errors = null;
        this.touched = false;
    }
    validate() {
        this.touch();
        this.errors = null;
        if (!this.subject) {
            this.errors = { required: true };
        }
        return this.errors;
    }
    getQeId() {
        return 'dms-fe-component-document-approvals' + (this.qeId ? '-' + this.qeId : '') + '-message-subject-field';
    }
    touch() {
        this.touched = true;
    }
    onChange() {
        this.validate();
        this.subjectChange.emit(this.subject);
    }
}
/** @nocollapse */ MessageSubjectFieldComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MessageSubjectFieldComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ MessageSubjectFieldComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: MessageSubjectFieldComponent, selector: "bdc-message-subject-field", inputs: { disabled: "disabled", subject: "subject", qeId: "qeId" }, outputs: { subjectChange: "subjectChange" }, providers: [], ngImport: i0, template: "<ng-container>\n\t<div class=\"message-subject\">\n\t\t<label>{{'Blue.DocumentComponents.Communications.MessageSubject' | translate}}</label>\n\t\t<input\n\t\t\tname=\"messageSubject\"\n\t\t\ttype=\"text\"\n\t\t\tclass=\"form-control\"\n\t\t\t[(ngModel)]=\"subject\"\n\t\t\t(ngModelChange)=\"onChange()\"\n\t\t\t[disabled]=\"disabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId()\"\n\t\t\tselect-on-focus\n\t\t\tmaxlength=\"250\"\n\t\t\tplaceholder=\"{{'Blue.DocumentComponents.Communications.MessageSubjectHint' | translate}}\"\n\t\t\tautocomplete=\"new-password\"\n\t\t\t(blur)=\"validate()\"\n\t\t/>\n\t\t<!-- Required error -->\n\t\t<div *ngIf=\"errors?.required\" class=\"validation danger\">\n\t\t\t{{'Blue.DocumentComponents.Communications.SubjectRequired' | translate}}\n\t\t</div>\n\t</div>\n</ng-container>\n", styles: [".message-subject{margin-bottom:5px;margin-top:5px}.message-subject label{margin-bottom:4px}.message-subject select:disabled{cursor:not-allowed}.input-border{border:3px;max-width:150}.bm-input{display:inline-block;width:250px}.input-extension{display:inline;margin-right:0}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], directives: [{ type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.MaxLengthValidator, selector: "[maxlength][formControlName],[maxlength][formControl],[maxlength][ngModel]", inputs: ["maxlength"] }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MessageSubjectFieldComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-message-subject-field', providers: [], template: "<ng-container>\n\t<div class=\"message-subject\">\n\t\t<label>{{'Blue.DocumentComponents.Communications.MessageSubject' | translate}}</label>\n\t\t<input\n\t\t\tname=\"messageSubject\"\n\t\t\ttype=\"text\"\n\t\t\tclass=\"form-control\"\n\t\t\t[(ngModel)]=\"subject\"\n\t\t\t(ngModelChange)=\"onChange()\"\n\t\t\t[disabled]=\"disabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId()\"\n\t\t\tselect-on-focus\n\t\t\tmaxlength=\"250\"\n\t\t\tplaceholder=\"{{'Blue.DocumentComponents.Communications.MessageSubjectHint' | translate}}\"\n\t\t\tautocomplete=\"new-password\"\n\t\t\t(blur)=\"validate()\"\n\t\t/>\n\t\t<!-- Required error -->\n\t\t<div *ngIf=\"errors?.required\" class=\"validation danger\">\n\t\t\t{{'Blue.DocumentComponents.Communications.SubjectRequired' | translate}}\n\t\t</div>\n\t</div>\n</ng-container>\n", styles: [".message-subject{margin-bottom:5px;margin-top:5px}.message-subject label{margin-bottom:4px}.message-subject select:disabled{cursor:not-allowed}.input-border{border:3px;max-width:150}.bm-input{display:inline-block;width:250px}.input-extension{display:inline;margin-right:0}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], propDecorators: { disabled: [{
                type: Input
            }], subject: [{
                type: Input
            }], qeId: [{
                type: Input
            }], subjectChange: [{
                type: Output
            }] } });

const translateModule$1 = TranslateModule.forChild();
class MessageSubjectFieldModule {
}
/** @nocollapse */ MessageSubjectFieldModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MessageSubjectFieldModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ MessageSubjectFieldModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MessageSubjectFieldModule, declarations: [MessageSubjectFieldComponent], imports: [CommonModule, FormsModule, i1.TranslateModule], exports: [MessageSubjectFieldComponent] });
/** @nocollapse */ MessageSubjectFieldModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MessageSubjectFieldModule, imports: [[CommonModule, FormsModule, translateModule$1]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: MessageSubjectFieldModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [MessageSubjectFieldComponent],
                    imports: [CommonModule, FormsModule, translateModule$1],
                    exports: [MessageSubjectFieldComponent],
                }]
        }] });

class RequestDestinationComponent {
    constructor(itemSelectorService) {
        this.itemSelectorService = itemSelectorService;
        this.isValid = true;
        this.destinationContainerKeyChange = new EventEmitter();
    }
    /**
     * Validates the current state of the component
     *
     * @returns ValidationErrors when the component is invalid, null otherwise
     */
    validate() {
        if (!this.destinationContainerKey) {
            this.isValid = false;
            return { required: true };
        }
        this.isValid = true;
        return null;
    }
    /**
     * Open the item selector modal to select a destination
     */
    browse() {
        var _a, _b;
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                showClientSelector: false,
                treeShowFiles: false,
                allowFileSelection: false,
                allowFolderSelection: true,
                allowLockedFileSelection: false,
                showFirmDocumentsDrawer: false,
                showMyDocumentsDrawer: false,
                showAddFolderButton: true,
                customTitle: marker('Blue.DocumentComponents.RequestDestination.UploadTo'),
                customSelectButtonText: marker('Blue.DocumentComponents.RequestDestination.Select'),
                containerId: (_a = this.openingContainerKey) === null || _a === void 0 ? void 0 : _a.id,
                containerType: (_b = this.openingContainerKey) === null || _b === void 0 ? void 0 : _b.type,
            };
            const value = yield this.itemSelectorService.open(this.clientId, config);
            if (value && value.container) {
                this.destinationContainerKey = value.container;
                this.openingContainerKey = value.container;
            }
            else {
                this.destinationContainerKey = undefined;
            }
            this.destinationContainerKeyChange.emit(this.destinationContainerKey);
            this.validate();
        });
    }
    getDataQeId(id) {
        if (this.dataQeIdRoot) {
            return this.dataQeIdRoot + '-' + id;
        }
        return id;
    }
}
/** @nocollapse */ RequestDestinationComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestDestinationComponent, deps: [{ token: ItemSelectorService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ RequestDestinationComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: RequestDestinationComponent, selector: "bdc-request-destination", inputs: { dataQeIdRoot: "dataQeIdRoot", clientId: "clientId", openingContainerKey: "openingContainerKey", destinationContainerKey: "destinationContainerKey" }, outputs: { destinationContainerKeyChange: "destinationContainerKeyChange" }, ngImport: i0, template: "<div class=\"destination-container\">\n\t<div class=\"breadcrumb-container\">\n\t\t<bdc-breadcrumb [containerKey]=\"destinationContainerKey\" [disableLinks]=\"true\" [collapseLength]=\"5\"> </bdc-breadcrumb>\n\t</div>\n\t<button\n\t\tclass=\"btn btn-outline-primary btn-icon browse\"\n\t\t(click)=\"browse()\"\n\t\t[disabled]=\"!clientId\"\n\t\t[attr.data-qe-id]=\"getDataQeId('bdc-request-destination-browse')\"\n\t>\n\t\t<span class=\"btn-text\">{{('Blue.DocumentComponents.RequestDestination.Browse' | translate)}}</span>\n\t\t<i class=\"bento-icon-arrow-right\"></i>\n\t</button>\n</div>\n<div *ngIf=\"!isValid\" class=\"validation danger\">\n\t<span> {{'Blue.DocumentComponents.RequestDestination.DestinationRequired' | translate}} </span>\n</div>\n", styles: [".destination-container{display:flex}.breadcrumb-container{background-color:#f4f5f7;border:1px solid #bababe;border-radius:3px;height:30px;width:100%}.browse{margin-left:16px;padding-right:0;width:100px}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], components: [{ type: BreadcrumbComponent, selector: "bdc-breadcrumb", inputs: ["containerKey", "disableLinks", "hrefBuilder", "dataQeIdPrefix", "collapseLength", "folderNameLength"] }], directives: [{ type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestDestinationComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-request-destination', template: "<div class=\"destination-container\">\n\t<div class=\"breadcrumb-container\">\n\t\t<bdc-breadcrumb [containerKey]=\"destinationContainerKey\" [disableLinks]=\"true\" [collapseLength]=\"5\"> </bdc-breadcrumb>\n\t</div>\n\t<button\n\t\tclass=\"btn btn-outline-primary btn-icon browse\"\n\t\t(click)=\"browse()\"\n\t\t[disabled]=\"!clientId\"\n\t\t[attr.data-qe-id]=\"getDataQeId('bdc-request-destination-browse')\"\n\t>\n\t\t<span class=\"btn-text\">{{('Blue.DocumentComponents.RequestDestination.Browse' | translate)}}</span>\n\t\t<i class=\"bento-icon-arrow-right\"></i>\n\t</button>\n</div>\n<div *ngIf=\"!isValid\" class=\"validation danger\">\n\t<span> {{'Blue.DocumentComponents.RequestDestination.DestinationRequired' | translate}} </span>\n</div>\n", styles: [".destination-container{display:flex}.breadcrumb-container{background-color:#f4f5f7;border:1px solid #bababe;border-radius:3px;height:30px;width:100%}.browse{margin-left:16px;padding-right:0;width:100px}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], ctorParameters: function () { return [{ type: ItemSelectorService }]; }, propDecorators: { dataQeIdRoot: [{
                type: Input
            }], clientId: [{
                type: Input
            }], openingContainerKey: [{
                type: Input
            }], destinationContainerKey: [{
                type: Input
            }], destinationContainerKeyChange: [{
                type: Output
            }] } });

class RequestDestinationModule {
}
/** @nocollapse */ RequestDestinationModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestDestinationModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ RequestDestinationModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestDestinationModule, declarations: [RequestDestinationComponent], imports: [BrowserModule, BentoModule, NgbModule, i1.TranslateModule, BreadcrumbModule], exports: [RequestDestinationComponent] });
/** @nocollapse */ RequestDestinationModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestDestinationModule, imports: [[BrowserModule, BentoModule, NgbModule, TranslateModule.forChild(), BreadcrumbModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestDestinationModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RequestDestinationComponent],
                    imports: [BrowserModule, BentoModule, NgbModule, TranslateModule.forChild(), BreadcrumbModule],
                    exports: [RequestDestinationComponent],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                }]
        }] });

class DateInputComponent {
    constructor(elRef, translateService) {
        this.elRef = elRef;
        this.translateService = translateService;
        this.qeIdPrefix = '';
        this.required = false;
        this.label = '';
        this.dateChange = new EventEmitter();
        this.isErrorsToBeShown = true;
        /**
         * List of errors typically used by the validate function to return to the parent component
         */
        this.errors = null;
        /**
         * The error string(s) to display, can be passed in by a parent component
         */
        this.errorStrings = [];
        this.touched = false;
        this.openCalendar = '';
        // Default date format if no format provided.
        this.dateConfig = { type: 'recent', format: 'mm/dd/yyyy' };
    }
    ngAfterViewInit() {
        const openCalendarEl = this.elRef.nativeElement.querySelector('#date-calender-icon');
        openCalendarEl === null || openCalendarEl === void 0 ? void 0 : openCalendarEl.setAttribute('aria-label', this.openCalendar);
    }
    ngOnInit() {
        this.openCalendar = this.translateService.instant('bmpp.ng.common.openCalendar');
    }
    ngOnChanges(changes) {
        if (this.dateFormat) {
            this.dateConfig = Object.assign(Object.assign({}, this.dateConfig), { format: this.dateFormat });
        }
        if (changes)
            console.log(changes.date.currentValue);
        // make sure the new data is valid
        this.validate();
    }
    validate() {
        this.touched = true;
        this.errors = null;
        this.errorStrings = [];
        if (!this.date && this.isErrorsToBeShown) {
            this.errors = { required: true };
            this.errorStrings.push(this.requiredValidationError);
        }
        // If there's no validation error for this field being required
        // And the consumer has set the before or after date
        if (!this.errors && !!this.beforeOrAfter && this.date < this.beforeOrAfter) {
            this.errors = { futureDueDate: true };
            this.errorStrings.push(this.beforeOrAfterValidationError);
        }
        return this.errors;
    }
    updateBeforeOrAfter(newDate, newMessage) {
        this.beforeOrAfter = newDate;
        this.beforeOrAfterValidationError = newMessage;
        this.validate();
    }
}
/** @nocollapse */ DateInputComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateInputComponent, deps: [{ token: i0.ElementRef }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DateInputComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DateInputComponent, selector: "bdc-date-input", inputs: { qeIdPrefix: "qeIdPrefix", required: "required", label: "label", date: "date", dateFormat: "dateFormat", isErrorsToBeShown: "isErrorsToBeShown", errors: "errors", errorStrings: "errorStrings", beforeOrAfter: "beforeOrAfter", requiredValidationError: "requiredValidationError", beforeOrAfterValidationError: "beforeOrAfterValidationError" }, outputs: { dateChange: "dateChange" }, providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }], usesOnChanges: true, ngImport: i0, template: "<label for=\"due-date\"> {{label | translate}} <span *ngIf=\"required\">*</span> </label>\n<div>\n\t<div class=\"inputs\">\n\t\t<input\n\t\t\tid=\"date-input\"\n\t\t\tclass=\"form-control bento-datepicker\"\n\t\t\t[firstDayOfWeek]=\"7\"\n\t\t\tname=\"date-input\"\n\t\t\t[(ngModel)]=\"date\"\n\t\t\tngbDatepicker\n\t\t\t#dateInput=\"ngbDatepicker\"\n\t\t\t(dateSelect)=\"dateChange.emit(date)\"\n\t\t\t(blur)=\"dateChange.emit(date)\"\n\t\t\t[bentoDatepickerConfig]=\"dateConfig\"\n\t\t/>\n\t\t<button\n\t\t\tid=\"date-calender-icon\"\n\t\t\tclass=\"btn btn-outline-primary btn-icon ml-2\"\n\t\t\t[bentoDatepickerToggle]=\"dateInput\"\n\t\t\ttype=\"button\"\n\t\t\taria-haspopup=\"true\"\n\t\t>\n\t\t\t<i class=\"bento-icon-calendar\" aria-hidden=\"true\"></i>\n\t\t</button>\n\t</div>\n\t<div class=\"errors\">\n\t\t<div class=\"validation danger\" *ngFor=\"let error of errorStrings\">{{error | translate}}</div>\n\t</div>\n</div>\n", styles: [".date{display:inline-block;width:228px}.inputs input{display:inline-block;width:100px}.bento-icon-calendar{font-family:bento-icomoon}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbInputDatepicker, selector: "input[ngbDatepicker]", inputs: ["autoClose", "datepickerClass", "dayTemplate", "dayTemplateData", "displayMonths", "firstDayOfWeek", "footerTemplate", "markDisabled", "minDate", "maxDate", "navigation", "outsideDays", "placement", "restoreFocus", "showWeekNumbers", "startDate", "container", "positionTarget", "weekdays", "disabled"], outputs: ["dateSelect", "navigate", "closed"], exportAs: ["ngbDatepicker"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.BentoDatepickerConfigDirective, selector: "[bentoDatepickerConfig]", inputs: ["bentoDatepickerConfig"] }, { type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }, { type: i2.BentoDatepickerToggleDirective, selector: "[bentoDatepickerToggle]", inputs: ["bentoDatepickerToggle"] }, { type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateInputComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-date-input', providers: [{ provide: NgbDateAdapter, useClass: NgbDateNativeAdapter }], template: "<label for=\"due-date\"> {{label | translate}} <span *ngIf=\"required\">*</span> </label>\n<div>\n\t<div class=\"inputs\">\n\t\t<input\n\t\t\tid=\"date-input\"\n\t\t\tclass=\"form-control bento-datepicker\"\n\t\t\t[firstDayOfWeek]=\"7\"\n\t\t\tname=\"date-input\"\n\t\t\t[(ngModel)]=\"date\"\n\t\t\tngbDatepicker\n\t\t\t#dateInput=\"ngbDatepicker\"\n\t\t\t(dateSelect)=\"dateChange.emit(date)\"\n\t\t\t(blur)=\"dateChange.emit(date)\"\n\t\t\t[bentoDatepickerConfig]=\"dateConfig\"\n\t\t/>\n\t\t<button\n\t\t\tid=\"date-calender-icon\"\n\t\t\tclass=\"btn btn-outline-primary btn-icon ml-2\"\n\t\t\t[bentoDatepickerToggle]=\"dateInput\"\n\t\t\ttype=\"button\"\n\t\t\taria-haspopup=\"true\"\n\t\t>\n\t\t\t<i class=\"bento-icon-calendar\" aria-hidden=\"true\"></i>\n\t\t</button>\n\t</div>\n\t<div class=\"errors\">\n\t\t<div class=\"validation danger\" *ngFor=\"let error of errorStrings\">{{error | translate}}</div>\n\t</div>\n</div>\n", styles: [".date{display:inline-block;width:228px}.inputs input{display:inline-block;width:100px}.bento-icon-calendar{font-family:bento-icomoon}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.TranslateService }]; }, propDecorators: { qeIdPrefix: [{
                type: Input
            }], required: [{
                type: Input
            }], label: [{
                type: Input
            }], date: [{
                type: Input
            }], dateFormat: [{
                type: Input
            }], dateChange: [{
                type: Output
            }], isErrorsToBeShown: [{
                type: Input
            }], errors: [{
                type: Input
            }], errorStrings: [{
                type: Input
            }], beforeOrAfter: [{
                type: Input
            }], requiredValidationError: [{
                type: Input
            }], beforeOrAfterValidationError: [{
                type: Input
            }] } });

class DateInputModule {
}
/** @nocollapse */ DateInputModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateInputModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DateInputModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateInputModule, declarations: [DateInputComponent], imports: [CommonModule,
        FormsModule,
        ReactiveFormsModule, i1.TranslateModule, NgbDatepickerModule,
        BentoDatepickerToggleModule,
        BentoModule], exports: [DateInputComponent] });
/** @nocollapse */ DateInputModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateInputModule, imports: [[
            CommonModule,
            FormsModule,
            ReactiveFormsModule,
            TranslateModule.forChild(),
            NgbDatepickerModule,
            BentoDatepickerToggleModule,
            BentoModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DateInputModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DateInputComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ReactiveFormsModule,
                        TranslateModule.forChild(),
                        NgbDatepickerModule,
                        BentoDatepickerToggleModule,
                        BentoModule,
                    ],
                    exports: [DateInputComponent],
                }]
        }] });

const defaultRequest = {
    requestType: CommunicationRequestType.Informational,
    communicationStatus: CommunicationDisplayStatus.WaitingOnClient,
    subRequests: [],
    recipients: [],
};
const defaultSubRequest = {
    communicationStatus: CommunicationDisplayStatus.WaitingOnClient,
    type: 'File',
};
const defaultRecipient = {
    culture: 'en-US',
};
class TaxRequestComponent {
    constructor(communicationService, emailBodyService, translateService) {
        this.communicationService = communicationService;
        this.emailBodyService = emailBodyService;
        this.translateService = translateService;
        this.request = defaultRequest;
        /**
         * (Optional) If true, the user will not be able to change the selected client
         */
        this.disableClientSelector = false;
        this.requestCreated = new EventEmitter();
        this.cancelClicked = new EventEmitter();
        this.alerts = [];
        this.getCompanyId = getCompanyId;
        this.submitting = false;
        /**
         * Today's date
         */
        this.currDate = new Date();
        this.recipientTouched = false;
        registerAlert();
        this.clientComboLabel = this.translateService.get('Blue.DocumentComponents.Communications.Client').pipe(startWith('Client'), map(s => `${s} *`));
    }
    ngOnInit() {
        void this.setDefaultExpirationDate();
        this.selectedRecipients = this.getSelectedRecipients();
        void this.setCompanyId();
    }
    subjectChanged(subject) {
        this.request = Object.assign(Object.assign({}, this.request), { subject });
    }
    submit() {
        var _a, _b, _c;
        return __awaiter(this, void 0, void 0, function* () {
            this.alerts = [];
            this.submitting = true;
            this.recipientTouched = true;
            try {
                const locale = (_b = (_a = this.request.recipients) === null || _a === void 0 ? void 0 : _a[0].culture) !== null && _b !== void 0 ? _b : 'en-US';
                const emailBody = yield this.getDefaultEmailBody((_c = this.request.requestType) !== null && _c !== void 0 ? _c : CommunicationRequestType.Informational, locale);
                this.request = yield this.completeRequest(this.request, emailBody);
                const isValid = this.validateForm();
                if (!isValid) {
                    // Not translating (yet) as this is still US-only
                    this.displayMessage('Please complete all required fields', 'danger');
                    return;
                }
                const result = yield this.communicationService.createRequest(this.request);
                yield this.emailRequestRecipients(result, emailBody, locale);
                this.requestCreated.emit(result);
                this.displayMessage('Document Request was sent successfully', 'success');
            }
            catch (error) {
                console.log(error);
                this.submitError = String(error);
            }
            finally {
                this.submitting = false;
            }
        });
    }
    setCompanyId() {
        return __awaiter(this, void 0, void 0, function* () {
            this.companyId = yield this.getCompanyId();
        });
    }
    displayMessage(message, type) {
        this.alerts.push({
            type,
            msg: message,
            closeable: true,
        });
    }
    completeRequest(request, emailBody) {
        return __awaiter(this, void 0, void 0, function* () {
            const companyId = yield this.getCompanyId();
            return Object.assign(Object.assign(Object.assign({}, defaultRequest), request), { companyId, subRequests: request.subRequests.map(subRequest => (Object.assign(Object.assign({}, defaultSubRequest), subRequest))), recipients: request.recipients.map(recipient => (Object.assign(Object.assign({}, defaultRecipient), recipient))), metaData: {
                    body: emailBody,
                    notificationEmailSubject: request.subject,
                } });
        });
    }
    clientSelected(client) {
        this.request = Object.assign(Object.assign({}, this.request), { clientId: client === null || client === void 0 ? void 0 : client.id });
    }
    dueDateChanged(dueDate) {
        this.request = Object.assign(Object.assign({}, this.request), { dueDate });
        this.updateBeforeOrAfter(dueDate);
    }
    expirationDateChanged(expirationDate) {
        this.request = Object.assign(Object.assign({}, this.request), { expirationDate });
    }
    recipientListChanged(recipients) {
        const mappedRecipients = recipients.map(r => this.selectedRecipientToCommunicationRecipient(r));
        this.request = Object.assign(Object.assign({}, this.request), { recipients: mappedRecipients });
    }
    recipientType(recipient) {
        return recipient.email && recipient.clientCenter
            ? CommunicationRequestRecipientType.Both
            : recipient.email
                ? CommunicationRequestRecipientType.Email
                : recipient.clientCenter
                    ? CommunicationRequestRecipientType.ClientCenter
                    : undefined;
    }
    selectedRecipientToCommunicationRecipient(recipient) {
        var _a, _b, _c;
        return {
            name: (_a = recipient.contact) === null || _a === void 0 ? void 0 : _a.displayAs,
            contactId: (_b = recipient === null || recipient === void 0 ? void 0 : recipient.contact) === null || _b === void 0 ? void 0 : _b.id,
            emailAddress: (_c = recipient.contact) === null || _c === void 0 ? void 0 : _c.emailAddress,
            type: this.recipientType(recipient),
            culture: 'en-US',
        };
    }
    setDefaultExpirationDate() {
        if (!this.request.expirationDate) {
            const expirationDate = new Date();
            expirationDate.setFullYear(expirationDate.getFullYear() + 1);
            this.request = Object.assign(Object.assign({}, this.request), { expirationDate });
        }
    }
    emailRequestRecipients(request, emailBody, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const recipients = (request.recipients || []).map(recipient => ({ id: recipient.id }));
            yield this.communicationService.emailRecipientsAsync(request.id, {
                // TODO: Translate button text
                buttonText: 'Okay',
                message: emailBody,
                recipients,
                language: locale,
                locale,
                authorizationCode: this.securityOptions.isRequired ? this.securityOptions.password : undefined,
            });
        });
    }
    getDefaultEmailBody(requestType, locale) {
        return __awaiter(this, void 0, void 0, function* () {
            const template = yield this.emailBodyService.getEmailTemplate(requestType, locale);
            const emailChannel = template.defaultTemplate.channels.find(channel => channel.method === 'email');
            if (!emailChannel) {
                throw new Error('Email message not found in templates');
            }
            return emailChannel.body;
        });
    }
    isEmailType(communicationRequestRecipientType) {
        return (communicationRequestRecipientType == CommunicationRequestRecipientType.Email ||
            communicationRequestRecipientType == CommunicationRequestRecipientType.Both);
    }
    isClientCenterType(communicationRequestRecipientType) {
        return (communicationRequestRecipientType == CommunicationRequestRecipientType.ClientCenter ||
            communicationRequestRecipientType == CommunicationRequestRecipientType.Both);
    }
    communicationRecipientToContact(recipient, addRelationship) {
        return {
            emailAddress: recipient.emailAddress,
            id: recipient.contactId,
            displayAs: recipient.name,
            isClientCenterEnabled: false,
            isIndividual: true,
            // We assume the consumer is only providing client center contacts with relationships
            // but due to a race condition, the recipientSelector doesn't set the relationship on the contact
            // when it is found. So we're going to put a placeholder so the contactCenter checkbox is enabled.
            relationship: addRelationship ? 'placeholder relationship' : undefined,
        };
    }
    communicationRecipientToSelectedRecipient(recipient) {
        const hasClientCenter = this.isClientCenterType(recipient.type);
        return {
            contact: this.communicationRecipientToContact(recipient, true) || undefined,
            clientCenter: hasClientCenter,
            email: this.isEmailType(recipient.type),
            isValid: true, // Should this be assumed true??
        };
    }
    destinationContainerChange(key) {
        this.request = Object.assign(Object.assign({}, this.request), { subRequests: (this.request.subRequests || []).map(subRequest => (Object.assign(Object.assign({}, subRequest), { containerKey: key }))) });
    }
    getSelectedRecipients() {
        return this.request.recipients
            ? this.request.recipients.map(r => this.communicationRecipientToSelectedRecipient(r))
            : [{ email: true, clientCenter: false, isValid: false }];
    }
    recipientValid() {
        var _a;
        const recipient = (_a = this.request.recipients) === null || _a === void 0 ? void 0 : _a[0];
        const type = recipient === null || recipient === void 0 ? void 0 : recipient.type;
        return ((type === CommunicationRequestRecipientType.ClientCenter && !!(recipient === null || recipient === void 0 ? void 0 : recipient.contactId)) ||
            (type === CommunicationRequestRecipientType.Email && !!(recipient === null || recipient === void 0 ? void 0 : recipient.emailAddress)));
    }
    validateForm() {
        var _a, _b, _c, _d, _e, _f;
        // We can't just AND these together directly because short-circuiting means some of them might not get run
        const clientValid = !((_a = this.clientSelector) === null || _a === void 0 ? void 0 : _a.validate());
        const destinationValid = !((_b = this.uploadDestination) === null || _b === void 0 ? void 0 : _b.validate());
        const securityOptionsValid = !((_c = this.securityOptions) === null || _c === void 0 ? void 0 : _c.validate());
        const subjectValid = !((_d = this.messageSubjectField) === null || _d === void 0 ? void 0 : _d.validate());
        const dueDateValid = !((_e = this.dueDateInput) === null || _e === void 0 ? void 0 : _e.validate());
        const expirationDateValid = !((_f = this.expirationDateInput) === null || _f === void 0 ? void 0 : _f.validate());
        return clientValid && destinationValid && securityOptionsValid && subjectValid && expirationDateValid && dueDateValid;
    }
    dueDateAfterToday() {
        return !!this.request.dueDate && this.request.dueDate > this.currDate;
    }
    validateRecipients(recipients) {
        return (recipients || []).every(recipient => recipient.contactId || recipient.type === CommunicationRequestRecipientType.Email);
    }
    getBeforeAfterDate() {
        if (this.dueDateAfterToday()) {
            return this.request.dueDate;
        }
        return this.currDate;
    }
    updateBeforeOrAfter(newDate) {
        if (this.dueDateAfterToday()) {
            this.expirationDateInput.updateBeforeOrAfter(newDate, 'Blue.DocumentComponents.DateInput.ExpirationDateOnOrAfterDueDate');
        }
        else {
            this.expirationDateInput.updateBeforeOrAfter(this.currDate, 'Blue.DocumentComponents.DateInput.ExpirationDateOnOrAfterToday');
        }
    }
}
/** @nocollapse */ TaxRequestComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestComponent, deps: [{ token: i1$1.CommunicationService }, { token: i1$1.EmailBodyService }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ TaxRequestComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TaxRequestComponent, selector: "bdc-tax-request", inputs: { request: "request", disableClientSelector: "disableClientSelector" }, outputs: { requestCreated: "requestCreated", cancelClicked: "cancelClicked" }, viewQueries: [{ propertyName: "clientSelector", first: true, predicate: ClientSelectorComponent, descendants: true }, { propertyName: "uploadDestination", first: true, predicate: RequestDestinationComponent, descendants: true }, { propertyName: "securityOptions", first: true, predicate: SecurityOptionsComponent, descendants: true }, { propertyName: "messageSubjectField", first: true, predicate: MessageSubjectFieldComponent, descendants: true }, { propertyName: "dueDateInput", first: true, predicate: ["dueDate"], descendants: true }, { propertyName: "expirationDateInput", first: true, predicate: ["expirationDate"], descendants: true }], ngImport: i0, template: "<div class=\"tax-request-form\">\n\t<!-- HEADER -->\n\t<div class=\"row\">\n\t\t<h1 class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\" ng-if=\"!isEditMode\">\n\t\t\t{{'Blue.DocumentComponents.Communications.AddDocumentRequest' | translate}}\n\t\t</h1>\n\t</div>\n\n\t<div class=\"row\">\n\t\t<!-- CLIENT SELECTOR -->\n\t\t<div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\">\n\t\t\t<bdc-client-selector\n\t\t\t\t[required]=\"true\"\n\t\t\t\t[comboLabelText]=\"clientComboLabel | async\"\n\t\t\t\t(selectedChange)=\"clientSelected($event)\"\n\t\t\t\t[selected]=\"{id: request.clientId}\"\n\t\t\t\t[disabled]=\"disableClientSelector\"\n\t\t\t></bdc-client-selector>\n\t\t</div>\n\t\t<!-- STATUS DROP DOWN -->\n\t\t<!-- Un-wired and disabled because status can only be \"Waiting on Client\" for new requests -->\n\t\t<bdc-communication-status-dropdown class=\"col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group\">\n\t\t</bdc-communication-status-dropdown>\n\t</div>\n\n\t<!-- RECIPIENT SELECTOR -->\n\t<!-- recipient headers -->\n\t<div class=\"row\">\n\t\t<div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7\">\n\t\t\t{{'Blue.DocumentComponents.Communications.Recipient' | translate}} *\n\t\t</div>\n\t\t<div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 align-center\">\n\t\t\t{{'Blue.DocumentComponents.RecipientSelector.SendViaEmailLabel' | translate}}\n\t\t</div>\n\t\t<div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 align-center\">\n\t\t\t{{'Blue.DocumentComponents.RecipientSelector.SendViaClientCenterLabel' | translate}}\n\t\t</div>\n\t</div>\n\t<div class=\"client-center-tool-tip\">\n\t\t<!--\n\t\t<i\n\t\t\tngbTooltip=\"{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsClientCenterToolTip' | translate}}\"\n\t\t\tplacement=\"right\"\n\t\t\ttriggers=\"mouseenter\"\n\t\t\tcontainer=\"body\"\n\t\t\ttooltipClass=\"send-to-client-center-tool-tip\"\n\t\t\tclass=\"bento-icon-info info-icon\"\n\t\t></i>\n\t--></div>\n\t<!-- recipient input -->\n\t<bdc-recipient-selector\n\t\t[clientId]=\"request.clientId\"\n\t\t[companyId]=\"companyId\"\n\t\t[maxAllowedCount]=\"1\"\n\t\t(recipientsChange)=\"recipientListChanged($event)\"\n\t\t[recipients]=\"selectedRecipients\"\n\t\t(onBlur)=\"recipientTouched = true\"\n\t></bdc-recipient-selector>\n\t<!-- Recipient required error -->\n\t<div class=\"validation danger\" *ngIf=\"recipientTouched && !recipientValid()\">\n\t\t{{'Blue.DocumentComponents.RecipientSelector.Error.EnterRecipientAndDeliveryMethod' | translate}}\n\t</div>\n\n\t<!-- REQUEST DETAILS HEADER -->\n\t<label class=\"group-title\">{{'Blue.DocumentComponents.Communications.RequestDetails' | translate}}</label>\n\n\t<!-- DOCUMENT UPLOAD DESTINATION -->\n\t<div class=\"form-group flex-col\">\n\t\t<label for=\"\">{{'Blue.DocumentComponents.Communications.DocumentUploadDestination' | translate}} *</label>\n\t\t<bdc-request-destination\n\t\t\t[clientId]=\"request.clientId\"\n\t\t\t(destinationContainerKeyChange)=\"destinationContainerChange($event)\"\n\t\t></bdc-request-destination>\n\t</div>\n\n\t<!-- DUE DATE/EXPIRATION DATE -->\n\t<div class=\"form-group flex\">\n\t\t<!-- Due Date -->\n\t\t<bdc-date-input\n\t\t\t#dueDate\n\t\t\t[label]=\"('Blue.DocumentComponents.Communications.DueDate.Label' | translate) + (' *')\"\n\t\t\t[date]=\"request.dueDate\"\n\t\t\t[dateFormat]=\"'mm/dd/yyyy'\"\n\t\t\t(dateChange)=\"dueDateChanged($event)\"\n\t\t\t[requiredValidationError]=\"'Blue.DocumentComponents.DateInput.DateError' | translate\"\n\t\t\t[beforeOrAfter]=\"currDate.setUTCHours(0, 0, 0, 0)\"\n\t\t\t[beforeOrAfterValidationError]=\"'Blue.DocumentComponents.DateInput.DueDateOnOrAfterToday' | translate\"\n\t\t></bdc-date-input>\n\t\t<!-- Expiration Date -->\n\t\t<bdc-date-input\n\t\t\t#expirationDate\n\t\t\t[label]=\"('Blue.DocumentComponents.Communications.ExpirationDate.Label' | translate) + (' *')\"\n\t\t\t[date]=\"request.expirationDate\"\n\t\t\t[dateFormat]=\"'mm/dd/yyyy'\"\n\t\t\t(dateChange)=\"expirationDateChanged($event)\"\n\t\t\t[beforeOrAfter]=\"getBeforeAfterDate()\"\n\t\t\t[requiredValidationError]=\"'Blue.DocumentComponents.DateInput.ExpirationDateOnOrAfterToday' | translate\"\n\t\t\t[beforeOrAfterValidationError]=\"'Blue.DocumentComponents.DateInput.ExpirationDateOnOrAfterDueDate' | translate\"\n\t\t>\n\t\t</bdc-date-input>\n\t</div>\n\n\t<!-- MESSAGE DETAILS HEADER -->\n\t<label class=\"group-title\">{{'Blue.DocumentComponents.Communications.MessageDetails' | translate}}</label>\n\n\t<!-- SECURITY OPTIONS -->\n\t<div class=\"form-group\">\n\t\t<label class=\"\">{{'Blue.DocumentComponents.Communications.SecurityOption' | translate}}</label>\n\t\t<bdc-security-options [isRequired]=\"false\" [password]=\"\" [isNew]=\"true\" [dataQeIdPrefix]=\"'tax-request'\">\n\t\t</bdc-security-options>\n\t</div>\n\n\t<!-- MESSAGE SUBJECT -->\n\t<div class=\"row form-group\">\n\t\t<bdc-message-subject-field\n\t\t\tclass=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"\n\t\t\t[subject]=\"request.subject\"\n\t\t\t(subjectChange)=\"subjectChanged($event)\"\n\t\t></bdc-message-subject-field>\n\t</div>\n\n\t<!-- REQUIRED -->\n\t<div class=\"required-text align-container\">\n\t\t* {{'Blue.DocumentComponents.Communications.RequiredField' | translate}}\n\t</div>\n\n\t<div class=\"row footer\">\n\t\t<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\">\n\t\t\t<!-- SEND BUTTON -->\n\t\t\t<button type=\"submit\" (click)=\"submit()\" class=\"btn btn-primary\" [disabled]=\"submitting\">Send</button>\n\t\t\t<!-- CANCEL BUTTON -->\n\t\t\t<button type=\"submit\" (click)=\"cancelClicked.emit()\" class=\"btn\" [disabled]=\"submitting\">Cancel</button>\n\t\t</div>\n\t</div>\n\n\t<div *ngIf=\"submitError\">{{submitError | json}}</div>\n\n\t<!-- ALERT -->\n\t<div class=\"alerts-container\">\n\t\t<bento-alert [items]=\"alerts\"></bento-alert>\n\t</div>\n</div>\n", styles: [".placeholder{font-style:italic;margin-bottom:2em}.flex{display:flex}.flex-col{display:flex;flex-direction:column}.align-center{text-align:center}.footer{border-top:1px solid #e5e5e5;padding:20px 0}.footer button{margin-right:4px}bdc-date-input{width:180px}.group-title{color:#212121;font-family:KnowledgeRegular;font-size:18px;margin-top:10px}.request-destination{display:flex;flex-direction:column}::ng-deep bdc-message-subject-field div.message-subject>label:after{content:\" *\"}bdc-communication-status-dropdown{margin-left:auto}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"], components: [{ type: ClientSelectorComponent, selector: "bdc-client-selector", inputs: ["required", "selected", "bubbleClientsUp", "disabled", "comboLabelText"], outputs: ["selectedChange"] }, { type: CommunicationStatusDropdownComponent, selector: "bdc-communication-status-dropdown", inputs: ["disableDropdown", "selectedStatus", "qeId", "showLabel"] }, { type: RecipientSelectorComponent, selector: "bdc-recipient-selector", inputs: ["recipients", "maxAllowedCount", "validator", "companyId", "clientId", "readonly", "showClientCenterCheckbox", "disableSendEmailCheckbox"], outputs: ["recipientsChange", "onBlur"] }, { type: RequestDestinationComponent, selector: "bdc-request-destination", inputs: ["dataQeIdRoot", "clientId", "openingContainerKey", "destinationContainerKey"], outputs: ["destinationContainerKeyChange"] }, { type: DateInputComponent, selector: "bdc-date-input", inputs: ["qeIdPrefix", "required", "label", "date", "dateFormat", "isErrorsToBeShown", "errors", "errorStrings", "beforeOrAfter", "requiredValidationError", "beforeOrAfterValidationError"], outputs: ["dateChange"] }, { type: SecurityOptionsComponent, selector: "bdc-security-options", inputs: ["isRequired", "password", "isNew", "dataQeIdPrefix"], outputs: ["isRequiredChange", "passwordChange", "isValid"] }, { type: MessageSubjectFieldComponent, selector: "bdc-message-subject-field", inputs: ["disabled", "subject", "qeId"], outputs: ["subjectChange"] }, { type: i2.BentoAlertComponent, selector: "bento-alert", inputs: ["items", "inline", "grabFocus"], outputs: ["close"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe, "async": i2$1.AsyncPipe, "json": i2$1.JsonPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-tax-request', template: "<div class=\"tax-request-form\">\n\t<!-- HEADER -->\n\t<div class=\"row\">\n\t\t<h1 class=\"col-xs-12 col-sm-12 col-md-8 col-lg-8\" ng-if=\"!isEditMode\">\n\t\t\t{{'Blue.DocumentComponents.Communications.AddDocumentRequest' | translate}}\n\t\t</h1>\n\t</div>\n\n\t<div class=\"row\">\n\t\t<!-- CLIENT SELECTOR -->\n\t\t<div class=\"col-xs-12 col-sm-6 col-md-6 col-lg-6 form-group\">\n\t\t\t<bdc-client-selector\n\t\t\t\t[required]=\"true\"\n\t\t\t\t[comboLabelText]=\"clientComboLabel | async\"\n\t\t\t\t(selectedChange)=\"clientSelected($event)\"\n\t\t\t\t[selected]=\"{id: request.clientId}\"\n\t\t\t\t[disabled]=\"disableClientSelector\"\n\t\t\t></bdc-client-selector>\n\t\t</div>\n\t\t<!-- STATUS DROP DOWN -->\n\t\t<!-- Un-wired and disabled because status can only be \"Waiting on Client\" for new requests -->\n\t\t<bdc-communication-status-dropdown class=\"col-xs-12 col-sm-4 col-md-4 col-lg-3 form-group\">\n\t\t</bdc-communication-status-dropdown>\n\t</div>\n\n\t<!-- RECIPIENT SELECTOR -->\n\t<!-- recipient headers -->\n\t<div class=\"row\">\n\t\t<div class=\"col-xs-7 col-sm-7 col-md-7 col-lg-7\">\n\t\t\t{{'Blue.DocumentComponents.Communications.Recipient' | translate}} *\n\t\t</div>\n\t\t<div class=\"col-xs-2 col-sm-2 col-md-2 col-lg-2 align-center\">\n\t\t\t{{'Blue.DocumentComponents.RecipientSelector.SendViaEmailLabel' | translate}}\n\t\t</div>\n\t\t<div class=\"col-xs-3 col-sm-3 col-md-3 col-lg-3 align-center\">\n\t\t\t{{'Blue.DocumentComponents.RecipientSelector.SendViaClientCenterLabel' | translate}}\n\t\t</div>\n\t</div>\n\t<div class=\"client-center-tool-tip\">\n\t\t<!--\n\t\t<i\n\t\t\tngbTooltip=\"{{'Bluemoon.DMS.Requests.AddEditForm.RecipientsClientCenterToolTip' | translate}}\"\n\t\t\tplacement=\"right\"\n\t\t\ttriggers=\"mouseenter\"\n\t\t\tcontainer=\"body\"\n\t\t\ttooltipClass=\"send-to-client-center-tool-tip\"\n\t\t\tclass=\"bento-icon-info info-icon\"\n\t\t></i>\n\t--></div>\n\t<!-- recipient input -->\n\t<bdc-recipient-selector\n\t\t[clientId]=\"request.clientId\"\n\t\t[companyId]=\"companyId\"\n\t\t[maxAllowedCount]=\"1\"\n\t\t(recipientsChange)=\"recipientListChanged($event)\"\n\t\t[recipients]=\"selectedRecipients\"\n\t\t(onBlur)=\"recipientTouched = true\"\n\t></bdc-recipient-selector>\n\t<!-- Recipient required error -->\n\t<div class=\"validation danger\" *ngIf=\"recipientTouched && !recipientValid()\">\n\t\t{{'Blue.DocumentComponents.RecipientSelector.Error.EnterRecipientAndDeliveryMethod' | translate}}\n\t</div>\n\n\t<!-- REQUEST DETAILS HEADER -->\n\t<label class=\"group-title\">{{'Blue.DocumentComponents.Communications.RequestDetails' | translate}}</label>\n\n\t<!-- DOCUMENT UPLOAD DESTINATION -->\n\t<div class=\"form-group flex-col\">\n\t\t<label for=\"\">{{'Blue.DocumentComponents.Communications.DocumentUploadDestination' | translate}} *</label>\n\t\t<bdc-request-destination\n\t\t\t[clientId]=\"request.clientId\"\n\t\t\t(destinationContainerKeyChange)=\"destinationContainerChange($event)\"\n\t\t></bdc-request-destination>\n\t</div>\n\n\t<!-- DUE DATE/EXPIRATION DATE -->\n\t<div class=\"form-group flex\">\n\t\t<!-- Due Date -->\n\t\t<bdc-date-input\n\t\t\t#dueDate\n\t\t\t[label]=\"('Blue.DocumentComponents.Communications.DueDate.Label' | translate) + (' *')\"\n\t\t\t[date]=\"request.dueDate\"\n\t\t\t[dateFormat]=\"'mm/dd/yyyy'\"\n\t\t\t(dateChange)=\"dueDateChanged($event)\"\n\t\t\t[requiredValidationError]=\"'Blue.DocumentComponents.DateInput.DateError' | translate\"\n\t\t\t[beforeOrAfter]=\"currDate.setUTCHours(0, 0, 0, 0)\"\n\t\t\t[beforeOrAfterValidationError]=\"'Blue.DocumentComponents.DateInput.DueDateOnOrAfterToday' | translate\"\n\t\t></bdc-date-input>\n\t\t<!-- Expiration Date -->\n\t\t<bdc-date-input\n\t\t\t#expirationDate\n\t\t\t[label]=\"('Blue.DocumentComponents.Communications.ExpirationDate.Label' | translate) + (' *')\"\n\t\t\t[date]=\"request.expirationDate\"\n\t\t\t[dateFormat]=\"'mm/dd/yyyy'\"\n\t\t\t(dateChange)=\"expirationDateChanged($event)\"\n\t\t\t[beforeOrAfter]=\"getBeforeAfterDate()\"\n\t\t\t[requiredValidationError]=\"'Blue.DocumentComponents.DateInput.ExpirationDateOnOrAfterToday' | translate\"\n\t\t\t[beforeOrAfterValidationError]=\"'Blue.DocumentComponents.DateInput.ExpirationDateOnOrAfterDueDate' | translate\"\n\t\t>\n\t\t</bdc-date-input>\n\t</div>\n\n\t<!-- MESSAGE DETAILS HEADER -->\n\t<label class=\"group-title\">{{'Blue.DocumentComponents.Communications.MessageDetails' | translate}}</label>\n\n\t<!-- SECURITY OPTIONS -->\n\t<div class=\"form-group\">\n\t\t<label class=\"\">{{'Blue.DocumentComponents.Communications.SecurityOption' | translate}}</label>\n\t\t<bdc-security-options [isRequired]=\"false\" [password]=\"\" [isNew]=\"true\" [dataQeIdPrefix]=\"'tax-request'\">\n\t\t</bdc-security-options>\n\t</div>\n\n\t<!-- MESSAGE SUBJECT -->\n\t<div class=\"row form-group\">\n\t\t<bdc-message-subject-field\n\t\t\tclass=\"col-xs-12 col-sm-12 col-md-12 col-lg-12\"\n\t\t\t[subject]=\"request.subject\"\n\t\t\t(subjectChange)=\"subjectChanged($event)\"\n\t\t></bdc-message-subject-field>\n\t</div>\n\n\t<!-- REQUIRED -->\n\t<div class=\"required-text align-container\">\n\t\t* {{'Blue.DocumentComponents.Communications.RequiredField' | translate}}\n\t</div>\n\n\t<div class=\"row footer\">\n\t\t<div class=\"col-xs-12 col-sm-12 col-md-12 col-lg-12 form-group\">\n\t\t\t<!-- SEND BUTTON -->\n\t\t\t<button type=\"submit\" (click)=\"submit()\" class=\"btn btn-primary\" [disabled]=\"submitting\">Send</button>\n\t\t\t<!-- CANCEL BUTTON -->\n\t\t\t<button type=\"submit\" (click)=\"cancelClicked.emit()\" class=\"btn\" [disabled]=\"submitting\">Cancel</button>\n\t\t</div>\n\t</div>\n\n\t<div *ngIf=\"submitError\">{{submitError | json}}</div>\n\n\t<!-- ALERT -->\n\t<div class=\"alerts-container\">\n\t\t<bento-alert [items]=\"alerts\"></bento-alert>\n\t</div>\n</div>\n", styles: [".placeholder{font-style:italic;margin-bottom:2em}.flex{display:flex}.flex-col{display:flex;flex-direction:column}.align-center{text-align:center}.footer{border-top:1px solid #e5e5e5;padding:20px 0}.footer button{margin-right:4px}bdc-date-input{width:180px}.group-title{color:#212121;font-family:KnowledgeRegular;font-size:18px;margin-top:10px}.request-destination{display:flex;flex-direction:column}::ng-deep bdc-message-subject-field div.message-subject>label:after{content:\" *\"}bdc-communication-status-dropdown{margin-left:auto}\n", ".validation{box-sizing:border-box;display:block;font-family:KnowledgeRegular,arial,helvetica,sans-serif;padding-top:5px;position:relative}.validation.danger{color:#dc0a0a}.validation.danger:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"20\" height=\"20\" viewBox=\"0 0 24 24\"><path d=\"M0 0h24v24H0z\" fill=\"none\"/><path d=\"M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z\" fill=\"red\"/></svg>');position:relative;top:4px}.validation.info:before{content:url('data:image/svg+xml; utf8, <svg xmlns=\"http://www.w3.org/2000/svg\" width=\"16\" height=\"16\" viewBox=\"0 -40 1024 984\" transform=\"scale(1, -1)\"><path d=\"M576 448v64h-192v-64h64v-192h-64v-64h256v64h-64v192zM448 704h128v-128h-128v128zM512 960c-281.6 0-512-230.4-512-512s230.4-512 512-512 512 230.4 512 512-230.4 512-512 512zM512 64c-211.2 0-384 172.8-384 384s172.8 384 384 384 384-172.8 384-384-172.8-384-384-384z\" /></svg>');position:relative;top:2px}.bm-input.ng-invalid.ng-dirty,.bm-input.ng-invalid.ng-touched{border-color:#a94442}\n"] }]
        }], ctorParameters: function () { return [{ type: i1$1.CommunicationService }, { type: i1$1.EmailBodyService }, { type: i1.TranslateService }]; }, propDecorators: { request: [{
                type: Input
            }], disableClientSelector: [{
                type: Input
            }], requestCreated: [{
                type: Output
            }], cancelClicked: [{
                type: Output
            }], clientSelector: [{
                type: ViewChild,
                args: [ClientSelectorComponent]
            }], uploadDestination: [{
                type: ViewChild,
                args: [RequestDestinationComponent]
            }], securityOptions: [{
                type: ViewChild,
                args: [SecurityOptionsComponent]
            }], messageSubjectField: [{
                type: ViewChild,
                args: [MessageSubjectFieldComponent]
            }], dueDateInput: [{
                type: ViewChild,
                args: ['dueDate']
            }], expirationDateInput: [{
                type: ViewChild,
                args: ['expirationDate']
            }] } });

const weekMs = 7 * 24 * 60 * 60 * 1000;
const exampleRequest = {
    subject: 'Example Email Subject',
    subRequests: [
        {
            details: 'Example document request description 1',
        },
    ],
    // recipients: [
    // 	{
    // 		name: 'Benson, Drew',
    // 		contactId: 'E77BA04021794F02ABABD8E272520FCA',
    // 		emailAddress: 'drew.benson@thomsonreuters.com',
    // 		type: CommunicationRequestRecipientType.ClientCenter,
    // 		isIndividual: true,
    // 		relationship: true,
    // 	},
    // ],
    clientId: 'D974515C45A44DB9853108158235E3FE',
};
class TaxRequestDemoComponent {
    constructor() {
        this.errors = null;
        this.request = exampleRequest;
        this.clientDisabled = false;
    }
    get communicationModelString() {
        return JSON.stringify(this.request, null, 2);
    }
    requestCreated(communication) {
        this.resultString = JSON.stringify(communication, null, 2);
    }
    inputChange(e) {
        var _a;
        const str = (_a = e.target) === null || _a === void 0 ? void 0 : _a.value;
        this.request = JSON.parse(str);
        if (this.request.dueDate) {
            this.request.dueDate = new Date(this.request.dueDate);
        }
        if (this.request.expirationDate) {
            this.request.expirationDate = new Date(this.request.expirationDate);
        }
    }
    cancelClicked() {
        this.request = exampleRequest;
        this.resultString = '';
        console.log('Cancel clicked');
    }
}
/** @nocollapse */ TaxRequestDemoComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestDemoComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ TaxRequestDemoComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: TaxRequestDemoComponent, selector: "app-tax-request-demo", ngImport: i0, template: `
		Input
		<textarea [value]="communicationModelString" (change)="inputChange($event)"></textarea><br />
		<input type="checkbox" [(ngModel)]="clientDisabled" /> Disable Client Selector
		<div class="tax-request-container">
			<bdc-tax-request
				[request]="request"
				(requestCreated)="requestCreated($event)"
				(cancelClicked)="cancelClicked()"
				[disableClientSelector]="clientDisabled"
			></bdc-tax-request>
		</div>
		Result
		<textarea [(ngModel)]="resultString"></textarea>
	`, isInline: true, styles: ["textarea{width:100%}div.tax-request-container{background:white;width:90%;border:1px black solid;padding:1em;margin:1em}\n"], components: [{ type: TaxRequestComponent, selector: "bdc-tax-request", inputs: ["request", "disableClientSelector"], outputs: ["requestCreated", "cancelClicked"] }], directives: [{ type: i5.CheckboxControlValueAccessor, selector: "input[type=checkbox][formControlName],input[type=checkbox][formControl],input[type=checkbox][ngModel]" }, { type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i5.DefaultValueAccessor, selector: "input:not([type=checkbox])[formControlName],textarea[formControlName],input:not([type=checkbox])[formControl],textarea[formControl],input:not([type=checkbox])[ngModel],textarea[ngModel],[ngDefaultControl]" }] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestDemoComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'app-tax-request-demo',
                    template: `
		Input
		<textarea [value]="communicationModelString" (change)="inputChange($event)"></textarea><br />
		<input type="checkbox" [(ngModel)]="clientDisabled" /> Disable Client Selector
		<div class="tax-request-container">
			<bdc-tax-request
				[request]="request"
				(requestCreated)="requestCreated($event)"
				(cancelClicked)="cancelClicked()"
				[disableClientSelector]="clientDisabled"
			></bdc-tax-request>
		</div>
		Result
		<textarea [(ngModel)]="resultString"></textarea>
	`,
                    styles: [
                        `
			textarea {
				width: 100%;
			}
			div.tax-request-container {
				background: white;
				width: 90%;
				border: 1px black solid;
				padding: 1em;
				margin: 1em;
			}
		`,
                    ],
                }]
        }] });

class TaxRequestModule {
}
/** @nocollapse */ TaxRequestModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ TaxRequestModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestModule, declarations: [TaxRequestComponent, TaxRequestDemoComponent], imports: [CommonModule,
        FormsModule,
        ClientSelectorModule,
        CommunicationStatusDropdownModule,
        RecipientSelectorModule,
        MessageSubjectFieldModule,
        SecurityOptionsModule,
        RequestDestinationModule,
        DateInputModule,
        BrowserAnimationsModule,
        NgbAlertModule,
        BentoAlertModule, i1.TranslateModule], exports: [TaxRequestComponent, TaxRequestDemoComponent] });
/** @nocollapse */ TaxRequestModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestModule, imports: [[
            CommonModule,
            FormsModule,
            ClientSelectorModule,
            CommunicationStatusDropdownModule,
            RecipientSelectorModule,
            MessageSubjectFieldModule,
            SecurityOptionsModule,
            RequestDestinationModule,
            DateInputModule,
            BrowserAnimationsModule,
            NgbAlertModule,
            BentoAlertModule,
            TranslateModule.forChild(),
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: TaxRequestModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [TaxRequestComponent, TaxRequestDemoComponent],
                    imports: [
                        CommonModule,
                        FormsModule,
                        ClientSelectorModule,
                        CommunicationStatusDropdownModule,
                        RecipientSelectorModule,
                        MessageSubjectFieldModule,
                        SecurityOptionsModule,
                        RequestDestinationModule,
                        DateInputModule,
                        BrowserAnimationsModule,
                        NgbAlertModule,
                        BentoAlertModule,
                        TranslateModule.forChild(),
                    ],
                    exports: [TaxRequestComponent, TaxRequestDemoComponent],
                }]
        }] });

class RequestTemplateSelectorComponent {
    constructor(communicationService) {
        this.communicationService = communicationService;
        this.comboboxOptions = {
            searchable: true,
            /* Set the item height to 50px so that it can properly display each item in the dropdown */
            itemHeight: 50,
            columns: [{ name: 'subject', width: '*' }],
        };
        this.isLoadingTemplates = false;
        /** Disables the controls */
        this.disabled = true;
        /** Event that occurs when a template is applied */
        this.applyTemplate = new EventEmitter();
    }
    ngOnInit() {
        return __awaiter(this, void 0, void 0, function* () { });
    }
    loadTemplates() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.templates) {
                this.isLoadingTemplates = true;
                const templates = (yield this.communicationService.getRequestTemplateList()).items;
                this.templates = new BehaviorSubject(templates);
                this.isLoadingTemplates = false;
            }
        });
    }
    getQeId(qeId) {
        return 'dms-fe-component-document-approvals' + (this.baseQeId ? '-' + this.baseQeId : '') + '-' + qeId;
    }
    applySelectedTemplate() {
        var _a;
        this.applyTemplate.emit((_a = this.selectedTemplate) === null || _a === void 0 ? void 0 : _a.id);
    }
}
/** @nocollapse */ RequestTemplateSelectorComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestTemplateSelectorComponent, deps: [{ token: i1$1.CommunicationService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ RequestTemplateSelectorComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: RequestTemplateSelectorComponent, selector: "bdc-request-template-selector", inputs: { disabled: "disabled", baseQeId: "baseQeId" }, outputs: { applyTemplate: "applyTemplate" }, ngImport: i0, template: "<div class=\"row col-sm-12 col-md-8 col-lg-8\">\n\t<div class=\"col-sm-11 col-md-11 col-lg-11\">\n\t\t<label id=\"requestSelectorLabel\"\n\t\t\t>{{'Blue.DocumentComponents.DocumentRequests.RequestTemplateSelector' | translate}}</label\n\t\t>\n\t</div>\n\t<div class=\"col-sm-11 col-md-11 col-lg-11\">\n\t\t<bento-combobox\n\t\t\tid=\"templateDropDown\"\n\t\t\t[itemsObservable]=\"templates\"\n\t\t\tinputLabelText=\"{{'Blue.DocumentComponents.DocumentRequests.RequestTemplateSelector' | translate}}\"\n\t\t\tname=\"templateDropDown\"\n\t\t\tclass=\"form-control\"\n\t\t\t[(ngModel)]=\"selectedTemplate\"\n\t\t\t[attr.data-qe-id]=\"getQeId('template-drop-down')\"\n\t\t\t[options]=\"comboboxOptions\"\n\t\t\t(click)=\"loadTemplates()\"\n\t\t\t[bentoBusyLoader]=\"isLoadingTemplates\"\n\t\t\t[size]=\"'sm'\"\n\t\t\taria-labelledby=\"requestSelectorLabel\"\n\t\t\t[disabled]=\"disabled\"\n\t\t>\n\t\t</bento-combobox>\n\t</div>\n\t<div class=\"col-sm-1 col-md-1 col-lg-1\">\n\t\t<button\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t(click)=\"applySelectedTemplate()\"\n\t\t\t[disabled]=\"!selectedTemplate || disabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId('add-template-button')\"\n\t\t>\n\t\t\t{{'Blue.DocumentComponents.DocumentRequests.RequestTemplateApply' | translate}}\n\t\t</button>\n\t</div>\n</div>\n", components: [{ type: i2.BentoComboboxComponent, selector: "bento-combobox", inputs: ["appendTo", "options", "up", "readonly", "open", "itemsObservable", "required", "revertOnInvalidInput", "rowTemplate", "id", "inputLabelText", "inputLabelClass"], outputs: ["search", "resetItems", "endOfScroll", "openChange"] }], directives: [{ type: i5.NgControlStatus, selector: "[formControlName],[ngModel],[formControl]" }, { type: i5.NgModel, selector: "[ngModel]:not([formControlName]):not([formControl])", inputs: ["name", "disabled", "ngModel", "ngModelOptions"], outputs: ["ngModelChange"], exportAs: ["ngModel"] }, { type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }, { type: i2.BentoFocusMonitorDirective, selector: "a, button.btn, button.close, button.dropdown-item, a.dropdown-item, button.bento-number-input-button, button.bento-toast-action-btn" }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestTemplateSelectorComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-request-template-selector', template: "<div class=\"row col-sm-12 col-md-8 col-lg-8\">\n\t<div class=\"col-sm-11 col-md-11 col-lg-11\">\n\t\t<label id=\"requestSelectorLabel\"\n\t\t\t>{{'Blue.DocumentComponents.DocumentRequests.RequestTemplateSelector' | translate}}</label\n\t\t>\n\t</div>\n\t<div class=\"col-sm-11 col-md-11 col-lg-11\">\n\t\t<bento-combobox\n\t\t\tid=\"templateDropDown\"\n\t\t\t[itemsObservable]=\"templates\"\n\t\t\tinputLabelText=\"{{'Blue.DocumentComponents.DocumentRequests.RequestTemplateSelector' | translate}}\"\n\t\t\tname=\"templateDropDown\"\n\t\t\tclass=\"form-control\"\n\t\t\t[(ngModel)]=\"selectedTemplate\"\n\t\t\t[attr.data-qe-id]=\"getQeId('template-drop-down')\"\n\t\t\t[options]=\"comboboxOptions\"\n\t\t\t(click)=\"loadTemplates()\"\n\t\t\t[bentoBusyLoader]=\"isLoadingTemplates\"\n\t\t\t[size]=\"'sm'\"\n\t\t\taria-labelledby=\"requestSelectorLabel\"\n\t\t\t[disabled]=\"disabled\"\n\t\t>\n\t\t</bento-combobox>\n\t</div>\n\t<div class=\"col-sm-1 col-md-1 col-lg-1\">\n\t\t<button\n\t\t\tclass=\"btn btn-outline-primary\"\n\t\t\t(click)=\"applySelectedTemplate()\"\n\t\t\t[disabled]=\"!selectedTemplate || disabled\"\n\t\t\t[attr.data-qe-id]=\"getQeId('add-template-button')\"\n\t\t>\n\t\t\t{{'Blue.DocumentComponents.DocumentRequests.RequestTemplateApply' | translate}}\n\t\t</button>\n\t</div>\n</div>\n" }]
        }], ctorParameters: function () { return [{ type: i1$1.CommunicationService }]; }, propDecorators: { disabled: [{
                type: Input
            }], baseQeId: [{
                type: Input
            }], applyTemplate: [{
                type: Output
            }] } });

const translateModule = TranslateModule.forChild();
class RequestTemplateSelectorModule {
}
/** @nocollapse */ RequestTemplateSelectorModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestTemplateSelectorModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ RequestTemplateSelectorModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestTemplateSelectorModule, declarations: [RequestTemplateSelectorComponent], imports: [CommonModule, FormsModule, BentoModule, i1.TranslateModule], exports: [RequestTemplateSelectorComponent] });
/** @nocollapse */ RequestTemplateSelectorModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestTemplateSelectorModule, imports: [[CommonModule, FormsModule, BentoModule, translateModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RequestTemplateSelectorModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [RequestTemplateSelectorComponent],
                    imports: [CommonModule, FormsModule, BentoModule, translateModule],
                    exports: [RequestTemplateSelectorComponent],
                }]
        }] });

class EventFilterSidebarComponent {
    constructor(elRef, translateService, userLanguageService, ItemDateFnPipe) {
        this.elRef = elRef;
        this.translateService = translateService;
        this.userLanguageService = userLanguageService;
        this.ItemDateFnPipe = ItemDateFnPipe;
        this.baseQeId = 'event-filter-sidebar';
        this.eventByFilterModel = [];
        this.onEventModelChanged = new EventEmitter();
        this.onEventByModelChanged = new EventEmitter();
        this.onFromDatePicked = new EventEmitter();
        this.onToDatePicked = new EventEmitter();
        this.dateFormat = '';
        this.eventFilterExpanded = true;
        this.eventByFilterExpanded = true;
        this.eventDateFilterExpanded = ['eventDatePicker'];
        this.showClearAllButton = false;
        this.clearAllClicked = 0;
        this.eventModel = [
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Accessed')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Created')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Updated')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Moved')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Copied')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Deleted')),
            new FilterCheckBoxOptions(marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Restored')),
        ];
        this.eventByModel = [];
        this.eventDateModel = [];
        this.expandButtonTitle = '';
        this.collapseButtonTitle = '';
        this.selectedEventDateCount = 0;
        this.eventDates = { fromDate: '', toDate: '' };
    }
    setUserLanguage() {
        return __awaiter(this, void 0, void 0, function* () {
            this.userLanguage = yield this.userLanguageService.getUserLanguage();
            this.setDateFormat();
        });
    }
    setDateFormat() {
        var _a, _b;
        this.dateFormat = (_b = (_a = this.ItemDateFnPipe.transform(undefined, this.userLanguage, true)) === null || _a === void 0 ? void 0 : _a.split(' ')[0]) === null || _b === void 0 ? void 0 : _b.toLowerCase();
    }
    expandAll() {
        this.eventFilterExpanded = true;
        this.eventByFilterExpanded = true;
        this.eventDateFilterExpanded = ['eventDatePicker'];
    }
    collapseAll() {
        this.eventFilterExpanded = false;
        this.eventByFilterExpanded = false;
        this.eventDateFilterExpanded = [];
    }
    eventDateClearClicked(event) {
        event.preventDefault();
        event.stopPropagation();
        this.eventDates.fromDate = '';
        this.eventDates.toDate = '';
        this.updateSelectedCount();
        this.onFromDatePicked.emit(this.eventDates);
    }
    fromDateChanged(event) {
        if (event instanceof Date || event === '' || event === null) {
            this.eventDates.fromDate = event;
            this.updateSelectedCount();
            this.onFromDatePicked.emit(this.eventDates);
        }
    }
    toDateChanged(event) {
        if (event instanceof Date || event === '' || event === null) {
            this.eventDates.toDate = event;
            this.updateSelectedCount();
            this.onToDatePicked.emit(this.eventDates);
        }
    }
    updateSelectedCount() {
        this.selectedEventDateCount = this.eventDates.fromDate || this.eventDates.toDate ? 1 : 0;
        this.updateClearAll();
    }
    panelStateChanged($event) {
        switch ($event.panelId) {
            case 'event-filter':
                this.eventFilterExpanded = $event.panelActive;
                break;
            case 'event-by-filter':
                this.eventByFilterExpanded = $event.panelActive;
                break;
            default:
                throw new Error(`Panel with id "${$event.panelId}" doesn't exist on eventFilterSidebar`);
        }
    }
    ngOnInit() {
        this.expandButtonTitle = this.translateService.instant('Blue.DocumentComponents.EventFilterSidebar.ExpandAllFilters');
        this.collapseButtonTitle = this.translateService.instant('Blue.DocumentComponents.EventFilterSidebar.CollapseAllFilters');
        this.eventByModel = this.getEventByModel();
        this.setUserLanguage();
        this.setDateFormat();
    }
    ngAfterViewInit() {
        const expandButton = this.elRef.nativeElement.querySelector('bento-expand-collapse-button-group button:first-child');
        const collapseButton = this.elRef.nativeElement.querySelector('bento-expand-collapse-button-group button:last-child');
        expandButton === null || expandButton === void 0 ? void 0 : expandButton.setAttribute('data-qe-id', buildQeId('expand-button', this.baseQeId));
        collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.setAttribute('data-qe-id', buildQeId('collapse-button', this.baseQeId));
        expandButton === null || expandButton === void 0 ? void 0 : expandButton.setAttribute('aria-label', this.expandButtonTitle.slice(0, -1));
        collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.setAttribute('aria-label', this.collapseButtonTitle.slice(0, -1));
        expandButton === null || expandButton === void 0 ? void 0 : expandButton.setAttribute('title', this.expandButtonTitle);
        collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.setAttribute('title', this.collapseButtonTitle);
        // TODO: This is a temporary solution. It should be removed after Bento tooltip issues are fixed.
        expandButton === null || expandButton === void 0 ? void 0 : expandButton.removeAllListeners('mouseenter');
        expandButton === null || expandButton === void 0 ? void 0 : expandButton.removeAllListeners('focusin');
        collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.removeAllListeners('mouseenter');
        collapseButton === null || collapseButton === void 0 ? void 0 : collapseButton.removeAllListeners('focusin');
    }
    getEventByModel() {
        return this.eventByFilterModel.map(userName => new FilterCheckBoxOptions(userName.name, userName.id));
    }
    updateClearAll() {
        this.showClearAllButton =
            this.eventModel.filter(ele => ele.isChecked).length > 0 ||
                this.eventByModel.filter(ele => ele.isChecked).length > 0 ||
                this.eventDates.fromDate ||
                this.eventDates.toDate;
    }
    itemCountChanged() {
        this.updateClearAll();
        const selectedEventModel = this.eventModel.filter(ele => ele.isChecked).map(ele => ele.checkBoxName);
        const selectedEventByModel = this.eventByModel.filter(ele => ele.isChecked).map(ele => ele.contactId);
        this.onEventModelChanged.emit(selectedEventModel);
        this.onEventByModelChanged.emit(selectedEventByModel);
    }
    clearAll($event) {
        $event.preventDefault();
        this.eventModel.forEach(ele => {
            ele.isChecked = false;
        });
        this.eventByModel.forEach(ele => {
            ele.isChecked = false;
        });
        this.eventDateClearClicked($event);
        this.clearAllClicked++;
    }
}
/** @nocollapse */ EventFilterSidebarComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EventFilterSidebarComponent, deps: [{ token: i0.ElementRef }, { token: i1.TranslateService }, { token: UserLanguageService }, { token: ItemDateFnPipe }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ EventFilterSidebarComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: EventFilterSidebarComponent, selector: "bdc-event-filter-sidebar", inputs: { baseQeId: "baseQeId", eventByFilterModel: "eventByFilterModel" }, outputs: { onEventModelChanged: "onEventModelChanged", onEventByModelChanged: "onEventByModelChanged", onFromDatePicked: "onFromDatePicked", onToDatePicked: "onToDatePicked" }, providers: [ItemDateFnPipe], viewQueries: [{ propertyName: "dueDateInput", first: true, predicate: ["fromDate"], descendants: true }, { propertyName: "expirationDateInput", first: true, predicate: ["toDate"], descendants: true }], ngImport: i0, template: "<div class=\"event-filter-sidebar\">\n\t<div class=\"event-filter-header\">\n\t\t<h2>{{ 'Blue.DocumentComponents.EventFilterSidebar.FilterHeading' | translate }}</h2>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-xs btn-default clear-all-button float-right\"\n\t\t\t(click)=\"clearAll($event)\"\n\t\t\t*ngIf=\"showClearAllButton\"\n\t\t>\n\t\t\t{{ 'Bluemoon.Practice.Common.Actions.ClearAll' | translate }}\n\t\t</button>\n\t\t<bento-expand-collapse-button-group\n\t\t\t(expand)=\"expandAll()\"\n\t\t\t(collapse)=\"collapseAll()\"\n\t\t></bento-expand-collapse-button-group>\n\t</div>\n\t<bdc-multiselect-filter-section\n\t\t[qeId]=\"baseQeId + '-' + 'event'\"\n\t\t[heading]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.Event' | translate\"\n\t\t[model]=\"eventModel\"\n\t\t[allowCollapsing]=\"false\"\n\t\t[collapseCount]=\"0\"\n\t\t[isExpanded]=\"false\"\n\t\t[panelActive]=\"eventFilterExpanded\"\n\t\t[panelId]=\"'event-filter'\"\n\t\t[clearAll]=\"clearAllClicked\"\n\t\t(panelStateChanged)=\"panelStateChanged($event)\"\n\t\t(itemCountChanged)=\"itemCountChanged()\"\n\t></bdc-multiselect-filter-section>\n\t<bdc-multiselect-filter-section\n\t\t[qeId]=\"baseQeId + '-' + 'eventBy'\"\n\t\t[heading]=\"'Blue.DocumentComponents.Grid.Header.Contact' | translate\"\n\t\t[model]=\"eventByModel\"\n\t\t[allowCollapsing]=\"true\"\n\t\t[collapseCount]=\"4\"\n\t\t[isExpanded]=\"false\"\n\t\t[panelActive]=\"eventByFilterExpanded\"\n\t\t[panelId]=\"'event-by-filter'\"\n\t\t(panelStateChanged)=\"panelStateChanged($event)\"\n\t\t[clearAll]=\"clearAllClicked\"\n\t\t(itemCountChanged)=\"itemCountChanged()\"\n\t></bdc-multiselect-filter-section>\n\t<ngb-accordion\n\t\tclass=\"bento-accordion bento-accordion-alternate\"\n\t\tanimation=\"false\"\n\t\t[activeIds]=\"eventDateFilterExpanded\"\n\t>\n\t\t<ngb-panel id=\"eventDatePicker\">\n\t\t\t<ng-template ngbPanelTitle aria-expanded=\"eventDateFilterExpanded\">\n\t\t\t\t<b style=\"font-size: 16px; font-weight: 500\">{{ 'Blue.DocumentComponents.Grid.Header.EventDate' | translate }}</b>\n\t\t\t\t<span class=\"selected-count-badge\" *ngIf=\"selectedEventDateCount > 0\">{{ selectedEventDateCount }}</span>\n\t\t\t\t<a\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\trole=\"button\"\n\t\t\t\t\thref\n\t\t\t\t\tclass=\"btn btn-xs btn-default float-right clear\"\n\t\t\t\t\t*ngIf=\"eventDates.fromDate || eventDates.toDate\"\n\t\t\t\t\t(click)=\"eventDateClearClicked($event)\"\n\t\t\t\t\t(keydown.Space)=\"eventDateClearClicked($event)\"\n\t\t\t\t>\n\t\t\t\t\t{{ 'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n\t\t\t\t</a>\n\t\t\t</ng-template>\n\t\t\t<ng-template ngbPanelContent>\n\t\t\t\t<div class=\"date-picker-filter\" *ngIf=\"dateFormat\">\n\t\t\t\t\t<div class=\"from-date-picker\">\n\t\t\t\t\t\t<bdc-date-input\n\t\t\t\t\t\t\t#fromDate\n\t\t\t\t\t\t\t[label]=\"'Bluemoon.DMS.Grid.Communications.From' | translate\"\n\t\t\t\t\t\t\t[date]=\"eventDates.fromDate\"\n\t\t\t\t\t\t\t[dateFormat]=\"dateFormat\"\n\t\t\t\t\t\t\t[isErrorsToBeShown]=\"false\"\n\t\t\t\t\t\t\t(dateChange)=\"fromDateChanged($event)\"\n\t\t\t\t\t\t></bdc-date-input>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<bdc-date-input\n\t\t\t\t\t\t\t#toDate\n\t\t\t\t\t\t\t[label]=\"'Bluemoon.DMS.Grid.Communications.To' | translate\"\n\t\t\t\t\t\t\t[date]=\"eventDates.toDate\"\n\t\t\t\t\t\t\t[dateFormat]=\"dateFormat\"\n\t\t\t\t\t\t\t[isErrorsToBeShown]=\"false\"\n\t\t\t\t\t\t\t(dateChange)=\"toDateChanged($event)\"\n\t\t\t\t\t\t></bdc-date-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</ngb-panel>\n\t</ngb-accordion>\n</div>\n", styles: ["bdc-event-filter-sidebar .event-filter-header{align-items:center;display:flex;flex-wrap:wrap;justify-content:space-between;padding:0 20px 0 8px}bdc-event-filter-sidebar .event-filter-header bento-expand-collapse-button-group{border:none}bdc-event-filter-sidebar .event-filter-header .bento-expand-divider:before{color:#b2b2b8;vertical-align:middle}bdc-event-filter-sidebar .event-filter-header .btn.btn-outline-primary{background-color:#fff;border-color:#b2b2b8;border-radius:5px}bdc-event-filter-sidebar .event-filter-header .force-desktop .btn.btn-icon.btn-xs [class^=bento-icon-]{line-height:16px}bdc-event-filter-sidebar .event-filter-header i:before{font-size:10px;font-weight:700;text-shadow:0 0 .35px #000}bdc-event-filter-sidebar .event-filter-header .btn.btn-xs.btn-icon{padding:.6rem .45rem!important}bdc-event-filter-sidebar .event-filter-header .btn.btn-xs.btn-icon:hover{background-color:#f4f5f7;border-color:#000}bdc-event-filter-sidebar .event-filter-header .btn.btn-xs.btn-icon:focus{border-color:#606169;box-shadow:0 0 0 .2rem #b2b2b8}bdc-event-filter-sidebar .event-filter-sidebar .event-filter-header h2{font-size:18px}bdc-event-filter-sidebar .event-filter-header .ng-bento .btn-outline-primary{background-color:#fff}bdc-event-filter-sidebar .clear-all-button{background-color:#efefef;border:#666;color:#37383d;font-family:Knowledge Medium;font-size:9px;height:18px;margin-left:auto;min-width:-moz-fit-content!important;min-width:fit-content!important;text-transform:uppercase;width:auto}.clear-all-button:hover{background-color:#fff}bdc-event-filter-sidebar .selected-count-badge{background-color:#000;border-radius:2px;color:#b6b6b6;line-height:1.2em;margin-left:7px;padding:0 6px}@supports (-moz-appearance: none){bdc-event-filter-sidebar .event-filter-header i:before{padding-right:1px}}.card-header{border-bottom:none!important}.from-date-picker{margin-bottom:7px}.date-picker-filter{white-space:nowrap}.ng-bento ngb-datepicker .ngb-dp-day.hidden{display:block!important}\n"], components: [{ type: i2.BentoExpandCollapseButtonGroupComponent, selector: "bento-expand-collapse-button-group", inputs: ["expandAllTitle", "collapseAllTitle"], outputs: ["expand", "collapse"] }, { type: MultiselectFilterSectionComponent, selector: "bdc-multiselect-filter-section", inputs: ["qeId", "allowCollapsing", "collapseCount", "isExpanded", "panelActive", "heading", "model", "panelId", "clearAll"], outputs: ["panelStateChanged", "itemCountChanged"] }, { type: i1$2.NgbAccordion, selector: "ngb-accordion", inputs: ["animation", "activeIds", "closeOthers", "destroyOnHide", "type"], outputs: ["panelChange", "shown", "hidden"], exportAs: ["ngbAccordion"] }, { type: DateInputComponent, selector: "bdc-date-input", inputs: ["qeIdPrefix", "required", "label", "date", "dateFormat", "isErrorsToBeShown", "errors", "errorStrings", "beforeOrAfter", "requiredValidationError", "beforeOrAfterValidationError"], outputs: ["dateChange"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i1$2.NgbPanel, selector: "ngb-panel", inputs: ["disabled", "id", "title", "type", "cardClass"], outputs: ["shown", "hidden"] }, { type: i1$2.NgbPanelTitle, selector: "ng-template[ngbPanelTitle]" }, { type: i1$2.NgbPanelContent, selector: "ng-template[ngbPanelContent]" }], pipes: { "translate": i1.TranslatePipe }, encapsulation: i0.ViewEncapsulation.None });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EventFilterSidebarComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-event-filter-sidebar', encapsulation: ViewEncapsulation.None, providers: [ItemDateFnPipe], template: "<div class=\"event-filter-sidebar\">\n\t<div class=\"event-filter-header\">\n\t\t<h2>{{ 'Blue.DocumentComponents.EventFilterSidebar.FilterHeading' | translate }}</h2>\n\t\t<button\n\t\t\ttype=\"button\"\n\t\t\tclass=\"btn btn-xs btn-default clear-all-button float-right\"\n\t\t\t(click)=\"clearAll($event)\"\n\t\t\t*ngIf=\"showClearAllButton\"\n\t\t>\n\t\t\t{{ 'Bluemoon.Practice.Common.Actions.ClearAll' | translate }}\n\t\t</button>\n\t\t<bento-expand-collapse-button-group\n\t\t\t(expand)=\"expandAll()\"\n\t\t\t(collapse)=\"collapseAll()\"\n\t\t></bento-expand-collapse-button-group>\n\t</div>\n\t<bdc-multiselect-filter-section\n\t\t[qeId]=\"baseQeId + '-' + 'event'\"\n\t\t[heading]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.Event' | translate\"\n\t\t[model]=\"eventModel\"\n\t\t[allowCollapsing]=\"false\"\n\t\t[collapseCount]=\"0\"\n\t\t[isExpanded]=\"false\"\n\t\t[panelActive]=\"eventFilterExpanded\"\n\t\t[panelId]=\"'event-filter'\"\n\t\t[clearAll]=\"clearAllClicked\"\n\t\t(panelStateChanged)=\"panelStateChanged($event)\"\n\t\t(itemCountChanged)=\"itemCountChanged()\"\n\t></bdc-multiselect-filter-section>\n\t<bdc-multiselect-filter-section\n\t\t[qeId]=\"baseQeId + '-' + 'eventBy'\"\n\t\t[heading]=\"'Blue.DocumentComponents.Grid.Header.Contact' | translate\"\n\t\t[model]=\"eventByModel\"\n\t\t[allowCollapsing]=\"true\"\n\t\t[collapseCount]=\"4\"\n\t\t[isExpanded]=\"false\"\n\t\t[panelActive]=\"eventByFilterExpanded\"\n\t\t[panelId]=\"'event-by-filter'\"\n\t\t(panelStateChanged)=\"panelStateChanged($event)\"\n\t\t[clearAll]=\"clearAllClicked\"\n\t\t(itemCountChanged)=\"itemCountChanged()\"\n\t></bdc-multiselect-filter-section>\n\t<ngb-accordion\n\t\tclass=\"bento-accordion bento-accordion-alternate\"\n\t\tanimation=\"false\"\n\t\t[activeIds]=\"eventDateFilterExpanded\"\n\t>\n\t\t<ngb-panel id=\"eventDatePicker\">\n\t\t\t<ng-template ngbPanelTitle aria-expanded=\"eventDateFilterExpanded\">\n\t\t\t\t<b style=\"font-size: 16px; font-weight: 500\">{{ 'Blue.DocumentComponents.Grid.Header.EventDate' | translate }}</b>\n\t\t\t\t<span class=\"selected-count-badge\" *ngIf=\"selectedEventDateCount > 0\">{{ selectedEventDateCount }}</span>\n\t\t\t\t<a\n\t\t\t\t\ttype=\"button\"\n\t\t\t\t\trole=\"button\"\n\t\t\t\t\thref\n\t\t\t\t\tclass=\"btn btn-xs btn-default float-right clear\"\n\t\t\t\t\t*ngIf=\"eventDates.fromDate || eventDates.toDate\"\n\t\t\t\t\t(click)=\"eventDateClearClicked($event)\"\n\t\t\t\t\t(keydown.Space)=\"eventDateClearClicked($event)\"\n\t\t\t\t>\n\t\t\t\t\t{{ 'Bluemoon.Practice.Common.Actions.Clear' | translate }}\n\t\t\t\t</a>\n\t\t\t</ng-template>\n\t\t\t<ng-template ngbPanelContent>\n\t\t\t\t<div class=\"date-picker-filter\" *ngIf=\"dateFormat\">\n\t\t\t\t\t<div class=\"from-date-picker\">\n\t\t\t\t\t\t<bdc-date-input\n\t\t\t\t\t\t\t#fromDate\n\t\t\t\t\t\t\t[label]=\"'Bluemoon.DMS.Grid.Communications.From' | translate\"\n\t\t\t\t\t\t\t[date]=\"eventDates.fromDate\"\n\t\t\t\t\t\t\t[dateFormat]=\"dateFormat\"\n\t\t\t\t\t\t\t[isErrorsToBeShown]=\"false\"\n\t\t\t\t\t\t\t(dateChange)=\"fromDateChanged($event)\"\n\t\t\t\t\t\t></bdc-date-input>\n\t\t\t\t\t</div>\n\t\t\t\t\t<div>\n\t\t\t\t\t\t<bdc-date-input\n\t\t\t\t\t\t\t#toDate\n\t\t\t\t\t\t\t[label]=\"'Bluemoon.DMS.Grid.Communications.To' | translate\"\n\t\t\t\t\t\t\t[date]=\"eventDates.toDate\"\n\t\t\t\t\t\t\t[dateFormat]=\"dateFormat\"\n\t\t\t\t\t\t\t[isErrorsToBeShown]=\"false\"\n\t\t\t\t\t\t\t(dateChange)=\"toDateChanged($event)\"\n\t\t\t\t\t\t></bdc-date-input>\n\t\t\t\t\t</div>\n\t\t\t\t</div>\n\t\t\t</ng-template>\n\t\t</ngb-panel>\n\t</ngb-accordion>\n</div>\n", styles: ["bdc-event-filter-sidebar .event-filter-header{align-items:center;display:flex;flex-wrap:wrap;justify-content:space-between;padding:0 20px 0 8px}bdc-event-filter-sidebar .event-filter-header bento-expand-collapse-button-group{border:none}bdc-event-filter-sidebar .event-filter-header .bento-expand-divider:before{color:#b2b2b8;vertical-align:middle}bdc-event-filter-sidebar .event-filter-header .btn.btn-outline-primary{background-color:#fff;border-color:#b2b2b8;border-radius:5px}bdc-event-filter-sidebar .event-filter-header .force-desktop .btn.btn-icon.btn-xs [class^=bento-icon-]{line-height:16px}bdc-event-filter-sidebar .event-filter-header i:before{font-size:10px;font-weight:700;text-shadow:0 0 .35px #000}bdc-event-filter-sidebar .event-filter-header .btn.btn-xs.btn-icon{padding:.6rem .45rem!important}bdc-event-filter-sidebar .event-filter-header .btn.btn-xs.btn-icon:hover{background-color:#f4f5f7;border-color:#000}bdc-event-filter-sidebar .event-filter-header .btn.btn-xs.btn-icon:focus{border-color:#606169;box-shadow:0 0 0 .2rem #b2b2b8}bdc-event-filter-sidebar .event-filter-sidebar .event-filter-header h2{font-size:18px}bdc-event-filter-sidebar .event-filter-header .ng-bento .btn-outline-primary{background-color:#fff}bdc-event-filter-sidebar .clear-all-button{background-color:#efefef;border:#666;color:#37383d;font-family:Knowledge Medium;font-size:9px;height:18px;margin-left:auto;min-width:-moz-fit-content!important;min-width:fit-content!important;text-transform:uppercase;width:auto}.clear-all-button:hover{background-color:#fff}bdc-event-filter-sidebar .selected-count-badge{background-color:#000;border-radius:2px;color:#b6b6b6;line-height:1.2em;margin-left:7px;padding:0 6px}@supports (-moz-appearance: none){bdc-event-filter-sidebar .event-filter-header i:before{padding-right:1px}}.card-header{border-bottom:none!important}.from-date-picker{margin-bottom:7px}.date-picker-filter{white-space:nowrap}.ng-bento ngb-datepicker .ngb-dp-day.hidden{display:block!important}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1.TranslateService }, { type: UserLanguageService }, { type: ItemDateFnPipe }]; }, propDecorators: { baseQeId: [{
                type: Input
            }], eventByFilterModel: [{
                type: Input
            }], onEventModelChanged: [{
                type: Output
            }], onEventByModelChanged: [{
                type: Output
            }], onFromDatePicked: [{
                type: Output
            }], onToDatePicked: [{
                type: Output
            }], dueDateInput: [{
                type: ViewChild,
                args: ['fromDate']
            }], expirationDateInput: [{
                type: ViewChild,
                args: ['toDate']
            }] } });

const PAGE_SIZE = 50;
const validationDebounce = createDebounce(2000);
class DocumentHistoryModalComponent {
    constructor(elRef, documentService, activeModal, translateService, userLanguageService, modalCloseService) {
        this.elRef = elRef;
        this.documentService = documentService;
        this.activeModal = activeModal;
        this.translateService = translateService;
        this.userLanguageService = userLanguageService;
        this.modalCloseService = modalCloseService;
        this.selectionMode = SelectionMode.None;
        this.dataIsLoading = true;
        this.isLeftOpened = true;
        this.leftWidth = 300;
        this.baseQeId = 'document-history';
        this.buildQeId = buildQeId;
        this.splitterExpandButtonTitle = '';
        this.splitterCollapseButtonTitle = '';
        this.splitterButtonLabel = '';
        this.isBusyLoader = false;
        this.deletedContactLabel = '';
        this.hasMore = false;
        this.eventModel = [];
        this.eventByModel = [];
        this.fromDate = '';
        this.toDate = '';
        this.recentItemVerbTranslations = {
            [RecentItemVerb.Accessed]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Accessed'),
            [RecentItemVerb.Created]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Created'),
            [RecentItemVerb.Updated]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Updated'),
            [RecentItemVerb.Moved]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Moved'),
            [RecentItemVerb.Copied]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Copied'),
            [RecentItemVerb.Linked]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Linked'),
            [RecentItemVerb.Trashed]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Deleted'),
            [RecentItemVerb.Restored]: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Restored'),
            Deleted: marker('Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Deleted'),
        };
        this.documentService = documentService;
    }
    escPressHandler() {
        this.activeModal.close();
    }
    ngOnInit() {
        this.initialGetDocumentAuditEvents();
        this.setUserLanguage();
        this.modalCloseService.subscribeOnBack(() => this.activeModal.close('cancel'));
        this.splitterExpandButtonTitle = this.translateService.instant('Blue.DocumentComponents.DocumentHistory.SplitterExpandButtonTitle');
        this.splitterCollapseButtonTitle = this.translateService.instant('Blue.DocumentComponents.DocumentHistory.SplitterCollapseButtonTitle');
        this.splitterButtonLabel = this.translateService.instant('Blue.DocumentComponents.DocumentHistory.SplitterButtonLabel');
        this.deletedContactLabel = this.translateService.instant('Bluemoon.DMS.RecentsGrid.DeletedContact');
    }
    ngAfterViewInit() {
        if (this.showFilter) {
            const splitterButton = this.elRef.nativeElement.querySelector('.bento-splitter-toggle');
            const historyModal = document.querySelector('.modal-content');
            const documentHistoryModal = this;
            splitterButton.setAttribute('title', this.splitterCollapseButtonTitle);
            splitterButton.setAttribute('aria-label', this.splitterButtonLabel);
            splitterButton.setAttribute('data-qe-id', buildQeId('splitter-button', this.baseQeId));
            splitterButton.addEventListener('click', function () {
                documentHistoryModal.setAttributesToSplitterButton(splitterButton);
            });
            historyModal.setAttribute('style', 'width: 950px;');
            // TODO: This is a temporary solution. It should be removed after Bento tooltip issues are fixed.
            splitterButton.removeAllListeners('mouseenter');
            splitterButton.removeAllListeners('focusin');
        }
    }
    triggerEventsFilter(eventDates) {
        return __awaiter(this, void 0, void 0, function* () {
            this.fromDate = eventDates.fromDate ? eventDates.fromDate.toISOString().split('T')[0] : '';
            this.toDate = eventDates.toDate ? eventDates.toDate.toISOString().split('T')[0] : '';
            yield validationDebounce(() => {
                this.initialGetDocumentAuditEvents(this.eventModel, this.eventByModel, this.fromDate, this.toDate);
            });
        });
    }
    triggerEventModelFilter(eventModels) {
        return __awaiter(this, void 0, void 0, function* () {
            this.eventModel = eventModels.map(ele => this.getEventDocumentTypes(ele));
            yield validationDebounce(() => {
                this.initialGetDocumentAuditEvents(this.eventModel, this.eventByModel, this.fromDate, this.toDate);
            });
        });
    }
    triggerEventByModelFilter(eventByModel) {
        return __awaiter(this, void 0, void 0, function* () {
            this.eventByModel = eventByModel;
            yield validationDebounce(() => {
                this.initialGetDocumentAuditEvents(this.eventModel, this.eventByModel, this.fromDate, this.toDate);
            });
        });
    }
    initializeGrid(flex) {
        flex.scrollPositionChanged.addHandler((wjcGrid) => {
            // if we're close to the bottom, add 50 items
            if (wjcGrid.viewRange.bottomRow >= wjcGrid.rows.length - 20) {
                const view = wjcGrid.collectionView;
                if (this.documentAuditEvents && this.hasMore && !this.dataIsLoading) {
                    this.addData(view, this.documentAuditEvents, this.eventModel, this.eventByModel, this.fromDate, this.toDate);
                }
            }
        });
    }
    getEvent(item) {
        if (item.verb) {
            return this.translateService.get(this.recentItemVerbTranslations[item.verb]);
        }
        return of('');
    }
    setUserLanguage() {
        return __awaiter(this, void 0, void 0, function* () {
            this.userLanguage = yield this.userLanguageService.getUserLanguage();
        });
    }
    initialGetDocumentAuditEvents(eventParams = [], eventByParams = [], fromDate = '', toDate = '') {
        return __awaiter(this, void 0, void 0, function* () {
            this.page = 1;
            const documentAuditParams = Page.fromPageNumber(this.page, PAGE_SIZE);
            this.isBusyLoader = true;
            const auditEvents = yield this.documentService.getDocumentAuditEventsAsync(this.selectedDocumentId, documentAuditParams, eventParams, eventByParams, fromDate, toDate);
            this.documentAuditEvents = auditEvents.items;
            this.hasMore = auditEvents.hasMore;
            this.isBusyLoader = false;
            this.dataIsLoading = false;
        });
    }
    getContactName(name) {
        return !name || name.trim() === '' ? this.deletedContactLabel : name;
    }
    addData(view, data, eventParams = [], eventByParams = [], fromDate = '', toDate = '') {
        return __awaiter(this, void 0, void 0, function* () {
            this.page = this.page ? this.page + 1 : 1;
            const documentAuditParams = Page.fromPageNumber(this.page, PAGE_SIZE);
            this.dataIsLoading = true;
            const items = yield this.documentService.getDocumentAuditEventsAsync(this.selectedDocumentId, documentAuditParams, eventParams, eventByParams, fromDate, toDate);
            this.hasMore = items.hasMore;
            for (const item of items.items) {
                data.push(item);
            }
            this.dataIsLoading = false;
            view.refresh();
        });
    }
    setAttributesToSplitterButton(splitterButton) {
        splitterButton.setAttribute('aria-label', this.splitterButtonLabel);
        if (splitterButton.getAttribute('aria-expanded') === 'true') {
            splitterButton.setAttribute('title', this.splitterCollapseButtonTitle);
        }
        else {
            splitterButton.setAttribute('title', this.splitterExpandButtonTitle);
        }
    }
    getEventDocumentTypes(eventType) {
        switch (eventType) {
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Accessed':
                return DocumentEventTypes.Accessed;
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Created':
                return DocumentEventTypes.Created;
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Updated':
                return DocumentEventTypes.Updated;
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Moved':
                return DocumentEventTypes.Moved;
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Copied':
                return DocumentEventTypes.Copied;
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Deleted':
                return DocumentEventTypes.Trashed;
            case 'Blue.DocumentComponents.AllDocumentsPaneFilter.EventPlaceholder.Restored':
                return DocumentEventTypes.Restored;
            default:
                throw new Error(`Invalid event type specified: ${eventType}`);
        }
    }
}
/** @nocollapse */ DocumentHistoryModalComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryModalComponent, deps: [{ token: i0.ElementRef }, { token: i1$1.DocumentService }, { token: i1$2.NgbActiveModal }, { token: i1.TranslateService }, { token: UserLanguageService }, { token: ModalCloseService }], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ DocumentHistoryModalComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: DocumentHistoryModalComponent, selector: "bdc-document-history-modal", inputs: { selectedDocumentId: "selectedDocumentId", selectedDocumentName: "selectedDocumentName", showFilter: "showFilter", allUsersList: "allUsersList" }, host: { listeners: { "document:keydown.escape": "escPressHandler()" } }, ngImport: i0, template: "<div class=\"document-history-container\">\n\t<div class=\"modal-header document-history-header\">\n\t\t<div class=\"document-name\">\n\t\t\t<h1 class=\"modal-title\">\n\t\t\t\t{{ 'Blue.DocumentComponents.DocumentHistory.HistoryHeader' | translate }}: {{ selectedDocumentName }}\n\t\t\t</h1>\n\t\t</div>\n\t\t<div class=\"modal-close-icon\">\n\t\t\t<button\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"close\"\n\t\t\t\taria-label=\"close\"\n\t\t\t\t(click)=\"activeModal.close()\"\n\t\t\t\t[attr.data-qe-id]=\"buildQeId('close-icon', baseQeId)\"\n\t\t\t>\n\t\t\t\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<div class=\"card mb-3\">\n\t\t<div class=\"card-body all-documents-overall\">\n\t\t\t<bento-splitter-group [(leftOpened)]=\"isLeftOpened\" [(leftWidth)]=\"leftWidth\">\n\t\t\t\t<bento-splitter-group-left *ngIf=\"showFilter\">\n\t\t\t\t\t<bdc-event-filter-sidebar\n\t\t\t\t\t\t[baseQeId]=\"baseQeId\"\n\t\t\t\t\t\t[eventByFilterModel]=\"allUsersList\"\n\t\t\t\t\t\t(onEventModelChanged)=\"triggerEventModelFilter($event)\"\n\t\t\t\t\t\t(onEventByModelChanged)=\"triggerEventByModelFilter($event)\"\n\t\t\t\t\t\t(onFromDatePicked)=\"triggerEventsFilter($event)\"\n\t\t\t\t\t\t(onToDatePicked)=\"triggerEventsFilter($event)\"\n\t\t\t\t\t></bdc-event-filter-sidebar>\n\t\t\t\t</bento-splitter-group-left>\n\t\t\t\t<bento-splitter-group-main>\n\t\t\t\t\t<div class=\"document-history-container-content\">\n\t\t\t\t\t\t<wj-flex-grid\n\t\t\t\t\t\t\t#flex\n\t\t\t\t\t\t\tclass=\"bdc-wijmo-history-grid\"\n\t\t\t\t\t\t\t[headersVisibility]=\"'Column'\"\n\t\t\t\t\t\t\t(initialized)=\"initializeGrid(flex)\"\n\t\t\t\t\t\t\t[(itemsSource)]=\"documentAuditEvents\"\n\t\t\t\t\t\t\t[selectionMode]=\"selectionMode\"\n\t\t\t\t\t\t\t[allowSorting]=\"'None'\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t\t\t\t[header]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.Event' | translate\"\n\t\t\t\t\t\t\t\t[binding]=\"'verb'\"\n\t\t\t\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t\t\t\t\t\t{{ getEvent(cell.item) | async }}\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Contact' | translate\"\n\t\t\t\t\t\t\t\t[binding]=\"'contactDisplayName'\"\n\t\t\t\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t\t\t\t\t\t{{ getContactName(cell.item.contactDisplayName) }}\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.EventDate' | translate\"\n\t\t\t\t\t\t\t\t[binding]=\"'eventTimestamp'\"\n\t\t\t\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t\t\t\t\t\t{{ cell.item.eventTimestamp | bdcDateFn: userLanguage }}\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</wj-flex-grid-column>\n\t\t\t\t\t\t</wj-flex-grid>\n\t\t\t\t\t</div>\n\t\t\t\t</bento-splitter-group-main>\n\t\t\t</bento-splitter-group>\n\t\t</div>\n\t</div>\n\t<div [bentoBusyLoader]=\"isBusyLoader\" [size]=\"'sm'\" class=\"document-history-loader\"></div>\n\n\t<div class=\"modal-footer document-history-modal-footer close-button\">\n\t\t<button\n\t\t\tclass=\"btn btn-primary close-button\"\n\t\t\t(click)=\"activeModal.close()\"\n\t\t\t[attr.data-qe-id]=\"buildQeId('close-button', baseQeId)\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Button.Close' | translate }}\n\t\t</button>\n\t</div>\n</div>\n", styles: [".document-history-container .document-history-header{border-bottom-color:#fff;height:48px;justify-content:space-between}.document-history-container .modal-footer.document-history-modal-footer.close-button{border-top-color:#939393;display:flex;height:64px;margin-top:40px;padding:10px 0 0!important}.document-history-container .document-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.document-history-container .modal-title{color:#1f1f1f;font-family:KnowledgeRegular;font-size:26px;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.document-history-container .bento-icon-close-x{font-family:bento-icomoon}.document-history-container .close{font-size:17px;padding-right:16px}.document-history-container .btn.btn-primary.close-button{font-size:14px;height:30px;margin:0}.document-history-container .document-history-loader{margin-top:-3px;position:absolute;right:50%}.document-history-container .bento-busyloader-front-blocker{opacity:0}.document-history-container .wj-flexgrid{height:500px}::ng-deep .document-history-container .bdc-wijmo-history-grid.wj-flexgrid .wj-cell.wj-header{background:#fff;color:#212121;font-family:Arial,Helvetica,sans-serif;font-size:13px;height:40px!important;padding:10px}::ng-deep .document-history-container .bdc-wijmo-history-grid.wj-flexgrid .wj-cell.wj-alt{background:#fff}:host ::ng-deep div .wj-colheaders{height:40px}:host ::ng-deep [wj-part=ch]{height:40px!important}:host ::ng-deep .wj-cells{top:40px!important}:host ::ng-deep .wj-row .wj-cell div{padding-left:4px}:host ::ng-deep .wj-content{border:none}.all-documents-overall{height:500px;position:relative;width:100%}bento-expand-collapse-button-group{border-style:none}:host ::ng-deep .card .card-body .bento-splitter-group-main>.bento-splitter-group-inner{overflow:hidden}:host ::ng-deep .btn .toggle-button,:host ::ng-deep .btn.btn-icon.bento-splitter-decrease,:host ::ng-deep .btn.btn-icon.bento-splitter-increase,:host ::ng-deep .btn.btn-icon i.bento-icon-double-caret-left-filled,:host ::ng-deep [wj-part=focus]{display:none}:host ::ng-deep .card .card-body .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{background:#fff}:host ::ng-deep .card .bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left>.btn.btn-icon{background:url('data:image/svg+xml;charset=UTF-8, \t<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 13 73\" enable-background=\"new 0 0 13 73\" xml:space=\"preserve\"><g><g><path d=\"M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 C0,61.9,0,58.6,5.4,57.3z\"></path><path d=\"M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 C0,58.9,0,56.9,4.8,55.8z\"></path></g><polygon fill=\"white\" points=\"3,32.4 8.3,36.5 3,40.6\"></polygon></g></svg>') no-repeat;border:none;height:65px}:host ::ng-deep .bento-splitter-toggle:hover{opacity:.7}:host ::ng-deep .opened-left .bento-splitter-toggle{transform:rotate(180deg)}:host ::ng-deep .btn.btn-outline-primary.btn-icon.bento-splitter-toggle.btn-sm{padding:0!important}:host ::ng-deep .splitter-group-handle-triangle{fill:#fff}:host ::ng-deep .card .card-body .btn.btn-icon.bento-splitter-toggle:focus{box-shadow:none;opacity:.7}:host ::ng-deep .card .card-body .bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left{width:14px}:host ::ng-deep .accordion.bento-accordion .card .card-body{padding-top:5px}:host ::ng-deep .card-body .bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner{right:13px}.modal-close-icon .close{height:58px;margin-right:-16px;margin-top:-16px;width:58px}button.close:focus{outline:1px dotted #000}::ng-deep .document-history-container .card{border-color:#d1d1d4}:host ::ng-deep .btn.btn-icon.bento-splitter-dragdrop.btn-sm{display:none}:host ::ng-deep .modal-header.document-history-header:before,.modal-header.document-history-header:after{content:none}\n"], components: [{ type: i2.BentoSplitterGroupComponent, selector: "bento-splitter-group", inputs: ["autoResize", "resizeStepSize", "noCollapse", "leftWidth", "leftMaxWidth", "leftOpened", "rightWidth", "rightMaxWidth", "rightOpened", "topHeight", "topMaxHeight", "topOpened", "bottomHeight", "bottomMaxHeight", "bottomOpened"], outputs: ["leftWidthChange", "leftOpenedChange", "rightWidthChange", "rightOpenedChange", "topHeightChange", "topOpenedChange", "bottomHeightChange", "bottomOpenedChange"] }, { type: i2.BentoSplitterGroupLeftComponent, selector: "bento-splitter-group-left" }, { type: EventFilterSidebarComponent, selector: "bdc-event-filter-sidebar", inputs: ["baseQeId", "eventByFilterModel"], outputs: ["onEventModelChanged", "onEventByModelChanged", "onFromDatePicked", "onToDatePicked"] }, { type: i2.BentoSplitterGroupMainComponent, selector: "bento-splitter-group-main" }, { type: i5$1.WjFlexGrid, selector: "wj-flex-grid", inputs: ["wjModelProperty", "isDisabled", "newRowAtTop", "allowAddNew", "allowDelete", "allowDragging", "allowMerging", "allowResizing", "allowSorting", "allowPinning", "autoScroll", "autoRowHeights", "autoSizeMode", "autoGenerateColumns", "autoSearch", "caseSensitiveSearch", "quickAutoSize", "bigCheckboxes", "childItemsPath", "groupHeaderFormat", "headersVisibility", "showSelectedHeaders", "showMarquee", "showPlaceholders", "itemFormatter", "isReadOnly", "imeEnabled", "mergeManager", "selectionMode", "showGroups", "showSort", "showDropDown", "showAlternatingRows", "showErrors", "alternatingRowStep", "itemValidator", "validateEdits", "treeIndent", "itemsSource", "autoClipboard", "expandSelectionOnCopyPaste", "frozenRows", "frozenColumns", "cloneFrozenCells", "deferResizing", "sortRowIndex", "editColumnIndex", "stickyHeaders", "preserveSelectedState", "preserveOutlineState", "preserveWhiteSpace", "keyActionTab", "keyActionEnter", "rowHeaderPath", "virtualizationThreshold", "anchorCursor", "lazyRender", "refreshOnEdit", "copyHeaders", "columnGroups"], outputs: ["initialized", "gotFocus", "lostFocus", "refreshing", "refreshed", "invalidInput", "beginningEdit", "cellEditEnded", "cellEditEnding", "prepareCellForEdit", "formatItem", "resizingColumn", "resizedColumn", "autoSizingColumn", "autoSizedColumn", "draggingColumn", "draggingColumnOver", "draggedColumn", "sortingColumn", "sortedColumn", "pinningColumn", "pinnedColumn", "resizingRow", "resizedRow", "autoSizingRow", "autoSizedRow", "draggingRow", "draggingRowOver", "draggedRow", "deletingRow", "deletedRow", "loadingRows", "loadedRows", "rowEditStarting", "rowEditStarted", "rowEditEnding", "rowEditEnded", "rowAdded", "groupCollapsedChanging", "groupCollapsedChanged", "itemsSourceChanging", "itemsSourceChanged", "selectionChanging", "selectionChanged", "scrollPositionChanged", "updatingView", "updatedView", "updatingLayout", "updatedLayout", "pasting", "pasted", "pastingCell", "pastedCell", "copying", "copied"] }, { type: i5$1.WjFlexGridColumn, selector: "wj-flex-grid-column", inputs: ["asyncBindings", "wjProperty", "name", "dataMap", "dataType", "binding", "sortMemberPath", "format", "cellTemplate", "header", "width", "maxLength", "minWidth", "maxWidth", "align", "allowDragging", "allowSorting", "allowResizing", "allowMerging", "aggregate", "isReadOnly", "cssClass", "isContentHtml", "isSelected", "visible", "wordWrap", "multiLine", "mask", "inputType", "isRequired", "showDropDown", "dataMapEditor", "dropDownCssClass", "quickAutoSize", "editor"], outputs: ["initialized", "isSelectedChange"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }, { type: i5$1.WjFlexGridCellTemplate, selector: "[wjFlexGridCellTemplate]", inputs: ["wjFlexGridCellTemplate", "cellType", "cellOverflow", "valuePaths", "autoSizeRows", "forceFullEdit"], exportAs: ["wjFlexGridCellTemplate"] }, { type: i2.BentoBusyLoaderDirective, selector: "[bentoBusyLoader]", inputs: ["bentoBusyLoader", "size", "showDelay", "hideDelay"], outputs: ["show", "hide"] }], pipes: { "translate": i1.TranslatePipe, "async": i2$1.AsyncPipe, "bdcDateFn": ItemDateFnPipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryModalComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-document-history-modal', template: "<div class=\"document-history-container\">\n\t<div class=\"modal-header document-history-header\">\n\t\t<div class=\"document-name\">\n\t\t\t<h1 class=\"modal-title\">\n\t\t\t\t{{ 'Blue.DocumentComponents.DocumentHistory.HistoryHeader' | translate }}: {{ selectedDocumentName }}\n\t\t\t</h1>\n\t\t</div>\n\t\t<div class=\"modal-close-icon\">\n\t\t\t<button\n\t\t\t\ttype=\"button\"\n\t\t\t\tclass=\"close\"\n\t\t\t\taria-label=\"close\"\n\t\t\t\t(click)=\"activeModal.close()\"\n\t\t\t\t[attr.data-qe-id]=\"buildQeId('close-icon', baseQeId)\"\n\t\t\t>\n\t\t\t\t<i class=\"bento-icon-close-x\" aria-hidden=\"true\"></i>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n\t<div class=\"card mb-3\">\n\t\t<div class=\"card-body all-documents-overall\">\n\t\t\t<bento-splitter-group [(leftOpened)]=\"isLeftOpened\" [(leftWidth)]=\"leftWidth\">\n\t\t\t\t<bento-splitter-group-left *ngIf=\"showFilter\">\n\t\t\t\t\t<bdc-event-filter-sidebar\n\t\t\t\t\t\t[baseQeId]=\"baseQeId\"\n\t\t\t\t\t\t[eventByFilterModel]=\"allUsersList\"\n\t\t\t\t\t\t(onEventModelChanged)=\"triggerEventModelFilter($event)\"\n\t\t\t\t\t\t(onEventByModelChanged)=\"triggerEventByModelFilter($event)\"\n\t\t\t\t\t\t(onFromDatePicked)=\"triggerEventsFilter($event)\"\n\t\t\t\t\t\t(onToDatePicked)=\"triggerEventsFilter($event)\"\n\t\t\t\t\t></bdc-event-filter-sidebar>\n\t\t\t\t</bento-splitter-group-left>\n\t\t\t\t<bento-splitter-group-main>\n\t\t\t\t\t<div class=\"document-history-container-content\">\n\t\t\t\t\t\t<wj-flex-grid\n\t\t\t\t\t\t\t#flex\n\t\t\t\t\t\t\tclass=\"bdc-wijmo-history-grid\"\n\t\t\t\t\t\t\t[headersVisibility]=\"'Column'\"\n\t\t\t\t\t\t\t(initialized)=\"initializeGrid(flex)\"\n\t\t\t\t\t\t\t[(itemsSource)]=\"documentAuditEvents\"\n\t\t\t\t\t\t\t[selectionMode]=\"selectionMode\"\n\t\t\t\t\t\t\t[allowSorting]=\"'None'\"\n\t\t\t\t\t\t>\n\t\t\t\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t\t\t\t[header]=\"'Blue.DocumentComponents.AllDocumentsPaneFilter.Event' | translate\"\n\t\t\t\t\t\t\t\t[binding]=\"'verb'\"\n\t\t\t\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t\t\t\t\t\t{{ getEvent(cell.item) | async }}\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.Contact' | translate\"\n\t\t\t\t\t\t\t\t[binding]=\"'contactDisplayName'\"\n\t\t\t\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t\t\t\t\t\t{{ getContactName(cell.item.contactDisplayName) }}\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</wj-flex-grid-column>\n\n\t\t\t\t\t\t\t<wj-flex-grid-column\n\t\t\t\t\t\t\t\t[header]=\"'Blue.DocumentComponents.Grid.Header.EventDate' | translate\"\n\t\t\t\t\t\t\t\t[binding]=\"'eventTimestamp'\"\n\t\t\t\t\t\t\t\t[width]=\"'*'\"\n\t\t\t\t\t\t\t\t[isReadOnly]=\"true\"\n\t\t\t\t\t\t\t>\n\t\t\t\t\t\t\t\t<ng-template wjFlexGridCellTemplate [cellType]=\"'Cell'\" let-cell=\"cell\">\n\t\t\t\t\t\t\t\t\t{{ cell.item.eventTimestamp | bdcDateFn: userLanguage }}\n\t\t\t\t\t\t\t\t</ng-template>\n\t\t\t\t\t\t\t</wj-flex-grid-column>\n\t\t\t\t\t\t</wj-flex-grid>\n\t\t\t\t\t</div>\n\t\t\t\t</bento-splitter-group-main>\n\t\t\t</bento-splitter-group>\n\t\t</div>\n\t</div>\n\t<div [bentoBusyLoader]=\"isBusyLoader\" [size]=\"'sm'\" class=\"document-history-loader\"></div>\n\n\t<div class=\"modal-footer document-history-modal-footer close-button\">\n\t\t<button\n\t\t\tclass=\"btn btn-primary close-button\"\n\t\t\t(click)=\"activeModal.close()\"\n\t\t\t[attr.data-qe-id]=\"buildQeId('close-button', baseQeId)\"\n\t\t>\n\t\t\t{{ 'Blue.DocumentComponents.Button.Close' | translate }}\n\t\t</button>\n\t</div>\n</div>\n", styles: [".document-history-container .document-history-header{border-bottom-color:#fff;height:48px;justify-content:space-between}.document-history-container .modal-footer.document-history-modal-footer.close-button{border-top-color:#939393;display:flex;height:64px;margin-top:40px;padding:10px 0 0!important}.document-history-container .document-name{overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.document-history-container .modal-title{color:#1f1f1f;font-family:KnowledgeRegular;font-size:26px;margin:0;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.document-history-container .bento-icon-close-x{font-family:bento-icomoon}.document-history-container .close{font-size:17px;padding-right:16px}.document-history-container .btn.btn-primary.close-button{font-size:14px;height:30px;margin:0}.document-history-container .document-history-loader{margin-top:-3px;position:absolute;right:50%}.document-history-container .bento-busyloader-front-blocker{opacity:0}.document-history-container .wj-flexgrid{height:500px}::ng-deep .document-history-container .bdc-wijmo-history-grid.wj-flexgrid .wj-cell.wj-header{background:#fff;color:#212121;font-family:Arial,Helvetica,sans-serif;font-size:13px;height:40px!important;padding:10px}::ng-deep .document-history-container .bdc-wijmo-history-grid.wj-flexgrid .wj-cell.wj-alt{background:#fff}:host ::ng-deep div .wj-colheaders{height:40px}:host ::ng-deep [wj-part=ch]{height:40px!important}:host ::ng-deep .wj-cells{top:40px!important}:host ::ng-deep .wj-row .wj-cell div{padding-left:4px}:host ::ng-deep .wj-content{border:none}.all-documents-overall{height:500px;position:relative;width:100%}bento-expand-collapse-button-group{border-style:none}:host ::ng-deep .card .card-body .bento-splitter-group-main>.bento-splitter-group-inner{overflow:hidden}:host ::ng-deep .btn .toggle-button,:host ::ng-deep .btn.btn-icon.bento-splitter-decrease,:host ::ng-deep .btn.btn-icon.bento-splitter-increase,:host ::ng-deep .btn.btn-icon i.bento-icon-double-caret-left-filled,:host ::ng-deep [wj-part=focus]{display:none}:host ::ng-deep .card .card-body .bento-splitter-group>.bento-splitter-group-panel>.bento-splitter-handle{background:#fff}:host ::ng-deep .card .bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left>.btn.btn-icon{background:url('data:image/svg+xml;charset=UTF-8, \t<svg version=\"1.1\" id=\"Layer_1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 13 73\" enable-background=\"new 0 0 13 73\" xml:space=\"preserve\"><g><g><path d=\"M5.4,57.3c6.1-1.4,5.6-8.9,5.6-8.9V36.5V24.6c0,0,0.5-7.5-5.6-8.9C0,14.3,0,11,0,11v25.5V62 C0,61.9,0,58.6,5.4,57.3z\"></path><path d=\"M4.8,55.8c5.3-1.3,4.8-7.1,4.8-7.1V36.5V24.4c0,0,0.5-5.9-4.8-7.1C0,16.1,0,13.9,0,13.9v22.6v22.4 C0,58.9,0,56.9,4.8,55.8z\"></path></g><polygon fill=\"white\" points=\"3,32.4 8.3,36.5 3,40.6\"></polygon></g></svg>') no-repeat;border:none;height:65px}:host ::ng-deep .bento-splitter-toggle:hover{opacity:.7}:host ::ng-deep .opened-left .bento-splitter-toggle{transform:rotate(180deg)}:host ::ng-deep .btn.btn-outline-primary.btn-icon.bento-splitter-toggle.btn-sm{padding:0!important}:host ::ng-deep .splitter-group-handle-triangle{fill:#fff}:host ::ng-deep .card .card-body .btn.btn-icon.bento-splitter-toggle:focus{box-shadow:none;opacity:.7}:host ::ng-deep .card .card-body .bento-splitter-group-panel>.bento-splitter-handle.bento-splitter-handle-left{width:14px}:host ::ng-deep .accordion.bento-accordion .card .card-body{padding-top:5px}:host ::ng-deep .card-body .bento-splitter-group .bento-splitter-group-left>.bento-splitter-group-inner{right:13px}.modal-close-icon .close{height:58px;margin-right:-16px;margin-top:-16px;width:58px}button.close:focus{outline:1px dotted #000}::ng-deep .document-history-container .card{border-color:#d1d1d4}:host ::ng-deep .btn.btn-icon.bento-splitter-dragdrop.btn-sm{display:none}:host ::ng-deep .modal-header.document-history-header:before,.modal-header.document-history-header:after{content:none}\n"] }]
        }], ctorParameters: function () { return [{ type: i0.ElementRef }, { type: i1$1.DocumentService }, { type: i1$2.NgbActiveModal }, { type: i1.TranslateService }, { type: UserLanguageService }, { type: ModalCloseService }]; }, propDecorators: { selectedDocumentId: [{
                type: Input
            }], selectedDocumentName: [{
                type: Input
            }], showFilter: [{
                type: Input
            }], allUsersList: [{
                type: Input
            }], escPressHandler: [{
                type: HostListener,
                args: ['document:keydown.escape']
            }] } });

class EventFilterSidebarModule {
}
/** @nocollapse */ EventFilterSidebarModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EventFilterSidebarModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ EventFilterSidebarModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EventFilterSidebarModule, declarations: [EventFilterSidebarComponent], imports: [CommonModule, i1.TranslateModule, BentoExpandCollapseButtonGroupModule,
        MultiselectFilterSectionModule,
        AllDocumentsPaneModule,
        DateInputModule,
        NgbAccordionModule], exports: [EventFilterSidebarComponent] });
/** @nocollapse */ EventFilterSidebarModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EventFilterSidebarModule, imports: [[
            CommonModule,
            TranslateModule.forChild(),
            BentoExpandCollapseButtonGroupModule,
            MultiselectFilterSectionModule,
            AllDocumentsPaneModule,
            DateInputModule,
            NgbAccordionModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EventFilterSidebarModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [EventFilterSidebarComponent],
                    imports: [
                        CommonModule,
                        TranslateModule.forChild(),
                        BentoExpandCollapseButtonGroupModule,
                        MultiselectFilterSectionModule,
                        AllDocumentsPaneModule,
                        DateInputModule,
                        NgbAccordionModule,
                    ],
                    exports: [EventFilterSidebarComponent],
                }]
        }] });

class DocumentHistoryModule {
}
/** @nocollapse */ DocumentHistoryModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentHistoryModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryModule, declarations: [DocumentHistoryModalComponent], imports: [WjGridModule,
        WjInputModule,
        BrowserModule, i1.TranslateModule, DocumentGridModule,
        BentoBusyLoaderModule,
        EventFilterSidebarModule,
        BentoSplitterGroupModule], exports: [DocumentHistoryModalComponent] });
/** @nocollapse */ DocumentHistoryModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryModule, imports: [[
            WjGridModule,
            WjInputModule,
            BrowserModule,
            TranslateModule.forChild(),
            DocumentGridModule,
            BentoBusyLoaderModule,
            EventFilterSidebarModule,
            BentoSplitterGroupModule,
        ]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryModule, decorators: [{
            type: NgModule,
            args: [{
                    imports: [
                        WjGridModule,
                        WjInputModule,
                        BrowserModule,
                        TranslateModule.forChild(),
                        DocumentGridModule,
                        BentoBusyLoaderModule,
                        EventFilterSidebarModule,
                        BentoSplitterGroupModule,
                    ],
                    declarations: [DocumentHistoryModalComponent],
                    exports: [DocumentHistoryModalComponent],
                }]
        }] });

class SubRequestComponent {
    constructor() {
        /** boolean telling whether to show the communication status dropdown */
        this.showStatusDropdown = true;
        /** boolean telling whether to disable the communication status dropdown */
        this.disableStatusDropdown = false;
        /** boolean telling whether to disable the description field */
        this.disableDescriptionField = false;
        /** boolean telling whether to show the remove link */
        this.showRemoveLink = true;
        /** An event that emits the changes in subrequest  */
        this.subRequestChange = new EventEmitter();
        /** An event that indicates that the sub request is to be removed. */
        this.subRequestRemove = new EventEmitter();
    }
    /** Emits SubRequestRemove when the remove link is clicked */
    remove() {
        this.subRequestRemove.emit(this.subRequest);
    }
    /** Tells whether to disable the remove link */
    disableInputs() {
        if (this.statusDropdown) {
            return (this.statusDropdown.selectedStatus === CommunicationDisplayStatus.Completed ||
                this.statusDropdown.selectedStatus === CommunicationDisplayStatus.Canceled);
        }
        return false;
    }
    /** Emits SubRequestChange whenever the sub request is updated */
    update(arg) {
        var _a;
        if (arg === void 0) { arg = (_a = this.subRequest) === null || _a === void 0 ? void 0 : _a.details; }
        const result = this.cloneSubRequest(arg);
        if (result) {
            this.subRequestChange.emit(result);
        }
    }
    cloneSubRequest(arg) {
        let newSubRequest;
        if (this.subRequest) {
            newSubRequest = new CommunicationSubRequest(this.subRequest.documents, this.subRequest.type, this.subRequest.containerKey, this.statusDropdown ? this.statusDropdown.selectedStatus : CommunicationDisplayStatus.WaitingOnClient, this.subRequest.id, this.subRequest.requestId, this.subRequest.recipients, arg, this.subRequest.receivedDate, this.subRequest.status, this.subRequest.comments, this.subRequest.changedDate, this.subRequest.updateToken, this.subRequest.order);
        }
        return newSubRequest;
    }
    /** Returns data-qe-id for user interactive element */
    getQeId(qeId) {
        return 'dms-fe-component-sub-request' + (this.baseQeId ? '-' + this.baseQeId : '') + '-' + qeId;
    }
}
/** @nocollapse */ SubRequestComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SubRequestComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SubRequestComponent, selector: "bdc-sub-request", inputs: { subRequest: "subRequest", showStatusDropdown: "showStatusDropdown", disableStatusDropdown: "disableStatusDropdown", disableDescriptionField: "disableDescriptionField", showRemoveLink: "showRemoveLink", baseQeId: "baseQeId" }, outputs: { subRequestChange: "subRequestChange", subRequestRemove: "subRequestRemove" }, viewQueries: [{ propertyName: "statusDropdown", first: true, predicate: CommunicationStatusDropdownComponent, descendants: true }], ngImport: i0, template: "<div class=\"dms-sub-request col-sm-10 col-md-10 col-lg-10\">\n\t<fieldset class=\"well\">\n\t\t<div class=\"row\">\n\t\t\t<!-- Subrequest text input -->\n\t\t\t<div class=\"col-sm-8 col-md-8 col-lg-8\">\n\t\t\t\t<textarea\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tmaxlength=\"2500\"\n\t\t\t\t\t[disabled]=\"disableDescriptionField || disableInputs()\"\n\t\t\t\t\tplaceholder=\"{{'Blue.DocumentComponents.DocumentRequests.RequestHint' | translate}}\"\n\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t(ngModelChange)=\"update($event)\"\n\t\t\t\t\t[attr.data-qe-id]=\"getQeId('description-box')\"\n\t\t\t\t>\n{{subRequest?.details}}</textarea\n\t\t\t\t>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-3 col-md-3 col-lg-3\">\n\t\t\t\t<!-- REMOVE BUTTON-->\n\t\t\t\t<div *ngIf=\"showRemoveLink\">\n\t\t\t\t\t<button\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t(click)=\"remove()\"\n\t\t\t\t\t\t[disabled]=\"disableInputs()\"\n\t\t\t\t\t\tclass=\"btn btn-link\"\n\t\t\t\t\t\t[attr.data-qe-id]=\"getQeId('remove-button')\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class=\"bento-icon-close-x\"></i>\n\t\t\t\t\t\t<span>{{'Blue.DocumentComponents.DocumentRequests.Remove' | translate}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- STATUS -->\n\t\t\t\t<div [hidden]=\"!showStatusDropdown\">\n\t\t\t\t\t<bdc-communication-status-dropdown\n\t\t\t\t\t\t[disableDropdown]=\"disableStatusDropdown\"\n\t\t\t\t\t\t[selectedStatus]=\"subRequest? subRequest.communicationStatus : 'WaitingOnClient'\"\n\t\t\t\t\t\t(ngModelChange)=\"update()\"\n\t\t\t\t\t\t[qeId]=\"'sub-request'\"\n\t\t\t\t\t\t[showLabel]=\"false\"\n\t\t\t\t\t></bdc-communication-status-dropdown>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n</div>\n", styles: [".dms-sub-request{background-color:#f4f5f7;border:1px solid #d5d4d9;border-radius:5px}.dms-sub-request fieldset.well{margin:0;padding:20px 0}.dms-sub-request .btn.btn-link{border:none;color:#00f;font-weight:700;padding-left:0}.dms-sub-request .btn.btn-link:disabled{color:#a9a9a9}.dms-sub-request textarea{height:65px;min-height:65px;overflow-y:scroll;resize:vertical;transition:width .25s;width:100%}\n"], components: [{ type: CommunicationStatusDropdownComponent, selector: "bdc-communication-status-dropdown", inputs: ["disableDropdown", "selectedStatus", "qeId", "showLabel"] }], directives: [{ type: i2$1.NgIf, selector: "[ngIf]", inputs: ["ngIf", "ngIfThen", "ngIfElse"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-sub-request', template: "<div class=\"dms-sub-request col-sm-10 col-md-10 col-lg-10\">\n\t<fieldset class=\"well\">\n\t\t<div class=\"row\">\n\t\t\t<!-- Subrequest text input -->\n\t\t\t<div class=\"col-sm-8 col-md-8 col-lg-8\">\n\t\t\t\t<textarea\n\t\t\t\t\ttype=\"text\"\n\t\t\t\t\tmaxlength=\"2500\"\n\t\t\t\t\t[disabled]=\"disableDescriptionField || disableInputs()\"\n\t\t\t\t\tplaceholder=\"{{'Blue.DocumentComponents.DocumentRequests.RequestHint' | translate}}\"\n\t\t\t\t\tautocomplete=\"off\"\n\t\t\t\t\t(ngModelChange)=\"update($event)\"\n\t\t\t\t\t[attr.data-qe-id]=\"getQeId('description-box')\"\n\t\t\t\t>\n{{subRequest?.details}}</textarea\n\t\t\t\t>\n\t\t\t</div>\n\t\t\t<div class=\"col-sm-3 col-md-3 col-lg-3\">\n\t\t\t\t<!-- REMOVE BUTTON-->\n\t\t\t\t<div *ngIf=\"showRemoveLink\">\n\t\t\t\t\t<button\n\t\t\t\t\t\ttype=\"button\"\n\t\t\t\t\t\t(click)=\"remove()\"\n\t\t\t\t\t\t[disabled]=\"disableInputs()\"\n\t\t\t\t\t\tclass=\"btn btn-link\"\n\t\t\t\t\t\t[attr.data-qe-id]=\"getQeId('remove-button')\"\n\t\t\t\t\t>\n\t\t\t\t\t\t<i class=\"bento-icon-close-x\"></i>\n\t\t\t\t\t\t<span>{{'Blue.DocumentComponents.DocumentRequests.Remove' | translate}}</span>\n\t\t\t\t\t</button>\n\t\t\t\t</div>\n\n\t\t\t\t<!-- STATUS -->\n\t\t\t\t<div [hidden]=\"!showStatusDropdown\">\n\t\t\t\t\t<bdc-communication-status-dropdown\n\t\t\t\t\t\t[disableDropdown]=\"disableStatusDropdown\"\n\t\t\t\t\t\t[selectedStatus]=\"subRequest? subRequest.communicationStatus : 'WaitingOnClient'\"\n\t\t\t\t\t\t(ngModelChange)=\"update()\"\n\t\t\t\t\t\t[qeId]=\"'sub-request'\"\n\t\t\t\t\t\t[showLabel]=\"false\"\n\t\t\t\t\t></bdc-communication-status-dropdown>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t</div>\n\t</fieldset>\n</div>\n", styles: [".dms-sub-request{background-color:#f4f5f7;border:1px solid #d5d4d9;border-radius:5px}.dms-sub-request fieldset.well{margin:0;padding:20px 0}.dms-sub-request .btn.btn-link{border:none;color:#00f;font-weight:700;padding-left:0}.dms-sub-request .btn.btn-link:disabled{color:#a9a9a9}.dms-sub-request textarea{height:65px;min-height:65px;overflow-y:scroll;resize:vertical;transition:width .25s;width:100%}\n"] }]
        }], propDecorators: { subRequest: [{
                type: Input
            }], showStatusDropdown: [{
                type: Input
            }], disableStatusDropdown: [{
                type: Input
            }], disableDescriptionField: [{
                type: Input
            }], showRemoveLink: [{
                type: Input
            }], baseQeId: [{
                type: Input
            }], subRequestChange: [{
                type: Output
            }], subRequestRemove: [{
                type: Output
            }], statusDropdown: [{
                type: ViewChild,
                args: [CommunicationStatusDropdownComponent]
            }] } });

class SubRequestModule {
}
/** @nocollapse */ SubRequestModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SubRequestModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestModule, declarations: [SubRequestComponent], imports: [CommonModule, i1.TranslateModule, CommunicationStatusDropdownModule], exports: [SubRequestComponent] });
/** @nocollapse */ SubRequestModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestModule, imports: [[CommonModule, TranslateModule.forChild(), CommunicationStatusDropdownModule]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SubRequestComponent],
                    imports: [CommonModule, TranslateModule.forChild(), CommunicationStatusDropdownModule],
                    exports: [SubRequestComponent],
                }]
        }] });

class SubRequestListComponent {
    constructor() {
        /** Boolean telling whether to show the communication status drop downs */
        this.showStatusDropdown = true;
        /** Boolean telling whether to disable the communication status drop downs */
        this.disableStatusDropdown = false;
        /** Boolean telling whether to disable the description fields */
        this.disableDescriptionField = false;
        /** Event raised when a new sub request is requested */
        this.addSubRequest = new EventEmitter();
        /** Event raised when removal of a sub request is requested */
        this.removeSubRequest = new EventEmitter();
    }
    ngOnChanges(changes) {
        var _a;
        if (changes.subRequestList && this.subRequestList) {
            if (((_a = this.subRequestList) === null || _a === void 0 ? void 0 : _a.length) < 1) {
                throw new Error('At least one sub-request must be in the set');
            }
            this.subRequestList = this.subRequestList.sort((a, b) => {
                const aOrder = a.order ? a.order : 0;
                const bOrder = b.order ? b.order : 0;
                return aOrder - bOrder;
            });
        }
    }
    /** Get the data qe id - since the only controls are the list of sub-requests, include the index on each */
    getQeId(qeId, index) {
        return (this.baseQeId ? this.baseQeId + '-' : '') + 'dms-sub-request-list' + '-' + qeId + '-' + index;
    }
    /** Determine the proper label for the given index */
    getLabel(index) {
        let label = marker('Blue.DocumentComponents.DocumentRequest.SubRequestLabel');
        if (index > 0) {
            label += ' ' + (index + 1);
        }
        label += '*';
        return label;
    }
    /** Raises the event indicating that a new document request has been requested  */
    addNewDocumentRequest() {
        // raise the add sub request event
        this.addSubRequest.emit();
    }
    /** Raises the event indicating that a new document request has been requested  */
    removeDocumentRequest(request) {
        // raise the add sub request event
        this.removeSubRequest.emit(request);
    }
}
/** @nocollapse */ SubRequestListComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestListComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
/** @nocollapse */ SubRequestListComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "12.0.0", version: "13.4.0", type: SubRequestListComponent, selector: "bdc-sub-request-list", inputs: { subRequestList: "subRequestList", showStatusDropdown: "showStatusDropdown", disableStatusDropdown: "disableStatusDropdown", disableDescriptionField: "disableDescriptionField", baseQeId: "baseQeId" }, outputs: { addSubRequest: "addSubRequest", removeSubRequest: "removeSubRequest" }, usesOnChanges: true, ngImport: i0, template: "<div class=\"sub-request-list\">\n\t<div class=\"sub-request\" *ngFor=\"let subRequest of subRequestList; index as index\">\n\t\t<div>\n\t\t\t<label>{{getLabel(index)}}</label>\n\t\t</div>\n\t\t<bdc-sub-request\n\t\t\t[subRequest]=\"subRequest\"\n\t\t\t[showStatusDropdown]=\"showStatusDropdown\"\n\t\t\t[disableStatusDropdown]=\"disableStatusDropdown\"\n\t\t\t[disableDescriptionField]=\"disableDescriptionField\"\n\t\t\t[showRemoveLink]=\"index > 0\"\n\t\t\t[baseQeId]=\"index\"\n\t\t>\n\t\t</bdc-sub-request>\n\t\t<div>\n\t\t\t<button class=\"btn btn-link btn-icon\" onclick=\"addNewDocumentRequest()\">\n\t\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-user-plus\"></i>\n\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.DocumentRequest.AddSubRequest' | translate}}</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".sub-request-list .sub-request{margin-bottom:5px}\n"], components: [{ type: SubRequestComponent, selector: "bdc-sub-request", inputs: ["subRequest", "showStatusDropdown", "disableStatusDropdown", "disableDescriptionField", "showRemoveLink", "baseQeId"], outputs: ["subRequestChange", "subRequestRemove"] }], directives: [{ type: i2$1.NgForOf, selector: "[ngFor][ngForOf]", inputs: ["ngForOf", "ngForTrackBy", "ngForTemplate"] }], pipes: { "translate": i1.TranslatePipe } });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestListComponent, decorators: [{
            type: Component,
            args: [{ selector: 'bdc-sub-request-list', template: "<div class=\"sub-request-list\">\n\t<div class=\"sub-request\" *ngFor=\"let subRequest of subRequestList; index as index\">\n\t\t<div>\n\t\t\t<label>{{getLabel(index)}}</label>\n\t\t</div>\n\t\t<bdc-sub-request\n\t\t\t[subRequest]=\"subRequest\"\n\t\t\t[showStatusDropdown]=\"showStatusDropdown\"\n\t\t\t[disableStatusDropdown]=\"disableStatusDropdown\"\n\t\t\t[disableDescriptionField]=\"disableDescriptionField\"\n\t\t\t[showRemoveLink]=\"index > 0\"\n\t\t\t[baseQeId]=\"index\"\n\t\t>\n\t\t</bdc-sub-request>\n\t\t<div>\n\t\t\t<button class=\"btn btn-link btn-icon\" onclick=\"addNewDocumentRequest()\">\n\t\t\t\t<i aria-hidden=\"true\" class=\"bento-icon-user-plus\"></i>\n\t\t\t\t<span class=\"btn-text\">{{'Blue.DocumentComponents.DocumentRequest.AddSubRequest' | translate}}</span>\n\t\t\t</button>\n\t\t</div>\n\t</div>\n</div>\n", styles: [".sub-request-list .sub-request{margin-bottom:5px}\n"] }]
        }], propDecorators: { subRequestList: [{
                type: Input
            }], showStatusDropdown: [{
                type: Input
            }], disableStatusDropdown: [{
                type: Input
            }], disableDescriptionField: [{
                type: Input
            }], baseQeId: [{
                type: Input
            }], addSubRequest: [{
                type: Output
            }], removeSubRequest: [{
                type: Output
            }] } });

class SubRequestListModule {
}
/** @nocollapse */ SubRequestListModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestListModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ SubRequestListModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestListModule, declarations: [SubRequestListComponent], imports: [SubRequestModule, BrowserModule, i1.TranslateModule], exports: [SubRequestListComponent] });
/** @nocollapse */ SubRequestListModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestListModule, imports: [[SubRequestModule, BrowserModule, TranslateModule.forChild()]] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: SubRequestListModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [SubRequestListComponent],
                    imports: [SubRequestModule, BrowserModule, TranslateModule.forChild()],
                    exports: [SubRequestListComponent],
                }]
        }] });

function exposeVersionNumber() {
    const w = window;
    w.bmdms = w.bmdms || {};
    w.bmdms.components = {
        version: /* inject-version start */ '25.0.12' /* inject-version end */,
    };
}
function windowFactory() {
    return window;
}
function documentFactory() {
    return document;
}
class DocumentComponentsModule {
    constructor() {
        exposeVersionNumber();
    }
}
/** @nocollapse */ DocumentComponentsModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
/** @nocollapse */ DocumentComponentsModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsModule, declarations: [DocumentComponentsComponent, DocumentTreePaneComponent, ClientPersonalDetailsComponent], imports: [CommonModule,
        CommentBoxModule,
        HttpClientModule, i1.TranslateModule, ReactiveFormsModule,
        FormsModule,
        DocumentServicesModule,
        NameInputModule,
        ToolbarModule,
        NewFolderModalModule,
        RenameModalModule,
        EsignModalModule,
        DocumentHistoryModule,
        TreeNavToolbarModule,
        RecipientSelectorModule,
        DocumentApprovalsModule,
        ToggleModule,
        CommunicationStatusDropdownModule,
        ServiceBootstrapModule,
        BentoModule,
        NgbModule,
        DrawerTabsModule,
        ClientSelectorModule,
        ContactSelectorModule,
        ContactPersonalDetailsModule,
        DocumentTreeModule,
        ItemSelectorModule,
        CompanyHeaderModule,
        EsignFileViewerModule,
        DocumentGridModule,
        AllDocumentsPaneModule,
        DocumentGridPaneModule,
        MultiselectFilterSectionModule,
        BreadcrumbModule,
        ColumnSelectorModule,
        AllDocumentsGridModule,
        SecurityOptionsModule,
        MessageSubjectFieldModule,
        RequestDestinationModule,
        DateInputModule,
        TaxRequestModule,
        RequestTemplateSelectorModule,
        SubRequestModule,
        SubRequestListModule,
        EventFilterSidebarModule], exports: [DocumentComponentsComponent,
        ClientSelectorModule,
        ContactSelectorModule,
        CommentBoxModule,
        DrawerTabsModule,
        DocumentTreePaneComponent,
        DocumentServicesModule,
        ClientPersonalDetailsComponent,
        NameInputModule,
        RecipientSelectorModule,
        DocumentApprovalsModule,
        ToggleModule,
        CommunicationStatusDropdownModule,
        ServiceBootstrapModule,
        DocumentTreeModule,
        ContactPersonalDetailsModule,
        ItemSelectorModule,
        CompanyHeaderComponent,
        CompanyHeaderModule,
        EsignFileViewerModule,
        DocumentHistoryModule,
        DocumentGridModule,
        AllDocumentsPaneModule,
        DocumentGridPaneModule,
        MultiselectFilterSectionModule,
        BreadcrumbModule,
        ColumnSelectorModule,
        AllDocumentsGridModule,
        SecurityOptionsModule,
        MessageSubjectFieldModule,
        RequestDestinationModule,
        DateInputModule,
        TaxRequestModule,
        RequestTemplateSelectorModule,
        SubRequestModule,
        SubRequestListModule] });
/** @nocollapse */ DocumentComponentsModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsModule, providers: [
        { provide: 'windowWrapper', useFactory: windowFactory },
        { provide: 'documentWrapper', useFactory: documentFactory },
        ModalCloseService,
    ], imports: [[
            CommonModule,
            CommentBoxModule,
            HttpClientModule,
            TranslateModule.forChild(),
            ReactiveFormsModule,
            FormsModule,
            DocumentServicesModule,
            NameInputModule,
            ToolbarModule,
            NewFolderModalModule,
            RenameModalModule,
            EsignModalModule,
            DocumentHistoryModule,
            TreeNavToolbarModule,
            RecipientSelectorModule,
            DocumentApprovalsModule,
            ToggleModule,
            CommunicationStatusDropdownModule,
            ServiceBootstrapModule,
            BentoModule,
            NgbModule,
            DrawerTabsModule,
            ClientSelectorModule,
            ContactSelectorModule,
            ContactPersonalDetailsModule,
            DocumentTreeModule,
            ItemSelectorModule,
            CompanyHeaderModule,
            EsignFileViewerModule,
            DocumentGridModule,
            AllDocumentsPaneModule,
            DocumentGridPaneModule,
            MultiselectFilterSectionModule,
            BreadcrumbModule,
            ColumnSelectorModule,
            AllDocumentsGridModule,
            SecurityOptionsModule,
            MessageSubjectFieldModule,
            RequestDestinationModule,
            DateInputModule,
            TaxRequestModule,
            RequestTemplateSelectorModule,
            SubRequestModule,
            SubRequestListModule,
            EventFilterSidebarModule,
        ], ClientSelectorModule,
        ContactSelectorModule,
        CommentBoxModule,
        DrawerTabsModule,
        DocumentServicesModule,
        NameInputModule,
        RecipientSelectorModule,
        DocumentApprovalsModule,
        ToggleModule,
        CommunicationStatusDropdownModule,
        ServiceBootstrapModule,
        DocumentTreeModule,
        ContactPersonalDetailsModule,
        ItemSelectorModule,
        CompanyHeaderModule,
        EsignFileViewerModule,
        DocumentHistoryModule,
        DocumentGridModule,
        AllDocumentsPaneModule,
        DocumentGridPaneModule,
        MultiselectFilterSectionModule,
        BreadcrumbModule,
        ColumnSelectorModule,
        AllDocumentsGridModule,
        SecurityOptionsModule,
        MessageSubjectFieldModule,
        RequestDestinationModule,
        DateInputModule,
        TaxRequestModule,
        RequestTemplateSelectorModule,
        SubRequestModule,
        SubRequestListModule] });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentComponentsModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [DocumentComponentsComponent, DocumentTreePaneComponent, ClientPersonalDetailsComponent],
                    imports: [
                        CommonModule,
                        CommentBoxModule,
                        HttpClientModule,
                        TranslateModule.forChild(),
                        ReactiveFormsModule,
                        FormsModule,
                        DocumentServicesModule,
                        NameInputModule,
                        ToolbarModule,
                        NewFolderModalModule,
                        RenameModalModule,
                        EsignModalModule,
                        DocumentHistoryModule,
                        TreeNavToolbarModule,
                        RecipientSelectorModule,
                        DocumentApprovalsModule,
                        ToggleModule,
                        CommunicationStatusDropdownModule,
                        ServiceBootstrapModule,
                        BentoModule,
                        NgbModule,
                        DrawerTabsModule,
                        ClientSelectorModule,
                        ContactSelectorModule,
                        ContactPersonalDetailsModule,
                        DocumentTreeModule,
                        ItemSelectorModule,
                        CompanyHeaderModule,
                        EsignFileViewerModule,
                        DocumentGridModule,
                        AllDocumentsPaneModule,
                        DocumentGridPaneModule,
                        MultiselectFilterSectionModule,
                        BreadcrumbModule,
                        ColumnSelectorModule,
                        AllDocumentsGridModule,
                        SecurityOptionsModule,
                        MessageSubjectFieldModule,
                        RequestDestinationModule,
                        DateInputModule,
                        TaxRequestModule,
                        RequestTemplateSelectorModule,
                        SubRequestModule,
                        SubRequestListModule,
                        EventFilterSidebarModule,
                    ],
                    exports: [
                        DocumentComponentsComponent,
                        ClientSelectorModule,
                        ContactSelectorModule,
                        CommentBoxModule,
                        DrawerTabsModule,
                        DocumentTreePaneComponent,
                        DocumentServicesModule,
                        ClientPersonalDetailsComponent,
                        NameInputModule,
                        RecipientSelectorModule,
                        DocumentApprovalsModule,
                        ToggleModule,
                        CommunicationStatusDropdownModule,
                        ServiceBootstrapModule,
                        DocumentTreeModule,
                        ContactPersonalDetailsModule,
                        ItemSelectorModule,
                        CompanyHeaderComponent,
                        CompanyHeaderModule,
                        EsignFileViewerModule,
                        DocumentHistoryModule,
                        DocumentGridModule,
                        AllDocumentsPaneModule,
                        DocumentGridPaneModule,
                        MultiselectFilterSectionModule,
                        BreadcrumbModule,
                        ColumnSelectorModule,
                        AllDocumentsGridModule,
                        SecurityOptionsModule,
                        MessageSubjectFieldModule,
                        RequestDestinationModule,
                        DateInputModule,
                        TaxRequestModule,
                        RequestTemplateSelectorModule,
                        SubRequestModule,
                        SubRequestListModule,
                    ],
                    schemas: [CUSTOM_ELEMENTS_SCHEMA],
                    providers: [
                        { provide: 'windowWrapper', useFactory: windowFactory },
                        { provide: 'documentWrapper', useFactory: documentFactory },
                        ModalCloseService,
                    ],
                }]
        }], ctorParameters: function () { return []; } });

class RenameModalService {
    constructor(modalService, documentService) {
        this.modalService = modalService;
        this.documentService = documentService;
    }
    open(itemKey, containerKey) {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = this.modalService.open(RenameModalComponent, {
                backdrop: 'static',
            });
            // Only supporting documents for now
            const doc = yield this.documentService.get(itemKey, containerKey);
            modal.componentInstance.item = doc;
            const result = yield modal.result;
            return result;
        });
    }
}
/** @nocollapse */ RenameModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalService, deps: [{ token: i1$2.NgbModal }, { token: i1$1.DocumentService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ RenameModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: RenameModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: i1$1.DocumentService }]; } });

class CopyModalService {
    constructor(modalService, itemStore, containerStore) {
        this.modalService = modalService;
        this.itemStore = itemStore;
        this.containerStore = containerStore;
        this.options = {
            showClientSelector: true,
            treeShowFiles: false,
            allowFileSelection: false,
            allowFolderSelection: true,
            allowLockedFileSelection: false,
            showFirmDocumentsDrawer: true,
            showMyDocumentsDrawer: true,
            showAddFolderButton: true,
            customTitle: marker('Blue.DocumentComponents.Modal.Copy.Header'),
            customSelectButtonText: marker('Blue.DocumentComponents.Modal.Copy.CopyButtonText'),
        };
    }
    open(clientId, sourceContainerKey, documents, folders) {
        return __awaiter(this, void 0, void 0, function* () {
            const modal = this.modalService.open(ItemSelectorComponent, {
                windowClass: 'item-selector-modal-window',
                backdrop: 'static',
            });
            modal.componentInstance.clientId = clientId;
            modal.componentInstance.options = this.options;
            modal.componentInstance.qeId = 'bdc-copy-items';
            modal.componentInstance.canBeSelected = (item) => {
                return this.canBeSelected(item, sourceContainerKey);
            };
            const selectedContainer = yield modal.result;
            this.copyItems(selectedContainer, documents, folders);
        });
    }
    copyItems(selected, documents, folders) {
        if (!selected.container)
            return;
        documents === null || documents === void 0 ? void 0 : documents.forEach((document) => __awaiter(this, void 0, void 0, function* () { return this.itemStore.copyDocument(document, selected.container); }));
        folders === null || folders === void 0 ? void 0 : folders.forEach((folder) => __awaiter(this, void 0, void 0, function* () { return this.containerStore.copyFolder(folder, selected.container); }));
    }
    canBeSelected(item, sourceContainerKey) {
        var _a, _b, _c;
        if (item.type === sourceContainerKey.type && item.id === sourceContainerKey.id) {
            return false;
        }
        if (((_a = item.lock) === null || _a === void 0 ? void 0 : _a.type) === LockType.Read &&
            (((_b = item.lock) === null || _b === void 0 ? void 0 : _b.level) === LockLevel.Master || ((_c = item.lock) === null || _c === void 0 ? void 0 : _c.level) === LockLevel.Ancestor)) {
            return false;
        }
        return true;
    }
}
/** @nocollapse */ CopyModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CopyModalService, deps: [{ token: i1$2.NgbModal }, { token: i1$1.ItemStore }, { token: i1$1.ContainerStore }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ CopyModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CopyModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: CopyModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }, { type: i1$1.ItemStore }, { type: i1$1.ContainerStore }]; } });

class AlertsService extends ReplaySubject {
    constructor() {
        super(1);
        this.alerts = [];
        registerAlert();
        this.notify();
    }
    add(alert) {
        this.alerts = [...this.alerts, alert];
        this.notify();
    }
    remove(alert) {
        this.alerts = this.alerts.filter(a => alert !== a);
        this.notify();
    }
    notify() {
        this.next([...this.alerts]);
    }
}
/** @nocollapse */ AlertsService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertsService, deps: [], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ AlertsService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertsService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: AlertsService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return []; } });

class ModalResult {
    constructor(resultType, detail) {
        this.resultType = resultType;
        this.detail = detail;
    }
}
var ModalResultType;
(function (ModalResultType) {
    ModalResultType["OK"] = "OK";
    ModalResultType["Cancel"] = "Cancel";
    ModalResultType["Save"] = "Save";
    ModalResultType["Yes"] = "Yes";
    ModalResultType["No"] = "No";
})(ModalResultType || (ModalResultType = {}));

class EsignModalService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                size: 'lg',
                windowClass: 'esign-modal-window modal-full-height',
                backdrop: 'static',
                keyboard: false,
            };
            if (parameters.container) {
                options.container = parameters.container;
            }
            const modal = this.modalService.open(EsignModalComponent, options);
            const component = modal.componentInstance;
            component.readonly = parameters.readonly;
            component.recipients = parameters.recipients;
            component.esignDocuments = parameters.documents;
            component.selectedDocumentId = parameters.documents.selectedDocumentId;
            component.placeholders = JSON.parse(JSON.stringify(parameters.placeholders));
            component.container = parameters.container;
            try {
                yield modal.result;
                return new ModalResult(ModalResultType.Save, [component.placeholders, component.loadedDocumentsMetadata]);
            }
            catch (error) {
                return new ModalResult(ModalResultType.Cancel, String(error));
            }
        });
    }
}
/** @nocollapse */ EsignModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ EsignModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: EsignModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class DocumentHistoryService {
    constructor(modalService) {
        this.modalService = modalService;
    }
    open(parameters) {
        return __awaiter(this, void 0, void 0, function* () {
            const options = {
                size: 'lg',
                windowClass: 'document-history-modal-window',
                backdrop: 'static',
                keyboard: false,
            };
            if (parameters.container) {
                options.container = parameters.container;
            }
            const modal = this.modalService.open(DocumentHistoryModalComponent, options);
            modal.componentInstance.selectedDocumentId = parameters.selectedDocumentId;
            modal.componentInstance.selectedDocumentName = parameters.selectedDocumentName;
            modal.componentInstance.container = parameters.container;
            modal.componentInstance.showFilter = parameters.showFilter;
            modal.componentInstance.allUsersList = parameters.allUsersList;
            return modal.result;
        });
    }
}
/** @nocollapse */ DocumentHistoryService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryService, deps: [{ token: i1$2.NgbModal }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ DocumentHistoryService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: DocumentHistoryService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$2.NgbModal }]; } });

class DownloadButtonService {
    constructor(documentService) {
        this.documentService = documentService;
    }
    handleButtonClick(event) {
        return __awaiter(this, void 0, void 0, function* () {
            if (event.buttonId === 'download') {
                yield this.handleDownloadButtonClick(event.items.items.filter(item => isDocument(item)));
            }
        });
    }
    handleDownloadButtonClick(downloadQueue) {
        return __awaiter(this, void 0, void 0, function* () {
            if (downloadQueue.length === 0) {
                return;
            }
            downloadQueue.forEach((doc, i) => {
                setTimeout(() => __awaiter(this, void 0, void 0, function* () {
                    const downloadUrl = yield this.getDocument(doc);
                    this.downloadDocument(downloadUrl, doc.name);
                }), i * 1000);
            });
        });
    }
    downloadDocument(downloadUrl, fileName) {
        const linkElement = document.createElement('a');
        linkElement.style.display = 'none';
        linkElement.setAttribute('href', downloadUrl);
        linkElement.setAttribute('download', fileName);
        document.body.appendChild(linkElement);
        linkElement.click();
        linkElement.remove();
        URL.revokeObjectURL(downloadUrl);
    }
    getDocument(document) {
        return __awaiter(this, void 0, void 0, function* () {
            return (yield this.documentService.get(document, document.parent)).toString();
        });
    }
}

class LanguageConfirmationModalService {
    constructor(confirmationModalService) {
        this.confirmationModalService = confirmationModalService;
    }
    /**
     * When called, a confirmation modal is displayed allowing the user to select Yes or No.
     * @returns true if Yes is selected otherwise false.
     */
    open() {
        return __awaiter(this, void 0, void 0, function* () {
            const confirmationModalConfig = {
                message: {
                    translationKey: marker('Blue.DocumentComponents.Modal.SendItems.SendTemplateLoad'),
                },
                buttons: [
                    {
                        button: 2 /* Yes */,
                        isPrimary: true,
                    },
                    {
                        button: 3 /* No */,
                        isPrimary: false,
                    },
                ],
                iconName: 'bento-icon-warning-filled',
                iconColorType: 'danger',
            };
            const ngbModalRef = this.confirmationModalService.open(confirmationModalConfig, {
                backdrop: 'static',
            });
            const buttonPressed = yield ngbModalRef.result;
            return buttonPressed === 2 /* Yes */;
        });
    }
}
/** @nocollapse */ LanguageConfirmationModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LanguageConfirmationModalService, deps: [{ token: ConfirmationModalService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ LanguageConfirmationModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LanguageConfirmationModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: LanguageConfirmationModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: ConfirmationModalService }]; } });
function selectedRecipientToCommunicationRecipient(recipient) {
    var _a, _b, _c;
    return {
        name: (_a = recipient.contact) === null || _a === void 0 ? void 0 : _a.displayAs,
        contactId: (_b = recipient === null || recipient === void 0 ? void 0 : recipient.contact) === null || _b === void 0 ? void 0 : _b.id,
        emailAddress: (_c = recipient.contact) === null || _c === void 0 ? void 0 : _c.emailAddress,
        type: recipientType(recipient),
        culture: 'en-US',
    };
}
function recipientType(recipient) {
    return recipient.email && recipient.clientCenter
        ? CommunicationRequestRecipientType.Both
        : recipient.email
            ? CommunicationRequestRecipientType.Email
            : recipient.clientCenter
                ? CommunicationRequestRecipientType.ClientCenter
                : undefined;
}

class ToastMessageService {
    constructor(documentWrapper, translateService) {
        this.translateService = translateService;
        this.document = documentWrapper;
    }
    showToastMessage(type, message, dataQeId) {
        const toastComponent = this.document.createElement('onvio-toast');
        toastComponent.setAttribute('type', type);
        toastComponent.setAttribute('body-text', message);
        toastComponent.setAttribute('close-label', this.translateService.instant('Blue.DocumentComponents.Button.Close'));
        if (dataQeId) {
            toastComponent.setAttribute('data-qe-id', dataQeId);
        }
        document.body.prepend(toastComponent);
    }
}
/** @nocollapse */ ToastMessageService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastMessageService, deps: [{ token: 'documentWrapper' }, { token: i1.TranslateService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ ToastMessageService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastMessageService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ToastMessageService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () {
        return [{ type: undefined, decorators: [{
                        type: Inject,
                        args: ['documentWrapper']
                    }] }, { type: i1.TranslateService }];
    } });

class ConfirmationLockedDocumentModalService {
    constructor(confirmationModalService, lockMessageService) {
        this.confirmationModalService = confirmationModalService;
        this.lockMessageService = lockMessageService;
    }
    /**
     * Opens a confirmation modal when a user tries to open a document in
     * Onvio Link but the document is already locked.
     * @param lock ItemLock for the item for which we are opening the modal for
     * @returns Result from ConfirmationModal
     */
    open(lock) {
        return __awaiter(this, void 0, void 0, function* () {
            const modalMessage = yield this.lockMessageService.getLockMessage(lock);
            const confirmationModalConfig = {
                message: {
                    translationKey: modalMessage,
                },
                buttons: [
                    {
                        button: 1 /* Cancel */,
                        isPrimary: true,
                    },
                ],
                iconName: 'bento-icon-warning-filled',
                iconColorType: 'danger',
            };
            const confirmationModal = this.confirmationModalService.open(confirmationModalConfig, {
                backdrop: 'static',
            });
            return confirmationModal.result;
        });
    }
}
/** @nocollapse */ ConfirmationLockedDocumentModalService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationLockedDocumentModalService, deps: [{ token: ConfirmationModalService }, { token: LockMessageService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ ConfirmationLockedDocumentModalService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationLockedDocumentModalService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: ConfirmationLockedDocumentModalService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: ConfirmationModalService }, { type: LockMessageService }]; } });

class OpenItemService {
    constructor(itemStore, confirmationModalService, documentService, confirmationLockedDocumentModalService, itemService) {
        this.itemStore = itemStore;
        this.confirmationModalService = confirmationModalService;
        this.documentService = documentService;
        this.confirmationLockedDocumentModalService = confirmationLockedDocumentModalService;
        this.itemService = itemService;
        this.getCurrentUser = getCurrentUser;
        this.getContactId = getContactId;
        this.loadCurrentHelpInfo = loadCurrent;
        this.hasIac = has;
        this.hasFrp = has$1;
        this.customProtocolCheck = customProtocolCheck;
    }
    /**
     * Attempts to open a passed item in Onvio Link
     *
     * @remarks
     * If Onvio Link is not installed the user will be prompted and
     * given the opportunity to learn about the application
     *
     * @param item - The item to open locally
     * @returns Promise<void>
     */
    openItemLocally(item) {
        var _a;
        return __awaiter(this, void 0, void 0, function* () {
            // if the passed item is locked, we can't do anything here and should just exit
            if (item.lock !== undefined && ((_a = item.lock) === null || _a === void 0 ? void 0 : _a.type) !== LockType.None)
                return;
            const user = yield this.getCurrentUser();
            const currentUser = new User(user.id, true, user.firstName, user.lastName);
            const contactId = yield this.getContactId();
            // we only want to do anything if this is a document and the current user has lock/unlock rights
            if (isDocument(item) && (yield this.hasFrp('OnvioDrive.LinkUnlock')) && (yield this.hasIac('DMS_ResourceLocking'))) {
                // place a fake lock on the item to give the appearance that it is locked
                // the back end will put the actual lock on it
                this.itemStore.addTemporaryLock(item, currentUser);
                const lock = yield this.itemService.getLockRestrictions(item.id);
                if (lock === null || lock === void 0 ? void 0 : lock.type) {
                    yield this.confirmationLockedDocumentModalService.open(lock);
                    const itemWithLock = Object.assign(Object.assign({}, item), { lock: lock });
                    // Update the item stored to refresh the grid
                    this.itemStore.updateItem(itemWithLock, item.parent);
                }
                else {
                    const url = this.documentService.getOnvioLinkUrl(item, user.blueID, contactId);
                    this.customProtocolCheck(url, this.promptToInstallOnvioLink.bind(this));
                }
            }
        });
    }
    /**
     * Opens dialog suggesting Onvio Link installation with an option to learn  more
     *
     * @remarks
     * If Onvio Link is not installed the user will be prompted and
     * given the opportunity to learn about the application
     *
     * @returns Promise<void>
     */
    promptToInstallOnvioLink() {
        return __awaiter(this, void 0, void 0, function* () {
            const config = {
                message: { translationKey: marker('Blue.DocumentComponents.Modal.OpenLocally.LinkErrorMessage') },
                buttons: [
                    {
                        button: 6 /* LearnMore */,
                        isPrimary: true,
                    },
                    {
                        button: 1 /* Cancel */,
                        isPrimary: false,
                    },
                ],
                iconName: 'bento-icon-warning',
                iconColorType: 'danger',
            };
            const modal = this.confirmationModalService.open(config, {
                backdrop: 'static',
                backdropClass: 'confirmation-popup-backdrop',
                size: 'sm',
            });
            const result = yield modal.result;
            if (result !== 6 /* LearnMore */) {
                return;
            }
            const help = yield this.loadCurrentHelpInfo();
            window.open(help.baseUrl + 'onvio-link.htm', '_blank');
        });
    }
}
/** @nocollapse */ OpenItemService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OpenItemService, deps: [{ token: i1$1.ItemStore }, { token: ConfirmationModalService }, { token: i1$1.DocumentService }, { token: ConfirmationLockedDocumentModalService }, { token: i1$1.ItemService }], target: i0.ɵɵFactoryTarget.Injectable });
/** @nocollapse */ OpenItemService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OpenItemService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "13.4.0", ngImport: i0, type: OpenItemService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root',
                }]
        }], ctorParameters: function () { return [{ type: i1$1.ItemStore }, { type: ConfirmationModalService }, { type: i1$1.DocumentService }, { type: ConfirmationLockedDocumentModalService }, { type: i1$1.ItemService }]; } });

/*
 * Public API Surface of document-components
 */

/**
 * Generated bundle index. Do not edit.
 */

export { AlertsService, AllDocumentsGridComponent, AllDocumentsGridModule, AllDocumentsPaneComponent, AllDocumentsPaneModule, BreadcrumbComponent, BreadcrumbItemComponent, BreadcrumbModule, ClientPersonalDetailsComponent, ClientSelectorComponent, ClientSelectorModule, ColumnSelectorComponent, ColumnSelectorModule, CommentBoxComponent, CommentBoxModule, CommunicationStatusDropdownComponent, CommunicationStatusDropdownModule, CompanyHeaderComponent, CompanyHeaderModule, ConfirmationLockedDocumentModalService, ConfirmationModalModule, ConfirmationModalService, ConfirmationPopupComponent, ContactPersonalDetailsComponent, ContactPersonalDetailsModule, ContactSelectorComponent, ContactSelectorModule, CopyModalService, DateInputComponent, DateInputModule, DocumentApprovalsComponent, DocumentApprovalsModule, DocumentComponentsCommonModule, DocumentComponentsComponent, DocumentComponentsModule, DocumentGridComponent, DocumentGridModule, DocumentGridPaneComponent, DocumentGridPaneModule, DocumentHistoryModalComponent, DocumentHistoryModule, DocumentHistoryService, DocumentServicesModule, DocumentTreeComponent, DocumentTreeModule, DocumentTreePaneComponent, DownloadButtonService, DrawerTabsComponent, DrawerTabsModule, EsignFileViewerComponent, EsignFileViewerModule, EsignModalComponent, EsignModalModule, EsignModalService, ItemDateFnPipe, ItemDatePipe, ItemNameLinkColumnComponent, ItemSelectorComponent, ItemSelectorModule, ItemSelectorService, ItemStatusIconComponent, ItemTimePipe, ItemTypeColumnComponent, LanguageConfirmationModalService, LockMessageService, MessageSubjectFieldComponent, MessageSubjectFieldModule, ModalCloseService, MultiselectFilterSectionComponent, MultiselectFilterSectionModule, NameInputComponent, NameInputModule, NewFolderModalComponent, NewFolderModalModule, NewFolderModalService, OpenItemService, ProjectAppColumnComponent, RecipientSelectorComponent, RecipientSelectorModule, RenameModalComponent, RenameModalModule, RenameModalService, RequestDestinationComponent, RequestDestinationModule, RequestTemplateSelectorComponent, RequestTemplateSelectorModule, SafeResourcePipe, SecurityOptionsComponent, SecurityOptionsModule, ServiceBootstrapComponent, ServiceBootstrapModule, SharedColumnComponent, SubRequestComponent, SubRequestListComponent, SubRequestListModule, SubRequestModule, TaxRequestComponent, TaxRequestDemoComponent, TaxRequestModule, ToastMessageService, ToggleComponent, ToggleModule, ToolbarComponent, ToolbarModule, TreeNavToolbarComponent, TreeNavToolbarModule, TruncateFileNamePipe, UserLanguageService, WEB_VIEWER_LIBRARY_PATH, annotationsServiceFactory, approvalServiceFactory, approvalStoreFactory, bdsContainerInstanceProvider, clientServiceFactory, clientStoreFactory, commentsServiceFactory, commentsStoreFactory, communicationServiceFactory, communicationSubRequestServiceFactory, companyServiceFactory, contactServiceFactory, containerServiceFactory, containerStoreFactory, documentConstraintsServiceFactory, documentFactory, documentServiceFactory, emailBodyServiceFactory, itemServiceFactory, itemStoreFactory, jobServiceFactory, recentItemServiceFactory, shareServiceFactory, shareStoreFactory, templateServiceFactory, templateStoreFactory, themeServiceFactory, translateFailoverServiceFactory, treeServiceFactory, treeStoreFactory, windowFactory };
